import { of, firstValueFrom, iif, BehaviorSubject, forkJoin, Subject, combineLatest, ReplaySubject, Observable, timer, zip, throwError, EMPTY, fromEvent, NEVER } from 'rxjs';
import * as i0 from '@angular/core';
import { Injectable, assertInInjectionContext, inject, InjectionToken, Inject, makeEnvironmentProviders, ErrorHandler, APP_INITIALIZER, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpErrorResponse, HttpBackend, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { share, tap, mapTo, switchMap, map, finalize, catchError, take, shareReplay, distinctUntilChanged, startWith, concatMap, switchMapTo, mergeMap } from 'rxjs/operators';
import * as i4 from '@auth0/angular-jwt';
import { EntityStore, StoreConfig, QueryEntity, combineQueries, QueryConfig, Order, Store, Query, cacheable, entitiesToArray, arrayUpdate, applyTransaction, withTransaction, guid, EntityActions, transaction, persistState } from '@datorama/akita';
import { __decorate } from 'tslib';
import * as i4$1 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import * as i5 from '@angular/common';
import { formatDate, DatePipe, CurrencyPipe, CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { Router, convertToParamMap } from '@angular/router';
import { HubConnectionState, HubConnectionBuilder } from '@microsoft/signalr';
import moment$1 from 'moment/moment';
import { DateTime } from 'luxon';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as i3 from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as moment from 'moment';
import { SwPush } from '@angular/service-worker';
import * as i4$2 from 'ngx-device-detector';

/**
 * Performs a deep comparison between two _Arrays_ or _Objects_ to determine if they are equivalent.
 * It compares items types, length and properties.
 * @param value The value to compare.
 * @param other The other value to compare.
 * @param unordered Ignores the order when comparing arrays.
 * @returns Returns true if the values are equivalent, else false.
 */
function isEqual(value, other, unordered) {
    // Compare types
    const type = Object.prototype.toString.call(value);
    if (type !== Object.prototype.toString.call(other)) {
        return false;
    }
    // If items are not an object or array, return false
    if (['[object Array]', '[object Object]'].indexOf(type) < 0) {
        return false;
    }
    // Compare the length of the length of the two items
    const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) {
        return false;
    }
    // Compare properties
    if (type === '[object Array]') {
        if (unordered) {
            return unorderedArraysEqual(value, other);
        }
        for (let i = 0; i < valueLen; i++) {
            if (compareValues(value[i], other[i]) === false) {
                return false;
            }
        }
    }
    else {
        for (const key in value) {
            if (value.hasOwnProperty(key)) {
                if (compareValues(value[key], other[key]) === false) {
                    return false;
                }
            }
        }
    }
    // If nothing failed, return true
    return true;
}
/**
 * Compare items values.
 * @param item1 The first item to compare.
 * @param item2 The other item to compare.
 * @returns Returns true if the item values are the same, else false.
 */
function compareValues(item1, item2) {
    // Get the object type
    const itemType = Object.prototype.toString.call(item1);
    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
        if (!isEqual(item1, item2)) {
            return false;
        }
    }
    // Otherwise, do a simple comparison
    else {
        // If the two items are not the same type, return false
        if (itemType !== Object.prototype.toString.call(item2)) {
            return false;
        }
        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === '[object Function]') {
            if (item1.toString() !== item2.toString()) {
                return false;
            }
        }
        else {
            if (item1 !== item2) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Compare arrays, unordered.
 * @param array1 The first array to compare.
 * @param array2 The other array to compare.
 * @returns Returns true if the arrays contain the same values, else false.
 */
function unorderedArraysEqual(array1, array2) {
    if (array1.length !== array2.length) {
        return false;
    }
    let sortedArray1 = array1.concat().sort();
    let sortedArray2 = array2.concat().sort();
    for (let i = 0; i < sortedArray1.length; i++) {
        if (sortedArray1[i] !== sortedArray2[i]) {
            return false;
        }
    }
    return true;
}
/**
 * Get an array of keys for a record type
 * @param object Record to get keys for
 * @returns Keys for the record
 */
function recordKeys(object) {
    return Object.keys(object);
}

class AccountModel {
}

// tslint:disable: variable-name
var LoginType;
(function (LoginType) {
    LoginType[LoginType["Portal"] = 1] = "Portal";
    LoginType[LoginType["Admin"] = 2] = "Admin";
    LoginType[LoginType["External"] = 3] = "External";
    LoginType[LoginType["SingleSignOn"] = 4] = "SingleSignOn";
    LoginType[LoginType["Social"] = 5] = "Social";
})(LoginType || (LoginType = {}));
var ProviderName;
(function (ProviderName) {
    ProviderName[ProviderName["Dummy"] = 0] = "Dummy";
    ProviderName[ProviderName["Fortress"] = 1] = "Fortress";
    ProviderName[ProviderName["TicketMaster"] = 2] = "TicketMaster";
    ProviderName[ProviderName["Sage"] = 3] = "Sage";
    ProviderName[ProviderName["SeeTickets"] = 4] = "SeeTickets";
    ProviderName[ProviderName["Facebook"] = 5] = "Facebook";
    ProviderName[ProviderName["Instagram"] = 6] = "Instagram";
    ProviderName[ProviderName["Google"] = 7] = "Google";
    ProviderName[ProviderName["Twitter"] = 8] = "Twitter";
    ProviderName[ProviderName["Pinterest"] = 9] = "Pinterest";
    ProviderName[ProviderName["LinkedIn"] = 10] = "LinkedIn";
    ProviderName[ProviderName["Yahoo"] = 11] = "Yahoo";
    ProviderName[ProviderName["Yandex"] = 12] = "Yandex";
    ProviderName[ProviderName["TencentQQ"] = 13] = "TencentQQ";
    ProviderName[ProviderName["Weibo"] = 14] = "Weibo";
    ProviderName[ProviderName["Youku"] = 15] = "Youku";
    ProviderName[ProviderName["TDC"] = 16] = "TDC";
    ProviderName[ProviderName["YesPay"] = 17] = "YesPay";
    ProviderName[ProviderName["PayEx"] = 18] = "PayEx";
    ProviderName[ProviderName["StreamingVideoProvider"] = 20] = "StreamingVideoProvider";
    ProviderName[ProviderName["Lodestone"] = 23] = "Lodestone";
    ProviderName[ProviderName["MLBAM"] = 24] = "MLBAM";
    ProviderName[ProviderName["OutBox"] = 25] = "OutBox";
    ProviderName[ProviderName["OptBank"] = 26] = "OptBank";
    ProviderName[ProviderName["EPay"] = 27] = "EPay";
    ProviderName[ProviderName["TNS"] = 28] = "TNS";
    ProviderName[ProviderName["WhatsApp"] = 29] = "WhatsApp";
    ProviderName[ProviderName["FourSquare"] = 30] = "FourSquare";
    ProviderName[ProviderName["YouTube"] = 31] = "YouTube";
    ProviderName[ProviderName["RoboTicket"] = 32] = "RoboTicket";
    ProviderName[ProviderName["SportSubs"] = 33] = "SportSubs";
    ProviderName[ProviderName["TopTix"] = 34] = "TopTix";
    ProviderName[ProviderName["PayPal"] = 35] = "PayPal";
    ProviderName[ProviderName["Forecast"] = 36] = "Forecast";
    ProviderName[ProviderName["OptimalPayments"] = 37] = "OptimalPayments";
    ProviderName[ProviderName["TicketMasterUK"] = 38] = "TicketMasterUK";
    ProviderName[ProviderName["Wirecard"] = 39] = "Wirecard";
    ProviderName[ProviderName["Passbook"] = 40] = "Passbook";
    ProviderName[ProviderName["GlobalProcessingService"] = 41] = "GlobalProcessingService";
    ProviderName[ProviderName["TradableBits"] = 42] = "TradableBits";
    ProviderName[ProviderName["CreditGuard"] = 43] = "CreditGuard";
    ProviderName[ProviderName["Ingenico"] = 44] = "Ingenico";
    ProviderName[ProviderName["SidelineSports"] = 45] = "SidelineSports";
    ProviderName[ProviderName["Awin"] = 46] = "Awin";
    ProviderName[ProviderName["ThreePAK"] = 47] = "ThreePAK";
    ProviderName[ProviderName["Stripe"] = 48] = "Stripe";
    ProviderName[ProviderName["FreedomPay"] = 49] = "FreedomPay";
    ProviderName[ProviderName["Paya"] = 50] = "Paya";
    ProviderName[ProviderName["Viemo"] = 51] = "Viemo";
    ProviderName[ProviderName["Twitch"] = 52] = "Twitch";
    ProviderName[ProviderName["Zoom"] = 53] = "Zoom";
    ProviderName[ProviderName["Boxcast"] = 54] = "Boxcast";
    ProviderName[ProviderName["Streamable"] = 55] = "Streamable";
    ProviderName[ProviderName["Incrowd"] = 56] = "Incrowd";
    ProviderName[ProviderName["UrbanZoo"] = 57] = "UrbanZoo";
    ProviderName[ProviderName["SAP"] = 58] = "SAP";
    ProviderName[ProviderName["TheFirstClub"] = 59] = "TheFirstClub";
    ProviderName[ProviderName["SportsAlliance"] = 60] = "SportsAlliance";
    ProviderName[ProviderName["StreamAMG"] = 61] = "StreamAMG";
    ProviderName[ProviderName["Rakuten"] = 62] = "Rakuten";
    ProviderName[ProviderName["Fidel"] = 63] = "Fidel";
    ProviderName[ProviderName["Partnerize"] = 64] = "Partnerize";
    ProviderName[ProviderName["EBay"] = 65] = "EBay";
    ProviderName[ProviderName["Impact"] = 66] = "Impact";
    ProviderName[ProviderName["OctopusEnergy"] = 67] = "OctopusEnergy";
    ProviderName[ProviderName["TheSupermarketingGroup"] = 68] = "TheSupermarketingGroup";
    ProviderName[ProviderName["Optomany"] = 69] = "Optomany";
    ProviderName[ProviderName["SmartPayFuse"] = 70] = "SmartPayFuse";
    ProviderName[ProviderName["SQWAD"] = 71] = "SQWAD";
    ProviderName[ProviderName["KeyCloak"] = 72] = "KeyCloak";
    ProviderName[ProviderName["SeatGeek"] = 73] = "SeatGeek";
    ProviderName[ProviderName["Secutix"] = 74] = "Secutix";
    ProviderName[ProviderName["Tappit"] = 75] = "Tappit";
    ProviderName[ProviderName["OtherMedia"] = 76] = "OtherMedia";
    ProviderName[ProviderName["GlobalPayments"] = 77] = "GlobalPayments";
    ProviderName[ProviderName["TradeDoubler"] = 78] = "TradeDoubler";
    ProviderName[ProviderName["GlobalPaymentsUK"] = 79] = "GlobalPaymentsUK";
    ProviderName[ProviderName["EnduranceZone"] = 80] = "EnduranceZone";
})(ProviderName || (ProviderName = {}));
var InputType;
(function (InputType) {
    InputType[InputType["Text"] = 1] = "Text";
    InputType[InputType["Password"] = 2] = "Password";
    InputType[InputType["Cookie"] = 3] = "Cookie";
    InputType[InputType["QueryString"] = 4] = "QueryString";
    InputType[InputType["Header"] = 5] = "Header";
    InputType[InputType["Hidden"] = 6] = "Hidden";
    InputType[InputType["Url"] = 7] = "Url";
    InputType[InputType["RequestData"] = 8] = "RequestData";
    InputType[InputType["Javascript"] = 9] = "Javascript";
})(InputType || (InputType = {}));

class UserContext {
}

// tslint:disable: variable-name
class CustomerTag {
    constructor(TagValue, TagId, TagName) {
        this.TagValue = TagValue;
        this.TagId = TagId;
        this.TagName = TagName;
    }
}

const USERCONTEXT_MOCK_FR = {
    userContext$: of({
        portalId: '',
        memberId: '',
        externalRef: '',
        populationId: '',
        populationName: '',
        clubId: 0,
        sessionId: '',
        lcid: '3084',
        status: 2,
        customerTags: [],
        clientType: 1,
        loginType: 4,
        clientAttribute: ''
    })
};
const MEMBER_DETAILS_MOCK = {
    PortalId: '',
    MemberId: '',
    ClubId: 0,
    TicketActionStatus: 0,
    Title: 'M',
    FirstName: 'FirstName',
    Surname: 'Surname',
    DOB: '',
    Gender: '',
    AddressType: 0,
    AddressName: 'Work',
    Street: 'Street',
    Town: 'Town',
    County: 'County',
    PostCode: 'WC1H 9LG',
    Country: 'United Kingdom',
    HomeNumber: '',
    OtherNumber: '',
    MobileNumber: '',
    EmailAddress1: '',
    EmailAddress2: '',
    LastUpdated: '',
    IsFirstTimeUser: false,
    IsAccountActive: true,
    CompanyName: 'Fortress GB',
    EntityUserLevel: 0,
    ExternalRefNumber: '',
    EventTypeId: '',
    Deleted: 0,
    LastLogin: '',
    ActivationDate: '',
    CreationDate: '',
    UpgradeDate: '',
    SpareExternalId: '',
    Username: '',
    CountyId: 0,
    CountryId: 0,
    UserAccountStatus: 0,
};

const MEMBERSHIP_OPTION_MOCK = [{
        MembershipOptionId: 1,
        ClubId: 1,
        DisplayName: '',
        PaymentType: 1,
        ShippingType: 1,
        AutoAssignBarcodeType: 1,
        Description: '',
        ProductId: 1,
        ProductType: 1,
        WizardType: 1,
        ImageUrl: null
    }];

var AutoAssignBarcodeType;
(function (AutoAssignBarcodeType) {
    AutoAssignBarcodeType[AutoAssignBarcodeType["DontAssign"] = 0] = "DontAssign";
    AutoAssignBarcodeType[AutoAssignBarcodeType["AutoAssignFree"] = 1] = "AutoAssignFree";
    AutoAssignBarcodeType[AutoAssignBarcodeType["AutoAssignPaid"] = 2] = "AutoAssignPaid";
})(AutoAssignBarcodeType || (AutoAssignBarcodeType = {}));

var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType[PaymentOptionType["Free"] = 0] = "Free";
    PaymentOptionType[PaymentOptionType["Paid"] = 1] = "Paid";
})(PaymentOptionType || (PaymentOptionType = {}));

var ShippingType;
(function (ShippingType) {
    ShippingType[ShippingType["Collection"] = 0] = "Collection";
    ShippingType[ShippingType["Shipping"] = 1] = "Shipping";
})(ShippingType || (ShippingType = {}));

var ProviderTranslationStatus;
(function (ProviderTranslationStatus) {
    ProviderTranslationStatus[ProviderTranslationStatus["Unknown"] = 0] = "Unknown";
    ProviderTranslationStatus[ProviderTranslationStatus["Active"] = 1] = "Active";
    ProviderTranslationStatus[ProviderTranslationStatus["Inactive"] = 2] = "Inactive";
})(ProviderTranslationStatus || (ProviderTranslationStatus = {}));

const config = Object.freeze(window['config']);
// This is used to inject configuration into spec files for unit testing.
const configMock = {
    version: '',
    logging: '', // debug, info, warning, error, none
    portalUrl: '',
    baseApiUrl: '',
    contentUrl: '',
    languages: ['en-GB'], // default first
    defaultLcid: '2057',
    defaultClubId: 1,
    googleAnalyticsTag: '',
    googleMapsAPIKey: '',
    purseConfig: {
        ecash: 1,
        cashBack: 2,
        combined: 3,
        virtualEcash: 4,
        renewalGift: 5,
        virtualLoyalty: 6,
        lifetimeLoyalty: 7,
        corporateGift: 8,
    },
};

class Guid {
    constructor(guid) {
        this.toString = () => {
            return this.guid;
        };
        this.guid = guid || this.generateNewGuid();
    }
    generateNewGuid() {
        let result;
        let i;
        let j;
        result = '';
        for (j = 0; j < 32; j++) {
            if (j === 8 || j === 12 || j === 16 || j === 20) {
                result = result + '-';
            }
            i = Math.floor(Math.random() * 16)
                .toString(16)
                .toUpperCase();
            result = result + i;
        }
        return result;
    }
}

let MemberStore = class MemberStore extends EntityStore {
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberStore, providedIn: 'root' }); }
};
MemberStore = __decorate([
    StoreConfig({ name: 'member', cache: { ttl: 30000 } })
], MemberStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class LoggingService {
    constructor() {
        this.defaultLogLevel = LogLevel.Warning;
        const logLevelConfigValue = (config.logging || LogLevel[this.defaultLogLevel]).toString();
        if (!config.logging) {
            console.warn(`No log level specific in config.js, defaulting to '${LogLevel[this.defaultLogLevel]}'.`);
        }
        let logLevel = this.getLogLevel(logLevelConfigValue);
        if (logLevel === undefined) {
            console.warn(`Failed to parse log level from the provided vale of '${config.logging || ''}' in config.js, defaulting to '${LogLevel[this.defaultLogLevel]}'.`);
            logLevel = this.defaultLogLevel;
        }
        this.logLevel = logLevel;
    }
    /** Log a debug-level message and any associated objects to the browser console. */
    debug(message, ...objects) {
        if (this.logLevel > LogLevel.Debug) {
            return;
        }
        if (typeof message === 'string' && objects && objects.length > 0) {
            console.log(message, ...objects);
        }
        else {
            console.log(message);
        }
    }
    /** Log an info-level message and any associated objects to the browser console. */
    info(message, ...objects) {
        if (this.logLevel > LogLevel.Info) {
            return;
        }
        if (typeof message === 'string' && objects && objects.length > 0) {
            console.log(message, ...objects);
        }
        else {
            console.log(message);
        }
    }
    /** Log a warning-level message and any associated objects to the browser console. */
    warning(message, ...objects) {
        if (this.logLevel > LogLevel.Warning) {
            return;
        }
        if (typeof message === 'string' && objects && objects.length > 0) {
            console.warn(message, ...objects);
        }
        else {
            console.warn(message);
        }
    }
    /** Log an error-level message and any associated objects to the browser console. */
    error(message, ...objects) {
        if (this.logLevel > LogLevel.Error) {
            return;
        }
        if (typeof message === 'string' && objects && objects.length > 0) {
            console.error(message, ...objects);
        }
        else {
            console.error(message);
        }
    }
    /** Gets a LogLevel value from a configuration string value. */
    getLogLevel(logLevel) {
        // Trim spaces from the ends to account for user error
        logLevel = logLevel.trim();
        // Capitalises the first letter and makes the rest lowercase, to match the enum value
        logLevel = logLevel.charAt(0).toUpperCase() + logLevel.slice(1).toLowerCase();
        // Cast to the keys of the enum and get an enum value if possible
        let logLevelEnumKeyValue = logLevel;
        return LogLevel[logLevelEnumKeyValue];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoggingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoggingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });
var LogLevel;
(function (LogLevel) {
    /** Allows logging of all messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Allows logging of info, warning and error messages. */
    LogLevel[LogLevel["Info"] = 2] = "Info";
    /** Allows logging of warning and error messages. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Allows logging of error messages only. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Disables all logging. */
    LogLevel[LogLevel["None"] = 999] = "None";
})(LogLevel || (LogLevel = {}));

class MemberQuery extends QueryEntity {
    constructor(store, loggingService) {
        super(store);
        this.store = store;
        this.loggingService = loggingService;
        this.userContext$ = this.select((state) => state.user);
    }
    /** Gets the current user's member details. */
    selectMemberDetails() {
        return this.selectFirst();
    }
    /** Get the user context of the currently logged in user. */
    getUserContext() {
        const context = this.getValue().user;
        if (context) {
            return context;
        }
        else {
            this.loggingService.error('user context referenced before login');
            throw new Error('user context referenced before login');
        }
    }
    getPortalId() {
        return this.getValue().user?.portalId;
    }
    /** Get the loginType of the currently logged in user. */
    getLoginType() {
        return this.getUserContext().loginType;
    }
    /** Get the clientType of the currently logged in user. */
    getClientType() {
        return this.getUserContext().clientType;
    }
    /** Get the population ID of the currently logged in user. */
    getPopulationId() {
        return +this.getUserContext().populationId;
    }
    /** Get the population name of the currently logged in user. */
    getPopulationName() {
        return this.getUserContext().populationName;
    }
    /** Get the list of available accounts from translation that the user can log into. */
    getAvailableAccounts() {
        return this.getValue().availableAccounts;
    }
    /** Get the club ID of the currently logged in user. */
    getClubId() {
        return this.getUserContext().clubId;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberQuery, deps: [{ token: MemberStore }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberStore }, { type: LoggingService }] });

class ApiService {
    constructor(http, jwtService, memberQuery) {
        this.http = http;
        this.jwtService = jwtService;
        this.memberQuery = memberQuery;
    }
    getHeaders() {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let refreshToken = localStorage.getItem('refresh');
        let sessionStorageSessionId = sessionStorage.getItem('SessionId');
        if (refreshToken) {
            const decodedRefreshToken = this.jwtService.decodeToken(refreshToken);
            if (decodedRefreshToken) {
                let sessionId = decodedRefreshToken.login_id;
                if (sessionId) {
                    headers = headers.append('SessionId', sessionId);
                }
            }
        }
        else if (sessionStorageSessionId !== null) {
            headers = headers.append('SessionId', sessionStorageSessionId);
        }
        else {
            let sessionId = new Guid().toString();
            sessionStorage.setItem('SessionId', sessionId);
            headers = headers.append('SessionId', sessionId);
        }
        let token = localStorage.getItem('token');
        if (token) {
            headers = headers.append('Authorization', `Bearer ${token}`);
        }
        let lcid = localStorage.getItem('lcid');
        if (lcid === null) {
            try {
                lcid = this.memberQuery.getUserContext().lcid;
                localStorage.setItem('lcid', lcid);
            }
            catch (error) {
                lcid = config.defaultLcid;
            }
        }
        headers = headers.append('X-Fortress-LCID', lcid);
        return headers;
    }
    /** Gets an observable of type specified from baseUrl/entity/childRoute */
    getChildData(entity, childRoute) {
        return this.http.get(`${config.baseApiUrl}/api/${entity}/${childRoute}`, { headers: this.getHeaders() }).pipe(share());
    }
    /** Returns an observable array of type specified from baseUrl/entity */
    get(entity) {
        return this.http.get(`${config.baseApiUrl}/api/${entity}`, { headers: this.getHeaders() }).pipe(share());
    }
    /** Returns an observable of type specified from baseUrl/entity */
    getAnySingle(entity) {
        return this.http.get(`${config.baseApiUrl}/api/${entity}`, { headers: this.getHeaders() }).pipe(share());
    }
    /** Returns an observable array of type specified from baseUrl/entity */
    getForParent(parentEntity, parentId, childEntity) {
        return this.http
            .get(`${config.baseApiUrl}/api/${parentEntity}/${parentId}/${childEntity}`, {
            headers: this.getHeaders(),
        })
            .pipe(share());
    }
    /** Returns an observable of type specified from baseUrl/entity/id */
    getById(entity, id, queryParams) {
        return this.http
            .get(`${config.baseApiUrl}/api/${entity}/${id}`, { headers: this.getHeaders(), params: queryParams })
            .pipe(share());
    }
    /** Posts the given item to baseUrl/entity and returns an observable of the same type */
    post(entity, item, queryParams) {
        return this.http.post(`${config.baseApiUrl}/api/${entity}`, item, { headers: this.getHeaders(), params: queryParams });
    }
    /** Posts the given item array to baseUrl/entity and returns an observable of the same type */
    postWithArray(entity, item) {
        return this.http.post(`${config.baseApiUrl}/api/${entity}`, item, { headers: this.getHeaders() });
    }
    /** Posts the given item to baseUrl/entity and returns an observable of the same type */
    postForParent(parentEntity, parentId, childEntity, item) {
        return this.http.post(`${config.baseApiUrl}/api/${parentEntity}/${parentId}/${childEntity}`, item, {
            headers: this.getHeaders(),
        });
    }
    /** Puts the given item to baseUrl/entity/id and returns an observable of the same type */
    put(entity, id, item) {
        return this.http.put(`${config.baseApiUrl}/api/${entity}/${id}`, item, { headers: this.getHeaders() });
    }
    /** Sends a delete request to baseUrl/entity/id */
    delete(entity, id) {
        return this.http.delete(`${config.baseApiUrl}/api/${entity}/${id}`, { headers: this.getHeaders() });
    }
    setCardId(id) {
        this.cardId = id;
    }
    getFile(entity) {
        let headers = this.getHeaders();
        headers = headers.delete('Content-Type');
        return this.http.get(`${config.baseApiUrl}/api/${entity}`, { headers: headers, responseType: 'blob' }).pipe(share());
    }
    uploadForm(entity, formData) {
        let headers = this.getHeaders();
        headers = headers.delete('Content-Type');
        return this.http.post(`${config.baseApiUrl}/api/${entity}`, formData, { headers: headers, observe: 'events' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ApiService, deps: [{ token: i1.HttpClient }, { token: i4.JwtHelperService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i4.JwtHelperService }, { type: MemberQuery }] });

class CustomDataSetService {
    constructor(api, logService) {
        this.api = api;
        this.logService = logService;
    }
    GetCustomDataSet(dataId) {
        this.logService.debug('Getting custom dataset', dataId);
        return this.api.get('customDataSet/' + dataId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CustomDataSetService, deps: [{ token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CustomDataSetService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CustomDataSetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: LoggingService }] });

class ProviderService {
    constructor(api) {
        this.api = api;
    }
    ConnectToProvider(providerId, divName) {
        this.api.getAnySingle('Provider/' + providerId + '/Connect').subscribe(providerResponse => {
            let hasHiddens = providerResponse.OutputFields.find(x => x.InputType === InputType.Hidden);
            let hasUrl = providerResponse.OutputFields.find(x => x.InputType === InputType.Url);
            let hasQuery = providerResponse.OutputFields.find(x => x.InputType === InputType.QueryString);
            let hasJavascript = providerResponse.OutputFields.find(x => x.InputType === InputType.Javascript);
            if ((hasHiddens != null || hasQuery != null) && hasUrl != null) {
                let pageForm = document.getElementById(divName);
                if (pageForm) {
                    pageForm.innerHTML = '<form action="' + hasUrl.Value + '" method="post" name="form" id="SingleSignOnRedirect">';
                    providerResponse.OutputFields.forEach(element => {
                        if (element.InputType === InputType.Hidden && pageForm) {
                            pageForm.innerHTML += '\n<input type="hidden" name="' + element.FieldName + '" value="' + element.Value + '" />';
                        }
                    });
                    pageForm.innerHTML += '</form>';
                }
                let renderForm = document.getElementById('SingleSignOnRedirect');
                renderForm.submit();
                return;
            }
            else if (hasJavascript != null) {
                // javascript details
                // System.Text.StringBuilder javascriptStringBuilder = new System.Text.StringBuilder();
                // foreach (Fortress.Models.Portal.Auth.Inputs.InputField item in returnResult.OutputFields.FindAll(x => x.InputType == Models.Portal.Auth.Inputs.InputType.Javascript))
                // {
                //     javascriptStringBuilder.Append("\n" + item.Value);
                // }
                // return Content(javascriptStringBuilder.ToString());
            }
            else if (hasQuery != null) {
                window.location.href = hasQuery.Value;
                return;
            }
            else if (hasUrl != null) {
                window.location.href = hasUrl.Value;
                return;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProviderService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProviderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProviderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }] });

class MemberService {
    constructor(memberStore, memberQuery, api, jwtHelper, logService) {
        this.memberStore = memberStore;
        this.memberQuery = memberQuery;
        this.api = api;
        this.jwtHelper = jwtHelper;
        this.logService = logService;
    }
    /** Fetches the member details and puts them in the store. */
    fetchMemberDetails() {
        this.memberStore.setLoading(true);
        let user = this.memberQuery.getValue().user;
        // if no user is returned from the store, get memberId from the token
        if (!user) {
            let accessToken = localStorage.getItem('token');
            let refreshToken = localStorage.getItem('refresh');
            if (accessToken && refreshToken) {
                if (!this.jwtHelper.isTokenExpired(refreshToken)) {
                    let decodedToken = this.jwtHelper.decodeToken(accessToken);
                    user = new UserContext();
                    user.memberId = decodedToken.member_id;
                }
            }
            else {
                this.logService.warning('Failed to get member details as the user is not logged in.');
                return of(null);
            }
        }
        const request$ = this.api.getById('members', user.memberId).pipe(tap((details) => this.memberStore.set([details])), mapTo(null));
        return this.memberQuery.getHasCache() ? of(null) : request$;
    }
    /** Update member details */
    updateMemberDetails(portalId, memberDetails) {
        this.api.put('members', portalId, memberDetails).toPromise();
        this.memberStore.set([memberDetails]);
    }
    /** Update member and return api request observable */
    updateMemberDetailsAsync(portalId, memberDetails) {
        return this.api.put('members', portalId, memberDetails);
    }
    /** Update the user context in the store. */
    setUserContext(user) {
        this.logService.debug('Setting user context', user);
        this.memberStore.update({ user });
    }
    setPopulation(populationId) {
        this.memberStore.update((state) => ({ ...state, user: { ...state.user, populationId } }));
    }
    setLcid(lcid) {
        const promise = firstValueFrom(this.api.post('members/changelocale/' + lcid, undefined));
        promise.then(() => {
            localStorage.setItem('lcid', lcid.toString());
            this.memberStore.update((state) => ({ ...state, user: { ...state.user, lcid: lcid.toString() } }));
        });
        return promise;
    }
    /** Update the available accounts for the user to choose from in the store. */
    setAvailableAccounts(availableAccounts) {
        this.logService.debug('Settings available accounts', availableAccounts);
        this.memberStore.update({ availableAccounts });
    }
    resetPassword(email, clubId) {
        let lcid = localStorage.getItem('lcid');
        const resetFormBody = {
            Username: email,
            Lcid: lcid,
            ClubId: clubId,
        };
        return this.api.post(`members/resetpassword?providerName=${ProviderName.Fortress}`, resetFormBody).toPromise();
    }
    changePassword(resetKey, unhashedPassword, passwordConfirmation) {
        return this.api
            .post(`members/resetpasswordbyresetkey?resetKey=${resetKey}&unhashedPassword=${unhashedPassword}&passwordConfirmation=${passwordConfirmation}`, {})
            .toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberService, deps: [{ token: MemberStore }, { token: MemberQuery }, { token: ApiService }, { token: i4.JwtHelperService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberStore }, { type: MemberQuery }, { type: ApiService }, { type: i4.JwtHelperService }, { type: LoggingService }] });

var MlbamLoginResponseStatus;
(function (MlbamLoginResponseStatus) {
    MlbamLoginResponseStatus[MlbamLoginResponseStatus["Login"] = 1] = "Login";
    MlbamLoginResponseStatus[MlbamLoginResponseStatus["AccountList"] = 2] = "AccountList";
    MlbamLoginResponseStatus[MlbamLoginResponseStatus["CreateAccount"] = 3] = "CreateAccount";
})(MlbamLoginResponseStatus || (MlbamLoginResponseStatus = {}));

/**
 * A factory function that creates MemberCard
 */
function createMemberCard(params) {
    return {};
}
function wipeBalance(memberCard) {
    const { AvailableBalance, ...props } = memberCard;
    return { ...props, AvailableBalance: 0 };
}

let MemberCardStore = class MemberCardStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardStore, providedIn: 'root' }); }
};
MemberCardStore = __decorate([
    StoreConfig({ name: 'member-card', idKey: 'MemberId' })
], MemberCardStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let BalanceStore = class BalanceStore extends EntityStore {
    constructor() {
        super();
    }
    akitaPreAddEntity(balance) {
        return {
            ...balance,
            id: [balance.memberId, balance.purseId].join('-')
        };
    }
    akitaPreCheckEntity(balance) {
        return {
            ...balance,
            id: [balance.memberId, balance.purseId].join('-')
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceStore, providedIn: 'root' }); }
};
BalanceStore = __decorate([
    StoreConfig({ name: 'balance', idKey: 'id' })
], BalanceStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BalanceQuery extends QueryEntity {
    constructor(store, memberQuery) {
        super(store);
        this.store = store;
        this.memberQuery = memberQuery;
    }
    selectPurse(purse, memberId) {
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        return this.selectEntity([memberId, purse].join('-'), 'balance');
    }
    selectBalancesByPurse(purse) {
        return this.selectAll({ filterBy: (balance) => balance.purseId === purse });
    }
    selectBalancesByMember(memberId) {
        return this.selectAll({ filterBy: (balance) => balance.memberId === memberId });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceQuery, deps: [{ token: BalanceStore }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BalanceStore }, { type: MemberQuery }] });

class MemberCardQuery extends QueryEntity {
    constructor(store, balanceQuery, memberQuery) {
        super(store);
        this.store = store;
        this.balanceQuery = balanceQuery;
        this.memberQuery = memberQuery;
    }
    selectCurrentCard() {
        return this.selectEntity(this.memberQuery.getUserContext().memberId);
    }
    selectObservedMemberCard() {
        return this.memberQuery
            .select((state) => (state.user ? state.user.memberId : 0))
            .pipe(switchMap((id) => this.selectEntity(id)));
    }
    selectUserInProductCodes(productCodes) {
        return this.selectCurrentCard().pipe(map((cc) => {
            if (cc) {
                return productCodes.includes(cc.ProductCode) || productCodes.includes(cc.ProductCodeDisplayName);
            }
            else {
                return false;
            }
        }));
    }
    selectCardWithBalance(purse, memberId = '') {
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        return combineQueries([this.selectEntity(memberId), this.balanceQuery.selectPurse(purse, memberId)]).pipe(map(([memberCard, balance]) => {
            if (memberCard && balance) {
                return { ...memberCard, AvailableBalance: balance };
            }
            else {
                return undefined;
            }
        }));
    }
    selectCardsWithBalance(purse) {
        return combineQueries([this.selectAll(), this.balanceQuery.selectBalancesByPurse(purse)]).pipe(map(([memberCards, balances]) => {
            return memberCards.map((memberCard) => {
                let balance = balances.find((b) => b.memberId === memberCard.MemberId);
                return {
                    ...memberCard,
                    AvailableBalance: balance ? balance.balance : 0,
                };
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardQuery, deps: [{ token: MemberCardStore }, { token: BalanceQuery }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberCardStore }, { type: BalanceQuery }, { type: MemberQuery }] });

class MemberCardService {
    constructor(memberCardStore, balanceStore, api, memberQuery, loggingService, memberCardQuery) {
        this.memberCardStore = memberCardStore;
        this.balanceStore = balanceStore;
        this.api = api;
        this.memberQuery = memberQuery;
        this.loggingService = loggingService;
        this.memberCardQuery = memberCardQuery;
    }
    /** put cards into the store. Will retrieve balances if purse number is included */
    fetchCards(purse) {
        let withoutBalance = this.api.get('cards').pipe(tap(this.memberCardStore.upsertMany));
        let withBalance = this.api.get('cards/withbalance/' + purse).pipe(tap(cards => {
            // update the balances
            let balances = cards.map(card => ({ purseId: purse, memberId: card.MemberId, balance: card.AvailableBalance }));
            this.balanceStore.upsertMany(balances);
        }), map(cards => cards.map(card => wipeBalance(card))), tap(cards => this.memberCardStore.upsertMany(cards)));
        return iif(() => !!purse, withBalance, withoutBalance).pipe(mapTo('from server'));
    }
    setProductCode(productCode) {
        this.memberCardStore.update(this.memberQuery.getUserContext().memberId, entity => ({ ...entity, ProductCode: productCode }));
    }
    clearCacheAndFetchNewCards() {
        this.memberCardStore.setHasCache(false);
        this.fetchCards().toPromise();
    }
    /** get a single card from the store. will update balance if purse is specified. without memberId will default to current user's card */
    fetchCard(purse, memberId) {
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        let card$ = this.api.getAnySingle(`Members/${memberId}/card/${purse || 1}`).pipe(tap(card => {
            if (card == null) {
                this.loggingService.error('null MemberCard returned from API');
            }
            else {
                this.memberCardStore.remove(this.memberCardQuery.getAll().map(x => x.MemberId));
                this.memberCardStore.upsert(memberId, card);
            }
        }));
        if (purse) {
            card$ = card$.pipe(tap(card => this.balanceStore.update([memberId, purse].join('-'), { balance: card.AvailableBalance })));
        }
        return card$.pipe(mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardService, deps: [{ token: MemberCardStore }, { token: BalanceStore }, { token: ApiService }, { token: MemberQuery }, { token: LoggingService }, { token: MemberCardQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberCardStore }, { type: BalanceStore }, { type: ApiService }, { type: MemberQuery }, { type: LoggingService }, { type: MemberCardQuery }] });

let ChildStore = class ChildStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildStore, providedIn: 'root' }); }
};
ChildStore = __decorate([
    StoreConfig({ name: 'child', idKey: 'Id', cache: { ttl: 20000 } })
], ChildStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let ChildQuery = class ChildQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
        this.isLoaded$ = this.select(state => state.loaded);
    }
    /** Whether the current account is a guardian or not. */
    isGuardian() {
        return !!this.getValue().guardian;
    }
    /** Selects the current account's guardian or null if none exists */
    selectGuardian() {
        return this.select(childState => childState.guardian);
    }
    /** Gets the guardian ID of the current account. */
    getGuardianId() {
        return this.isGuardian() ? this.getValue().guardian.Id : NaN;
    }
    /** All children. */
    selectChildren() {
        return this.selectAll();
    }
    /** Children with free memberships. */
    selectFree() {
        return this.selectAll({ filterBy: child => child.MembershipOption.PaymentType === PaymentOptionType.Free });
    }
    selectChildLimitCount() {
        return this.getValue().childLimit;
    }
    getChildrenInfo() {
        return this.select(state => {
            const limit = state.childLimit || 0;
            const children = this.getAll();
            let empty = [];
            const len = limit - children.length;
            if (len > 0) {
                empty = new Array(len);
            }
            return {
                data: children,
                free: children.filter((y) => y.MembershipOption.PaymentType === PaymentOptionType.Free),
                empty,
                limit
            };
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildQuery, deps: [{ token: ChildStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildQuery, providedIn: 'root' }); }
};
ChildQuery = __decorate([
    QueryConfig({ sortBy: 'Id', sortByOrder: Order.ASC })
], ChildQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ChildStore }] });

class ErrorStateService {
    constructor() {
        this.errorSubject = new BehaviorSubject('');
        this.error$ = this.errorSubject.asObservable();
        this.errors = [];
    }
    hasErrors() {
        return this.errors && this.errors.length > 0;
    }
    addError(error) {
        this.errors.push(error);
    }
    clearErrors() {
        this.errors = [];
    }
    setError(error) {
        if (!this.isEmpty) {
            clearTimeout(this.timeout);
        }
        this.errorSubject.next(error);
        return {
            // clear the error after a certain amount of time, default is 3 seconds
            clearAfter: (timeout = 3000) => {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.clear();
                }, timeout);
            }
        };
    }
    clear() {
        this.errorSubject.next('');
    }
    get isEmpty() {
        return this.errorSubject.getValue() === '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ErrorStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ErrorStateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ErrorStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class ChildService {
    constructor(childStore, childQuery, api, logService, errorService, memberQuery) {
        this.childStore = childStore;
        this.childQuery = childQuery;
        this.api = api;
        this.logService = logService;
        this.errorService = errorService;
        this.memberQuery = memberQuery;
    }
    /** Fetches the children and puts them in the store. */
    fetchChildren() {
        this.childStore.setLoading(true);
        const request$ = this.api.get('guardian/children').pipe(tap((children) => {
            this.childStore.set(children);
            this.childStore.update({ loaded: true });
        }), mapTo(null), finalize(() => this.childStore.setLoading(false)));
        return this.childQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetch the current member's guardian information from the API and update the store's state. */
    fetchGuardian() {
        return this.api.getAnySingle('guardian').pipe(tap((guardian) => this.childStore.update({ guardian })), mapTo(null));
    }
    /** Fetch child details using child member id*/
    fetchChildByChildMemberId(childMemberId) {
        return this.api.getAnySingle(`guardian/childdetails/${childMemberId}`);
    }
    /** Fetch the max amount of children a guardian can add to their profile. */
    fetchChildCountLimit() {
        return this.api.getAnySingle('guardian/childcountlimit').pipe(tap((limit) => this.childStore.update({ childLimit: limit })), mapTo(null));
    }
    /** Make a request to register the current account as a guardian. */
    registerAsGuardian() {
        const memberId = this.memberQuery.getUserContext().memberId;
        if (!memberId) {
            this.logService.error('Member ID could not be found for registering as a guardian.');
            this.errorService.addError('Something went wrong, please try again.');
            return of(null);
        }
        let body = JSON.stringify(memberId);
        return this.api.post('guardian/register', body).pipe(switchMap(() => this.fetchGuardian()));
    }
    /** Make a request to print the child card with the new barcode */
    lostCard(childId, barcode) {
        return this.api.post(`guardian/lostcard/${childId}/${barcode}`, null).toPromise();
    }
    /**
     * Make a request to print the child card with the new barcode
     * @deprecated use the standard lostCard which returns as a promise
     */
    lostCardObservable(childId, barcode) {
        return this.api.post(`guardian/lostcard/${childId}/${barcode}`, null);
    }
    /** Make a request to get list of attendance  */
    attendance() {
        return this.api.get(`guardian/children/attendance`);
    }
    /** Make a request to get the chick-in Attendance */
    checkInAttendance(memberId = '') {
        if (memberId === '') {
            memberId = this.memberQuery.getUserContext().memberId;
        }
        return this.api.get(`guardian/children/checkinattendance/${memberId}`);
    }
    /** This endpoint is used to return create a guardian link request */
    linkRequest(memberId, lastName, dateOfBirth, externalRefNumber = '') {
        const request = encodeURI(`memberId=` + memberId + '&lastName=' + lastName + '&dateOfBirth=' + dateOfBirth + '&externalRefNumber=' + externalRefNumber);
        return this.api.post(`guardian/linkrequest?` + request, null).toPromise();
    }
    /** This endpoint is used to complete the link request */
    processLinkRequest(linkCode) {
        return this.api.post(`guardian/linkrequest/${linkCode}`, null).toPromise();
    }
    /** This endpoint is used to delete guardian link request */
    deleteLinkRequest(memberId) {
        return this.api.delete(`guardian/linkrequest/`, memberId).toPromise();
    }
    /** This endpoint is used to return a list of children, connected and pending child   */
    getLinkRequests() {
        return this.api.get(`guardian/linkrequests`);
    }
    /**
     * This will disable cache of the child store, so
     * that a fetch can be made again.
     */
    disableChildStoreCache() {
        this.childStore.setHasCache(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildService, deps: [{ token: ChildStore }, { token: ChildQuery }, { token: ApiService }, { token: LoggingService }, { token: ErrorStateService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ChildService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ChildStore }, { type: ChildQuery }, { type: ApiService }, { type: LoggingService }, { type: ErrorStateService }, { type: MemberQuery }] });

let CardStore = class CardStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardStore, providedIn: 'root' }); }
};
CardStore = __decorate([
    StoreConfig({ name: 'Card', idKey: 'ACN', cache: { ttl: 20000 } })
], CardStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let CardQuery = class CardQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All Cards. */
    selectCards() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardQuery, deps: [{ token: CardStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardQuery, providedIn: 'root' }); }
};
CardQuery = __decorate([
    QueryConfig({ sortBy: 'MemberId', sortByOrder: Order.ASC })
], CardQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardStore }] });

class CardService {
    constructor(cardStore, cardQuery, api) {
        this.cardStore = cardStore;
        this.cardQuery = cardQuery;
        this.api = api;
    }
    /** Fetches the Cards and puts them in the store. */
    fetchCards() {
        this.cardStore.setLoading(true);
        const request$ = this.api.get('cards').pipe(tap(cards => this.cardStore.set(cards)), mapTo(null));
        return this.cardQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardService, deps: [{ token: CardStore }, { token: CardQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardStore }, { type: CardQuery }, { type: ApiService }] });

/**
 * @deprecated PopulationStore no longer used as population data is not being kept in stores
 * - Population data should come from the user's JWT and accessible via the MemberQuery
 * - Retained for backwards compatibility
 */
let PopulationStore = class PopulationStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationStore, providedIn: 'root' }); }
};
PopulationStore = __decorate([
    StoreConfig({ name: 'population', idKey: 'PopulationId' })
], PopulationStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class PopulationService {
    constructor(populationStore, api) {
        this.populationStore = populationStore;
        this.api = api;
    }
    fetchPopulations(clubId = 1) {
        return this.api.get(`populations/${clubId}`).pipe(tap(x => this.populationStore.set(x)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationService, deps: [{ token: PopulationStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PopulationStore }, { type: ApiService }] });

class PopulationQuery extends QueryEntity {
    constructor(store, memberQuery, logger) {
        super(store);
        this.store = store;
        this.memberQuery = memberQuery;
        this.logger = logger;
    }
    selectUserInPopulation(populationNames) {
        return this.memberQuery
            .select((state) => (state.user ? state.user.populationId : 0))
            .pipe(map((pop) => {
            if (!pop) {
                return false;
            }
            return populationNames.includes(pop);
        }));
    }
    selectUserNotInPopulation(populationNames) {
        return this.selectUserInPopulation(populationNames).pipe(map((isIn) => !isIn));
    }
    userInPopulation(populationNames = []) {
        const population = this.memberQuery.getPopulationName();
        if (!population) {
            return false;
        }
        return populationNames.includes(population);
    }
    userNotInPopulation(populationNames) {
        return !this.userInPopulation(populationNames);
    }
    getCurrentPopulation() {
        const user = this.memberQuery.getUserContext();
        var pop = { PopulationId: parseInt(user.populationId), DisplayName: user.populationName, Description: user.populationName, ClubId: user.clubId };
        return pop;
    }
    /**
   * @deprecated selects current population from deprecated PopulationStore
   */
    selectCurrentPopulation() {
        return this.memberQuery
            .select((state) => (state.user ? state.user.populationId : 0))
            .pipe(switchMap((id) => this.selectEntity(id)));
    }
    /**
   * @deprecated selects current population name from deprecated PopulationStore
   */
    selectCurrentPopulationDisplayName() {
        return this.selectCurrentPopulation().pipe(map((p) => {
            if (!p) {
                return undefined;
            }
            return p.DisplayName;
        }));
    }
    /**
   * @deprecated selects all current population names from deprecated PopulationStore
   */
    selectPopulations(populationNames) {
        return this.selectAll().pipe(map((pops) => pops.map((pop) => pop.DisplayName)), tap((pops) => {
            populationNames.forEach((x) => {
                if (!pops.includes(x)) {
                    this.logger.error(`the population ${x} is not configured in the database`);
                }
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationQuery, deps: [{ token: PopulationStore }, { token: MemberQuery }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PopulationStore }, { type: MemberQuery }, { type: LoggingService }] });

class AuthService {
    constructor(jwtHelper, api, logService, cookieService, datepipe, memberService, router, memberCardService, memberStore, childService, childStore, cardService, cardStore, memberQuery, populationService, populationQuery) {
        this.jwtHelper = jwtHelper;
        this.api = api;
        this.logService = logService;
        this.cookieService = cookieService;
        this.datepipe = datepipe;
        this.memberService = memberService;
        this.router = router;
        this.memberCardService = memberCardService;
        this.memberStore = memberStore;
        this.childService = childService;
        this.childStore = childStore;
        this.cardService = cardService;
        this.cardStore = cardStore;
        this.memberQuery = memberQuery;
        this.populationService = populationService;
        this.populationQuery = populationQuery;
    }
    /** Check if a user is authenticated. */
    isAuthenticated() {
        if (this.hasAccessToken() && this.hasCurrentRefreshToken()) {
            return true;
        }
        else {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            return false;
        }
    }
    /** Check if api is in maintenance mode or having other issues. */
    checkApiStatus(clubId = 1) {
        this.checkMaintenceMode().subscribe((result) => {
            this.logService.info('API Available');
        }, (error) => {
            if (error.status === 503) {
                this.logService.warning('503 [Service Unavailable] received; Maintenance mode is probably on', error);
                this.router.navigate(['maintenance']);
            }
            else {
                this.logService.error('500 [Internal API Error] received', error);
                this.router.navigate(['maintenance']);
            }
        });
    }
    checkMaintenceMode(clubId = 1) {
        return this.api.get(`service/status/${clubId}`);
    }
    /** Check if the user has an access token. */
    hasAccessToken() {
        const token = this.getAccessToken();
        if (token) {
            if (!this.memberQuery.getValue().user) {
                let user = this._makeUserContext(token);
                /**
                 * If the user has picked a locale already we should use that
                 */
                const lcid = localStorage.getItem('lcid');
                if (lcid) {
                    user.lcid = lcid;
                }
                this.memberService.setUserContext(user);
            }
            return true;
        }
        else {
            return false;
        }
    }
    /** Check if the user has a valid refresh token. */
    hasCurrentRefreshToken() {
        const token = localStorage.getItem('refresh');
        if (token) {
            return !this.jwtHelper.isTokenExpired(token);
        }
        else {
            return false;
        }
    }
    /** Make a request to refresh the curent user's access token using the refresh token. */
    refreshAccessToken() {
        const token = localStorage.getItem('refresh');
        return this.api.post('token/refresh', `"${token}"`).pipe(tap((response) => {
            let token = this.jwtHelper.decodeToken(response.AccessToken);
            localStorage.setItem('token', response.AccessToken);
            localStorage.setItem('refresh', response.RefreshToken);
            localStorage.setItem('lcid', token.lcid);
        }));
    }
    /** Login as a user without a username and password. */
    ssoLogin(entityType, entity, loginDate, hashedValue, clubId, loginType, returnUrl, providerId, clientTypeId, locale, clientAttribute) {
        if (loginType !== undefined && isNaN(loginType)) {
            loginType = 1;
        }
        if (providerId !== undefined && isNaN(providerId)) {
            providerId = -1;
        }
        if (clientTypeId !== undefined && isNaN(clientTypeId)) {
            clientTypeId = 0;
        }
        let params = new HttpParams();
        if (locale) {
            params = params.append('locale', locale);
        }
        if (clientAttribute) {
            params = params.append('ClientAttribute', clientAttribute);
        }
        this.logService.debug('Logging on with SSO', {
            entityType,
            entity,
            loginDate,
            hashedValue,
            clubId,
            loginType,
            returnUrl,
            providerId,
            clientTypeId,
            locale,
            clientAttribute
        });
        return this.api
            .post('sso/validatesso?entityType=' +
            entityType +
            '&entity=' +
            entity +
            '&loginDate=' +
            this.datepipe.transform(loginDate, 'yyyy-MM-dd HH:mm:ss') +
            '&hashedValue=' +
            hashedValue +
            '&clubId=' +
            clubId +
            '&loginType=' +
            loginType +
            '&returnUrl=' +
            returnUrl +
            '&providerId=' +
            providerId +
            '&clientTypeId=' +
            clientTypeId, {}, params)
            .pipe(tap((authResponse) => {
            if (authResponse) {
                const accessToken = authResponse.AccessToken;
                this.loginUsingToken(accessToken, authResponse.RefreshToken);
            }
        }));
    }
    /** Returns a observable of Logging into third party */
    loginThirdPartyObservable(providerId, clubId, options) {
        this.logService.info('Attempting to log off to ', providerId);
        return this.api.post(`provider/thirdpartyoff/${clubId}/${providerId}`, options);
    }
    /** Logs into the third party */
    loginThirdParty(providerId, clubId, elementName = '', openInNewWindow = false, options = []) {
        this.loginThirdPartyObservable(providerId, clubId, options)
            .pipe(tap((data) => {
            let outputs = data;
            const hasHiddens = outputs.find((x) => x.InputType == InputType.Hidden);
            const hasUrl = outputs.find((x) => x.InputType == InputType.Url);
            const hasQuery = outputs.find((x) => x.InputType == InputType.QueryString);
            const hasJavascript = outputs.find((x) => x.InputType == InputType.Javascript);
            let target = '_self';
            if (openInNewWindow) {
                target = '_blank';
            }
            let pageForm = document.getElementById(elementName);
            if (!pageForm) {
                pageForm = document.body;
            }
            if ((hasHiddens != null || hasQuery != null) && hasUrl != null) {
                if (pageForm) {
                    let sendForm = "<form action='" +
                        hasUrl.Value +
                        "' method='post' name='form' Id=\"SingleSignOnRedirect\" target='" +
                        target +
                        "' >";
                    outputs.forEach((item) => {
                        if (item.InputType == InputType.Hidden) {
                            sendForm += "<input type='hidden' name='" + item.FieldName + "' value='" + item.Value + "' />";
                        }
                    });
                    sendForm += "<script>document.getElementById('SingleSignOnRedirect').submit();</script>";
                    pageForm.innerHTML = sendForm;
                }
                let renderForm = document.getElementById('SingleSignOnRedirect');
                renderForm.submit();
            }
            else if (hasJavascript != null) {
                let sendForm = '';
                outputs.forEach((item) => {
                    if (item.InputType == InputType.Javascript) {
                        sendForm += "<input type='hidden' name='" + item.FieldName + "' value='" + item.Value + "' />";
                    }
                });
                pageForm.innerHTML = sendForm;
            }
            else if (hasQuery != null) {
                window.open(hasQuery.Value, target);
            }
            else if (hasUrl != null) {
                window.open(hasUrl.Value, target);
            }
        }))
            .toPromise();
    }
    /** Set the auth token to the token provided in the 'portal-token' cookie. */
    sso() {
        let token = this.cookieService.get('portal-token');
        let user = this._makeUserContext(token);
        this.memberService.setUserContext(user);
        localStorage.setItem('token', token);
    }
    /**
     * Will log in the customer using the access token that has already been give to the customer
     *
     * @param accessToken Access Token from the login call
     * @param refreshToken Refresh token from the login call
     * @param redirectUrl if passed in and the redirectUrl is not undefined will navigate to that url
     */
    loginUsingToken(accessToken, refreshToken, redirectUrl = undefined) {
        let user = this._makeUserContext(accessToken);
        this.memberService.setUserContext(user);
        localStorage.setItem('token', accessToken);
        localStorage.setItem('refresh', refreshToken);
        localStorage.setItem('lcid', user.lcid);
        if (redirectUrl !== undefined) {
            this.router.navigate([redirectUrl]);
        }
    }
    /**
     * Will log in the customer using the access token that has already been give to the customer, while also refreshing store values
     *
     * @param accessToken Access Token from the login call
     * @param refreshToken Refresh token from the login call
     * @param redirectUrl if passed in and the redirectUrl is not undefined will navigate to that url
     */
    switchUserLoginUsingToken(accessToken, refreshToken, redirectUrl = undefined) {
        let user = this._makeUserContext(accessToken);
        this.memberService.setUserContext(user);
        localStorage.setItem('token', accessToken);
        localStorage.setItem('refresh', refreshToken);
        localStorage.setItem('lcid', user.lcid);
        //clear stores and refetch data to ensure data integrity when swapping accounts
        this.memberStore.setHasCache(false);
        this.memberService.fetchMemberDetails().toPromise();
        this.memberCardService.fetchCard().toPromise();
        this.childStore.setHasCache(false);
        this.childService.fetchChildren().toPromise();
        this.childService.fetchGuardian().toPromise();
        this.cardStore.setHasCache(false);
        this.cardService.fetchCards();
        if (redirectUrl !== undefined) {
            this.router.navigate([redirectUrl]);
        }
    }
    /** Login using the standard login flow. */
    login(username, password) {
        this.logService.info('Attempting to login as user', username);
        return this.api.post('token', { username, password }).pipe(tap((authResponse) => {
            if (authResponse) {
                this.loginUsingToken(authResponse.AccessToken, authResponse.RefreshToken);
            }
        }));
    }
    /**
     * Login using the MLBAM login flow.
     * @param username The username of the account to login with.
     * @param password The password for the account.
     * @param deviceGUID A GUID that represents the current device (without any hyphens).
     * @param successRedirectUrl The relative path the user should be redirected to on successful login.
     * @param chooseAccountRedirectUrl The relative path the user should be redirected to if there are multiple accounts for them to choose between.
     * @param createAccountRedirectUrl The relative path the user should be redirected to if they are required to create an account.
     */
    mlbamLogin(username, password, deviceGUID, successRedirectUrl = '/', chooseAccountRedirectUrl = '/login/accounts', createAccountRedirectUrl = '/register/new-member') {
        this.logService.info('Attempting to login as MLBAM user', username);
        const apiLoginModel = {
            LoginFields: { username, password, deviceGUID },
            PortalUrl: config.portalUrl,
        };
        return this.api.post('token/mlbam', apiLoginModel).pipe(tap((authResponse) => {
            if (authResponse) {
                if (authResponse.Tokens) {
                    // Tokens returned so we can log straight in as a user
                    this.logService.info('Tokens returned - logging in...');
                    this.loginUsingToken(authResponse.Tokens.AccessToken, authResponse.Tokens.RefreshToken, successRedirectUrl);
                }
                else if (authResponse.AvailableAccounts && authResponse.AvailableAccounts.length > 0) {
                    // Multiple accounts are linked to this MLBAM account so the user must choose one to continue
                    this.logService.info('Multiple accounts returned, selection is required to continue...');
                    this.memberService.setAvailableAccounts(authResponse.AvailableAccounts);
                    this.router.navigate([chooseAccountRedirectUrl]);
                }
                else if (authResponse.Status === MlbamLoginResponseStatus.CreateAccount) {
                    // username and password is successful but no translation exists so create it
                    this.logService.info('Account needs to be created');
                    this.router.navigate([createAccountRedirectUrl]);
                }
                else {
                    this.logService.error('Login response contains no tokens and no available accounts to choose from.', authResponse);
                }
            }
            else {
                this.logService.error('Login response is not type MlbamLoginResponse.', authResponse);
            }
        }));
    }
    /** Log the current user out. */
    logout(providerId = ProviderName.Fortress, providerTokens = {}) {
        this.logService.info('Logging out...');
        const token = localStorage.getItem('refresh');
        if (providerId !== ProviderName.Fortress && token) {
            let combinedTokens = { refreshToken: token, ...providerTokens };
            return this.api.post(`token/logout/${providerId}`, JSON.stringify(combinedTokens)).pipe(tap(() => {
                localStorage.removeItem('token');
                localStorage.removeItem('refresh');
            }));
        }
        else {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            return this.api.post('token/logout', `"${token}"`);
        }
    }
    /** Switch to one of the user's other members by member ID. */
    switchUser(memberId, reload = true) {
        this.logService.info('Switching to user with member ID', memberId);
        const refreshToken = localStorage.getItem('refresh');
        return this.api.post(`sso/switchUser?entity=${memberId}&entityType=3`, `"${refreshToken}"`).pipe(tap((token) => {
            this.switchUserLoginUsingToken(token.AccessToken, token.RefreshToken);
            if (reload) {
                location.reload();
            }
        }));
    }
    /** Switch to one of the user's other members by member ID. */
    switchToGuardian(redirectUrl = '/') {
        this.logService.info('Switching to daddy');
        const refreshToken = localStorage.getItem('refresh');
        return this.api.post(`sso/switchtoguardian`, `"${refreshToken}"`).pipe(tap((token) => {
            this.switchUserLoginUsingToken(token.AccessToken, token.RefreshToken, redirectUrl);
        }));
    }
    /** Decode the auth token and build a user context model. */
    _makeUserContext(token) {
        let decodedToken = this.jwtHelper.decodeToken(token);
        let user = new UserContext();
        user.externalRef = decodedToken.external_ref;
        user.lcid = decodedToken.lcid;
        user.memberId = decodedToken.member_id;
        user.populationId = decodedToken.population_id;
        if (!decodedToken.population_name) {
            this.populationService
                .fetchPopulations()
                .toPromise()
                .then(() => {
                user.populationName = this.populationQuery.getEntity(user.populationId)?.DisplayName;
            });
        }
        else {
            user.populationName = decodedToken.population_name;
        }
        user.portalId = decodedToken.portal_id;
        user.clubId = +decodedToken.clubId;
        user.sessionId = decodedToken.session_id;
        user.status = +decodedToken.account_status;
        user.clientType = +decodedToken.client_type;
        user.loginType = +decodedToken.login_type;
        user.clubs = decodedToken?.clubs;
        user.clientAttribute = decodedToken.client_attribute;
        if (decodedToken.customer_tags && decodedToken.customer_tags !== '[]') {
            user.customerTags = JSON.parse(decodedToken.customer_tags);
        }
        return user;
    }
    /* Support V1 SSO login as a user without a username and password.*/
    ssoLoginV1(sskey, cc, returnUrl) {
        this.logService.debug('Logging on with V1 SSO', {
            sskey,
            cc,
            returnUrl,
        });
        return this.api.post(`sso/ssov1?sskey=${sskey}&cc=${cc}&returnUrl=${returnUrl}`, {}).pipe(tap((authResponse) => {
            if (authResponse) {
                if (authResponse.ErrorNumber != 0) {
                    this.logService.error('Failed V1 SSO login', authResponse.ErrorDescription);
                    this.router.navigate([returnUrl]);
                }
                else {
                    const accessToken = authResponse.Data.AccessToken;
                    this.loginUsingToken(accessToken, authResponse.Data.RefreshToken, '/');
                }
            }
        }));
    }
    getAccessToken() {
        return localStorage.getItem('token') ?? '';
    }
    /**Switch Club ID with
     * @param clubId id of club
     *  and set new tokens to localStore*/
    switchClub(clubId) {
        let refreshToken = localStorage.getItem('refresh');
        return !this.jwtHelper.isTokenExpired(refreshToken)
            ? this.api
                .post(`sso/switchclub/${clubId}`, `"${refreshToken}"`)
                .pipe(map((response) => {
                return this.loginUsingToken(response.AccessToken, response.RefreshToken);
            }))
                .toPromise()
            : of();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthService, deps: [{ token: i4.JwtHelperService }, { token: ApiService }, { token: LoggingService }, { token: i4$1.CookieService }, { token: i5.DatePipe }, { token: MemberService }, { token: i2.Router }, { token: MemberCardService }, { token: MemberStore }, { token: ChildService }, { token: ChildStore }, { token: CardService }, { token: CardStore }, { token: MemberQuery }, { token: PopulationService }, { token: PopulationQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i4.JwtHelperService }, { type: ApiService }, { type: LoggingService }, { type: i4$1.CookieService }, { type: i5.DatePipe }, { type: MemberService }, { type: i2.Router }, { type: MemberCardService }, { type: MemberStore }, { type: ChildService }, { type: ChildStore }, { type: CardService }, { type: CardStore }, { type: MemberQuery }, { type: PopulationService }, { type: PopulationQuery }] });

class MemberResolver {
    constructor(memberService, logService, authService) {
        this.memberService = memberService;
        this.logService = logService;
        this.authService = authService;
    }
    resolve() {
        if (this.authService.isAuthenticated()) {
            this.logService.info('Resolving member details');
            return this.memberService.fetchMemberDetails();
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberResolver, deps: [{ token: MemberService }, { token: LoggingService }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberService }, { type: LoggingService }, { type: AuthService }] });

let MembershipOptionStore = class MembershipOptionStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionStore, providedIn: 'root' }); }
};
MembershipOptionStore = __decorate([
    StoreConfig({ name: 'membership-option', idKey: 'MembershipOptionId' })
], MembershipOptionStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class MembershipOptionService {
    constructor(store, api) {
        this.store = store;
        this.api = api;
    }
    fetchMembershipOptions() {
        return this.api.get('membershipoptions').pipe(tap(membershipOptions => this.store.set(membershipOptions)), mapTo(null));
    }
    fetchRegistrationMembershipOptions() {
        return this.api.get('register/membershipoptions').pipe(tap(membershipOptions => this.store.set(membershipOptions)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionService, deps: [{ token: MembershipOptionStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MembershipOptionStore }, { type: ApiService }] });

class MembershipOptionQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectPaid() {
        return this.selectAll({ filterBy: option => option.PaymentType === PaymentOptionType.Paid });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionQuery, deps: [{ token: MembershipOptionStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MembershipOptionQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MembershipOptionStore }] });

class RegistrationMembershipOptionResolver {
    constructor(membershipOptionService, loggingService) {
        this.membershipOptionService = membershipOptionService;
        this.loggingService = loggingService;
    }
    resolve(route) {
        this.loggingService.info('resolving membership options for wizard');
        return this.membershipOptionService.fetchRegistrationMembershipOptions();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationMembershipOptionResolver, deps: [{ token: MembershipOptionService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationMembershipOptionResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationMembershipOptionResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MembershipOptionService }, { type: LoggingService }] });

function createInitialState$3() {
    return {};
}
let MemberLoyaltyStatusStore = class MemberLoyaltyStatusStore extends Store {
    constructor() {
        super(createInitialState$3());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusStore, providedIn: 'root' }); }
};
MemberLoyaltyStatusStore = __decorate([
    StoreConfig({ name: 'member-loyalty-status' })
], MemberLoyaltyStatusStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class MemberLoyaltyStatusService {
    constructor(memberLoyaltyStatusStore, api, memberQuery) {
        this.memberLoyaltyStatusStore = memberLoyaltyStatusStore;
        this.api = api;
        this.memberQuery = memberQuery;
    }
    fetchMemberLoyaltyStatus() {
        const user = this.memberQuery.getUserContext();
        return this.api.getAnySingle(`members/${user.memberId}/loyalty/${config.purseConfig.virtualLoyalty}`).pipe(tap(loyaltyStatus => this.memberLoyaltyStatusStore.update(loyaltyStatus)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusService, deps: [{ token: MemberLoyaltyStatusStore }, { token: ApiService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberLoyaltyStatusStore }, { type: ApiService }, { type: MemberQuery }] });

class MemberLoyaltyStatusQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectMemberAveragePoints() {
        return this.select(state => state.AveragePointsBalance);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusQuery, deps: [{ token: MemberLoyaltyStatusStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberLoyaltyStatusStore }] });

class MemberLoyaltyStatusResolver {
    constructor(memberLoyaltyStatusService, loggingService) {
        this.memberLoyaltyStatusService = memberLoyaltyStatusService;
        this.loggingService = loggingService;
    }
    resolve() {
        this.loggingService.info('resolving member loyalty status info');
        return this.memberLoyaltyStatusService.fetchMemberLoyaltyStatus();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusResolver, deps: [{ token: MemberLoyaltyStatusService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberLoyaltyStatusResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberLoyaltyStatusService }, { type: LoggingService }] });

var AddressType;
(function (AddressType) {
    AddressType[AddressType["DefaultAddress"] = 0] = "DefaultAddress";
    AddressType[AddressType["BillingAddress1"] = 1] = "BillingAddress1";
    AddressType[AddressType["BillingAddress2"] = 2] = "BillingAddress2";
    AddressType[AddressType["ShippingAddress1"] = 3] = "ShippingAddress1";
    AddressType[AddressType["ShippingAddress2"] = 4] = "ShippingAddress2";
    AddressType[AddressType["AutomaticTopUpAddress"] = 5] = "AutomaticTopUpAddress";
    AddressType[AddressType["TopUpAddress"] = 6] = "TopUpAddress";
})(AddressType || (AddressType = {}));

const ADDRESS_DEFAULT_MOCK = {
    PortalId: '',
    AddressType: AddressType.DefaultAddress,
    ClubId: 0,
    MemberId: '',
    ExternalRefNumber: '',
    FirstName: '',
    Surname: '',
    AddressName: 'Default Address',
    Street: '',
    Town: '',
    County: '',
    Postcode: '',
    Country: '',
    HomeNumber: '',
    EmailAddress: '',
};
const ADDRESS_SHIPPING_MOCK = {
    PortalId: '',
    AddressType: AddressType.ShippingAddress1,
    ClubId: 0,
    MemberId: '',
    ExternalRefNumber: '',
    FirstName: '',
    Surname: '',
    AddressName: 'Shipping Address 1',
    Street: '',
    Town: '',
    County: '',
    Postcode: '',
    Country: '',
    HomeNumber: '',
    EmailAddress: '',
};
const VALID_ADDRESS_MOCK = {
    PortalId: '',
    AddressType: AddressType.DefaultAddress,
    ClubId: 0,
    MemberId: '',
    ExternalRefNumber: '',
    FirstName: 'First',
    Surname: 'Last',
    AddressName: 'Shipping Address 1',
    Street: 'Street',
    Town: 'City',
    County: 'County',
    Postcode: '54254',
    Country: 'Country',
    HomeNumber: '07111111111',
    EmailAddress: 'test@test.com',
};

let AddressStore = class AddressStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressStore, providedIn: 'root' }); }
};
AddressStore = __decorate([
    StoreConfig({ name: 'address', idKey: 'AddressType', cache: { ttl: 20000 } })
], AddressStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AddressQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All addresses. */
    selectAddresses(exclude) {
        return this.selectAll().pipe(map(addresses => addresses.filter(a => (!exclude || !exclude.includes(a.AddressType)))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressQuery, deps: [{ token: AddressStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressStore }] });

class AddressService {
    constructor(addressStore, addressQuery, api) {
        this.addressStore = addressStore;
        this.addressQuery = addressQuery;
        this.api = api;
    }
    /** Fetches the addresses and puts them in the store. */
    fetchAddresses() {
        this.addressStore.setLoading(true);
        const request$ = this.api.get('addresses').pipe(tap(addresses => this.addressStore.set(addresses)), mapTo(null));
        return this.addressQuery.getHasCache() ? of(null) : request$;
    }
    /** Save address */
    saveAddress(address) {
        return this.api.put('addresses', '', address).pipe(tap(() => this.addressStore.setHasCache(false)), switchMap(() => this.fetchAddresses())).toPromise();
    }
    getTopUpAddress() {
        return this.api.getAnySingle('topup/topupaddress');
    }
    postTopUpAddress(topupaddress) {
        return this.api.post('topup/topupaddress', topupaddress).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressService, deps: [{ token: AddressStore }, { token: AddressQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressStore }, { type: AddressQuery }, { type: ApiService }] });

class AddressResolver {
    constructor(addressService, logService, memberQuery, authService) {
        this.addressService = addressService;
        this.logService = logService;
        this.memberQuery = memberQuery;
        this.authService = authService;
    }
    resolve(route) {
        const user = this.memberQuery.getValue().user;
        //Only fetch the latest addresses when we know the user is logged in
        if (user && this.authService.isAuthenticated()) {
            this.logService.info('Resolving addresses');
            return this.addressService.fetchAddresses();
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressResolver, deps: [{ token: AddressService }, { token: LoggingService }, { token: MemberQuery }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressService }, { type: LoggingService }, { type: MemberQuery }, { type: AuthService }] });

class BalanceService {
    constructor(balanceStore, api, memberQuery) {
        this.balanceStore = balanceStore;
        this.api = api;
        this.memberQuery = memberQuery;
    }
    /** will return current member balance if memberId is null */
    fetchBalance(purse, memberId) {
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        let id = [memberId, purse].join('-');
        const useExternalRefBalance = config.useExternalRefBalance ?? false;
        return this.api
            .getAnySingle(`purse/balance/${purse}?accountBalance=${useExternalRefBalance}`)
            .pipe(tap((acc) => this.balanceStore.upsert(id, { purseId: purse, memberId: memberId || '', balance: acc.TotalBalanceAllowedToSpend })));
    }
    debitBalance(purse, amount, memberId) {
        if (amount < 0) {
            throw new Error('cannot debit a negative amount');
        }
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        let id = [memberId, purse].join('-');
        this.balanceStore.update(id, (b) => {
            return { balance: b.balance - amount };
        });
    }
    addBalance(purse, amount, memberId) {
        if (amount < 0) {
            throw new Error('cannot add a negative amount');
        }
        memberId = memberId || this.memberQuery.getUserContext().memberId;
        let id = [memberId, purse].join('-');
        this.balanceStore.update(id, (b) => {
            return { balance: b.balance + amount };
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceService, deps: [{ token: BalanceStore }, { token: ApiService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BalanceStore }, { type: ApiService }, { type: MemberQuery }] });

class BalanceResolver {
    constructor(balanceService, logService) {
        this.balanceService = balanceService;
        this.logService = logService;
    }
    resolve() {
        let ecash$ = this.balanceService.fetchBalance(config.purseConfig.combined);
        let points$ = this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty);
        return forkJoin([ecash$, points$]).pipe(mapTo(null), catchError((error) => {
            this.logService.error('[Balance Resolver] Request Error', error.error.Message);
            return of(null);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceResolver, deps: [{ token: BalanceService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BalanceResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BalanceService }, { type: LoggingService }] });

function getLoyaltyBalance() {
    assertInInjectionContext(getLoyaltyBalance);
    const virtualLoyalty = 6;
    const memberId = inject(MemberQuery).getUserContext().memberId;
    return inject(BalanceQuery).getEntity([memberId, virtualLoyalty].join('-'))?.balance || 0;
}

var AnnouncementLinkType;
(function (AnnouncementLinkType) {
    AnnouncementLinkType[AnnouncementLinkType["NoAction"] = 0] = "NoAction";
    AnnouncementLinkType[AnnouncementLinkType["Internal"] = 1] = "Internal";
    AnnouncementLinkType[AnnouncementLinkType["External"] = 2] = "External";
})(AnnouncementLinkType || (AnnouncementLinkType = {}));

// tslint:disable: variable-name
const ANNOUNCMENET_MOCK = [
    {
        Id: 1,
        Title: 'Announcenement',
        Type: 1,
        Description: '',
        ShortDescription: '',
        StartDate: new Date(),
        EndDate: new Date(),
        Active: true,
        Ordinal: 1,
        GameNumber: 1,
        GameTitle: '',
        Image: 'image.jpg',
        RequestTime: new Date(),
        LinkUrl: 'https://link.com/',
        LinkTitle: '',
        LinkType: AnnouncementLinkType.External,
        AllowComingSoon: false,
        ComingSoonDate: '2022-06-01T11:00:00',
        ComingSoonDescription: '',
        ComingSoonTitle: ''
    },
    {
        Id: 2,
        Title: 'Announcenement',
        Type: 2,
        Description: '',
        ShortDescription: '',
        StartDate: new Date(),
        EndDate: new Date(),
        Active: true,
        Ordinal: 2,
        GameNumber: 2,
        GameTitle: '',
        Image: 'image.jpg',
        RequestTime: new Date(),
        LinkUrl: 'https://link.com/',
        LinkTitle: '',
        LinkType: AnnouncementLinkType.Internal,
        AllowComingSoon: false,
        ComingSoonDate: '2022-06-01T11:00:00',
        ComingSoonDescription: '',
        ComingSoonTitle: ''
    },
    {
        Id: 3,
        Title: 'Announcenement',
        Type: 3,
        Description: '',
        ShortDescription: '',
        StartDate: new Date(),
        EndDate: new Date(),
        Active: true,
        Ordinal: 3,
        GameNumber: 3,
        GameTitle: '',
        Image: 'image.jpg',
        RequestTime: new Date(),
        LinkUrl: 'https://link.com/',
        LinkTitle: '',
        LinkType: AnnouncementLinkType.NoAction,
        AllowComingSoon: false,
        ComingSoonDate: '2022-06-01T11:00:00',
        ComingSoonDescription: '',
        ComingSoonTitle: ''
    },
];

let AnnouncementStore = class AnnouncementStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementStore, providedIn: 'root' }); }
};
AnnouncementStore = __decorate([
    StoreConfig({ name: 'announcement', cache: { ttl: 60000 }, idKey: 'Id' })
], AnnouncementStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AnnouncementQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All club announcements. */
    announcements() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementQuery, deps: [{ token: AnnouncementStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AnnouncementStore }] });

class AnnouncementService {
    constructor(announcementStore, api, announcementQuery) {
        this.announcementStore = announcementStore;
        this.api = api;
        this.announcementQuery = announcementQuery;
    }
    /** Fetch all announcements and put them in the store. */
    fetchAnnouncements() {
        this.announcementStore.setLoading(true);
        const request$ = this.api.get('announcements').pipe(tap(announcements => {
            this.announcementStore.set(announcements);
        }), mapTo(null));
        return this.announcementQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementService, deps: [{ token: AnnouncementStore }, { token: ApiService }, { token: AnnouncementQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AnnouncementService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AnnouncementStore }, { type: ApiService }, { type: AnnouncementQuery }] });

class ContactService {
    constructor(api) {
        this.api = api;
    }
    /** Get the categories of contact types  */
    getCategories() {
        return this.api.get('contactus/categories');
    }
    /** Send the message for the api to email */
    async sendMessage(message) {
        return await this.api.post('contactus/send', message).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ContactService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ContactService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ContactService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }] });

var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["All"] = 0] = "All";
    CompanyType[CompanyType["Fortress"] = 1] = "Fortress";
    CompanyType[CompanyType["Club"] = 2] = "Club";
    CompanyType[CompanyType["Sponsor"] = 3] = "Sponsor";
    CompanyType[CompanyType["Affiliate"] = 4] = "Affiliate";
})(CompanyType || (CompanyType = {}));

let CompanyStore = class CompanyStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyStore, providedIn: 'root' }); }
};
CompanyStore = __decorate([
    StoreConfig({ name: 'company', idKey: 'CompanyId', cache: { ttl: 20000 } })
], CompanyStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CompanyQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectCompanies() {
        return this.selectAll();
    }
    selectCompany(companyId) {
        return this.selectEntity(companyId);
    }
    /** returns all companies marked as favourite */
    selectFavouriteCompanies() {
        return this.selectAll({ filterBy: (company) => company.Favourite === true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyQuery, deps: [{ token: CompanyStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CompanyStore }] });

class CompanyService {
    constructor(companyStore, companyQuery, api) {
        this.companyStore = companyStore;
        this.companyQuery = companyQuery;
        this.api = api;
    }
    /** Fetches all the companies and puts them in the company store. */
    fetchAllCompanies() {
        this.companyStore.setLoading(true);
        const request$ = this.api.get('companies').pipe(tap((companies) => {
            this.companyStore.upsertMany(companies);
        }), mapTo(null));
        return this.companyQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetch a specific company and puts it in the store */
    fetchCompany(companyId) {
        this.companyStore.setLoading(true);
        const request$ = this.api.getAnySingle('companies/' + companyId).pipe(tap((company) => this.companyStore.upsert(companyId, company)), mapTo(null));
        return request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyService, deps: [{ token: CompanyStore }, { token: CompanyQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CompanyStore }, { type: CompanyQuery }, { type: ApiService }] });

const COMPANY_OFFERS_MOCK = [
    {
        CompanyId: 0,
        Content: [
            {
                Description: 'No matter where you are or need to go, Europcar has the right car rental for you.',
                LCID: 2057,
                Name: 'Europcar',
            },
        ],
        DepartmentId: 24,
        EndDate: new Date('2021-09-16T11:29:00'),
        Favorite: 0,
        GameNumber: 0,
        ImageUrl: 'europcarDepartment2.jpg',
        OfferId: 9,
        OfferType: 1,
        StartDate: new Date('2021-04-01T11:28:00'),
        TermsAndConditions: '',
        TermsAndConditionsType: 0,
        CategoryTags: [],
    },
    {
        CompanyId: 1,
        Content: [
            {
                Description: "Cadbury Gifts Direct also features a 'pick and mix' section enable you to create your own unique Cadbury hamper filled with all your favorites.",
                LCID: 2057,
                Name: 'Cadbury Gifts',
            },
        ],
        DepartmentId: 25,
        EndDate: new Date('2021-09-16T11:29:00'),
        Favorite: 1,
        GameNumber: 0,
        ImageUrl: 'cadburyGiftDepartment2.jpg',
        OfferId: 11,
        OfferType: 0,
        StartDate: new Date('2021-04-01T11:28:00'),
        TermsAndConditions: '',
        TermsAndConditionsType: 0,
        CategoryTags: [],
    },
];

var CompanyOfferType;
(function (CompanyOfferType) {
    CompanyOfferType[CompanyOfferType["ExternalWebsite"] = 0] = "ExternalWebsite";
    CompanyOfferType[CompanyOfferType["Discount"] = 1] = "Discount";
    CompanyOfferType[CompanyOfferType["CouponCode"] = 2] = "CouponCode";
    CompanyOfferType[CompanyOfferType["Affiliate"] = 3] = "Affiliate";
    CompanyOfferType[CompanyOfferType["NoAction"] = 4] = "NoAction";
    CompanyOfferType[CompanyOfferType["SingleSignOn"] = 5] = "SingleSignOn";
})(CompanyOfferType || (CompanyOfferType = {}));

var TermsAndConditionsDisplayType;
(function (TermsAndConditionsDisplayType) {
    /** No T&Cs */
    TermsAndConditionsDisplayType[TermsAndConditionsDisplayType["None"] = 0] = "None";
    /** Text T&Cs displayed on site */
    TermsAndConditionsDisplayType[TermsAndConditionsDisplayType["Text"] = 1] = "Text";
    /** External T&Cs */
    TermsAndConditionsDisplayType[TermsAndConditionsDisplayType["Url"] = 2] = "Url";
})(TermsAndConditionsDisplayType || (TermsAndConditionsDisplayType = {}));

let CompanyOfferStore = class CompanyOfferStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferStore, providedIn: 'root' }); }
};
CompanyOfferStore = __decorate([
    StoreConfig({ name: 'offer', idKey: 'OfferId', cache: { ttl: 20000 } })
], CompanyOfferStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CompanyOfferQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * select all available offers
     */
    selectAllOffers() {
        return this.selectAll();
    }
    /**
     * Selects all other offers from the same company
     * @param offerId - offerId to return related offers for
     */
    selectRelatedOffers(offerId) {
        let offer = this.getEntity(offerId);
        if (!offer) {
            return of(offer);
        }
        const foundOffer = offer;
        return this.selectAll({
            filterBy: (relatedOffer) => relatedOffer.CompanyId == foundOffer.CompanyId && relatedOffer.OfferId !== foundOffer.OfferId,
        });
    }
    /**
     * Selects all offers from different companies
     * @param companyId Company to exclude
     */
    selectOtherOffers(companyId) {
        return this.selectAll({ filterBy: (offer) => offer.CompanyId !== companyId });
    }
    /**
     * select a given offer using its offerId
     * @param offerId - Offer to retreive
     */
    selectOffer(offerId) {
        return this.selectEntity(offerId);
    }
    /**
     * select all offers for a given company
     * @param companyId - Company to retreive offers for
     */
    selectCompanyOffers(companyId) {
        return this.selectAll({ filterBy: (offer) => offer.CompanyId == companyId });
    }
    /**
     * select all featured offers
     */
    selectFeaturedOffers() {
        return this.selectAll({ filterBy: (offer) => offer.Favorite == 1 });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferQuery, deps: [{ token: CompanyOfferStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CompanyOfferStore }] });

var LoyaltyCategoryType;
(function (LoyaltyCategoryType) {
    LoyaltyCategoryType[LoyaltyCategoryType["None"] = 0] = "None";
    LoyaltyCategoryType[LoyaltyCategoryType["Facebook"] = 101] = "Facebook";
    LoyaltyCategoryType[LoyaltyCategoryType["Twitter"] = 102] = "Twitter";
    LoyaltyCategoryType[LoyaltyCategoryType["GooglePlus"] = 103] = "GooglePlus";
    LoyaltyCategoryType[LoyaltyCategoryType["FourSquare"] = 104] = "FourSquare";
    LoyaltyCategoryType[LoyaltyCategoryType["Instagram"] = 105] = "Instagram";
    LoyaltyCategoryType[LoyaltyCategoryType["Youtube"] = 106] = "Youtube";
    LoyaltyCategoryType[LoyaltyCategoryType["Membership"] = 200] = "Membership";
    LoyaltyCategoryType[LoyaltyCategoryType["Payment"] = 201] = "Payment";
    LoyaltyCategoryType[LoyaltyCategoryType["Events"] = 202] = "Events";
    LoyaltyCategoryType[LoyaltyCategoryType["Notification"] = 203] = "Notification";
    LoyaltyCategoryType[LoyaltyCategoryType["Ticketing"] = 204] = "Ticketing";
    LoyaltyCategoryType[LoyaltyCategoryType["Marketplace"] = 205] = "Marketplace";
    LoyaltyCategoryType[LoyaltyCategoryType["Lotto"] = 206] = "Lotto";
    LoyaltyCategoryType[LoyaltyCategoryType["Voucher"] = 207] = "Voucher";
    LoyaltyCategoryType[LoyaltyCategoryType["Auction"] = 208] = "Auction";
    LoyaltyCategoryType[LoyaltyCategoryType["Surveys"] = 209] = "Surveys";
    LoyaltyCategoryType[LoyaltyCategoryType["Fantasy"] = 210] = "Fantasy";
    LoyaltyCategoryType[LoyaltyCategoryType["Announcements"] = 211] = "Announcements";
    LoyaltyCategoryType[LoyaltyCategoryType["PortalProducts"] = 212] = "PortalProducts";
    LoyaltyCategoryType[LoyaltyCategoryType["Guardians"] = 213] = "Guardians";
    LoyaltyCategoryType[LoyaltyCategoryType["GiftCodes"] = 214] = "GiftCodes";
    LoyaltyCategoryType[LoyaltyCategoryType["UINotifications"] = 215] = "UINotifications";
    LoyaltyCategoryType[LoyaltyCategoryType["Worksheet"] = 216] = "Worksheet";
    LoyaltyCategoryType[LoyaltyCategoryType["CompanyOffer"] = 217] = "CompanyOffer";
    LoyaltyCategoryType[LoyaltyCategoryType["Scorecard"] = 218] = "Scorecard";
    LoyaltyCategoryType[LoyaltyCategoryType["Benefits"] = 219] = "Benefits";
    LoyaltyCategoryType[LoyaltyCategoryType["Games"] = 220] = "Games";
    LoyaltyCategoryType[LoyaltyCategoryType["Transactions"] = 280] = "Transactions";
    LoyaltyCategoryType[LoyaltyCategoryType["MLBAMapp"] = 300] = "MLBAMapp";
})(LoyaltyCategoryType || (LoyaltyCategoryType = {}));

class CompanyOfferService {
    constructor(companyOfferStore, api) {
        this.companyOfferStore = companyOfferStore;
        this.api = api;
        this.offersCategories = [];
    }
    /**
     * Fetch company offers for a given company and department
     * If CompanyId is set to 0, all Company offers are returned
     * If DepartmentId is set to 0 and Company set to 1, all Departments for CompanyId = 1 will be returned
     * If CompanyId and DepartmentId are 0, all offers for all comapnies/departments are retreived
     * @param companyId - company to fetch offers for - if 0 it will fetch all companies
     * @param departmentId - which company department to retreive offers for - if 0 all departments returned
     */
    fetchOffers(companyId, departmentId) {
        const request$ = this.api
            .getAnySingle(`companies/offers?companyId=${companyId}&departmentId=${departmentId}`)
            .pipe(tap((offers) => this.companyOfferStore.upsertMany(offers)), mapTo(null));
        return request$;
    }
    /**
     * Fetches the offer categories and stores them in the service.
     * If the service already loaded them, returns stored value.
     * @returns array of ClubCategoryTag as observable
     * */
    fetchOfferCategories() {
        if (!this.offersCategories.length) {
            return this.api.getAnySingle(`loyalty/categories/${LoyaltyCategoryType.CompanyOffer}`).pipe(tap((categories) => {
                this.offersCategories = categories;
            }));
        }
        else {
            return of(this.offersCategories);
        }
    }
    //TODO: This responses for this service method have not yet been fully defined
    async claimOffer(offerId) {
        return await this.api.post(`companies/claim/${offerId}`, offerId).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferService, deps: [{ token: CompanyOfferStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CompanyOfferService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CompanyOfferStore }, { type: ApiService }] });

var DepartmentType;
(function (DepartmentType) {
    DepartmentType[DepartmentType["All"] = 0] = "All";
    DepartmentType[DepartmentType["Admin"] = 1] = "Admin";
    DepartmentType[DepartmentType["Club"] = 2] = "Club";
    DepartmentType[DepartmentType["Sponsor"] = 3] = "Sponsor";
    DepartmentType[DepartmentType["SupportersClub"] = 4] = "SupportersClub";
    DepartmentType[DepartmentType["Affiliate"] = 5] = "Affiliate";
})(DepartmentType || (DepartmentType = {}));
/**
 * A factory function that creates Department
 */
function createDepartment(params) {
    return {};
}

const DEPARTMENT_MOCK = {
    DepartmentId: 24,
    CompanyId: 50,
    DisplayName: 'Department Name',
    Description: 'Department Description',
    Location: '01 Fake Street, PO0000 London',
    City: 'London',
    County: '',
    PostCode: 'PO0000',
    ImageUrl: 'assets/images/placeholders/404placeholder.svg',
    PageText: 'This is the text page',
    Link: '',
    WebsiteUrl: '',
    DepartmentType: 0,
    Balance: 0,
    Active: 1,
    EmailAddress: '',
    Longitude: 0.069782,
    Latitude: 51.624098,
    GeoLocation: {
        accuracy: 0,
        latitude: 51.624098,
        longitude: 0.069782,
        timestamp: 0,
    },
    Ordinal: 0,
};

function createInitialState$2() {
    return {
        parentCompany: new Array()
    };
}
let DepartmentStore = class DepartmentStore extends EntityStore {
    constructor() {
        super(createInitialState$2());
    }
    addCachedCompany(parentCompanyId) {
        let dateCached = new Date();
        let parentCacheIdentifier = { parentCompanyId, dateCached };
        this.update(x => {
            let state = {
                parentCompany: x.parentCompany
            };
            state.parentCompany = x.parentCompany.concat([parentCacheIdentifier]);
            return state;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentStore, providedIn: 'root' }); }
};
DepartmentStore = __decorate([
    StoreConfig({ name: 'department', idKey: 'DepartmentId', cache: { ttl: 20000 } })
], DepartmentStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class DepartmentQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectDepartments(companyId) {
        return this.selectAll({
            filterBy: (entity) => entity.CompanyId === companyId,
        });
    }
    selectDepartment(departmentId) {
        return this.selectEntity(departmentId);
    }
    getDepartment(departmentId) {
        return this.getEntity(departmentId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentQuery, deps: [{ token: DepartmentStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: DepartmentStore }] });

class DepartmentService {
    constructor(departmentStore, departmentQuery, api) {
        this.departmentStore = departmentStore;
        this.departmentQuery = departmentQuery;
        this.api = api;
        /** ms to cache departments */
        this.ttl = 60000;
    }
    /** Checks if the department is already cached using the parentCompany in the store */
    isCached(companyId) {
        return (this.departmentQuery.getValue().parentCompany
            .filter(d => d.parentCompanyId === companyId && this.cachedTimeout(d.dateCached))
            .length > 0);
    }
    /** Checks if the date cached is less than the ttl */
    cachedTimeout(dateCached) {
        let timeDiff = new Date().getTime() - dateCached.getTime();
        return timeDiff < this.ttl;
    }
    /** Fetches all the departments and puts them into the store */
    fetchDepartments(companyId) {
        if (this.isCached(companyId)) {
            return of(null);
        }
        let source = this.api.get('companies/' + companyId + '/departments');
        return source.pipe(tap(departments => this.departmentStore.upsertMany(departments)), tap(() => this.departmentStore.addCachedCompany(companyId)), mapTo(null));
    }
    processAffiliate(companyId, departmentId) {
        return this.api.post(`companies/${companyId}/departments/${departmentId}/affiliate`, '', undefined);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentService, deps: [{ token: DepartmentStore }, { token: DepartmentQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: DepartmentStore }, { type: DepartmentQuery }, { type: ApiService }] });

class DepartmentResolver {
    constructor(departmentService) {
        this.departmentService = departmentService;
    }
    resolve(route, state) {
        return this.departmentService.fetchDepartments(route.params.companyId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentResolver, deps: [{ token: DepartmentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: DepartmentResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: DepartmentService }] });

class SignalRBaseHub {
    constructor(logService, authService, jwtHelper) {
        this.logService = logService;
        this.authService = authService;
        this.jwtHelper = jwtHelper;
        /**
         * Subject which says if a connection is currently established
         */
        this.connectionEstablished$ = new BehaviorSubject(false);
    }
    /**
     * Stop SignalR connection
     */
    stopSignalR() {
        if (this.hubConnection.state === HubConnectionState.Connected) {
            this.hubConnection.stop();
        }
    }
    /**
     * Start SignalR connection only if it's not disconnected
     */
    startConnection() {
        if (this.hubConnection.state !== HubConnectionState.Disconnected) {
            return;
        }
        this.hubConnection.start().then(() => {
            this.logService.info('Connection started');
            this.connectionEstablished$.next(true);
        }, (error) => this.logService.error(error));
    }
    /**
     * Register .on server events
     */
    registerOnServerEvents() {
        this.hubConnection.onreconnecting(() => {
            this.logService.info('signalr is trying to reconnect');
        });
        this.hubConnection.onreconnected(() => {
            this.logService.info('signalr has been reconnected');
        });
        this.hubConnection.onclose(() => {
            this.connectionEstablished$.next(false);
            this.logService.info('signalr has been closed');
            if (this.hubConnection.state === HubConnectionState.Disconnected) {
                setTimeout(() => this.startConnection(), 3000);
            }
        });
    }
    joinGroup(groupName) {
        return this.connectionEstablished$.pipe(tap(connection => {
            if (connection) {
                this.hubConnection.invoke('AddToGroup', groupName).catch((err) => this.logService.info(err));
            }
        }), mapTo(null));
    }
    removeFromGroup(groupName) {
        if (this.hubConnection.state === HubConnectionState.Connected) {
            this.hubConnection.invoke('RemoveFromGroup', groupName).catch((err) => this.logService.info(err));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRBaseHub, deps: [{ token: LoggingService }, { token: AuthService }, { token: i4.JwtHelperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRBaseHub, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRBaseHub, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: AuthService }, { type: i4.JwtHelperService }] });

const lowerCaseKeys = (obj) => {
    if (typeof obj !== 'object' || !obj) {
        return obj;
    }
    if (Array.isArray(obj) && obj.length) {
        var mappedArr = obj.map(lowerCaseKeys);
        return mappedArr;
    }
    const entries = Object.entries(obj);
    const mappedEntries = entries.map(([k, v]) => {
        return [`${k.substr(0, 1).toLowerCase()}${k.substr(1)}`, lowerCaseKeys(v)];
    });
    return Object.fromEntries(mappedEntries);
};

/**
 * Retrieves the message language associated with the supplied LCID
 * @param languages Array of languages associated with the notification
 * @param lcid LCID of the notification we want
 * @returns The language associated with the lcid supplied otherwise the first record if it has one. Otherwise undefined
 */
function getMessageLanguageForLcid(languages, lcid) {
    if (languages && lcid) {
        if (languages.some((ml) => ml.lcid === lcid)) {
            return languages.find((ml) => ml.lcid === lcid);
        }
        else {
            return languages[0];
        }
    }
    return undefined;
}

const initialState = {
    total: 0,
    unseenCount: 0,
    ui: {
        isOpen: false,
        currentPage: 1,
        amountPerPage: 10,
    },
};
let NotificationCenterStore = class NotificationCenterStore extends EntityStore {
    constructor() {
        super(initialState);
    }
    updateUI(ui) {
        this.update((state) => ({
            ui: {
                ...state.ui,
                ...ui,
            },
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterStore, providedIn: 'root' }); }
};
NotificationCenterStore = __decorate([
    StoreConfig({ name: 'notification-center', idKey: 'id' })
], NotificationCenterStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let NotificationsCenterMappingStore = class NotificationsCenterMappingStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingStore, providedIn: 'root' }); }
};
NotificationsCenterMappingStore = __decorate([
    StoreConfig({ name: 'notifications-center-mapping', idKey: 'loyaltyActionId' })
], NotificationsCenterMappingStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class NotificationsCenterMappingService {
    constructor(notificationsCenterMappingStore, api) {
        this.notificationsCenterMappingStore = notificationsCenterMappingStore;
        this.api = api;
    }
    /**
     * Retrieve all of the notification mappings
     */
    fetchNotificationMappings() {
        const request$ = this.api.get('notificationscenter/mappings').pipe(tap((mappings) => {
            this.notificationsCenterMappingStore.set(lowerCaseKeys(mappings));
        }), mapTo(null));
        return request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingService, deps: [{ token: NotificationsCenterMappingStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationsCenterMappingStore }, { type: ApiService }] });

let NotificationManagementStore = class NotificationManagementStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementStore, providedIn: 'root' }); }
};
NotificationManagementStore = __decorate([
    StoreConfig({ name: 'notification-management', idKey: 'NotificationGroupId' })
], NotificationManagementStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class NotificationManagementService {
    constructor(notificationManagementStore, api) {
        this.notificationManagementStore = notificationManagementStore;
        this.api = api;
    }
    /**
     * Retrieve all of the notification mangement groups for user
     */
    fetchNotificationGroups() {
        const request$ = this.api.get('notificationsmanagement').pipe(tap((groups) => {
            this.notificationManagementStore.set(groups);
        }));
        return cacheable(this.notificationManagementStore, request$).pipe(mapTo(null));
    }
    /**
     * Post the update of the group to the api and update the store with response
     */
    updateGroup(groupDto) {
        this.api
            .post('notificationsmanagement/updategroup', groupDto)
            .subscribe((group) => {
            this.notificationManagementStore.update(group.NotificationGroupId, { Active: group.Active });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementService, deps: [{ token: NotificationManagementStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationManagementStore }, { type: ApiService }] });

function GroupHasLoyaltyTypeAndIsActive(group, loyaltyActionId) {
    if (!group.NotificationGroupItems || group.NotificationGroupItems.length === 0) {
        return false;
    }
    const foundItem = GetItemByLoyaltyId(group.NotificationGroupItems, loyaltyActionId);
    if (foundItem) {
        if (group.Active && foundItem.Active) {
            return true;
        }
        else if (!group.Active && foundItem.Active && foundItem.Critical) {
            return true;
        }
    }
    return false;
}
function GetItemByLoyaltyId(groupItems, loyaltyActionId) {
    for (const item of groupItems) {
        if (item.LoyaltyActionId === loyaltyActionId) {
            return item;
        }
    }
    return undefined;
}

/** Loyalty action types that are used for notifications  */
var NotificationLoyaltyType;
(function (NotificationLoyaltyType) {
    /** Null action */
    NotificationLoyaltyType[NotificationLoyaltyType["None"] = 0] = "None";
    /** Auction Outbid Action */
    NotificationLoyaltyType[NotificationLoyaltyType["AuctionOutBid"] = 200026] = "AuctionOutBid";
    /** Marketplace Purchase */
    NotificationLoyaltyType[NotificationLoyaltyType["MarketplaceOrderProcessed"] = 220001] = "MarketplaceOrderProcessed";
    /** Voucher code entered */
    NotificationLoyaltyType[NotificationLoyaltyType["VoucherCodeEntered"] = 220000] = "VoucherCodeEntered";
    /** Scorecard Complete */
    NotificationLoyaltyType[NotificationLoyaltyType["ScorecardComplete"] = 200077] = "ScorecardComplete";
    /** Points notification */
    NotificationLoyaltyType[NotificationLoyaltyType["PointsNotification"] = 230007] = "PointsNotification";
    /** Ecash spend */
    NotificationLoyaltyType[NotificationLoyaltyType["EcashSpend"] = 200080] = "EcashSpend";
    /** Attendance Check in (from access control) */
    NotificationLoyaltyType[NotificationLoyaltyType["AttendanceCheckIn"] = 200079] = "AttendanceCheckIn";
    /** Answer trivia */
    NotificationLoyaltyType[NotificationLoyaltyType["AnswerTrivia"] = 200044] = "AnswerTrivia";
    /** Lotto won */
    NotificationLoyaltyType[NotificationLoyaltyType["LottoWon"] = 200081] = "LottoWon";
    /** Auction won */
    NotificationLoyaltyType[NotificationLoyaltyType["AuctionWon"] = 200027] = "AuctionWon";
    /** AuctionBidPlaced */
    NotificationLoyaltyType[NotificationLoyaltyType["AuctionBidPlaced"] = 200025] = "AuctionBidPlaced";
    /** Scorecard Action Complete */
    NotificationLoyaltyType[NotificationLoyaltyType["ScorecardActionComplete"] = 200086] = "ScorecardActionComplete";
    /** Scorecard Milestone Complete */
    NotificationLoyaltyType[NotificationLoyaltyType["ScorecardMilestoneComplete"] = 200083] = "ScorecardMilestoneComplete";
    /** Campaign Manager Notification */
    NotificationLoyaltyType[NotificationLoyaltyType["CampaignManagerNotification"] = 231000] = "CampaignManagerNotification";
    /** Scorecard Expiration Notification */
    NotificationLoyaltyType[NotificationLoyaltyType["ScorecardExpirationNotification"] = 231001] = "ScorecardExpirationNotification";
    /** Scorecard Activation Notification */
    NotificationLoyaltyType[NotificationLoyaltyType["ScorecardActivationNotification"] = 231002] = "ScorecardActivationNotification";
})(NotificationLoyaltyType || (NotificationLoyaltyType = {}));

class NotificationManagementQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Checks the supplied loyaltyActionId against the store
     * and sees if the user allows this notification to be shown or if the notification is critical
     */
    loyaltyTypeIsActive(loyaltyActionId) {
        if (loyaltyActionId === NotificationLoyaltyType.None) {
            return true;
        }
        for (const group of this.getAll()) {
            const active = GroupHasLoyaltyTypeAndIsActive(group, loyaltyActionId);
            if (active) {
                return true;
            }
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementQuery, deps: [{ token: NotificationManagementStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationManagementStore }] });

/**
 * Message display type , used to alter the display of the notification
 */
var NotificationCenterMessageType;
(function (NotificationCenterMessageType) {
    NotificationCenterMessageType[NotificationCenterMessageType["Toast"] = 1] = "Toast";
    // Full screen not used currently
    // Fullscreen = 2,
    NotificationCenterMessageType[NotificationCenterMessageType["PersistentToast"] = 3] = "PersistentToast";
    NotificationCenterMessageType[NotificationCenterMessageType["Alert"] = 4] = "Alert";
})(NotificationCenterMessageType || (NotificationCenterMessageType = {}));
/**
 * Action type of the notification, used to change the action of the notification
 */
var NotificationCenterActionType;
(function (NotificationCenterActionType) {
    /** No link */
    NotificationCenterActionType[NotificationCenterActionType["NoAction"] = 1] = "NoAction";
    /** Internal link built via notification center mappings */
    NotificationCenterActionType[NotificationCenterActionType["InternalLink"] = 2] = "InternalLink";
    /** Action is to be used as the full url */
    NotificationCenterActionType[NotificationCenterActionType["ExternalLink"] = 3] = "ExternalLink";
})(NotificationCenterActionType || (NotificationCenterActionType = {}));

class NotificationsCenterMappingQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Gets the mapping url as a string for use as the link on the notification
     * @param notification Notification we want to get the mapping for
     */
    getMappingFromNotifciation(notification) {
        let mappingForLoyalty = this.getAll().find((nm) => nm.loyaltyActionId === notification.loyaltyActionId);
        if (!notification) {
            return '';
        }
        switch (notification.actionType) {
            case NotificationCenterActionType.NoAction:
                return '';
            case NotificationCenterActionType.InternalLink:
                return this.getInternalMappingLink(notification);
            case NotificationCenterActionType.ExternalLink:
                return mappingForLoyalty?.actionUrl;
        }
    }
    /**
     * Gets the mapping url for the internal mapping, when the actiontype is internal
     * @param notification Notification for the internal mapping
     */
    getInternalMappingLink(notification) {
        let mappingForLoyalty = this.getAll().find((nm) => nm.loyaltyActionId === notification.loyaltyActionId);
        if (!mappingForLoyalty || !mappingForLoyalty.mappingExists) {
            return '';
        }
        return mappingForLoyalty.actionUrl;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingQuery, deps: [{ token: NotificationsCenterMappingStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationsCenterMappingQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationsCenterMappingStore }] });

class NotificationCenterService {
    constructor(store, mappingService, notificationManagementService, notificationManagementQuery, api, memberQuery, mappingQuery) {
        this.store = store;
        this.mappingService = mappingService;
        this.notificationManagementService = notificationManagementService;
        this.notificationManagementQuery = notificationManagementQuery;
        this.api = api;
        this.memberQuery = memberQuery;
        this.mappingQuery = mappingQuery;
        this.notificationReceived$ = new Subject();
    }
    /**
     * Retrieve the first page for the notification center
     * @param pageSize Size of the page
     */
    fetchNotificationCenter(pageSize = 10) {
        const params = new HttpParams().set('page', '1').set('pageSize', pageSize.toString());
        const notificationRequest$ = this.api
            .getAnySingle('notificationscenter?' + params.toString())
            .pipe(tap((notifications) => {
            notifications = lowerCaseKeys(notifications);
            this.updateTotal(notifications.totalCount);
            this.store.set(notifications.items);
        }));
        let requests$ = combineLatest([
            notificationRequest$,
            this.mappingService.fetchNotificationMappings(),
            this.notificationManagementService.fetchNotificationGroups(),
            this.getUnseenNotificationCount(),
        ]);
        this.updateAmountPerPage(pageSize);
        return cacheable(this.store, requests$).pipe(mapTo(null));
    }
    /**
     * Get the current unseen notification count for the user
     */
    getUnseenNotificationCount() {
        return this.api.getAnySingle('notificationscenter/getunseencount').pipe(tap((count) => {
            this.updateUnseenCount(count);
        }));
    }
    /**
     * Retrieve a paged array for the notification center
     * @param page Page number
     * @param pageSize Size of the page
     */
    getNotificationCenterPage(page, pageSize = 10) {
        const params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString());
        return this.api.getAnySingle('notificationscenter?' + params.toString()).pipe(tap((notifications) => {
            if (notifications) {
                notifications = lowerCaseKeys(notifications);
                this.updateTotal(notifications.totalCount);
                this.store.upsertMany(notifications.items);
            }
        }), mapTo(null));
    }
    /**
     * Post back to the API a list of notification ids that we have seen
     * @param notificationIds Array of notification Ids tht we have seen
     */
    postNotificationsAsRead(notificationIds) {
        return this.api
            .postWithArray('notificationscenter/read', notificationIds)
            .pipe(tap(() => {
            let utcNow = moment$1.utc().toDate();
            this.store.update(notificationIds, { isRead: true, readDate: utcNow });
        }), mapTo(null))
            .toPromise();
    }
    /**
     * Set the isOpen store property
     * @param isOpen Is the notification center component open
     */
    updateIsOpen(open) {
        this.store.updateUI({ isOpen: open });
    }
    /**
     * Set the currentPage store property
     * @param currentPage New current page property
     */
    updateCurrentPage(currentPage) {
        this.store.updateUI({ currentPage: currentPage });
    }
    /**
     * Set the AmountPerPage store property
     * @param pageSize New Amount Per Page property
     */
    updateAmountPerPage(pageSize) {
        this.store.updateUI({ amountPerPage: pageSize });
    }
    /**
     * After 5 seconds call mark notifications as read
     */
    startNotificationCheck() {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }
        this.currentTimeout = setTimeout(() => {
            let notifications = entitiesToArray(this.store.getValue(), {
                asObject: false,
                filterBy: (n) => !n.isRead,
                limitTo: undefined,
            });
            let unseenNotificationIds = notifications.map((n) => n.id);
            if (unseenNotificationIds && unseenNotificationIds.length) {
                this.postNotificationsAsRead(unseenNotificationIds);
                let updatedUnseenCount = this.store.getValue().unseenCount - unseenNotificationIds.length;
                this.updateUnseenCount(updatedUnseenCount > 0 ? updatedUnseenCount : 0);
            }
        }, 5000);
    }
    /**
     * Set the total property on the store, to be used for pagination
     * @param total Total notifications the user can see
     */
    updateTotal(total) {
        this.store.update({
            total: total,
        });
    }
    /**
     * Go back one page and start the notification check
     */
    decrementPage() {
        const prevPage = this.store.getValue().ui.currentPage - 1;
        if (prevPage >= 1) {
            this.updateCurrentPage(prevPage);
            this.startNotificationCheck();
        }
    }
    /**
     * Go forward one page and start the notification check
     */
    incrementPage() {
        const nextPage = this.store.getValue().ui.currentPage + 1;
        if (nextPage <= this.MaxPage) {
            this.updateCurrentPage(nextPage);
            this.startNotificationCheck();
        }
    }
    /**
     * Handle receiving notifications, adding them to the store, and set the subject if required
     * @param notificationDto Notification DTO
     */
    receiveNotification(notificationDto) {
        let notification = this.getNotificationViewFromDto(notificationDto);
        // If first notification add to store
        if (this.MaxPage == 0) {
            this.addNotification(notificationDto);
        }
        else {
            // Otherwise invalidate the store and get from API
            this.invalidateCache();
        }
        //Increment unseen count
        this.updateUnseenCount(this.store.getValue().unseenCount + 1);
        // Do something with the notification only if the notification center is not open and not read
        if (!this.store.getValue().ui.isOpen &&
            !notification.isRead &&
            this.notificationManagementQuery.loyaltyTypeIsActive(notification.loyaltyActionId)) {
            this.notificationReceived$.next(notification);
        }
        else if (!this.store.getValue().ui.isOpen && !notification.isRead) {
            // Call the notification check to make sure the notification is marked as read
            // if the user is in the notification center
            this.startNotificationCheck();
        }
    }
    /**
     * Get View from DTO
     * @param notificationDto Notification DTO
     * @returns View object with correct message language
     */
    getNotificationViewFromDto(notificationDto) {
        let notification = notificationDto;
        // retrieve the linkUrl from the mappings and assign it
        let url = this.mappingQuery.getMappingFromNotifciation(notification);
        notification = Object.assign({}, notification, { linkUrl: url });
        let currentMessageLanguage = getMessageLanguageForLcid(notificationDto.messageLanguages, +this.memberQuery.getUserContext().lcid);
        notification.messageLanguage = currentMessageLanguage;
        return notification;
    }
    /**
     * Set unseen count property on the store
     * @param count New unseen notification count
     */
    updateUnseenCount(count) {
        this.store.update({
            unseenCount: count,
        });
    }
    /**
     * Invalidate the cache of the store
     */
    invalidateCache() {
        this.updateCurrentPage(1);
        this.store.setHasCache(false);
        this.store.remove();
    }
    /**
     * Add notification to the store and prepend
     */
    addNotification(notification) {
        this.store.add(notification, { prepend: true });
    }
    /**
     * Returns max page fusing stores values
     */
    get MaxPage() {
        return Math.ceil(this.store.getValue().total / this.store.getValue().ui.amountPerPage);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterService, deps: [{ token: NotificationCenterStore }, { token: NotificationsCenterMappingService }, { token: NotificationManagementService }, { token: NotificationManagementQuery }, { token: ApiService }, { token: MemberQuery }, { token: NotificationsCenterMappingQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationCenterStore }, { type: NotificationsCenterMappingService }, { type: NotificationManagementService }, { type: NotificationManagementQuery }, { type: ApiService }, { type: MemberQuery }, { type: NotificationsCenterMappingQuery }] });

class SignalRNotificationService {
    constructor(notificationCenterService) {
        this.notificationCenterService = notificationCenterService;
    }
    /** @inheritdoc */
    registerOnServerEvents(connection) {
        connection.on('ReceiveNotification', (notificationDto) => {
            this.notificationCenterService.receiveNotification(notificationDto);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRNotificationService, deps: [{ token: NotificationCenterService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRNotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRNotificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationCenterService }] });

let ScorecardStore = class ScorecardStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardStore, providedIn: 'root' }); }
};
ScorecardStore = __decorate([
    StoreConfig({ name: 'scorecard', idKey: 'ScorecardId' })
], ScorecardStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class ScorecardQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectCompletedScorecardIds() {
        return this.selectAll({ filterBy: (scorecard) => scorecard.Completed }).pipe(map((scorecards) => scorecards.map((s) => s.ScorecardId)));
    }
    hasLinkedScorecards(scorecardId) {
        return this.hasEntity((s) => s.ParentId === scorecardId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardQuery, deps: [{ token: ScorecardStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ScorecardStore }] });

/**
 * This scorecard service will handle
 * fetching the scorecards, set the
 * store and handle any interactions with
 * the scorecard store.
 *
 * The fetching of the data
 * will be called within the scorecard
 * resolver.
 */
class ScorecardService {
    constructor(scorecardStore, api, scorecardQuery) {
        this.scorecardStore = scorecardStore;
        this.api = api;
        this.scorecardQuery = scorecardQuery;
    }
    /**
     * fetch the active scorecards from the api
     * and set the store.
     */
    fetchScorecards() {
        const request$ = this.api.get('scorecard').pipe(tap((scorecards) => {
            scorecards = this.updateScorecardContent(scorecards);
            this.scorecardStore.set(scorecards);
        }), mapTo(null));
        return this.scorecardQuery.getHasCache() ? of(null) : request$;
    }
    /**
     * Will update each scorecards
     * content by checking against the users
     * LCID and scorecard LCID.
     *
     * If no match is found then first
     * content found will be displayed on
     * the frontend.
     *
     * @param scorecards array of active scorecards from
     * the response.
     */
    updateScorecardContent(scorecards) {
        this.currentLcid = localStorage.getItem('lcid');
        scorecards.forEach((scorecard) => {
            scorecard.Content.forEach((scorecardContent) => {
                if (scorecardContent.LCID.toString() == this.currentLcid) {
                    scorecard.Content[0] = scorecardContent;
                    scorecard.Actions.forEach((action) => {
                        action.Content.forEach((actionContent) => {
                            if (scorecardContent.LCID.toString() == actionContent.LCID.toString()) {
                                action.Content[0] = actionContent;
                            }
                        });
                    });
                }
            });
        });
        return scorecards;
    }
    /**
     * Set a scorecard action to be completed in the store
     */
    setScorecardActionToCompleted(scorecardId, scorecardActionId) {
        this.scorecardStore.update(scorecardId, ({ ActionsCompleted, Actions }) => ({
            ActionsCompleted: ActionsCompleted + 1,
            Actions: arrayUpdate(Actions, (a) => a.ScorecardActionId == scorecardActionId, {
                ScorecardActionId: scorecardActionId,
                CompletionDate: moment$1.utc().toDate(),
                ActionCompleted: true,
            }),
        }));
    }
    /**
     * Update scorecard milestone customer value within the
     * scorecard store with new customer value.
     * @param scorecardId ID of scorecard which will be updated in the scorecard store.
     * @param customerValue Customer value to replace current customer value of milestone progress within the store.
     */
    setScorecardMilesoneCustomerValueUpdate(scorecardId, customerValue) {
        this.scorecardStore.update(scorecardId, (scorecard) => ({
            ...scorecard,
            Milestone: {
                ...scorecard.Milestone,
                CustomerValue: customerValue,
            },
        }));
    }
    /**
     * Set a scorecard to be completed in the store, and unlock if has child-scorecard and it is locked
     */
    setScorecardToCompleted(scorecardId, completedDate) {
        this.scorecardStore.update(scorecardId, { Completed: true, CompletionDate: completedDate });
        if (this.scorecardQuery.hasLinkedScorecards(scorecardId)) {
            this.fetchScorecardBy(scorecardId)
                .pipe(take(1), map((data) => ({
                scorecard: this.findScorecard(data, scorecardId),
                linkedScorecards: data.filter((scorecard) => scorecard.ParentId === scorecardId),
            })))
                .subscribe(({ scorecard, linkedScorecards }) => {
                if (scorecard.Completed) {
                    linkedScorecards.forEach((linkedScorecard) => {
                        this.scorecardStore.update(linkedScorecard.ScorecardId, { Locked: linkedScorecard.Locked });
                    });
                }
            });
        }
    }
    /*
     * Triggers scorecard JoinWebCall event
     */
    joinWebCall(meetingNumber) {
        return this.api.post('webcall/joined', parseInt(meetingNumber));
    }
    fetchScorecardBy(scorecardId) {
        return this.api.get(`scorecard/details/${scorecardId}`).pipe(tap((scorecards) => {
            scorecards.forEach((scorecard) => {
                let hasCustomerSelectedPrize = this.scorecardQuery.getEntity(scorecardId)?.HasCustomerSelectedPrize;
                this.scorecardStore.update(scorecard.ScorecardId, { ...scorecard, HasCustomerSelectedPrize: hasCustomerSelectedPrize });
            });
        }));
    }
    findScorecard(listScorecard, id) {
        if (!id)
            return {};
        return listScorecard.find((scorecard) => scorecard.ScorecardId === id);
    }
    findScorecardIndex(listScorecard, id) {
        if (!id)
            return;
        return listScorecard.findIndex((scorecard) => scorecard.ScorecardId === id) + 1;
    }
    selectPrize(scorecardId, prizeId) {
        return this.api.post(`scorecard/selectPrize/${scorecardId}/${prizeId}`, {}).pipe(finalize(() => {
            this.scorecardStore.update(scorecardId, (scorecard) => {
                let prizes = JSON.parse(JSON.stringify(scorecard?.PrizeOptions?.Prizes));
                prizes.forEach((prize) => {
                    if (prize.PrizeId === prizeId)
                        prize.Selected = true;
                });
                return {
                    ...scorecard,
                    HasCustomerSelectedPrize: true,
                    PrizeOptions: {
                        Prizes: prizes,
                        CustomerHasSelected: true,
                    },
                };
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardService, deps: [{ token: ScorecardStore }, { token: ApiService }, { token: ScorecardQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScorecardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ScorecardStore }, { type: ApiService }, { type: ScorecardQuery }] });

let BadgesStore = class BadgesStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesStore, providedIn: 'root' }); }
};
BadgesStore = __decorate([
    StoreConfig({ name: 'badges', idKey: 'ScorecardId' })
], BadgesStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BadgesService {
    constructor(badgesStore, api) {
        this.badgesStore = badgesStore;
        this.api = api;
    }
    /**
     * fetch the active scorecards from the api
     * and set the store.
     */
    fetchBadges() {
        const request$ = this.api.get('scorecard/badges').pipe(tap((badges) => {
            this.badgesStore.set(badges);
        }), mapTo(null));
        return cacheable(this.badgesStore, request$);
    }
    /**
     * Get a scorecard by id
     */
    fetchScorecardBadge(scorecardId) {
        const request$ = this.api.getAnySingle('scorecard/' + scorecardId);
        return request$;
    }
    /**
     * Set a scorecard badge to be completed in the store
     */
    setBadgeToCompleted(scorecardId) {
        this.badgesStore.update(scorecardId, { Status: 1 });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesService, deps: [{ token: BadgesStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BadgesStore }, { type: ApiService }] });

class SignalRScorecardService {
    constructor(scorecardService, badgesService) {
        this.scorecardService = scorecardService;
        this.badgesService = badgesService;
    }
    /** @inheritdoc */
    registerOnServerEvents(connection) {
        connection.on('ScorecardActionComplete', (scorecardActionMessage) => {
            this.scorecardService.setScorecardActionToCompleted(scorecardActionMessage.scorecardId, scorecardActionMessage.scorecardActionId);
        });
        connection.on('ScorecardMilestoneUpdate', (scorecardMilestoneMessage) => {
            this.scorecardService.setScorecardMilesoneCustomerValueUpdate(scorecardMilestoneMessage.scorecardId, scorecardMilestoneMessage.customerValue);
        });
        connection.on('ScorecardComplete', (scorecardCompleteMessage) => {
            this.scorecardService.setScorecardToCompleted(scorecardCompleteMessage.scorecardId, scorecardCompleteMessage.dateCompleted);
            this.badgesService.setBadgeToCompleted(scorecardCompleteMessage.scorecardId);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRScorecardService, deps: [{ token: ScorecardService }, { token: BadgesService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRScorecardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRScorecardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ScorecardService }, { type: BadgesService }] });

class AuctionItemDto {
}

var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus[AuctionStatus["NoBids"] = 1] = "NoBids";
    AuctionStatus[AuctionStatus["UserNotBid"] = 2] = "UserNotBid";
    AuctionStatus[AuctionStatus["UserWinning"] = 3] = "UserWinning";
    AuctionStatus[AuctionStatus["UserLosing"] = 4] = "UserLosing";
})(AuctionStatus || (AuctionStatus = {}));

class AuctionItem extends AuctionItemDto {
    static [Symbol.hasInstance](instance) {
        return 'AllowSelfBid' in instance && typeof instance.AllowSelfBid === 'boolean';
    }
}
function flattenToAuction(auctionView) {
    if (!auctionView) {
        return auctionView;
    }
    let auction = auctionView.AuctionItem;
    auction.Images = auctionView.Images;
    auction.CurrentValue = auctionView.CurrentValue;
    auction.TimeRemainingInSeconds = auctionView.TimeRemainingInSeconds;
    auction.RequireRefesh = auctionView.RequireRefesh;
    auction.RefreshRate = auctionView.RefreshRate;
    auction.IsWinning = auctionView.IsWinning;
    auction.HasPreviousSuccessfulBid = auctionView.HasPreviousSuccessfulBid;
    auction.HasUserBidOnAuction = auctionView.HasUserBidOnAuction;
    if (auction.BidsCount === 0) {
        auction.Status = AuctionStatus.NoBids;
    }
    else if (auction.HasUserBidOnAuction === false) {
        auction.Status = AuctionStatus.UserNotBid;
    }
    else if (auction.HasPreviousSuccessfulBid) {
        if (auction.IsWinning) {
            auction.Status = AuctionStatus.UserWinning;
        }
        else {
            auction.Status = AuctionStatus.UserLosing;
        }
    }
    return auction;
}
const AUCTION_TEXT_COLOR = {
    BLACK: 'text-rewards-black',
    RED: 'text-rewards-danger',
    GREEN: 'text-rewards-success',
    NEW: 'text-rewards-new',
};
const AUCTION_STATE = {
    FEATURED: 'auction.featured.stock',
    NEW: 'auction.new.stock',
    NOT_ENOUGH_POINT: 'auction.not.enough.points',
    COMING_SOON: 'auction.coming.soon',
};

let AuctionStore = class AuctionStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionStore, providedIn: 'root' }); }
};
AuctionStore = __decorate([
    StoreConfig({ name: 'auction', idKey: 'Id', cache: { ttl: 5000 } })
], AuctionStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AuctionQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** return a single auction by ID */
    selectAuction(id) {
        return this.selectEntity(id);
    }
    /** return a list of all auctions */
    selectAuctions() {
        return this.selectAll();
    }
    /** returns true if the auction is no longer in the store */
    getExists(id) {
        const item = this.getEntity(id);
        return item === undefined || item === null;
    }
    selectAuctionStatus(id) {
        return this.selectAuction(id).pipe(map((auction) => {
            if (!auction) {
                return 'finished';
            }
            let now = new Date();
            if (new Date(auction.StartDate) > now) {
                return 'comingsoon';
            }
            else if (new Date(auction.EndDate) < now) {
                return 'finished';
            }
            else {
                return 'active';
            }
        }));
    }
    /** returns all auctions marked as favourite */
    selectFavourites() {
        return this.selectAll({ filterBy: (auction) => auction.Favourite !== 0 });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionQuery, deps: [{ token: AuctionStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionStore }] });

class AuctionService {
    constructor(auctionStore, api, auctionQuery, memberQuery) {
        this.auctionStore = auctionStore;
        this.api = api;
        this.auctionQuery = auctionQuery;
        this.memberQuery = memberQuery;
    }
    fetchAuction(id) {
        return this.api.getById('auctions', id.toString()).pipe(map(a => flattenToAuction(a)), tap(a => {
            if (!a) {
                this.auctionStore.remove(id);
            }
            else {
                this.auctionStore.upsert(id, a);
            }
        }), mapTo(null));
    }
    fetchAuctions() {
        const request$ = this.api.get('auctions').pipe(map(a => a.map(auction => flattenToAuction(auction))), tap(a => {
            this.auctionStore.set(a);
        }), mapTo(null));
        return this.auctionQuery.getHasCache() ? of(null) : request$;
    }
    postBid(bid, memberId = '') {
        return this.api.postForParent('auctions', bid.auctionId, 'bid?memberId=' + memberId, bid.value).pipe(map(a => flattenToAuction(a)), tap(a => this.auctionStore.upsert(a.Id, a)), mapTo('bid successful'));
    }
    updateAuctionAfterBid(auctionUpdate) {
        let portalId = this.memberQuery.getUserContext().portalId;
        this.auctionStore.update(auctionUpdate.auctionId, entity => ({
            CurrentValue: auctionUpdate.currentValue,
            BidsCount: auctionUpdate.bidCount,
            EndDate: auctionUpdate.endDate,
            IsWinning: portalId === auctionUpdate.winningPortalId ? 1 : 0,
            Status: portalId === auctionUpdate.winningPortalId ? AuctionStatus.UserWinning :
                entity.HasUserBidOnAuction === true ? AuctionStatus.UserLosing : AuctionStatus.UserNotBid,
            HasUserBidOnAuction: portalId === auctionUpdate.winningPortalId ? true : entity.HasUserBidOnAuction,
            HasPreviousSuccessfulBid: true
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionService, deps: [{ token: AuctionStore }, { token: ApiService }, { token: AuctionQuery }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionStore }, { type: ApiService }, { type: AuctionQuery }, { type: MemberQuery }] });

class SignalRAuctionService {
    constructor(auctionService, balanceService) {
        this.auctionService = auctionService;
        this.balanceService = balanceService;
    }
    /** @inheritdoc */
    registerOnServerEvents(connection) {
        connection.on('AuctionUpdateAfterBid', (auctionUpdateMessage) => {
            this.auctionService.updateAuctionAfterBid(auctionUpdateMessage);
        });
        connection.on('OutBidUserUpdate', () => {
            this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).toPromise();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRAuctionService, deps: [{ token: AuctionService }, { token: BalanceService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRAuctionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRAuctionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionService }, { type: BalanceService }] });

class SignalRHub extends SignalRBaseHub {
    constructor(logService, signalRNotificationService, signalRScorecardService, signalRAuctionService, authService, jwtHelper) {
        super(logService, authService, jwtHelper);
        this.logService = logService;
        this.signalRNotificationService = signalRNotificationService;
        this.signalRScorecardService = signalRScorecardService;
        this.signalRAuctionService = signalRAuctionService;
        this.authService = authService;
        this.jwtHelper = jwtHelper;
        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }
    /**
     * Create SignalR connection using token
     */
    createConnection() {
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(config.baseApiUrl + '/hub', {
            accessTokenFactory: async () => {
                const token = localStorage.getItem('token');
                if (token && this.authService.isAuthenticated() && !this.jwtHelper.isTokenExpired(token)) {
                    return token;
                }
                else if (!token) {
                    return '';
                }
                return (await firstValueFrom(this.authService.refreshAccessToken())).AccessToken;
            },
        })
            .build();
    }
    /**
     * Register .on server events
     */
    registerOnServerEvents() {
        this.signalRNotificationService.registerOnServerEvents(this.hubConnection);
        this.signalRScorecardService.registerOnServerEvents(this.hubConnection);
        this.signalRAuctionService.registerOnServerEvents(this.hubConnection);
        super.registerOnServerEvents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRHub, deps: [{ token: LoggingService }, { token: SignalRNotificationService }, { token: SignalRScorecardService }, { token: SignalRAuctionService }, { token: AuthService }, { token: i4.JwtHelperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRHub, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRHub, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: SignalRNotificationService }, { type: SignalRScorecardService }, { type: SignalRAuctionService }, { type: AuthService }, { type: i4.JwtHelperService }] });

class SignalRWizardService {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    /** @inheritdoc */
    registerOnServerEvents(connection) {
        connection.on('RegistrationFailComplete', (data) => {
            this.router.navigateByUrl('/register/failure' + `?orderId=${data.orderId}&errorCode=${data.errorCode}`);
        });
        connection.on('RegistrationSuccessComplete', (loginResponse) => {
            const accessToken = loginResponse.accessToken;
            this.authService.loginUsingToken(accessToken, loginResponse.refreshToken, '/');
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRWizardService, deps: [{ token: AuthService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRWizardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRWizardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuthService }, { type: i2.Router }] });

class SignalRUnauthrosiedHub extends SignalRBaseHub {
    constructor(logService, signalRWizardService, authService, jwtHelper) {
        super(logService, authService, jwtHelper);
        this.logService = logService;
        this.signalRWizardService = signalRWizardService;
        this.authService = authService;
        this.jwtHelper = jwtHelper;
    }
    /**
      * * Create a connection to the signlar hub (unauthorised)
      * @param orderId the order id of parameter
      */
    connectByOrderId(orderId) {
        this.createConnectionByOrderId(orderId);
        this.registerOnServerEvents();
        this.startConnection();
    }
    /**
    * Create SignalR connection using querystring
    */
    createConnectionByOrderId(orderId) {
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(config.baseApiUrl + '/huborder?orderId=' + orderId)
            .build();
    }
    /**
     * Register .on server events
     */
    registerOnServerEvents() {
        this.signalRWizardService.registerOnServerEvents(this.hubConnection);
        super.registerOnServerEvents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRUnauthrosiedHub, deps: [{ token: LoggingService }, { token: SignalRWizardService }, { token: AuthService }, { token: i4.JwtHelperService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRUnauthrosiedHub, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SignalRUnauthrosiedHub, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: SignalRWizardService }, { type: AuthService }, { type: i4.JwtHelperService }] });

/**
 * Base class of the notification center message
 * the notification center message is used to display the notification
 * when it is sent to the app from the API
 */
class NotificationCenterMessage {
}

/**
 * DTO of the notification center message and is mapped from the API
 */
class NotificationCenterMessageDto extends NotificationCenterMessage {
}

/**
 * View of the notification center message,
 * mapped from the {@link NotificationCenterMessageDto}
 * allows for easier display on the front end
 */
class NotificationCenterMessageView extends NotificationCenterMessage {
}

class NotificationCenterQuery extends QueryEntity {
    get pageSize() {
        return this.getValue().ui.amountPerPage;
    }
    get maxPage() {
        return Math.ceil(this.getValue().total / this.pageSize);
    }
    constructor(store, mappingQuery, notificationService) {
        super(store);
        this.store = store;
        this.mappingQuery = mappingQuery;
        this.notificationService = notificationService;
        /** observable for the isOpen ui state */
        this.isOpen$ = this.select((state) => state.ui.isOpen);
        this.unseenNotificationsCount$ = this.select((state) => state.unseenCount);
        this.pageNum$ = this.select((state) => state.ui.currentPage);
        this.showPrev$ = this.select((state) => state.ui.currentPage !== 1);
        this.showNext$ = this.select((state) => state.ui.currentPage !== this.maxPage && this.maxPage > 1);
        /**
         * The amount we should offset the pagination by
         * e.g. page 2 with 10 items per page - offset should be 20
         */
        this._offset = 0;
    }
    /**
     * Select the paged view of the Notification Center Messages
     * @param lcid LCID for the messages that should be displayed
     */
    selectAllPagedView(lcid) {
        return this.pageNum$.pipe(switchMap((pageNum) => {
            this._offset = this.getOffset(pageNum);
            return this.selectAll().pipe(tap((notifications) => {
                // If we don't have the next page in the store retrieve it from the API
                // Only if max page > 0 (Notifications exist for user)
                if (notifications.length <= this._offset && this.maxPage > 0) {
                    this.notificationService.getNotificationCenterPage(pageNum, this.pageSize).toPromise();
                }
            }), map((notifications) => notifications.slice(this._offset, this._offset + this.pageSize)), map((notifications) => {
                return notifications.map((n) => {
                    let notificationView = n;
                    // retrieve the linkUrl from the mappings and assign it
                    let url = this.mappingQuery.getMappingFromNotifciation(notificationView);
                    notificationView = Object.assign({}, notificationView, { linkUrl: url });
                    if (n.messageLanguages) {
                        let currentMessageLanguage = getMessageLanguageForLcid(n.messageLanguages, lcid);
                        notificationView = Object.assign({}, notificationView, { messageLanguage: currentMessageLanguage });
                    }
                    return notificationView;
                });
            }));
        }));
    }
    /**
     * Get the ids of all unseen notifications in the store
     */
    getUnseenNotificationIdsFromStore() {
        return this.getAll({
            filterBy: (n) => !n.isRead,
        }).map((n) => n.id);
    }
    /**
     * Get Offset using page number supplied or current page
     * @param pageNum page number to use when calculating offset
     * @returns offset count of items (page 2 with a page size of 5 would be 10)
     */
    getOffset(pageNum) {
        if (!pageNum) {
            pageNum = this.getValue().ui.currentPage;
        }
        return (pageNum - 1) * this.pageSize;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterQuery, deps: [{ token: NotificationCenterStore }, { token: NotificationsCenterMappingQuery }, { token: NotificationCenterService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationCenterStore }, { type: NotificationsCenterMappingQuery }, { type: NotificationCenterService }] });

/**
 * Mapping model which ties loyaltyActionId to the url
 */
class NotificationMappingModel {
}

class NotificationCenterMappingResolver {
    constructor(mappingService) {
        this.mappingService = mappingService;
    }
    /**
     * Resolves the notification mappings
     * @param route route data and params
     * @param state state of the router
     */
    resolve(route, state) {
        return this.mappingService.fetchNotificationMappings();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterMappingResolver, deps: [{ token: NotificationsCenterMappingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterMappingResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationCenterMappingResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationsCenterMappingService }] });

class EntityNotificationGroupDto {
    constructor(notificationGroupId, portalId, active, entityNotificaitonGroupId) {
        this.NotificationGroupId = notificationGroupId;
        this.PortalId = portalId;
        this.Active = active;
        this.EntityNotificationGroupId = entityNotificaitonGroupId;
    }
}

class EntityNotificationGroupItem {
}

class NotificationManagementResolver {
    constructor(notificationManagementService) {
        this.notificationManagementService = notificationManagementService;
    }
    resolve(route, state) {
        return this.notificationManagementService.fetchNotificationGroups();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementResolver, deps: [{ token: NotificationManagementService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NotificationManagementResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: NotificationManagementService }] });

/**
 * The type of commands the popup should display to the user
 * Only used for PopUpNotificationType == TextBased
 */
var PopUpCommandType;
(function (PopUpCommandType) {
    /** popup should display 'Confirm' button */
    PopUpCommandType[PopUpCommandType["Confirm"] = 0] = "Confirm";
    /** popup should display 'Ok' and 'Cancel' buttons */
    PopUpCommandType[PopUpCommandType["OkCancel"] = 1] = "OkCancel";
})(PopUpCommandType || (PopUpCommandType = {}));

/**
 * Model containing PopUp Notification data
 */
class PopUpNotificationModel {
}

/**
 * DTO for the PopUp Notification
 */
class PopUpNotificationDto extends PopUpNotificationModel {
}

/**
 * How the user responded to the popup
 */
var PopUpNotificationResponseType;
(function (PopUpNotificationResponseType) {
    /** user accepted (pressed 'Ok' or 'Confirm') */
    PopUpNotificationResponseType[PopUpNotificationResponseType["Accepted"] = 0] = "Accepted";
    /** user denied (did not  press 'Confirm') */
    PopUpNotificationResponseType[PopUpNotificationResponseType["Denied"] = 1] = "Denied";
    /** user pressed 'Cancel' */
    PopUpNotificationResponseType[PopUpNotificationResponseType["Cancelled"] = 2] = "Cancelled";
    /** an error occurred and the popup was not displayed */
    PopUpNotificationResponseType[PopUpNotificationResponseType["Error"] = 3] = "Error";
})(PopUpNotificationResponseType || (PopUpNotificationResponseType = {}));

/**
 * The type of popup notification
 */
var PopUpNotificationType;
(function (PopUpNotificationType) {
    /** text only */
    PopUpNotificationType[PopUpNotificationType["TextBased"] = 0] = "TextBased";
    /** directs user to an action/component */
    PopUpNotificationType[PopUpNotificationType["ActionBased"] = 1] = "ActionBased";
    /** tutorial for new functionality  */
    PopUpNotificationType[PopUpNotificationType["Guided"] = 2] = "Guided";
})(PopUpNotificationType || (PopUpNotificationType = {}));

/**
 * ViewModel for the required PopUp notification language variant
 */
class PopUpNotificationViewModel extends PopUpNotificationModel {
}

const POPUP_NOTIFICATION_TEXT_MOCK = {
    popUpNotificationId: 1,
    name: 'Mock text popup notification',
    description: 'Description of mock text popup notification',
    pageUrl: '',
    componentName: '',
    image: 'src',
    notificationType: 0,
    windowType: 0,
    commandType: 0,
    popUpNotificationLanguage: {
        description: 'Description of mock text popup notification',
        lCID: 2057,
        name: 'Mock text popup notification',
        popUpNotificationId: 1,
    },
};
const POPUP_NOTIFICATION_ACTION_MOCK = {
    popUpNotificationId: 2,
    name: 'Mock action popup notification',
    description: 'Description of mock action popup notification',
    pageUrl: '',
    componentName: 'fgb-edit-account-details',
    image: '',
    notificationType: 1,
    windowType: 0,
    commandType: 0,
    popUpNotificationLanguage: {
        description: 'Description of mock action popup notification',
        lCID: 2057,
        name: 'Mock text popup notification',
        popUpNotificationId: 1,
    },
};

/** the type of popup modal to display */
var PopUpWindowType;
(function (PopUpWindowType) {
    /** normal text modal */
    PopUpWindowType[PopUpWindowType["MessageBox"] = 0] = "MessageBox";
    /** urgent text modal */
    PopUpWindowType[PopUpWindowType["ImportantMessage"] = 1] = "ImportantMessage";
})(PopUpWindowType || (PopUpWindowType = {}));

let PopUpNotificationStore = class PopUpNotificationStore extends EntityStore {
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationStore, providedIn: 'root' }); }
};
PopUpNotificationStore = __decorate([
    StoreConfig({ name: 'popup-notifications', idKey: 'popUpNotificationId' })
], PopUpNotificationStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class PopUpNotificationQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Retrieves the popup notification for a given page
     * @param pageUrl the page to retreive popup notification for ('' for Home page)
     * @param lcid LCID of the required popup notification
     * @returns the popup notification associated with the given pageUrl, otherwise undefined
     */
    getPopUpNotificationForPage(pageUrl, lcid) {
        if (pageUrl && lcid) {
            // strip trailing forward slash for non homepage pages
            if (pageUrl.length > 1) {
                pageUrl = pageUrl.replace(/\/$/, '');
            }
            // Undefined page urls are to be shown on all pages
            let popUpNotification = this.getAll().filter((popup) => popup.pageUrl == pageUrl || popup.pageUrl == undefined)[0];
            if (popUpNotification) {
                let popUpNotificationViewModel = popUpNotification;
                if (popUpNotification.popUpNotificationLanguages) {
                    let popUpNotificationLanguage = this.popUpNotificationLanguageForLcid(popUpNotification, lcid);
                    popUpNotificationViewModel = Object.assign({}, popUpNotificationViewModel, {
                        popUpNotificationLanguage: popUpNotificationLanguage,
                    });
                }
                return popUpNotificationViewModel;
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    /**
     * Retrieves the popup notification language variant for a given LCID
     * @param popUpNotification Popup notification data object
     * @param lcid LCID of the required popup notification
     * @returns The language variant associated with the given lcid otherwise the original data as default.
     */
    popUpNotificationLanguageForLcid(popUpNotification, lcid) {
        const availableLanguages = popUpNotification.popUpNotificationLanguages;
        if (availableLanguages.length && lcid) {
            if (availableLanguages.some((popUpNotificationLanguage) => popUpNotificationLanguage.lCID === lcid)) {
                return availableLanguages.find((popUpNotificationLanguage) => popUpNotificationLanguage.lCID === lcid);
            }
            else {
                return this.defaultLanguage(popUpNotification);
            }
        }
        return this.defaultLanguage(popUpNotification);
    }
    /**
     * Retrieves the original data as default language for a popup notification
     * @param popUpNotification Popup notification data object
     * @returns The original data as default language variant.
     */
    defaultLanguage(popUpNotification) {
        return {
            description: popUpNotification.description,
            lCID: +config.defaultLcid,
            name: popUpNotification.name,
            popUpNotificationId: popUpNotification.popUpNotificationId,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationQuery, deps: [{ token: PopUpNotificationStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PopUpNotificationStore }] });

class PopUpNotificationService {
    constructor(store, api) {
        this.store = store;
        this.api = api;
    }
    /**
     * Retrieve the current customer's avalaible popup notifications and populate the store
     */
    fetchPopUpNotifications() {
        const request$ = this.api.get('notificationspopup/unseenpopup').pipe(tap((popUpNotifications) => {
            this.store.set(lowerCaseKeys(popUpNotifications));
        }));
        return cacheable(this.store, request$, { emitNext: true }).pipe(mapTo(null));
    }
    /**
     * Mark a given notification as read and remove it from the store
     * @param popUpNotificationId The popup notification to mark as read
     * @param responseType The user's response type to the popup
     * @param seenDate the date/time when the popup was seen/responded to
     */
    markNotificationsAsRead(popUpNotificationId, responseType) {
        return this.api
            .post('notificationspopup/respondtopopup', { popUpNotificationId, responseType })
            .pipe(tap(() => {
            this.store.remove(popUpNotificationId);
        }), mapTo(null))
            .toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationService, deps: [{ token: PopUpNotificationStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PopUpNotificationStore }, { type: ApiService }] });

class PopUpNotificationResolver {
    constructor(popUpNotificationService, logService) {
        this.popUpNotificationService = popUpNotificationService;
        this.logService = logService;
    }
    /**
       * Resolve the current user's popup notifications
       * @param route Route data/params
       * @param state State of the router
       */
    resolve() {
        this.logService.info(`Resolving popup Notifications`);
        return this.popUpNotificationService.fetchPopUpNotifications();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationResolver, deps: [{ token: PopUpNotificationService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopUpNotificationResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PopUpNotificationService }, { type: LoggingService }] });

var TermsAndConditionsType;
(function (TermsAndConditionsType) {
    // General terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["General"] = 1] = "General";
    // Loading card terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["LoadCard"] = 2] = "LoadCard";
    // Print ticket terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["PrintTicket"] = 3] = "PrintTicket";
    // Ticket sell terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["SellTickets"] = 4] = "SellTickets";
    // Ticket transfer terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["TransferTickets"] = 5] = "TransferTickets";
    // Pricacy policy
    TermsAndConditionsType[TermsAndConditionsType["PrivacyPolicy"] = 6] = "PrivacyPolicy";
    /// Loyalty terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["LoyaltyScheme"] = 7] = "LoyaltyScheme";
    // Guardian specific terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["Guardian"] = 8] = "Guardian";
    // Child specific terms and conditions
    TermsAndConditionsType[TermsAndConditionsType["GuardianChildren"] = 9] = "GuardianChildren";
})(TermsAndConditionsType || (TermsAndConditionsType = {}));

let TermsAndConditionsStore = class TermsAndConditionsStore extends EntityStore {
    constructor() {
        super();
    }
    akitaPreAddEntity(x) {
        return {
            ...x,
            storeID: [x.Type, x.Id, x.LCID].join('-'),
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsStore, providedIn: 'root' }); }
};
TermsAndConditionsStore = __decorate([
    StoreConfig({ name: 'termsAndConditions', idKey: 'storeID' })
], TermsAndConditionsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TermsAndConditionQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** Select terms and conditions by type and lcid.
     * @param selectedType terms and condition type
     * @param lcid language variant to be displayed
     */
    selectTermsAndConditions(selectedType, lcid) {
        return this.selectAll({
            filterBy: (entity) => entity.Type === selectedType && entity.LCID === lcid,
        });
    }
    /** Checks if there are terms of specific type in store.
     * @param termsType terms and condition type
     */
    hasTerms(termsType) {
        return Boolean(this.getAll({ filterBy: [(entity) => entity.Type == termsType] }).length);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionQuery, deps: [{ token: TermsAndConditionsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TermsAndConditionsStore }] });

class TermsAndConditionsService {
    constructor(api, termsAndConditionsStore, termsAndConditionsQuery, logService) {
        this.api = api;
        this.termsAndConditionsStore = termsAndConditionsStore;
        this.termsAndConditionsQuery = termsAndConditionsQuery;
        this.logService = logService;
    }
    /** Fetch all terms and conditions and put them in the store.
     * @param selectedType terms and condition type
     * @param lcid language variant to be displayed
     * @param clubId get the clubId of the user
     */
    fetchTermsAndConditions(selectedType, lcid, clubId = 1) {
        this.logService.debug(`Fetching ${TermsAndConditionsType[selectedType]} Terms and Conditions`);
        return this.api.get(`terms/all/${selectedType}/${clubId}`).pipe(tap((terms) => {
            terms.forEach((term) => {
                term.Type = selectedType;
            });
            this.termsAndConditionsStore.add(terms);
        }), map((terms) => terms.filter((term) => term.LCID === +lcid)));
    }
    /** Gets terms and conditions for a specific type
     * @param selectedType terms and condition type
     * @param lcid (Optional) language variant to be displayed. If not specified, config default lcid is used.
     */
    getTermsAndConditions(selectedType, lcid, clubId = 1) {
        return this.termsAndConditionsQuery.hasTerms(selectedType)
            ? this.termsAndConditionsQuery.selectTermsAndConditions(selectedType, lcid ? +lcid : +config.defaultLcid)
            : this.fetchTermsAndConditions(selectedType, lcid ? lcid : config.defaultLcid, clubId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsService, deps: [{ token: ApiService }, { token: TermsAndConditionsStore }, { token: TermsAndConditionQuery }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TermsAndConditionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: TermsAndConditionsStore }, { type: TermsAndConditionQuery }, { type: LoggingService }] });

let EarnPointsStore = class EarnPointsStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsStore, providedIn: 'root' }); }
};
EarnPointsStore = __decorate([
    StoreConfig({ name: 'earn-points', idKey: 'SectionId' })
], EarnPointsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class EarnPointsService {
    constructor(earnPointsStore, api, logService) {
        this.earnPointsStore = earnPointsStore;
        this.api = api;
        this.logService = logService;
    }
    /** Fetch all earn points and put them in the store.
     *
     * @param populationId population variant added onto call
     * @param lcid language variant to be displayed
     */
    fetchEarnPoints(populationId, lcid, clubId) {
        this.logService.debug(`Fetching Earn Points`);
        const request$ = this.api
            .get(`content/EarnPoints?clubId=${clubId}&lcid=${lcid}&populationId=${populationId}`)
            .pipe(tap((earnPoints) => {
            this.earnPointsStore.set(earnPoints);
        }));
        return cacheable(this.earnPointsStore, request$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsService, deps: [{ token: EarnPointsStore }, { token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: EarnPointsStore }, { type: ApiService }, { type: LoggingService }] });

class EarnPointsQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsQuery, deps: [{ token: EarnPointsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EarnPointsQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: EarnPointsStore }] });

let FaqSectionStore = class FaqSectionStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionStore, providedIn: 'root' }); }
};
FaqSectionStore = __decorate([
    StoreConfig({ name: 'faq-section', idKey: 'SectionId' })
], FaqSectionStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class FaqSectionService {
    constructor(FaqSectionStore, api, logService) {
        this.FaqSectionStore = FaqSectionStore;
        this.api = api;
        this.logService = logService;
    }
    /** Fetch all faqs and put them in the store.
     *
     * @param populationId population variant added onto call
     * @param lcid language variant to be displayed
     */
    fetchFaqSection(populationId, lcid, clubId) {
        this.logService.debug(`Fetching FAQs`);
        const request$ = this.api
            .get(`content/FAQs?clubId=${clubId}&lcid=${lcid}&populationId=${populationId}`)
            .pipe(tap((faqSection) => {
            this.FaqSectionStore.upsertMany(faqSection);
        }));
        return cacheable(this.FaqSectionStore, request$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionService, deps: [{ token: FaqSectionStore }, { token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FaqSectionStore }, { type: ApiService }, { type: LoggingService }] });

class FaqSectionQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionQuery, deps: [{ token: FaqSectionStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FaqSectionQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FaqSectionStore }] });

// tslint:disable: variable-name

// tslint:disable: variable-name
class CallBackModel {
    constructor(responseString, queryString, headers = {}) {
        this.ResponseString = responseString;
        this.QueryString = queryString;
        this.Headers = headers;
    }
}

const CARD_TOKEN_MOCK_DEFAULT = {
    TokenId: 0,
    PortalId: 'PortalID',
    ClubId: 0,
    CardToken: 'CardToken',
    ExpiryDate: null,
    CardType: 0,
    CardNumber: '4111111111111111',
    IsDefaultToken: true,
    Frozen: false,
};
const CARD_TOKEN_MOCK_OTHERS = [
    {
        TokenId: 0,
        PortalId: 'PortalID',
        ClubId: 0,
        CardToken: 'CardToken2',
        ExpiryDate: null,
        CardType: 0,
        CardNumber: '4111111111111112',
        IsDefaultToken: false,
        Frozen: false,
    },
    {
        TokenId: 0,
        PortalId: 'PortalID',
        ClubId: 0,
        CardToken: 'CardTokenFrozen',
        ExpiryDate: null,
        CardType: 0,
        CardNumber: '4111111111111113',
        IsDefaultToken: false,
        Frozen: true,
    },
];

class ProviderUiActionResponse {
}
class ProviderActionModel {
}
var ProviderActionKind;
(function (ProviderActionKind) {
    /// No Action is required
    ProviderActionKind[ProviderActionKind["None"] = 0] = "None";
    /// Post Form using the Form
    ProviderActionKind[ProviderActionKind["PostForm"] = 1] = "PostForm";
    /// Redirect using the URL
    ProviderActionKind[ProviderActionKind["RedirectUrl"] = 2] = "RedirectUrl";
    /// Create IFrame Modal using the URL
    ProviderActionKind[ProviderActionKind["IframeModalRedirect"] = 3] = "IframeModalRedirect";
    /// Create IFrame Modal post using the url
    ProviderActionKind[ProviderActionKind["IframeModalPostRedirect"] = 4] = "IframeModalPostRedirect";
    /// Create IFrame using the URL
    ProviderActionKind[ProviderActionKind["IframeRedirect"] = 5] = "IframeRedirect";
    /// Create IFrame post using the url
    ProviderActionKind[ProviderActionKind["IframePostRedirect"] = 6] = "IframePostRedirect";
    /// Render Content to the page
    ProviderActionKind[ProviderActionKind["RenderContent"] = 7] = "RenderContent";
    /// Render the Content to an IFrame
    ProviderActionKind[ProviderActionKind["RenderContentToIFrame"] = 8] = "RenderContentToIFrame";
})(ProviderActionKind || (ProviderActionKind = {}));
var ProviderNextActionKind;
(function (ProviderNextActionKind) {
    /// No Action Required
    ProviderNextActionKind[ProviderNextActionKind["None"] = 0] = "None";
    /// Need to make contact with the payment gateway
    ProviderNextActionKind[ProviderNextActionKind["ContactPaymentGateway"] = 10] = "ContactPaymentGateway";
    /// Require more information about shipping
    ProviderNextActionKind[ProviderNextActionKind["RequireShippingInformation"] = 20] = "RequireShippingInformation";
    /// Require customer to provide address information
    ProviderNextActionKind[ProviderNextActionKind["RequireAddressInformation"] = 30] = "RequireAddressInformation";
    /// Validate the user's address before proceeding with purchase
    ProviderNextActionKind[ProviderNextActionKind["ValidateDefaultAddressUponPurchase"] = 40] = "ValidateDefaultAddressUponPurchase";
})(ProviderNextActionKind || (ProviderNextActionKind = {}));

const PROVIDER_RESPONSE_SUCCESS_MOCK = {
    Success: true,
    OrderId: '12345',
    Amount: 5,
    ErrorCode: '',
    ErrorMessage: '',
    ProviderActionInformation: {
        FormId: '',
        Form: '',
        Url: '',
        TargetName: '',
        ActionKind: 0,
        NextAction: 0,
        Scripts: [''],
        Javascript: '',
    }
};
const PROVIDER_RESPONSE_NEED_SHIPPING_MOCK = {
    Success: false,
    OrderId: '12345',
    Amount: 5,
    ErrorCode: '',
    ErrorMessage: '',
    ProviderActionInformation: {
        FormId: '',
        Form: '',
        Url: '',
        TargetName: '',
        ActionKind: 0,
        NextAction: 20,
        Scripts: [''],
        Javascript: '',
    }
};
const PROVIDER_RESPONSE_NEED_ADDRESS_MOCK = {
    Success: false,
    OrderId: '12345',
    Amount: 5,
    ErrorCode: '',
    ErrorMessage: '',
    ProviderActionInformation: {
        FormId: '',
        Form: '',
        Url: '',
        TargetName: '',
        ActionKind: 0,
        NextAction: 40,
        Scripts: [''],
        Javascript: '',
    }
};
const PROVIDER_RESPONSE_ERROR_MOCK = {
    Success: false,
    OrderId: '12345',
    Amount: 5,
    ErrorCode: '404',
    ErrorMessage: 'Item Not Found',
    ProviderActionInformation: {
        FormId: '',
        Form: '',
        Url: '',
        TargetName: '',
        ActionKind: 0,
        NextAction: 0,
        Scripts: [''],
        Javascript: '',
    }
};

class TopUpViewModel {
    constructor(acn, amount, portalId, memberId, successUrl, failureUrl) {
        this.acn = acn;
        this.amount = amount;
        this.portalId = portalId;
        this.memberId = memberId;
        this.successUrl = successUrl;
        this.failureUrl = failureUrl;
    }
}

var TopUpAmountTypeId;
(function (TopUpAmountTypeId) {
    TopUpAmountTypeId[TopUpAmountTypeId["TopUpAmount"] = 1] = "TopUpAmount";
    TopUpAmountTypeId[TopUpAmountTypeId["AutoTopUpThreshHold"] = 2] = "AutoTopUpThreshHold";
    TopUpAmountTypeId[TopUpAmountTypeId["AutoTopUpTopUpAmount"] = 3] = "AutoTopUpTopUpAmount";
    TopUpAmountTypeId[TopUpAmountTypeId["TransferAmounts"] = 4] = "TransferAmounts";
    TopUpAmountTypeId[TopUpAmountTypeId["TopUpTicketAmount"] = 5] = "TopUpTicketAmount";
    TopUpAmountTypeId[TopUpAmountTypeId["TopUpMobile"] = 6] = "TopUpMobile";
    TopUpAmountTypeId[TopUpAmountTypeId["CharityDonation"] = 7] = "CharityDonation";
})(TopUpAmountTypeId || (TopUpAmountTypeId = {}));

class EcashTransferViewModel {
    constructor(MemberId, ToMemberId, Amount, PurseNumber, ClubId) {
        this.MemberId = MemberId;
        this.ToMemberId = ToMemberId;
        this.Amount = Amount;
        this.PurseNumber = PurseNumber;
        this.ClubId = ClubId;
    }
}

/**
 * A factory function that creates RenewalBonus
 */
function createRenewalBonus(params) {
    return {};
}

let CardTokenStore = class CardTokenStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenStore, providedIn: 'root' }); }
};
CardTokenStore = __decorate([
    StoreConfig({ name: 'card-token', idKey: 'TokenId', cache: { ttl: 20000 } })
], CardTokenStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CardTokenQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All card tokens. */
    selectCard() {
        return this.selectAll();
    }
    /** The default card token. */
    selectDefaultCard() {
        return this.selectActive().pipe(map(x => (Array.isArray(x) ? x[0] : x)));
    }
    /** All card tokens except the default card token. */
    selectExceptDefaultCard() {
        return this.selectAll({ filterBy: entity => !entity.IsDefaultToken });
    }
    /** All frozen card tokens. */
    selectFrozenCards() {
        return this.selectAll({ filterBy: card => card.Frozen });
    }
    /** All unfrozen card tokens. */
    selectUnfrozenCards() {
        return this.selectAll({ filterBy: card => !card.Frozen });
    }
    /** All expired card tokens. */
    selectExpiredCards() {
        return this.selectAll({
            filterBy: card => {
                if (!card.ExpiryDate) {
                    return false;
                }
                return new Date(card.ExpiryDate) < new Date();
            }
        });
    }
    /** All unexpired card tokens. */
    selectUnexpiredCards() {
        return this.selectAll({
            filterBy: card => {
                if (!card.ExpiryDate) {
                    return true;
                }
                return new Date(card.ExpiryDate) >= new Date();
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenQuery, deps: [{ token: CardTokenStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardTokenStore }] });

// tslint:disable: no-eval : JavaScript is returned from the API due to legacy support for Portal V3
class PaymentService {
    constructor(router, logService) {
        this.router = router;
        this.logService = logService;
        this.scripts = {};
    }
    /** Loads an external script with a new <script> tag. */
    loadScript(name) {
        this.logService.info('Loading script:', name);
        return new Promise((resolve, reject) => {
            if (this.scripts[name] == null) {
                this.scripts[name] = { loaded: false, src: name };
            }
            if (this.scripts[name].loaded) {
                this.logService.info('    Script has already been previously loaded, skipping...');
                resolve({ script: name, loaded: true, status: 'Already loaded' });
            }
            else {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = name;
                script.onload = () => {
                    this.scripts[name].loaded = true;
                    this.logService.info('    Script loaded successfully');
                    resolve({ script: name, loaded: true, status: 'Loaded' });
                };
                script.onerror = (error) => {
                    this.scripts[name].loaded = false;
                    script.remove();
                    reject({ script: name, loaded: false, status: JSON.stringify(error) });
                };
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }
    /** Process a provider UI action response from the API. */
    process(paymentResponse, divName, failureUrl = '/ecashfailure') {
        this.logService.info('Processing payment response...', ProviderActionKind[paymentResponse.ProviderActionInformation.ActionKind]);
        this.logService.debug('ProviderUiActionResult:', paymentResponse);
        if (paymentResponse.Success) {
            switch (paymentResponse.ProviderActionInformation.ActionKind) {
                case ProviderActionKind.PostForm:
                    this._providerActionResponsePostForm(paymentResponse, divName);
                    break;
                case ProviderActionKind.RedirectUrl:
                    window.location.href = paymentResponse.ProviderActionInformation.Url;
                    break;
                case ProviderActionKind.RenderContent:
                    this._providerActionResponseRenderContent(paymentResponse, divName);
                    break;
                case ProviderActionKind.IframeRedirect:
                    this._providerActionResponseIFrameRedirect(paymentResponse, divName);
                    break;
                default:
                    throw new Error(`No matching handler case found for ActionKind: '${ProviderActionKind[paymentResponse.ProviderActionInformation.ActionKind]}'`);
            }
        }
        else {
            this.logService.info('Provider response was not successful');
            this.router.navigate([failureUrl], {
                queryParams: { reasonId: paymentResponse.ErrorCode }
            });
        }
    }
    // Private Response Actions Helper Methods
    _providerActionResponsePostForm(paymentResponse, divName) {
        let pageForm = document.getElementById(divName);
        if (pageForm) {
            pageForm.innerHTML = paymentResponse.ProviderActionInformation.Form;
        }
        let renderForm = document.getElementById(paymentResponse.ProviderActionInformation.FormId);
        renderForm.submit();
    }
    _providerActionResponseIFrameRedirect(paymentResponse, divName) {
        let targetDivName = divName;
        if (targetDivName == null || targetDivName === '') {
            targetDivName = paymentResponse.ProviderActionInformation.TargetName;
        }
        let pageForm = document.getElementById(targetDivName);
        if (pageForm == null) {
            pageForm = document.getElementById(paymentResponse.ProviderActionInformation.TargetName);
        }
        if (pageForm) {
            pageForm.innerHTML = "<iframe id='" + paymentResponse.ProviderActionInformation.FormId + "' frameborder=0 src='" + paymentResponse.ProviderActionInformation.Url + "'></iframe>";
        }
        if (paymentResponse.ProviderActionInformation.Scripts && paymentResponse.ProviderActionInformation.Scripts.length > 0) {
            let promises = paymentResponse.ProviderActionInformation.Scripts.map(x => this.loadScript(x));
            Promise.all(promises)
                .then(() => {
                eval(paymentResponse.ProviderActionInformation.Javascript);
            })
                .catch(reason => {
                this.logService.error('Error loading external script(s):', reason);
            });
        }
        else {
            eval(paymentResponse.ProviderActionInformation.Javascript);
        }
    }
    _providerActionResponseRenderContent(paymentResponse, divName) {
        let lastItem = null;
        let targetDivName = divName;
        if (targetDivName == null || targetDivName === '') {
            targetDivName = paymentResponse.ProviderActionInformation.TargetName;
        }
        if (targetDivName != null && targetDivName !== '') {
            lastItem = document.getElementById(targetDivName);
            if (lastItem) {
                lastItem.innerHTML = paymentResponse.ProviderActionInformation.Form;
            }
        }
        if (paymentResponse.ProviderActionInformation.Scripts && paymentResponse.ProviderActionInformation.Scripts.length > 0) {
            let promises = paymentResponse.ProviderActionInformation.Scripts.map(x => this.loadScript(x));
            Promise.all(promises)
                .then(() => {
                eval(paymentResponse.ProviderActionInformation.Javascript);
            })
                .catch(reason => {
                this.logService.error('Error loading external script(s):', reason);
            });
        }
        else {
            eval(paymentResponse.ProviderActionInformation.Javascript);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PaymentService, deps: [{ token: i2.Router }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PaymentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PaymentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.Router }, { type: LoggingService }] });

//FIXME: needs to be refactored along with API to use TillTransactionAPI to check for card token.
class CardTokenService {
    constructor(cardTokenStore, cardTokenQuery, api, logService, paymentService) {
        this.cardTokenStore = cardTokenStore;
        this.cardTokenQuery = cardTokenQuery;
        this.api = api;
        this.logService = logService;
        this.paymentService = paymentService;
    }
    /** Fetches the payment card tokens and puts them in the store. */
    fetchCardTokens(ignoreCache = false) {
        const request$ = this.api.get('cardtokens').pipe(tap((cardTokens) => this.cardTokenStore.set(cardTokens)), mapTo(null));
        if (ignoreCache) {
            return request$;
        }
        return this.cardTokenQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetches the default payment card token, puts it in store and marks it as the active card token. */
    fetchDefaultCardToken() {
        return this.api.getAnySingle('cardtokens/default').pipe(tap((cardToken) => {
            if (cardToken) {
                applyTransaction(() => {
                    this.cardTokenStore.upsert(cardToken.TokenId, cardToken);
                    this.cardTokenStore.setActive(cardToken.TokenId);
                });
            }
            else {
                this.cardTokenStore.removeActive(this.cardTokenQuery.getActiveId());
            }
        }), mapTo(null));
    }
    /** Makes a request to add a new payment card token. */
    addNewCardToken(provider, redirectUrl, formName = 'topUpForm', failureUrl = '/ecashfailure') {
        this.logService.debug('Adding a new card token', { provider, redirectUrl, formName, failureUrl });
        return firstValueFrom(this.api
            .post('cardtokens/cardtokens', { provider, redirectUrl, failureUrl })
            .pipe(tap(() => {
            this.fetchCardTokens(true);
            this.fetchDefaultCardToken();
        })))
            .then((response) => {
            this.paymentService.process(response, formName, failureUrl);
            return response;
        });
    }
    /** Sets a given payment card token ID as the primary card token. */
    setCardAsDefault(cardTokenId) {
        this.logService.debug('Setting card token as default', cardTokenId);
        this.api
            .put('cardtokens/default', cardTokenId, '')
            .pipe(withTransaction(() => {
            this.cardTokenStore.setActive(cardTokenId);
            this.cardTokenStore.update(null, { IsDefaultToken: false, Frozen: false });
            this.cardTokenStore.update(cardTokenId, { IsDefaultToken: true });
        }), mapTo(null), catchError((error) => {
            this.logService.error('Failed to set card as primary.', error);
            throw error;
        }))
            .toPromise();
    }
    /** Freezes a given payment card token by ID. */
    setCardTokenFrozenState(cardTokenId, frozen) {
        this.logService.debug('Set card token frozen state to ' + frozen, cardTokenId);
        this.api
            .put('cardtokens/' + cardTokenId + '/freeze', frozen ? 1 : 0, '')
            .pipe(switchMap(() => this.cardTokenQuery.selectCard()), 
        // Change the matching card token to be frozen in the store
        map((cardTokens) => {
            let updatedCardTokens = JSON.parse(JSON.stringify(cardTokens));
            return updatedCardTokens.filter((cardToken) => {
                if (cardToken.TokenId === cardTokenId) {
                    cardToken.Frozen = frozen;
                }
                return cardToken;
            });
        }), tap((cardTokens) => this.cardTokenStore.set(cardTokens)), mapTo(null))
            .toPromise();
    }
    /** Deletes a given payment card token by ID. */
    deleteCardToken(cardTokenId) {
        this.logService.debug('Deleting card token', cardTokenId);
        this.api
            .delete('cardtokens', cardTokenId)
            .pipe(tap(() => this.cardTokenStore.remove(cardTokenId)), mapTo(null))
            .toPromise();
    }
    setCardTokenStatus(status) {
        this.logService.debug(`Setting card token cashback status to ${status}`);
        return firstValueFrom(this.api.post(`cardtokens/ecash/status/${status}`, {}).pipe(mapTo(null), catchError((error) => {
            this.logService.error(`Failed to set card token cashback status as ${status}`, error);
            throw error;
        })));
    }
    fetchCardTokenStatus() {
        this.logService.debug('Getting card token cashback status');
        const request$ = this.api.getAnySingle('cardtokens/ecash/status');
        return request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenService, deps: [{ token: CardTokenStore }, { token: CardTokenQuery }, { token: ApiService }, { token: LoggingService }, { token: PaymentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardTokenStore }, { type: CardTokenQuery }, { type: ApiService }, { type: LoggingService }, { type: PaymentService }] });

class CardTokenResolver {
    constructor(cardTokenService, loggingService) {
        this.cardTokenService = cardTokenService;
        this.loggingService = loggingService;
    }
    resolve() {
        this.loggingService.info('Resolving card tokens...');
        return combineLatest([this.cardTokenService.fetchCardTokens(), this.cardTokenService.fetchDefaultCardToken()]).pipe(mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenResolver, deps: [{ token: CardTokenService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardTokenResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardTokenService }, { type: LoggingService }] });

class TopupTicketStore {
    constructor() {
        this.tickets = new BehaviorSubject([]);
        this.tickets$ = this.tickets.asObservable();
        this.topUpTickets = new BehaviorSubject([]);
        this.topUpTickets$ = this.topUpTickets.asObservable();
        this.topUpAmounts = new BehaviorSubject([]);
        this.topUpAmounts$ = this.topUpAmounts.asObservable();
    }
    setTopUpAmounts(amounts) {
        this.topUpAmounts.next(amounts);
    }
    setTickets(tickets) {
        this.tickets.next(tickets);
    }
    addOrUpdateTicket(ticket) {
        this.tickets$
            .pipe(take(1))
            .subscribe(val => {
            const index = val.findIndex(t => t.BarcodeText === ticket.BarcodeText);
            if (index === -1) {
                const newArr = [...val, ticket];
                this.tickets.next(newArr);
            }
            else {
                val[index] = ticket;
                this.tickets.next(val);
            }
        });
    }
    removeTicket(barcodeText) {
        this.tickets$
            .pipe(take(1))
            .subscribe(val => {
            const index = val.findIndex(t => t.BarcodeText === barcodeText);
            if (index !== -1) {
                val.splice(index, 1);
                this.tickets.next(val);
            }
        });
    }
    clearAllTickets() {
        this.tickets.next(new Array());
        this.clearAllTopUpTickets();
    }
    addOrUpdateTopUpTicket(topUpTicket) {
        this.topUpTickets$
            .pipe(take(1))
            .subscribe(val => {
            const index = val.findIndex(t => t.barcodeText === topUpTicket.barcodeText);
            if (index === -1) {
                // Doesn't exist add new
                const newArr = [...val, topUpTicket];
                this.topUpTickets.next(newArr);
            }
            else {
                // Does exist update
                val[index] = topUpTicket;
                this.topUpTickets.next(val);
            }
        });
    }
    removeTopUpTicket(barcodeText) {
        this.topUpTickets$
            .pipe(take(1))
            .subscribe(val => {
            const index = val.findIndex(t => t.barcodeText === barcodeText);
            if (index !== -1) {
                val.splice(index, 1);
                this.topUpTickets.next(val);
            }
        });
    }
    clearAllTopUpTickets() {
        this.topUpTickets.next(new Array());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class EcashService {
    constructor(api, logService, paymentService, topupTicketStore) {
        this.api = api;
        this.logService = logService;
        this.paymentService = paymentService;
        this.topupTicketStore = topupTicketStore;
    }
    getTopUpAmounts(topUpAmountId) {
        return this.api.getById('topup/TopUpAmounts', topUpAmountId.toString()).pipe(
        // Convert returned values in pence to pounds
        tap(amounts => {
            this.topupTicketStore.setTopUpAmounts(amounts.map(amount => amount / 100));
        }));
    }
    topUp(topUp) {
        this.logService.debug('Making request for top up', topUp);
        this.api.post('topup/topup', topUp)
            .subscribe(response => this.paymentService.process(response, '', '/ecash/failure'));
    }
    callBack(callback) {
        this.logService.debug('Ecash callback received', callback);
        return this.api.post('topup/result', callback);
    }
    transferEcash(data) {
        this.logService.debug('Transferring ecash', data);
        return this.api.post('purse/transfer', data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EcashService, deps: [{ token: ApiService }, { token: LoggingService }, { token: PaymentService }, { token: TopupTicketStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EcashService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EcashService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: LoggingService }, { type: PaymentService }, { type: TopupTicketStore }] });

let AutoTopupStore = class AutoTopupStore extends Store {
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupStore, providedIn: 'root' }); }
};
AutoTopupStore = __decorate([
    StoreConfig({ name: 'auto-topup' })
], AutoTopupStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AutoTopupQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupQuery, deps: [{ token: AutoTopupStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AutoTopupStore }] });

class AutoTopupService {
    constructor(autoTopupStore, paymentService, logService, api) {
        this.autoTopupStore = autoTopupStore;
        this.paymentService = paymentService;
        this.logService = logService;
        this.api = api;
    }
    fetchAutoTopUpSubscriptions() {
        return this.api
            .getAnySingle('autoTopUp/subscriptions')
            .pipe(tap(entity => this.autoTopupStore.update(entity)));
    }
    autoTopUp(autoTopUp) {
        this.logService.debug('Making request for auto top up', autoTopUp);
        this.api
            .post('autoTopUp/topup', autoTopUp)
            .subscribe(response => this.paymentService.process(response, '', '/ecash/failure'));
    }
    deleteSubscription(model) {
        return this.api.post('autoTopUp/delete', model).pipe(tap(() => this.autoTopupStore.update({
            AutoTopUpItems: [{ ...model, HasSubscription: false }]
        })));
    }
    updateSubscription(model) {
        return this.api.put('autoTopUp', '', model).pipe(tap(() => this.autoTopupStore.update({
            AutoTopUpItems: [model]
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupService, deps: [{ token: AutoTopupStore }, { token: PaymentService }, { token: LoggingService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AutoTopupService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AutoTopupStore }, { type: PaymentService }, { type: LoggingService }, { type: ApiService }] });

/**
 * This renewal bonus credit service will make a request to an endpoint responsible for
 * retrieving the renewal bonus purse balance, as well as the all other purse balances.
 * It must be passed with the externalRef of the user and will return the purse balances of all members
 * linked to the supplied externalRef.
 */
class RenewalBonusService {
    constructor(balanceStore, api, memberQuery) {
        this.balanceStore = balanceStore;
        this.api = api;
        this.memberQuery = memberQuery;
    }
    /**
     * @returns This method will get the current users external ref, which will be passed to the required endpoint.
     * This will also update the balance store for purse number 5 (renewal bonus credit) with the balance
     * received from the response.
     */
    getRenewalBonusData() {
        let currentMember = this.memberQuery.getUserContext();
        let externalRef = currentMember.externalRef;
        return this.api.getAnySingle('bonuscredit/accountpursebalance?externalRef=' + externalRef).pipe(tap((entities) => {
            let renewalBonus = entities.Members.filter((member) => member.MemberID === currentMember.memberId)[0].RenewalBalanceInPence / 100;
            this.balanceStore.upsert(currentMember.memberId + '-5', {
                purseId: config.purseConfig.renewalGift,
                memberId: currentMember.memberId || '',
                balance: renewalBonus,
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RenewalBonusService, deps: [{ token: BalanceStore }, { token: ApiService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RenewalBonusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RenewalBonusService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BalanceStore }, { type: ApiService }, { type: MemberQuery }] });

var GameDataSource;
(function (GameDataSource) {
    GameDataSource[GameDataSource["Club"] = 0] = "Club";
    GameDataSource[GameDataSource["ExternalRef"] = 1] = "ExternalRef";
    GameDataSource[GameDataSource["MemberId"] = 2] = "MemberId";
})(GameDataSource || (GameDataSource = {}));

const GAME_MOCK = {
    AwayTeamId: -1,
    Date: '2021-05-01T13:05:00',
    EventTypeId: 1,
    GameNumber: 2,
    GameType: 0,
    HomeTeamId: -1,
    ProductCode: 'TEST01',
    ProductType: 0,
    ProductTypeId: 4,
    ProductTypeName: 'Test game GA',
    SeasonId: 8,
    TeamNames: { HomeTeamName: 'Team1', AwayTeamName: 'Team2' },
    Teams: 'Team1 v Team2',
    Title: 'Test Game',
    TicketsAvailableToTransfer: 0,
    TicketsTransferred: 0,
    TicketsPending: 0,
    WindowStartDate: '2021-05-01T13:05:00',
    WindowEndDate: '2021-05-01T13:05:00',
    dataSource: 0,
    id: 'h1pimkthu5h',
};

class EventsService {
    constructor(api) {
        this.api = api;
        this._eventWithTickets = new ReplaySubject(1);
        this.eventWithTickets$ = this._eventWithTickets.asObservable();
    }
    set eventWithTickets(eventWithTickets) {
        this._eventWithTickets.next(eventWithTickets);
    }
    getEvents() {
        return this.api.get('events?startDate=' + formatDate(Date.now(), 'yyyyMMdd', 'en-GB'));
    }
    getCurrentOrNext() {
        return this.api.getAnySingle('events/current?dataSource=club');
    }
    async getEventsWithTickets() {
        let result = await firstValueFrom(this.api.get('events/eventsWithTickets'));
        this.eventWithTickets = result;
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EventsService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EventsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: EventsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }] });

let GameStore = class GameStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameStore, providedIn: 'root' }); }
};
GameStore = __decorate([
    StoreConfig({ name: 'game', cache: { ttl: 20000 } })
], GameStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

var TicketMediaType;
(function (TicketMediaType) {
    TicketMediaType[TicketMediaType["CARD"] = 0] = "CARD";
    TicketMediaType[TicketMediaType["BARCODETICKET"] = 1] = "BARCODETICKET";
    TicketMediaType[TicketMediaType["PAPERTICKET"] = 2] = "PAPERTICKET";
})(TicketMediaType || (TicketMediaType = {}));
var TicketFlag;
(function (TicketFlag) {
    TicketFlag[TicketFlag["ACTIVE"] = 0] = "ACTIVE";
    TicketFlag[TicketFlag["EXTERNALBARCODE"] = 4] = "EXTERNALBARCODE";
    TicketFlag[TicketFlag["TRANSFERRED"] = 8] = "TRANSFERRED";
    TicketFlag[TicketFlag["CALLBACK"] = 16] = "CALLBACK";
    TicketFlag[TicketFlag["PENDING"] = 32] = "PENDING";
    TicketFlag[TicketFlag["ONSALE"] = 2048] = "ONSALE";
    TicketFlag[TicketFlag["SOLD"] = 4096] = "SOLD";
    TicketFlag[TicketFlag["DONATED"] = 32768] = "DONATED";
    TicketFlag[TicketFlag["DISTRIBUTED"] = 65536] = "DISTRIBUTED";
    TicketFlag[TicketFlag["SHARED"] = 262144] = "SHARED";
})(TicketFlag || (TicketFlag = {}));
var TicketActionType;
(function (TicketActionType) {
    TicketActionType[TicketActionType["TransferToEmail"] = 0] = "TransferToEmail";
    TicketActionType[TicketActionType["TransferToMember"] = 1] = "TransferToMember";
    TicketActionType[TicketActionType["Resell"] = 2] = "Resell";
    TicketActionType[TicketActionType["Donate"] = 3] = "Donate";
    TicketActionType[TicketActionType["Upgrade"] = 4] = "Upgrade";
    TicketActionType[TicketActionType["Callback"] = 5] = "Callback";
})(TicketActionType || (TicketActionType = {}));

let TicketStore = class TicketStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketStore, providedIn: 'root' }); }
};
TicketStore = __decorate([
    StoreConfig({ name: 'ticket', idKey: 'Id', cache: { ttl: 120000 } })
], TicketStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TicketQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectAllTickets() {
        return this.selectAll();
    }
    getTicketInformation(gameNumber) {
        let ticketInfo = {
            TicketsAvailableToTransfer: this.getCount((ticket) => ticket.GameNumber === gameNumber && ticket.Flag === TicketFlag.ACTIVE && ticket.MediaType === TicketMediaType.CARD),
            TicketsTransferred: this.getCount((ticket) => ticket.GameNumber === gameNumber &&
                TicketFlag.TRANSFERRED === this.checkFlag(ticket.Flag, TicketFlag.TRANSFERRED) &&
                ticket.MediaType === TicketMediaType.CARD),
            WindowEndDate: this.getAll({
                filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.IsCallbackAllowed && ticket.IsTransferToEmailAllowed,
            }).map((ticket) => {
                return ticket.EndTime;
            })[0],
            WindowStartDate: this.getAll({
                filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.IsCallbackAllowed && ticket.IsTransferToEmailAllowed,
            }).map((ticket) => {
                return ticket.StartTime;
            })[0],
        };
        return ticketInfo;
    }
    selectTicketsForGame(gameNumber) {
        return this.selectAll({
            filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.MediaType === TicketMediaType.CARD,
        });
    }
    selectedTickets() {
        return this.selectAll({ filterBy: (ticket) => ticket.selected });
    }
    selectTransferredTickets() {
        return this.selectAll({ filterBy: (ticket) => ticket.Transferred });
    }
    selectTransferredTicketsForGame(gameNumber) {
        return this.selectAll({
            filterBy: (ticket) => ticket.GameNumber === gameNumber && TicketFlag.TRANSFERRED === this.checkFlag(ticket.Flag, TicketFlag.TRANSFERRED),
        });
    }
    selectAvaialbleTicketsForGame(gameNumber) {
        return this.selectAll({ filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.Flag === TicketFlag.ACTIVE });
    }
    checkFlag(status, flag) {
        // tslint:disable-next-line: no-bitwise
        return status & flag;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketQuery, deps: [{ token: TicketStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TicketStore }] });

class GameQuery extends QueryEntity {
    constructor(store, ticketQuery) {
        super(store);
        this.store = store;
        this.ticketQuery = ticketQuery;
    }
    /**
     * Select all past and present games for the season.
     */
    selectAllGames() {
        return this.selectAll();
    }
    /**
     * Select all games filtered
     * by the given data source type.
     * @param dataSourceType type of game data
     * @returns the type of game data depending
     * on data source type passed.
     */
    selectAllGamesByDataSource(dataSourceType) {
        return this.selectAll({ filterBy: ({ dataSource }) => dataSource === dataSourceType });
    }
    /**
     * Select game by data source and game number.
     * @param dataSourceType data type of game
     * @param gameNumber game number of game
     * @returns returns the game by game number and data type.
     */
    selectGameByDataSourceAndGameNumber(dataSourceType, gameNumber) {
        return this.selectAll().pipe(map((games) => {
            if (!!games) {
                return games.filter((game) => game.dataSource === dataSourceType && game.GameNumber === gameNumber)[0];
            }
            return undefined;
        }));
    }
    /**
     * Will return the next game from the requested game date
     * type passed, e.g. if passed club type then this will
     * return the next game from the game data from the club.
     * @param dataSourceType required data source type for next game
     * @returns the next upcoming game for the season.
     */
    selectNextGame(dataSourceType) {
        return this.selectAllGamesByDataSource(dataSourceType).pipe(map((games) => {
            if (games.length === 0) {
                return null;
            }
            let gamesUpcoming = games.filter((game) => moment$1.utc(game.Date).isAfter(moment$1.utc().startOf('day')));
            gamesUpcoming = gamesUpcoming.sort((first, second) => moment$1(first.Date).diff(moment$1.utc(second.Date)));
            return gamesUpcoming[0];
        }));
    }
    /**
     * Select all past and present games for the season along with their ticket information.
     */
    selectGamesWithTickets(dataSourceType) {
        return this.selectAll({ filterBy: ({ dataSource }) => dataSource === dataSourceType }).pipe(map((games) => games.map((game) => {
            let ticketInfo = this.ticketQuery.getTicketInformation(game.GameNumber);
            return { ...game, ...ticketInfo };
        })), map((games) => {
            return this._getDistinctGames(games, 'GameNumber');
        }));
    }
    /**
     * Select all upcoming games with ticket data
     * @param dataSourceType required data source type for upcoming games
     * with ticket data defaulted to external ref dat
     * @returns list of upcoming games with ticket data
     */
    selectUpcomingGamesWithTicketData(dataSourceType = GameDataSource.ExternalRef) {
        return this.selectGamesWithTickets(dataSourceType).pipe(map((games) => games.filter((game) => moment$1.utc(game.Date).endOf('day').isAfter(moment$1.utc()))));
    }
    /**
     * Select all past games for the
     * season with ticket data.
     * @param dataSourceType required data source type for past games
     * with ticket data defaulted to external ref data
     * @returns list of past games with ticket data
     */
    selectPastGamesOnlyWithTicketData(dataSourceType = GameDataSource.ExternalRef) {
        return this.selectGamesWithTickets(dataSourceType).pipe(map((games) => games.filter((game) => moment$1.utc(game.Date).endOf('day').isBefore(moment$1.utc()))));
    }
    /**
     * Select upcoming games
     * with no ticket info
     * @param dataSourceType required data source type for upcoming games
     * without ticket data
     * @returns list of upcoming games without ticket data
     */
    selectUpcomingGames(dataSourceType) {
        return this.selectAllGamesByDataSource(dataSourceType).pipe(map((games) => games.filter((game) => moment$1.utc(game.Date).endOf('day').isAfter(moment$1.utc()))));
    }
    /**
     * Select past games
     * with no ticket info
     * @param dataSourceType required data source type for past games
     * without ticket data
     * @returns list of past games without ticket data
     */
    selectPastGames(dataSourceType) {
        return this.selectAllGamesByDataSource(dataSourceType).pipe(map((games) => games.filter((game) => moment$1.utc(game.Date).endOf('day').isBefore(moment$1.utc()))));
    }
    /**
     * Takes an array of Games and groups by Game Number, then selects first item
     */
    _getDistinctGames(data, key) {
        let grouping = data.reduce((object, value) => {
            object[value[key]] = object[value[key]] || value;
            return object;
        }, {});
        return Object.values(grouping);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameQuery, deps: [{ token: GameStore }, { token: TicketQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: GameStore }, { type: TicketQuery }] });

class GameService {
    constructor(gameStore, apiService, gameQuery) {
        this.gameStore = gameStore;
        this.apiService = apiService;
        this.gameQuery = gameQuery;
    }
    /**
     * Will fetch the game data depending
     * on the given game data source.
     * The game data will be added to the store
     * and set each games data source type.
     * If no data source passed, this will default
     * to member ID game data.
     * @param dataSource type of game data
     * @param startDate start date of data
     * @returns request to get data and add to store
     * or of(null) if data exists
     */
    fetchGames(startDate = '', dataSource = GameDataSource.MemberId) {
        let url = this.generateUrl(startDate, dataSource);
        const request$ = this.apiService.get(url).pipe(tap((games) => {
            games = this.setGameDataSource(games, dataSource);
            this.gameStore.add(games);
        }), mapTo(null));
        return this.gameDataExists(dataSource) ? of(null) : request$;
    }
    /**
     * This will generate the endpoint
     * depending on the game data source passed.
     * @param startDate
     * @param dataSource
     * @returns the url generated
     */
    generateUrl(startDate, dataSource) {
        let url = `events?startDate=${startDate}`;
        switch (dataSource) {
            case GameDataSource.Club:
                url = `${url}&dataSource=club`;
                break;
            case GameDataSource.ExternalRef:
                url = `${url}&dataSource=externalref`;
                break;
            case GameDataSource.MemberId:
                url = `${url}&dataSource=memberid`;
                break;
            default:
                break;
        }
        return url;
    }
    /**
     * This will set the data source
     * type of each game and the
     * random ID of the game.
     * @param games
     * @param dataSource
     * @returns This will return an array of games
     * which will have their random ID's set
     * and the data source type.
     */
    setGameDataSource(games, dataSource) {
        games.forEach((game) => {
            game.id = guid();
            switch (dataSource) {
                case GameDataSource.Club:
                    game.dataSource = GameDataSource.Club;
                    break;
                case GameDataSource.ExternalRef:
                    game.dataSource = GameDataSource.ExternalRef;
                    break;
                case GameDataSource.MemberId:
                    game.dataSource = GameDataSource.MemberId;
                    break;
                default:
                    game.dataSource = GameDataSource.MemberId;
                    break;
            }
        });
        return games;
    }
    /**
     * Check to see if game data of
     * given data source type
     * already exists within the
     * games store.
     * @param dataSourceType
     * @returns
     */
    gameDataExists(dataSourceType) {
        let dataExists = false;
        let games = this.gameQuery.getAll({ filterBy: ({ dataSource }) => dataSource === dataSourceType });
        if (games.length > 0) {
            dataExists = true;
        }
        return dataExists;
    }
    /**
     * Will fetch data if not cached but will also
     * set a game as active, for cases where
     * game banner is used in different places (which
     * depends on a acive game entity).
     * This will be called on parent component.
     * @param gameNumber game number of game
     * @param dataSourceType type of game data
     */
    fetchGamesAndSetActiveGame(gameNumber, dataSourceType) {
        this.fetchGames('', dataSourceType)
            .toPromise()
            .then(() => {
            this.gameQuery
                .selectGameByDataSourceAndGameNumber(dataSourceType, gameNumber)
                .subscribe((game) => {
                if (!!game) {
                    this.setActiveGame(game);
                }
            })
                .unsubscribe();
        });
    }
    /**
     * Set game entity as active.
     * @param game game to be active.
     */
    setActiveGame(game) {
        this.gameStore.setActive(game.id);
    }
    fetchGamesWithTickets() {
        return this.apiService.get('events/eventsandtickets');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameService, deps: [{ token: GameStore }, { token: ApiService }, { token: GameQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GameService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: GameStore }, { type: ApiService }, { type: GameQuery }] });

// tslint:disable: variable-name
class MobileAppRequest {
    constructor() {
        this.ClubID = config.defaultClubId,
            this.LanguageID = +config.defaultLcid,
            this.UniqID = Math.floor((Math.random() * 100) + 1);
    }
}

// tslint:disable: variable-name
class TransferFundsRequest {
    constructor(sourceMemberId, sourceAcn, targetMemberId, targetAccountId, amountInPence, targetEmailAddress) {
        this.RequestHeader = new MobileAppRequest();
        this.SourceMemberID = sourceMemberId;
        this.SourceACN = sourceAcn;
        this.TargetMemberID = targetMemberId;
        this.TargetAccountID = targetAccountId;
        this.AmountInPence = amountInPence;
        this.TargetEmailAddress = targetEmailAddress;
        this.TransRef = 'Transfer Funds';
    }
}

// tslint:disable: variable-name
class VerifyEmailAddressRequest {
    constructor() {
        this.RequestHeader = new MobileAppRequest();
    }
}

let ExternalCashTransferStore = class ExternalCashTransferStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferStore, providedIn: 'root' }); }
};
ExternalCashTransferStore = __decorate([
    StoreConfig({ name: 'ExternalCashTransfer', idKey: 'UniqID' })
], ExternalCashTransferStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class ExternalCashTransferQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** Select the last TransferAccounts */
    selectTransferAccounts() {
        return this.selectLast();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferQuery, deps: [{ token: ExternalCashTransferStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ExternalCashTransferStore }] });

class ExternalCashTransferService {
    constructor(externalTransferStore, api, memberQuery, errorService) {
        this.externalTransferStore = externalTransferStore;
        this.api = api;
        this.memberQuery = memberQuery;
        this.errorService = errorService;
    }
    /** Verify email address exists on external api */
    verifyEmailAddress(verifyEmailAddress) {
        this.externalTransferStore.setLoading(true);
        const request$ = this.api
            .post('provider/verifyexternalemail', verifyEmailAddress)
            .pipe(map((x) => x), tap((response) => {
            if (response === null) {
                return response;
            }
            response.TransferAmount = verifyEmailAddress.Amount;
            response.EmailAddress = verifyEmailAddress.EmailAddress;
            this.externalTransferStore.upsert(response.UniqID, response);
            return response;
        }));
        return request$;
    }
    /** Transfer funds from current account to target */
    transferFunds(transfer, selectedMemberId) {
        if (!selectedMemberId && transfer.Accounts[0].MemberIDs.length > 0) {
            selectedMemberId = transfer.Accounts[0].MemberIDs[0];
        }
        if (!selectedMemberId) {
            return new Observable();
        }
        let userContext = this.memberQuery.getValue().user;
        let transferRequest = new TransferFundsRequest(userContext.memberId, +userContext.externalRef, selectedMemberId, transfer.Accounts[0].AccountID, transfer.TransferAmount * 100, transfer.EmailAddress);
        const request$ = this.api.post('provider/transferfundsexternal', transferRequest).pipe(catchError((err) => {
            this.errorService.clearErrors();
            this.errorService.addError(err.error.toString());
            throw err;
        }), mapTo(null));
        return request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferService, deps: [{ token: ExternalCashTransferStore }, { token: ApiService }, { token: MemberQuery }, { token: ErrorStateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalCashTransferService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ExternalCashTransferStore }, { type: ApiService }, { type: MemberQuery }, { type: ErrorStateService }] });

const CHILD_REGISTRATION_MOCK = [
    {
        Id: 1,
        Gender: '',
        CardNumber: 1,
        GuardianId: 1,
        Firstname: '',
        Lastname: '',
        MemberId: '',
        Barcode: '',
        CardBarcode: '',
        ExternalRefNumber: '',
        AccountPaymentState: 1,
        DateOfBirth: new Date(),
        MembershipOptionId: 1,
        LastUpdate: new Date(),
        RegistrationId: 1,
        PortalId: '',
        IsAlreadyPaid: true,
    },
    {
        Id: 2,
        Gender: '',
        CardNumber: 1,
        GuardianId: 1,
        Firstname: '',
        Lastname: '',
        MemberId: '',
        Barcode: '',
        CardBarcode: '',
        ExternalRefNumber: '',
        AccountPaymentState: 1,
        DateOfBirth: new Date(),
        MembershipOptionId: 1,
        LastUpdate: new Date(),
        RegistrationId: 1,
        PortalId: '',
        IsAlreadyPaid: true,
    },
];

var GuardianFlags;
(function (GuardianFlags) {
    GuardianFlags[GuardianFlags["NONE"] = 0] = "NONE";
    GuardianFlags[GuardianFlags["IS_MEMBER"] = 1] = "IS_MEMBER";
    GuardianFlags[GuardianFlags["IS_SPECIAL_MEMBER"] = 2] = "IS_SPECIAL_MEMBER";
    GuardianFlags[GuardianFlags["INTRESTED_IN_SINGLE"] = 4] = "INTRESTED_IN_SINGLE";
    GuardianFlags[GuardianFlags["INTRESTED_IN_GROUP"] = 8] = "INTRESTED_IN_GROUP";
    GuardianFlags[GuardianFlags["INTRESTED_IN_SUITES"] = 16] = "INTRESTED_IN_SUITES";
    GuardianFlags[GuardianFlags["INTRESTED_IN_MEMBERSHIP"] = 32] = "INTRESTED_IN_MEMBERSHIP";
    GuardianFlags[GuardianFlags["RECIEVE_EMAIL_EVENTS"] = 1024] = "RECIEVE_EMAIL_EVENTS";
    GuardianFlags[GuardianFlags["RECIEVE_EMAIL_COMMERCIAL"] = 2048] = "RECIEVE_EMAIL_COMMERCIAL";
})(GuardianFlags || (GuardianFlags = {}));

class AuctionBid {
    constructor(auctionId, value) {
        this.auctionId = auctionId;
        this.value = value;
    }
}

// tslint:disable: no-bitwise
var ItemLoyaltyState;
(function (ItemLoyaltyState) {
    ItemLoyaltyState[ItemLoyaltyState["None"] = 0] = "None";
    ItemLoyaltyState[ItemLoyaltyState["ComingSoon"] = 1] = "ComingSoon";
    ItemLoyaltyState[ItemLoyaltyState["TestItem"] = 2] = "TestItem";
    ItemLoyaltyState[ItemLoyaltyState["AgeRestricted"] = 4] = "AgeRestricted";
    ItemLoyaltyState[ItemLoyaltyState["NotInPopulation"] = 8] = "NotInPopulation";
    ItemLoyaltyState[ItemLoyaltyState["OutOfStock"] = 16] = "OutOfStock";
    ItemLoyaltyState[ItemLoyaltyState["ItemLimitReached"] = 32] = "ItemLimitReached";
    ItemLoyaltyState[ItemLoyaltyState["ItemClosed"] = 128] = "ItemClosed";
    ItemLoyaltyState[ItemLoyaltyState["ItemNotStarted"] = 256] = "ItemNotStarted";
})(ItemLoyaltyState || (ItemLoyaltyState = {}));

class LottoItem {
    static [Symbol.hasInstance](instance) {
        return 'LottoId' in instance && typeof instance.LottoId === 'number';
    }
}
const LOTTO_TEXT_COLOR = {
    BLACK: 'text-rewards-black',
    RED: 'text-rewards-danger',
    GREEN: 'text-rewards-success',
    NEW: 'text-rewards-new',
};
const LOTTO_STATE = {
    LIMITED: 'lottos.limited.stock',
    FEATURED: 'lottos.featured.stock',
    REMAINING: 'lottos.panel.remaining.stock',
    NEW: 'lottos.new.stock',
    SOLD_OUT: 'lottos.sold.out',
    NOT_ENOUGH_POINT: 'lottos.not.enough',
    COMING_SOON: 'lottos.coming.soon',
    LIMIT_REACHED: 'lottos.limit.reached',
    VIEW: 'lottos.view',
    LOCKED: 'lottos.locked',
    ENTERED: 'lottos.entered',
};

var LoyaltyLimitType;
(function (LoyaltyLimitType) {
    LoyaltyLimitType[LoyaltyLimitType["NoLimit"] = 0] = "NoLimit";
    LoyaltyLimitType[LoyaltyLimitType["LimitByMember"] = 1] = "LimitByMember";
    LoyaltyLimitType[LoyaltyLimitType["LimitByAccount"] = 2] = "LimitByAccount";
})(LoyaltyLimitType || (LoyaltyLimitType = {}));

/* tslint:disable: variable-name */
/* Must directly match with the case-sensitive data returned from the API. */
class MarketplaceItem {
}
var MarketplaceItemLimitType;
(function (MarketplaceItemLimitType) {
    MarketplaceItemLimitType[MarketplaceItemLimitType["NoLimit"] = 0] = "NoLimit";
    MarketplaceItemLimitType[MarketplaceItemLimitType["LimitByMember"] = 1] = "LimitByMember";
    MarketplaceItemLimitType[MarketplaceItemLimitType["LimitByAccount"] = 2] = "LimitByAccount";
})(MarketplaceItemLimitType || (MarketplaceItemLimitType = {}));

const MARKETPLACE_ITEM_MOCK = {
    Id: 0,
    ClubId: 0,
    GameNumber: 0,
    PointValue: 5,
    EcashValue: 10,
    MerchantValue: 10,
    ProductItemId: 0,
    AvailableCount: 0,
    Active: true,
    StockCount: 100,
    AllowOne: false,
    TestOnly: false,
    Favourite: false,
    ComingSoon: false,
    ItemLimitCount: 0,
    ItemLimitType: 0,
    LimitCount: 0,
    LimitType: 0,
    IsOwnWindow: false,
    ItemStartDate: '',
    ItemEndDate: '',
    SoldCount: 0,
    AvailabilityCount: 90,
    MaxQuantity: 0,
    DisplayName: 'Item Mock Name',
    DescriptionText: 'Item mock description',
    ShortDescription: '',
    TermsAndConditions: '',
    ShowTermsAndConditions: false,
    TermsAndConditionsType: 0,
    ProductName: '',
    ImageURL: '',
    ThumbnailURL: '',
    ItemImageURL: 'assets/images/placeholders/404placeholder.svg',
    ItemThumbnailURL: '',
    ProductType: 0,
    ItemPopulationType: 0,
    AddedAdminId: 0,
    UpdatedAdminId: 0,
    Ordinal: 0,
    EmailText: '',
    PurchaseAllowed: true,
    MemberPurchaseCount: 0,
    AccountPurchaseCount: 0,
    ProcessProviderId: -1,
    NumberOfAvailableVouchers: null,
    EmailCategoryId: 0,
    ShippingEnabled: 0,
    ShippingMethods: [],
    ShippingFeeInMerchant: 0,
    ShippingFeeInEcash: 0,
    ExpiresAfter: null,
    ExpirationEndDate: null,
    RequestTime: '',
    IsAdminUser: false,
    StockType: 0,
    Attributes: [],
    AttributeMappings: [],
    theme: 'marketplace',
    CustomFields: [],
    Status: 0,
    UnlimitedStock: false,
    Sponsor: {
        SponsorId: '1',
        SponsorText: 'samsung',
        SponsorImage: 'samsung-logo.jpg',
        SponsorLink: 'https://google.com',
    },
};

class MarketplaceVirtualEvent {
}

/* tslint:disable: variable-name */
/* Must directly match with the case-sensitive data returned from the API. */
class MarketplaceItemExtended extends MarketplaceItem {
    static [Symbol.hasInstance](instance) {
        return 'ProductItemId' in instance && typeof instance.ProductItemId === 'number';
    }
}

var MarketplaceItemStatus;
(function (MarketplaceItemStatus) {
    MarketplaceItemStatus[MarketplaceItemStatus["Available"] = 0] = "Available";
    MarketplaceItemStatus[MarketplaceItemStatus["SoldOut"] = 1] = "SoldOut";
    MarketplaceItemStatus[MarketplaceItemStatus["ComingSoon"] = 2] = "ComingSoon";
    MarketplaceItemStatus[MarketplaceItemStatus["NotEnoughPoints"] = 3] = "NotEnoughPoints";
    MarketplaceItemStatus[MarketplaceItemStatus["MemberLimitReached"] = 4] = "MemberLimitReached";
    MarketplaceItemStatus[MarketplaceItemStatus["AllInBasket"] = 5] = "AllInBasket";
})(MarketplaceItemStatus || (MarketplaceItemStatus = {}));
const ActionLabels = {
    AvailableItem: 'Buy Now',
    AvailableEvent: 'Book Now',
    SoldOut: 'Sold Out',
    ComingSoon: 'Coming Soon',
    NotEnoughPoints: 'Not Enough Points',
    MemberLimitReached: 'Limit Reached',
    AllInBasket: 'Already in Basket',
};
const TEXT_COLOR = {
    BLACK: 'text-rewards-black',
    RED: 'text-rewards-danger',
    GREEN: 'text-rewards-success',
    NEW: 'text-rewards-new',
};
const MARKETPLACE_STATE = {
    LIMITED: 'marketplace.limited.stock',
    FEATURED: 'marketplace.featured.stock',
    REMAINING: 'marketplace.panel.remaining.stock',
    NEW: 'marketplace.new.stock',
    SOLD_OUT: 'marketplace.redeem.sold.out',
    NOT_ENOUGH_POINT: 'marketplace.redeem.not.enough.points',
    COMING_SOON: 'marketplace.redeem.coming.soon',
    LIMIT_REACHED: 'marketplace.redeem.member.limit',
    ALL_IN_BASKET: 'marketplace.redeem.all.in.basket',
};

class MarketplaceBasket {
    constructor() {
        this.items = [];
    }
    updateBasket(basket) {
        this.items = basket.items;
        this.total = basket.total;
    }
}

const MARKETPLACE_ATTRIBUTE_CART_ITEM = {
    AttributeMappingId: 156,
    LocalAttributes: [
        { AttributeName: 'Size', ValueName: 'S' },
        { AttributeName: 'Color', ValueName: 'Blue' },
    ],
};
const MARKETPLACE_CUSTOMFIELD_CART_ITEM = {
    customFieldId: 1,
    customFieldName: 'Your Nickname',
    customFieldValue: 'Nick',
};

class MarketplaceBasketItem {
    constructor(id, rewardItemId, gameNumber, displayName, pointsValue, ecashValue, merchantValue, quantity, attributeMappingId, maxQuantity, imageURL, customFields) {
        this.id = id;
        this.rewardItemId = rewardItemId;
        this.gameNumber = gameNumber;
        this.displayName = displayName;
        this.pointsValue = pointsValue;
        this.ecashValue = ecashValue;
        this.merchantValue = merchantValue;
        this.quantity = quantity;
        this.attributeMappingId = attributeMappingId;
        this.maxQuantity = maxQuantity;
        this.imageURL = imageURL;
        this.customFields = customFields;
    }
    static fromMarketplaceItem(marketplaceItem, quantity = 1, attributeMappingId, customFields) {
        return new MarketplaceBasketItem(marketplaceItem.Id, marketplaceItem.ProductItemId, marketplaceItem.GameNumber, marketplaceItem.DisplayName, marketplaceItem.PointValue, marketplaceItem.EcashValue, marketplaceItem.MerchantValue, quantity, attributeMappingId, undefined, undefined, customFields);
    }
}

class MarketplacePurchasedItem {
}

const CUSTOM_FIELD_TEXTBOX_MOCK = {
    CustomFieldId: 12,
    RewardItemId: 156,
    DisplayName: 'Your Nickname',
    FieldType: 0,
    CharacterLimit: 10,
    ValidationRegEx: '',
    IsRequired: false,
    Value: ''
};
const CUSTOM_FIELD_CHECKBOX_MOCK = {
    CustomFieldId: 13,
    RewardItemId: 156,
    DisplayName: 'Same Day Pick Up',
    FieldType: 2,
    CharacterLimit: 100,
    ValidationRegEx: '',
    IsRequired: false,
    Value: ''
};
const CUSTOM_FIELD_MULTILINE_MOCK = {
    CustomFieldId: 13,
    RewardItemId: 156,
    DisplayName: 'Multiline test field',
    FieldType: 1,
    CharacterLimit: 100,
    ValidationRegEx: '',
    IsRequired: false,
    Value: ''
};
const MARKETPLACE_ITEM_CUSTOM_FIELDS_MOCK = [
    CUSTOM_FIELD_TEXTBOX_MOCK,
    CUSTOM_FIELD_CHECKBOX_MOCK,
    CUSTOM_FIELD_MULTILINE_MOCK
];

var ProcessProviderId;
(function (ProcessProviderId) {
    ProcessProviderId[ProcessProviderId["All"] = -1] = "All";
    ProcessProviderId[ProcessProviderId["FortressGB"] = 0] = "FortressGB";
    ProcessProviderId[ProcessProviderId["UniqueCode"] = 1] = "UniqueCode";
    ProcessProviderId[ProcessProviderId["Download"] = 2] = "Download";
    ProcessProviderId[ProcessProviderId["Event"] = 3] = "Event";
    ProcessProviderId[ProcessProviderId["Product"] = 4] = "Product";
    ProcessProviderId[ProcessProviderId["VirtualEvent"] = 5] = "VirtualEvent";
})(ProcessProviderId || (ProcessProviderId = {}));
var FeaturesRewardsItem;
(function (FeaturesRewardsItem) {
    FeaturesRewardsItem["ALL"] = "all";
    FeaturesRewardsItem["Marketplace"] = "marketplace";
    FeaturesRewardsItem["Events"] = "events";
    FeaturesRewardsItem["Auctions"] = "auction";
    FeaturesRewardsItem["Lottos"] = "lotto";
})(FeaturesRewardsItem || (FeaturesRewardsItem = {}));
const marketplaceIdArr = [0, 1, 2];

var LoyaltyType;
(function (LoyaltyType) {
    LoyaltyType[LoyaltyType["NONE"] = 0] = "NONE";
    LoyaltyType[LoyaltyType["MARKETPLACE"] = 1] = "MARKETPLACE";
    LoyaltyType[LoyaltyType["AUCTION"] = 2] = "AUCTION";
    LoyaltyType[LoyaltyType["LOTTO"] = 3] = "LOTTO";
})(LoyaltyType || (LoyaltyType = {}));

/**
 * Priority enum where the lowest number has the highest priority
 */
var PRIORITY;
(function (PRIORITY) {
    PRIORITY[PRIORITY["HIGH"] = 1] = "HIGH";
    PRIORITY[PRIORITY["MEDIUM"] = 3] = "MEDIUM";
    PRIORITY[PRIORITY["LOW"] = 7] = "LOW";
})(PRIORITY || (PRIORITY = {}));
var LOYALTY_STATUS;
(function (LOYALTY_STATUS) {
    LOYALTY_STATUS[LOYALTY_STATUS["NONE"] = 5] = "NONE";
    LOYALTY_STATUS[LOYALTY_STATUS["FEATURED"] = 1] = "FEATURED";
    LOYALTY_STATUS[LOYALTY_STATUS["NEW"] = 2] = "NEW";
    // Disabled statuses
    LOYALTY_STATUS[LOYALTY_STATUS["SOLD_OUT"] = 10] = "SOLD_OUT";
    LOYALTY_STATUS[LOYALTY_STATUS["COMING_SOON"] = 7] = "COMING_SOON";
    LOYALTY_STATUS[LOYALTY_STATUS["LIMIT_REACHED"] = 9] = "LIMIT_REACHED";
    LOYALTY_STATUS[LOYALTY_STATUS["NOT_ENOUGH_POINTS"] = 8] = "NOT_ENOUGH_POINTS";
    // Stock availability statuses,
    LOYALTY_STATUS[LOYALTY_STATUS["LIMITED_STOCK"] = 4] = "LIMITED_STOCK";
    LOYALTY_STATUS[LOYALTY_STATUS["STOCK_LOW"] = 3] = "STOCK_LOW";
})(LOYALTY_STATUS || (LOYALTY_STATUS = {}));

class LoyaltyStatus {
    constructor(o) {
        this._disabledStatus = [LOYALTY_STATUS.COMING_SOON, LOYALTY_STATUS.LIMIT_REACHED, LOYALTY_STATUS.NOT_ENOUGH_POINTS, LOYALTY_STATUS.SOLD_OUT];
        o = o || {};
        this.theme = o.theme || "";
        this.status = o.status || LOYALTY_STATUS.NONE;
        this.type = o.type || LoyaltyType.NONE;
    }
    get disabled() {
        return this._disabledStatus.some(status => status === this.status);
    }
}

class MixedLoyaltyItem {
    constructor(o) {
        o = o || {};
        this.type = o.type || 'auction';
        this.data = o.data || {};
        this.status = o.status || new LoyaltyStatus();
    }
}

var MixedLoyaltyItemType;
(function (MixedLoyaltyItemType) {
    MixedLoyaltyItemType[MixedLoyaltyItemType["Auction"] = 0] = "Auction";
    MixedLoyaltyItemType[MixedLoyaltyItemType["Lotto"] = 1] = "Lotto";
    MixedLoyaltyItemType[MixedLoyaltyItemType["Marketplace"] = 2] = "Marketplace";
    MixedLoyaltyItemType[MixedLoyaltyItemType["All"] = 3] = "All";
})(MixedLoyaltyItemType || (MixedLoyaltyItemType = {}));

class MixedLoyaltyWalletItem {
}

var LoyaltyActionType;
(function (LoyaltyActionType) {
    LoyaltyActionType[LoyaltyActionType["None"] = 0] = "None";
    LoyaltyActionType[LoyaltyActionType["Facebook_Connect"] = 101000] = "Facebook_Connect";
    LoyaltyActionType[LoyaltyActionType["Facebook_LikeAPage"] = 101001] = "Facebook_LikeAPage";
    LoyaltyActionType[LoyaltyActionType["Facebook_PostOnWall"] = 101002] = "Facebook_PostOnWall";
    LoyaltyActionType[LoyaltyActionType["Facebook_ShareAPost"] = 101003] = "Facebook_ShareAPost";
    LoyaltyActionType[LoyaltyActionType["Facebook_CheckIn"] = 101004] = "Facebook_CheckIn";
    LoyaltyActionType[LoyaltyActionType["Facebook_CommentOnPost"] = 101005] = "Facebook_CommentOnPost";
    LoyaltyActionType[LoyaltyActionType["Facebook_LikePost"] = 101006] = "Facebook_LikePost";
    LoyaltyActionType[LoyaltyActionType["Facebook_LikeAComment"] = 101007] = "Facebook_LikeAComment";
    LoyaltyActionType[LoyaltyActionType["Facebook_PageVisit"] = 101008] = "Facebook_PageVisit";
    LoyaltyActionType[LoyaltyActionType["Facebook_DeleteItem"] = 101102] = "Facebook_DeleteItem";
    LoyaltyActionType[LoyaltyActionType["Facebook_Disconnect"] = 101103] = "Facebook_Disconnect";
    LoyaltyActionType[LoyaltyActionType["Facebook_Marketplace_Share"] = 101104] = "Facebook_Marketplace_Share";
    LoyaltyActionType[LoyaltyActionType["Facebook_Marketplace_Post"] = 101105] = "Facebook_Marketplace_Post";
    LoyaltyActionType[LoyaltyActionType["Facebook_Auction_Share"] = 101106] = "Facebook_Auction_Share";
    LoyaltyActionType[LoyaltyActionType["Facebook_Auction_Post"] = 101107] = "Facebook_Auction_Post";
    LoyaltyActionType[LoyaltyActionType["Facebook_Lottos_Share"] = 101108] = "Facebook_Lottos_Share";
    LoyaltyActionType[LoyaltyActionType["Facebook_Lottos_Post"] = 101109] = "Facebook_Lottos_Post";
    LoyaltyActionType[LoyaltyActionType["Twitter_Connect"] = 102000] = "Twitter_Connect";
    LoyaltyActionType[LoyaltyActionType["Twitter_Follow"] = 102001] = "Twitter_Follow";
    LoyaltyActionType[LoyaltyActionType["Twitter_HashTag"] = 102002] = "Twitter_HashTag";
    LoyaltyActionType[LoyaltyActionType["Twitter_Retweet"] = 102003] = "Twitter_Retweet";
    LoyaltyActionType[LoyaltyActionType["Twitter_Mention"] = 102004] = "Twitter_Mention";
    LoyaltyActionType[LoyaltyActionType["Twitter_Photo"] = 102005] = "Twitter_Photo";
    LoyaltyActionType[LoyaltyActionType["Twitter_Favorite"] = 102006] = "Twitter_Favorite";
    LoyaltyActionType[LoyaltyActionType["Twitter_SpredFastPost"] = 102007] = "Twitter_SpredFastPost";
    LoyaltyActionType[LoyaltyActionType["Twitter_Disconnect"] = 102008] = "Twitter_Disconnect";
    LoyaltyActionType[LoyaltyActionType["Twitter_Marketplace_Share"] = 102009] = "Twitter_Marketplace_Share";
    LoyaltyActionType[LoyaltyActionType["Twitter_Marketplace_Post"] = 102010] = "Twitter_Marketplace_Post";
    LoyaltyActionType[LoyaltyActionType["Twitter_Auction_Share"] = 102011] = "Twitter_Auction_Share";
    LoyaltyActionType[LoyaltyActionType["Twitter_Auction_Post"] = 102012] = "Twitter_Auction_Post";
    LoyaltyActionType[LoyaltyActionType["Twitter_Lottos_Share"] = 102013] = "Twitter_Lottos_Share";
    LoyaltyActionType[LoyaltyActionType["Twitter_Lottos_Post"] = 102014] = "Twitter_Lottos_Post";
    LoyaltyActionType[LoyaltyActionType["Google_Connect"] = 103000] = "Google_Connect";
    LoyaltyActionType[LoyaltyActionType["Google_Follow"] = 103001] = "Google_Follow";
    LoyaltyActionType[LoyaltyActionType["Google_Plus1"] = 103002] = "Google_Plus1";
    LoyaltyActionType[LoyaltyActionType["Google_Comment"] = 103003] = "Google_Comment";
    LoyaltyActionType[LoyaltyActionType["Google_Share"] = 103004] = "Google_Share";
    LoyaltyActionType[LoyaltyActionType["Google_Disconnect"] = 103005] = "Google_Disconnect";
    LoyaltyActionType[LoyaltyActionType["FourSquare_Connect"] = 104000] = "FourSquare_Connect";
    LoyaltyActionType[LoyaltyActionType["FourSquare_CheckIn"] = 104001] = "FourSquare_CheckIn";
    LoyaltyActionType[LoyaltyActionType["FourSquare_OfferRedemption"] = 104002] = "FourSquare_OfferRedemption";
    LoyaltyActionType[LoyaltyActionType["FourSquare_Follow"] = 104003] = "FourSquare_Follow";
    LoyaltyActionType[LoyaltyActionType["FourSquare_VenueLike"] = 104004] = "FourSquare_VenueLike";
    LoyaltyActionType[LoyaltyActionType["FourSquare_Disconnect"] = 104005] = "FourSquare_Disconnect";
    LoyaltyActionType[LoyaltyActionType["Instagram_Connect"] = 105000] = "Instagram_Connect";
    LoyaltyActionType[LoyaltyActionType["Instagram_Follow"] = 105001] = "Instagram_Follow";
    LoyaltyActionType[LoyaltyActionType["Instagram_Like"] = 105002] = "Instagram_Like";
    LoyaltyActionType[LoyaltyActionType["Instagram_Comment"] = 105003] = "Instagram_Comment";
    LoyaltyActionType[LoyaltyActionType["Instagram_PostPhoto"] = 105004] = "Instagram_PostPhoto";
    LoyaltyActionType[LoyaltyActionType["Instagram_HashTag"] = 105005] = "Instagram_HashTag";
    LoyaltyActionType[LoyaltyActionType["Instagram_Mention"] = 105006] = "Instagram_Mention";
    LoyaltyActionType[LoyaltyActionType["Instagram_SpredFastPost"] = 105007] = "Instagram_SpredFastPost";
    LoyaltyActionType[LoyaltyActionType["Instagram_Disconnect"] = 105008] = "Instagram_Disconnect";
    LoyaltyActionType[LoyaltyActionType["Youtube_Connect"] = 106000] = "Youtube_Connect";
    LoyaltyActionType[LoyaltyActionType["Youtube_Subscribe"] = 106001] = "Youtube_Subscribe";
    LoyaltyActionType[LoyaltyActionType["Youtube_Like"] = 106002] = "Youtube_Like";
    LoyaltyActionType[LoyaltyActionType["Youtube_View"] = 106003] = "Youtube_View";
    LoyaltyActionType[LoyaltyActionType["Youtube_Comment"] = 106004] = "Youtube_Comment";
    LoyaltyActionType[LoyaltyActionType["Youtube_Disconnect"] = 106005] = "Youtube_Disconnect";
    LoyaltyActionType[LoyaltyActionType["LoginToPortal"] = 200001] = "LoginToPortal";
    LoyaltyActionType[LoyaltyActionType["LoginToPortal3rdParty"] = 200002] = "LoginToPortal3rdParty";
    LoyaltyActionType[LoyaltyActionType["LoginToPortalSSO"] = 200003] = "LoginToPortalSSO";
    LoyaltyActionType[LoyaltyActionType["LoginIntoChildAccount"] = 200004] = "LoginIntoChildAccount";
    LoyaltyActionType[LoyaltyActionType["SwitchAccount"] = 200005] = "SwitchAccount";
    LoyaltyActionType[LoyaltyActionType["LoginIntoGuardian"] = 200006] = "LoginIntoGuardian";
    LoyaltyActionType[LoyaltyActionType["SwitchClub"] = 200007] = "SwitchClub";
    LoyaltyActionType[LoyaltyActionType["Attendance"] = 200010] = "Attendance";
    LoyaltyActionType[LoyaltyActionType["AddPartner"] = 200011] = "AddPartner";
    LoyaltyActionType[LoyaltyActionType["AddPartnerNewMember"] = 200012] = "AddPartnerNewMember";
    LoyaltyActionType[LoyaltyActionType["DeletePendingPartner"] = 200013] = "DeletePendingPartner";
    LoyaltyActionType[LoyaltyActionType["ReferredAFriend"] = 200014] = "ReferredAFriend";
    LoyaltyActionType[LoyaltyActionType["ReferredByAFriend"] = 200015] = "ReferredByAFriend";
    LoyaltyActionType[LoyaltyActionType["PartnerRemoved"] = 200016] = "PartnerRemoved";
    LoyaltyActionType[LoyaltyActionType["AnswerSurvey"] = 200020] = "AnswerSurvey";
    LoyaltyActionType[LoyaltyActionType["AnswerPoll"] = 200021] = "AnswerPoll";
    LoyaltyActionType[LoyaltyActionType["AnswerFeedBack"] = 200022] = "AnswerFeedBack";
    LoyaltyActionType[LoyaltyActionType["BuySweepstake"] = 200023] = "BuySweepstake";
    LoyaltyActionType[LoyaltyActionType["BuyRaffle"] = 200024] = "BuyRaffle";
    LoyaltyActionType[LoyaltyActionType["PlaceAuctionBid"] = 200025] = "PlaceAuctionBid";
    LoyaltyActionType[LoyaltyActionType["AuctionOutBid"] = 200026] = "AuctionOutBid";
    LoyaltyActionType[LoyaltyActionType["AuctionItemWon"] = 200027] = "AuctionItemWon";
    LoyaltyActionType[LoyaltyActionType["AnswerSurveyCorrect"] = 200028] = "AnswerSurveyCorrect";
    LoyaltyActionType[LoyaltyActionType["AnswerSurveyCorrectBonus"] = 200029] = "AnswerSurveyCorrectBonus";
    LoyaltyActionType[LoyaltyActionType["ConnectToMLBAM"] = 200030] = "ConnectToMLBAM";
    LoyaltyActionType[LoyaltyActionType["WatchVideoInPortal"] = 200031] = "WatchVideoInPortal";
    LoyaltyActionType[LoyaltyActionType["UpgradeMembershipLevel"] = 200032] = "UpgradeMembershipLevel";
    LoyaltyActionType[LoyaltyActionType["AutoTopUpSubscription"] = 200033] = "AutoTopUpSubscription";
    LoyaltyActionType[LoyaltyActionType["BirthdayBonusPoints"] = 200034] = "BirthdayBonusPoints";
    LoyaltyActionType[LoyaltyActionType["MarketplacePurchase"] = 200035] = "MarketplacePurchase";
    LoyaltyActionType[LoyaltyActionType["MarketplaceEventPurchase"] = 200036] = "MarketplaceEventPurchase";
    LoyaltyActionType[LoyaltyActionType["MarketplaceDownloadPurchase"] = 200037] = "MarketplaceDownloadPurchase";
    LoyaltyActionType[LoyaltyActionType["MarketplaceVoucherPurchase"] = 200038] = "MarketplaceVoucherPurchase";
    LoyaltyActionType[LoyaltyActionType["MarketplaceVirtualEventPurchase"] = 200039] = "MarketplaceVirtualEventPurchase";
    LoyaltyActionType[LoyaltyActionType["FanAssit"] = 200040] = "FanAssit";
    LoyaltyActionType[LoyaltyActionType["FanAssit_Tickets"] = 200041] = "FanAssit_Tickets";
    LoyaltyActionType[LoyaltyActionType["AttachTicketMasterAccount"] = 200042] = "AttachTicketMasterAccount";
    LoyaltyActionType[LoyaltyActionType["AnswerPredictorCorrectly"] = 200043] = "AnswerPredictorCorrectly";
    LoyaltyActionType[LoyaltyActionType["AnswerTrivia"] = 200044] = "AnswerTrivia";
    LoyaltyActionType[LoyaltyActionType["AnswerPredictor"] = 200045] = "AnswerPredictor";
    LoyaltyActionType[LoyaltyActionType["AuctionItemLost"] = 200046] = "AuctionItemLost";
    LoyaltyActionType[LoyaltyActionType["NewAccountCreation"] = 200050] = "NewAccountCreation";
    LoyaltyActionType[LoyaltyActionType["NewPartnerAccountCreation"] = 200051] = "NewPartnerAccountCreation";
    LoyaltyActionType[LoyaltyActionType["NewFriendAccountCreation"] = 200052] = "NewFriendAccountCreation";
    LoyaltyActionType[LoyaltyActionType["AccountActivation"] = 200053] = "AccountActivation";
    LoyaltyActionType[LoyaltyActionType["LinkChildAccount"] = 200054] = "LinkChildAccount";
    LoyaltyActionType[LoyaltyActionType["CardReprintRequest"] = 200055] = "CardReprintRequest";
    LoyaltyActionType[LoyaltyActionType["CardReprintRequestOrderProcessed"] = 200056] = "CardReprintRequestOrderProcessed";
    LoyaltyActionType[LoyaltyActionType["ProductCodeChanged"] = 200057] = "ProductCodeChanged";
    LoyaltyActionType[LoyaltyActionType["AccountCreatedViaSync"] = 200058] = "AccountCreatedViaSync";
    LoyaltyActionType[LoyaltyActionType["MarketplaceTransferCompleted"] = 200059] = "MarketplaceTransferCompleted";
    LoyaltyActionType[LoyaltyActionType["Fantasy_PlayerSelection"] = 200060] = "Fantasy_PlayerSelection";
    LoyaltyActionType[LoyaltyActionType["PortalProductPurchase"] = 200061] = "PortalProductPurchase";
    LoyaltyActionType[LoyaltyActionType["PortalProductMembershipPurchase"] = 200062] = "PortalProductMembershipPurchase";
    LoyaltyActionType[LoyaltyActionType["PortalProductAccDescriptionPurchase"] = 200063] = "PortalProductAccDescriptionPurchase";
    LoyaltyActionType[LoyaltyActionType["ChildCardPrint"] = 200064] = "ChildCardPrint";
    LoyaltyActionType[LoyaltyActionType["GuardianCardPrint"] = 200065] = "GuardianCardPrint";
    LoyaltyActionType[LoyaltyActionType["Questions"] = 200066] = "Questions";
    LoyaltyActionType[LoyaltyActionType["AdminUpgradeChildAccount"] = 200067] = "AdminUpgradeChildAccount";
    LoyaltyActionType[LoyaltyActionType["PortalProductDiscountPurchase"] = 200068] = "PortalProductDiscountPurchase";
    LoyaltyActionType[LoyaltyActionType["PortalProductUpgradeMembership"] = 200069] = "PortalProductUpgradeMembership";
    LoyaltyActionType[LoyaltyActionType["CardSubscriptionAdded"] = 200070] = "CardSubscriptionAdded";
    LoyaltyActionType[LoyaltyActionType["PortalProductRsnMembershipSubscriptionAdded"] = 200071] = "PortalProductRsnMembershipSubscriptionAdded";
    LoyaltyActionType[LoyaltyActionType["NewGuardianAccountCreated"] = 200072] = "NewGuardianAccountCreated";
    LoyaltyActionType[LoyaltyActionType["NewChildAccountCreated"] = 200073] = "NewChildAccountCreated";
    LoyaltyActionType[LoyaltyActionType["NewExternalAccountCreated"] = 200074] = "NewExternalAccountCreated";
    LoyaltyActionType[LoyaltyActionType["DownloadWorksheetClick"] = 200075] = "DownloadWorksheetClick";
    LoyaltyActionType[LoyaltyActionType["CustomerTagUpdated"] = 200076] = "CustomerTagUpdated";
    LoyaltyActionType[LoyaltyActionType["ScorecardComplete"] = 200077] = "ScorecardComplete";
    LoyaltyActionType[LoyaltyActionType["BenefitClaimed"] = 200078] = "BenefitClaimed";
    LoyaltyActionType[LoyaltyActionType["AttendanceCheckIn"] = 200079] = "AttendanceCheckIn";
    LoyaltyActionType[LoyaltyActionType["EcashSpend"] = 200080] = "EcashSpend";
    LoyaltyActionType[LoyaltyActionType["LottoWon"] = 200081] = "LottoWon";
    LoyaltyActionType[LoyaltyActionType["PortalProductPointsPurchase"] = 200082] = "PortalProductPointsPurchase";
    LoyaltyActionType[LoyaltyActionType["ScorecardMilestoneComplete"] = 200083] = "ScorecardMilestoneComplete";
    LoyaltyActionType[LoyaltyActionType["ReadArticle"] = 200084] = "ReadArticle";
    LoyaltyActionType[LoyaltyActionType["SKUPurchase"] = 200085] = "SKUPurchase";
    LoyaltyActionType[LoyaltyActionType["ScorecardActionComplete"] = 200086] = "ScorecardActionComplete";
    LoyaltyActionType[LoyaltyActionType["SKUBasketPurchase"] = 200087] = "SKUBasketPurchase";
    LoyaltyActionType[LoyaltyActionType["WorksheetItemActivated"] = 200088] = "WorksheetItemActivated";
    LoyaltyActionType[LoyaltyActionType["RedeemMarketplaceCoupon"] = 200089] = "RedeemMarketplaceCoupon";
    LoyaltyActionType[LoyaltyActionType["CompleteProfile"] = 200090] = "CompleteProfile";
    LoyaltyActionType[LoyaltyActionType["DeletePendingChild"] = 200091] = "DeletePendingChild";
    LoyaltyActionType[LoyaltyActionType["AddPendingChild"] = 200092] = "AddPendingChild";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpAmericanExpress"] = 210000] = "PaymentTopUpAmericanExpress";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpVisa"] = 210001] = "PaymentTopUpVisa";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpMasterCard"] = 210002] = "PaymentTopUpMasterCard";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpDiscover"] = 210003] = "PaymentTopUpDiscover";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpJCB"] = 210004] = "PaymentTopUpJCB";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpDebit"] = 210005] = "PaymentTopUpDebit";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpOther"] = 210006] = "PaymentTopUpOther";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpAmericanExpress"] = 210020] = "PaymentAutoTopUpAmericanExpress";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpVisa"] = 210021] = "PaymentAutoTopUpVisa";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpMasterCard"] = 210022] = "PaymentAutoTopUpMasterCard";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpDiscover"] = 210023] = "PaymentAutoTopUpDiscover";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpJCB"] = 210024] = "PaymentAutoTopUpJCB";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpDebit"] = 210025] = "PaymentAutoTopUpDebit";
    LoyaltyActionType[LoyaltyActionType["PaymentAutoTopUpOther"] = 210026] = "PaymentAutoTopUpOther";
    LoyaltyActionType[LoyaltyActionType["PaymentRecurringSubscriptionSuccessfullyCompleted"] = 210050] = "PaymentRecurringSubscriptionSuccessfullyCompleted";
    LoyaltyActionType[LoyaltyActionType["PaymentRecurringSubscriptionFailedCompleted"] = 210051] = "PaymentRecurringSubscriptionFailedCompleted";
    LoyaltyActionType[LoyaltyActionType["PaymentRecurringSubscriptionCancelledCompleted"] = 210052] = "PaymentRecurringSubscriptionCancelledCompleted";
    LoyaltyActionType[LoyaltyActionType["PaymentGatewayTransaction"] = 211000] = "PaymentGatewayTransaction";
    LoyaltyActionType[LoyaltyActionType["CardLinkTransaction"] = 212000] = "CardLinkTransaction";
    LoyaltyActionType[LoyaltyActionType["CardLinkAddNewCard"] = 212001] = "CardLinkAddNewCard";
    LoyaltyActionType[LoyaltyActionType["OnlineAffiliateTransaction"] = 212100] = "OnlineAffiliateTransaction";
    LoyaltyActionType[LoyaltyActionType["VoucherCodeEntered"] = 220000] = "VoucherCodeEntered";
    LoyaltyActionType[LoyaltyActionType["MarketPlaceOrderProcessed"] = 220001] = "MarketPlaceOrderProcessed";
    LoyaltyActionType[LoyaltyActionType["PaymentTopUpCompleted"] = 220002] = "PaymentTopUpCompleted";
    LoyaltyActionType[LoyaltyActionType["AuctionNotification"] = 230000] = "AuctionNotification";
    LoyaltyActionType[LoyaltyActionType["MarketplaceNotification"] = 230001] = "MarketplaceNotification";
    LoyaltyActionType[LoyaltyActionType["LottoNotification"] = 230002] = "LottoNotification";
    LoyaltyActionType[LoyaltyActionType["SurveyNotification"] = 230003] = "SurveyNotification";
    LoyaltyActionType[LoyaltyActionType["FantasyNotification"] = 230004] = "FantasyNotification";
    LoyaltyActionType[LoyaltyActionType["DigitialTicketingNotification"] = 230005] = "DigitialTicketingNotification";
    LoyaltyActionType[LoyaltyActionType["EcashNotification"] = 230006] = "EcashNotification";
    LoyaltyActionType[LoyaltyActionType["PointsNotification"] = 230007] = "PointsNotification";
    LoyaltyActionType[LoyaltyActionType["RewardsNotification"] = 230008] = "RewardsNotification";
    LoyaltyActionType[LoyaltyActionType["MLBAMNotification"] = 230009] = "MLBAMNotification";
    LoyaltyActionType[LoyaltyActionType["AffiliateNotification"] = 230010] = "AffiliateNotification";
    LoyaltyActionType[LoyaltyActionType["CampaignManagerNotification"] = 231000] = "CampaignManagerNotification";
    LoyaltyActionType[LoyaltyActionType["ScorecardExpirationNotification"] = 231001] = "ScorecardExpirationNotification";
    LoyaltyActionType[LoyaltyActionType["ScorecardActivationNotification"] = 231002] = "ScorecardActivationNotification";
    LoyaltyActionType[LoyaltyActionType["AuctionExpirationNotification"] = 231011] = "AuctionExpirationNotification";
    LoyaltyActionType[LoyaltyActionType["AuctionActivationNotification"] = 231012] = "AuctionActivationNotification";
    LoyaltyActionType[LoyaltyActionType["TicketTransferOrder"] = 240000] = "TicketTransferOrder";
    LoyaltyActionType[LoyaltyActionType["TicketTransferSentTicket"] = 240001] = "TicketTransferSentTicket";
    LoyaltyActionType[LoyaltyActionType["TicketTransferRecieveTicket"] = 240002] = "TicketTransferRecieveTicket";
    LoyaltyActionType[LoyaltyActionType["TicketTransferSendInviteTicket"] = 240003] = "TicketTransferSendInviteTicket";
    LoyaltyActionType[LoyaltyActionType["TicketTransferAcceptTicket"] = 240004] = "TicketTransferAcceptTicket";
    LoyaltyActionType[LoyaltyActionType["TicketTransferCallBackTicket"] = 240005] = "TicketTransferCallBackTicket";
    LoyaltyActionType[LoyaltyActionType["TicketDonationOrder"] = 240020] = "TicketDonationOrder";
    LoyaltyActionType[LoyaltyActionType["TicketDonationSentTicket"] = 240021] = "TicketDonationSentTicket";
    LoyaltyActionType[LoyaltyActionType["TicketDonationRecieveTicket"] = 240022] = "TicketDonationRecieveTicket";
    LoyaltyActionType[LoyaltyActionType["TicketResaleOrder"] = 240030] = "TicketResaleOrder";
    LoyaltyActionType[LoyaltyActionType["TicketResalePlaceTicketOnResaleTicket"] = 240031] = "TicketResalePlaceTicketOnResaleTicket";
    LoyaltyActionType[LoyaltyActionType["TicketResaleSellTicket"] = 240032] = "TicketResaleSellTicket";
    LoyaltyActionType[LoyaltyActionType["TicketResaleBuyTicket"] = 240033] = "TicketResaleBuyTicket";
    LoyaltyActionType[LoyaltyActionType["SiteVisit"] = 300000] = "SiteVisit";
    LoyaltyActionType[LoyaltyActionType["SidelineSportsRiskIt"] = 300100] = "SidelineSportsRiskIt";
    LoyaltyActionType[LoyaltyActionType["SidelineSportsPick3"] = 300101] = "SidelineSportsPick3";
    LoyaltyActionType[LoyaltyActionType["SidelineSportsBingo"] = 300102] = "SidelineSportsBingo";
    LoyaltyActionType[LoyaltyActionType["ThirdPartySSOReturn"] = 310000] = "ThirdPartySSOReturn";
    LoyaltyActionType[LoyaltyActionType["TransactionsAccess"] = 400001] = "TransactionsAccess";
    LoyaltyActionType[LoyaltyActionType["TransactionsPayment"] = 400002] = "TransactionsPayment";
    LoyaltyActionType[LoyaltyActionType["TransactionsLoyalty"] = 400003] = "TransactionsLoyalty";
    LoyaltyActionType[LoyaltyActionType["TransactionsInteractions"] = 400004] = "TransactionsInteractions";
    LoyaltyActionType[LoyaltyActionType["TransactionsSocial"] = 400005] = "TransactionsSocial";
    LoyaltyActionType[LoyaltyActionType["TransactionsCorrection"] = 400006] = "TransactionsCorrection";
    LoyaltyActionType[LoyaltyActionType["TransactionsRefund"] = 400007] = "TransactionsRefund";
    LoyaltyActionType[LoyaltyActionType["TransactionsMarketplace"] = 400031] = "TransactionsMarketplace";
    LoyaltyActionType[LoyaltyActionType["TransactionsAuctions"] = 400032] = "TransactionsAuctions";
    LoyaltyActionType[LoyaltyActionType["TransactionsCompetitions"] = 400033] = "TransactionsCompetitions";
    LoyaltyActionType[LoyaltyActionType["TransactionsVoucherCode"] = 400041] = "TransactionsVoucherCode";
    LoyaltyActionType[LoyaltyActionType["TransactionsCheckIns"] = 400042] = "TransactionsCheckIns";
    LoyaltyActionType[LoyaltyActionType["TransactionsPollsSurveys"] = 400043] = "TransactionsPollsSurveys";
    LoyaltyActionType[LoyaltyActionType["TransactionsTrivia"] = 400044] = "TransactionsTrivia";
    LoyaltyActionType[LoyaltyActionType["TransactionsFantasy"] = 400045] = "TransactionsFantasy";
    LoyaltyActionType[LoyaltyActionType["BingoFantasy"] = 400046] = "BingoFantasy";
    LoyaltyActionType[LoyaltyActionType["DebitAccountGPSSuccess"] = 500000] = "DebitAccountGPSSuccess";
    LoyaltyActionType[LoyaltyActionType["DebitAccountGPSFail"] = 500001] = "DebitAccountGPSFail";
    LoyaltyActionType[LoyaltyActionType["CreditAccountGPSTopUp"] = 500002] = "CreditAccountGPSTopUp";
    LoyaltyActionType[LoyaltyActionType["CreditAccountGPSAutoTopUp"] = 500003] = "CreditAccountGPSAutoTopUp";
    LoyaltyActionType[LoyaltyActionType["LoyaltyEmailAlert"] = 510001] = "LoyaltyEmailAlert";
    LoyaltyActionType[LoyaltyActionType["LoyaltyEmailAlert2"] = 510002] = "LoyaltyEmailAlert2";
    LoyaltyActionType[LoyaltyActionType["LoyaltyEmailAlert3"] = 510003] = "LoyaltyEmailAlert3";
    LoyaltyActionType[LoyaltyActionType["JoinWebCall"] = 510004] = "JoinWebCall";
})(LoyaltyActionType || (LoyaltyActionType = {}));

var MarketplaceItemStockType;
(function (MarketplaceItemStockType) {
    MarketplaceItemStockType[MarketplaceItemStockType["SingleStockType"] = 0] = "SingleStockType";
    MarketplaceItemStockType[MarketplaceItemStockType["AttributeStockType"] = 1] = "AttributeStockType";
})(MarketplaceItemStockType || (MarketplaceItemStockType = {}));

class MarketplaceItemMapping {
}

class MarketplaceItemMappingAttribute extends MarketplaceItemMapping {
}

var MarketplaceItemAttributeDisplayType;
(function (MarketplaceItemAttributeDisplayType) {
    MarketplaceItemAttributeDisplayType[MarketplaceItemAttributeDisplayType["Free_Text"] = 0] = "Free_Text";
    MarketplaceItemAttributeDisplayType[MarketplaceItemAttributeDisplayType["Date"] = 1] = "Date";
    MarketplaceItemAttributeDisplayType[MarketplaceItemAttributeDisplayType["Date_No_Expire"] = 2] = "Date_No_Expire";
    MarketplaceItemAttributeDisplayType[MarketplaceItemAttributeDisplayType["Colour"] = 3] = "Colour";
    MarketplaceItemAttributeDisplayType[MarketplaceItemAttributeDisplayType["Other"] = 4] = "Other";
})(MarketplaceItemAttributeDisplayType || (MarketplaceItemAttributeDisplayType = {}));

const MARKETPLACE_ITEM_ATTRIBUTES_MOCK = [
    {
        RewardAttributeId: 44,
        DisplayName: 'Color',
        DisplayType: MarketplaceItemAttributeDisplayType.Colour,
        Values: [
            {
                RewardValueId: 138,
                DisplayName: 'Red',
                RewardMappingIds: 'string',
                Ordinal: 0,
                Locales: [
                    {
                        RewardValueId: 138,
                        DisplayName: 'Red',
                        LCID: 2057,
                    },
                    {
                        RewardValueId: 138,
                        DisplayName: 'Rouge',
                        LCID: 3084,
                    },
                ],
            },
            {
                RewardValueId: 139,
                DisplayName: 'Blue',
                RewardMappingIds: 'string',
                Ordinal: 1,
                Locales: [
                    {
                        RewardValueId: 139,
                        DisplayName: 'Blue',
                        LCID: 2057,
                    },
                    {
                        RewardValueId: 139,
                        DisplayName: 'Bleu',
                        LCID: 3084,
                    },
                ],
            },
        ],
        Locales: [
            {
                RewardAttributeId: 44,
                DisplayName: 'Color',
                LCID: 2057,
            },
            {
                RewardAttributeId: 44,
                DisplayName: 'Couleur',
                LCID: 3084,
            },
        ],
    },
    {
        RewardAttributeId: 42,
        DisplayName: 'Size',
        DisplayType: MarketplaceItemAttributeDisplayType.Free_Text,
        Values: [
            {
                RewardValueId: 133,
                DisplayName: 'S',
                RewardMappingIds: 'string',
                Ordinal: 0,
                Locales: [
                    {
                        RewardValueId: 133,
                        DisplayName: 'S',
                        LCID: 2057,
                    },
                ],
            },
            {
                RewardValueId: 134,
                DisplayName: 'M',
                RewardMappingIds: 'string',
                Ordinal: 1,
                Locales: [
                    {
                        RewardValueId: 134,
                        DisplayName: 'M',
                        LCID: 2057,
                    },
                ],
            },
        ],
        Locales: [
            {
                RewardAttributeId: 42,
                DisplayName: 'Size',
                LCID: 2057,
            },
            {
                RewardAttributeId: 42,
                DisplayName: 'Taille',
                LCID: 3084,
            },
        ],
    },
];
const MARKETPLACE_ITEM_FR_ATTRIBUTES_MOCK = [
    {
        RewardAttributeId: 44,
        DisplayName: 'Couleur',
        DisplayType: MarketplaceItemAttributeDisplayType.Colour,
        Values: [
            {
                RewardValueId: 138,
                DisplayName: 'Rouge',
                RewardMappingIds: 'string',
                Ordinal: 0,
                Locales: [
                    {
                        RewardValueId: 138,
                        DisplayName: 'Red',
                        LCID: 2057,
                    },
                    {
                        RewardValueId: 138,
                        DisplayName: 'Rouge',
                        LCID: 3084,
                    },
                ],
            },
            {
                RewardValueId: 139,
                DisplayName: 'Bleu',
                RewardMappingIds: 'string',
                Ordinal: 1,
                Locales: [
                    {
                        RewardValueId: 139,
                        DisplayName: 'Blue',
                        LCID: 2057,
                    },
                    {
                        RewardValueId: 139,
                        DisplayName: 'Bleu',
                        LCID: 3084,
                    },
                ],
            },
        ],
        Locales: [
            {
                RewardAttributeId: 44,
                DisplayName: 'Color',
                LCID: 2057,
            },
            {
                RewardAttributeId: 44,
                DisplayName: 'Couleur',
                LCID: 3084,
            },
        ],
    },
    {
        RewardAttributeId: 42,
        DisplayName: 'Taille',
        DisplayType: MarketplaceItemAttributeDisplayType.Free_Text,
        Values: [
            {
                RewardValueId: 133,
                DisplayName: 'S',
                RewardMappingIds: 'string',
                Ordinal: 0,
                Locales: [
                    {
                        RewardValueId: 133,
                        DisplayName: 'S',
                        LCID: 2057,
                    },
                ],
            },
            {
                RewardValueId: 134,
                DisplayName: 'M',
                RewardMappingIds: 'string',
                Ordinal: 1,
                Locales: [
                    {
                        RewardValueId: 134,
                        DisplayName: 'M',
                        LCID: 2057,
                    },
                ],
            },
        ],
        Locales: [
            {
                RewardAttributeId: 42,
                DisplayName: 'Size',
                LCID: 2057,
            },
            {
                RewardAttributeId: 42,
                DisplayName: 'Taille',
                LCID: 3084,
            },
        ],
    },
];
const MARKETPLACE_ITEM_ATTRIBUTE_MAPPING_MOCK = [
    {
        AttributeValues: [133, 138],
        AttributeMappingId: 167,
        StockCount: 50,
        AvailableStockCount: 39,
        DisplayName: 'S - Red',
    },
    {
        AttributeValues: [133, 139],
        AttributeMappingId: 168,
        StockCount: 5,
        AvailableStockCount: 3,
        DisplayName: 'S - Blue',
    },
    {
        AttributeValues: [134, 138],
        AttributeMappingId: 169,
        StockCount: 3,
        AvailableStockCount: 2,
        DisplayName: 'M - Red',
    },
    {
        AttributeValues: [134, 139],
        AttributeMappingId: 170,
        StockCount: 45,
        AvailableStockCount: 40,
        DisplayName: 'M - Blue',
    },
];
const MARKETPLACE_ITEM_ATTRIBUTE_VALUE_MOCK = {
    RewardValueId: 0,
    DisplayName: 'Size',
    RewardMappingIds: '168',
    Ordinal: 0,
    Locales: [
        { RewardValueId: 0, DisplayName: 'Size', LCID: 2057 },
        { RewardValueId: 0, DisplayName: 'Taille', LCID: 3084 },
    ],
};

let TransactionSuccessStore = class TransactionSuccessStore extends Store {
    constructor() {
        super({ item: null, quantity: 0, totalPrice: 0, orderId: '' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessStore, providedIn: 'root' }); }
};
TransactionSuccessStore = __decorate([
    StoreConfig({ name: 'transaction-success' })
], TransactionSuccessStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TransactionSuccessQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessQuery, deps: [{ token: TransactionSuccessStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TransactionSuccessStore }] });

/**
 * stop navigation to success pages except when a transaction has been made.
 * optionally include a txRedirect for when navigation fails, else 404:
 * {
 *    path: 'purchaseSuccess'
 *    component: PurchaseSuccessComponent,
 *    canActivate: [ TransactionSuccessGuard ]
 *    data: {
 *            txRedirect: 'purchase'
 *          }
 *  }
 */
class TransactionSuccessGuard {
    constructor(loggingService, router, transactionSuccessQuery) {
        this.loggingService = loggingService;
        this.router = router;
        this.transactionSuccessQuery = transactionSuccessQuery;
    }
    canActivate(route) {
        this.loggingService.info('transactionSuccessGuard hit');
        const itemExists = !!this.transactionSuccessQuery.getValue().item;
        const queryParams = route.queryParams;
        const purchaseOrderId = queryParams.purchaseOrderId;
        this.loggingService.info(`item exists: ${itemExists}`);
        if (!itemExists && !purchaseOrderId) {
            this.router.navigate([route.data.txRedirect || '404']);
        }
        if (purchaseOrderId) {
            return true;
        }
        return itemExists;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessGuard, deps: [{ token: LoggingService }, { token: i2.Router }, { token: TransactionSuccessQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: i2.Router }, { type: TransactionSuccessQuery }] });

class TransactionSuccessService {
    constructor(transactionSuccessStore) {
        this.transactionSuccessStore = transactionSuccessStore;
    }
    setTransaction(item, quantity, totalPrice, orderId = '') {
        this.transactionSuccessStore.update((state) => ({ item, quantity, totalPrice, orderId }));
    }
    clear() {
        this.transactionSuccessStore.reset();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessService, deps: [{ token: TransactionSuccessStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionSuccessService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TransactionSuccessStore }] });

let RewardsWalletStore = class RewardsWalletStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletStore, providedIn: 'root' }); }
};
RewardsWalletStore = __decorate([
    StoreConfig({ name: 'rewards-wallet', idKey: 'UniqueId', cache: { ttl: 20000 } })
], RewardsWalletStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let RewardsWalletQuery = class RewardsWalletQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All items. */
    selectRewardWalletItems() {
        return this.selectAll();
    }
    /** All items by redeem date. */
    selectRewardWalletItemsByStatus(redeemed = false) {
        return this.selectAll({ filterBy: ({ RedeemDate }) => !!RedeemDate == redeemed }).pipe(map((items) => {
            if (redeemed) {
                return items.sort(this._sortByRedeemDate());
            }
            return items.sort(this._sortByPurchaseDate());
        }));
    }
    /** A specific item by ID. */
    selectRewardWalletItem(id) {
        return this.selectEntity(id);
    }
    _sortByPurchaseDate() {
        return (a, b) => moment$1.utc(b.PurchaseDate).diff(moment$1.utc(a.PurchaseDate));
    }
    _sortByRedeemDate() {
        return (a, b) => moment$1.utc(b.RedeemDate).diff(moment$1.utc(a.RedeemDate));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletQuery, deps: [{ token: RewardsWalletStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletQuery, providedIn: 'root' }); }
};
RewardsWalletQuery = __decorate([
    QueryConfig({ sortBy: 'EndDate', sortByOrder: Order.ASC })
], RewardsWalletQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RewardsWalletStore }] });

var WalletItemType;
(function (WalletItemType) {
    WalletItemType[WalletItemType["Marketplace"] = 1] = "Marketplace";
    WalletItemType[WalletItemType["Lotto"] = 2] = "Lotto";
    WalletItemType[WalletItemType["Auction"] = 3] = "Auction";
})(WalletItemType || (WalletItemType = {}));

class RewardsWalletService {
    constructor(rewardsWalletStore, rewardsWalletQuery, api) {
        this.rewardsWalletStore = rewardsWalletStore;
        this.rewardsWalletQuery = rewardsWalletQuery;
        this.api = api;
    }
    /** Fetches the wallet items and puts them in the store. */
    fetchWalletItems() {
        this.rewardsWalletStore.setLoading(true);
        const request$ = this.api.get('purchases/wallet').pipe(tap((rewardItems) => {
            rewardItems.forEach((item) => {
                if (item.ItemType == WalletItemType.Marketplace) {
                    item.UniqueId = item.LogId + '_' + item.ItemType;
                }
                else {
                    item.UniqueId = item.Id + '_' + item.ItemType;
                }
            });
            this.rewardsWalletStore.set(rewardItems);
        }), mapTo(null));
        return this.rewardsWalletQuery.getHasCache() ? of(null) : request$;
    }
    /**
       * This will disable cache of the rewards wallet store, so
       * that a fetch can be made again.
       */
    disableRewardsWalletStoreCache() {
        this.rewardsWalletStore.setHasCache(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletService, deps: [{ token: RewardsWalletStore }, { token: RewardsWalletQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RewardsWalletService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RewardsWalletStore }, { type: RewardsWalletQuery }, { type: ApiService }] });

class WalletAttributes {
}

class WalletCustomFields {
}

class LottoState extends LoyaltyStatus {
    constructor(o) {
        o = o || {};
        super(o);
        this.type = LoyaltyType.LOTTO;
    }
}

class AuctionState extends LoyaltyStatus {
    constructor(o) {
        o = o || {};
        super(o);
        this.type = LoyaltyType.AUCTION;
    }
}

class MarketplaceState extends LoyaltyStatus {
    constructor(o) {
        o = o || {};
        super(o);
        this.type = LoyaltyType.MARKETPLACE;
    }
}

class AuctionResolver {
    constructor(auctionService) {
        this.auctionService = auctionService;
    }
    resolve(route) {
        const id = +(route.paramMap.get('id') || 0);
        if (id) {
            return this.auctionService.fetchAuction(id);
        }
        else {
            return this.auctionService.fetchAuctions();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionResolver, deps: [{ token: AuctionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionService }] });

let LottoStore = class LottoStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoStore, providedIn: 'root' }); }
};
LottoStore = __decorate([
    StoreConfig({ name: 'lotto', idKey: 'LottoId', cache: { ttl: 20000 } })
], LottoStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let LottoQuery = class LottoQuery extends QueryEntity {
    constructor(store, balanceQuery) {
        super(store);
        this.store = store;
        this.balanceQuery = balanceQuery;
    }
    /** All lottos. */
    selectLottos() {
        return this.selectAll();
    }
    /** A specific lotto by ID. */
    selectLotto(id) {
        return this.selectEntity(id);
    }
    getPrice(id) {
        return this.getEntity(id)?.PurchasePrice;
    }
    /** Favourite lottos. */
    selectFavourites() {
        return this.selectAll({ filterBy: (item) => item.Favourite === 1 });
    }
    selectEntriesLimit(lottoId, memberId) {
        return this._maxEntries(lottoId, memberId).pipe(map((x) => x?.limit || 0));
    }
    selectEntriesLimitMessage(lottoId, memberId) {
        return this._maxEntries(lottoId, memberId).pipe(map((x) => {
            return x?.message || '';
        }));
    }
    _maxEntries(lottoId, memberId) {
        return combineLatest([
            this.selectLotto(lottoId),
            this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty, memberId),
        ]).pipe(map(([lotto, balance]) => {
            if (lotto == undefined || balance == undefined) {
                return;
            }
            let limit = lotto.MaxTotalTicketLimit;
            let message = '';
            if (lotto.LimitType !== LoyaltyLimitType.NoLimit) {
                switch (lotto.LimitType) {
                    case LoyaltyLimitType.LimitByAccount:
                        limit = lotto.LimitCount - lotto.NumberOfTicketsPurchasedByAccount;
                        message = 'error.lotto-accountLimitReached';
                        break;
                    case LoyaltyLimitType.LimitByMember:
                        limit = lotto.LimitCount - lotto.NumberOfTicketsPurchased;
                        message = 'error.lotto-memberLimitReached';
                        break;
                    default:
                        limit = lotto.LimitCount;
                        break;
                }
                if (limit <= 0) {
                    limit = 0;
                    message = 'error.loyalty-memberLimitReached';
                    return { limit, message };
                }
            }
            if (!lotto.UnlimitedLimit && lotto.AvailableCount < limit) {
                if (lotto.AvailableCount > 0) {
                    limit = lotto.AvailableCount;
                }
                else {
                    limit = 0;
                    message = 'error.marketplace-notEnoughStock';
                    return { limit, message };
                }
            }
            let quantityLimitFromFunds;
            if (!!balance) {
                const purchasePrice = lotto.PurchasePrice;
                if (purchasePrice === 0) {
                    const availableCount = lotto.AvailableCount > 0 ? lotto.AvailableCount : 100;
                    quantityLimitFromFunds = availableCount;
                }
                else {
                    quantityLimitFromFunds = Math.floor(balance / lotto.PurchasePrice);
                }
            }
            else {
                quantityLimitFromFunds = 10;
            }
            if (quantityLimitFromFunds < limit || (lotto.UnlimitedLimit && limit == 0)) {
                limit = quantityLimitFromFunds;
                if (quantityLimitFromFunds === 0) {
                    message = 'error.user-insufficientFunds';
                }
            }
            return { limit, message };
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoQuery, deps: [{ token: LottoStore }, { token: BalanceQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoQuery, providedIn: 'root' }); }
};
LottoQuery = __decorate([
    QueryConfig({ sortBy: 'EndDate', sortByOrder: Order.ASC })
], LottoQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoStore }, { type: BalanceQuery }] });

class LottoService {
    constructor(lottoStore, lottoQuery, api, logService) {
        this.lottoStore = lottoStore;
        this.lottoQuery = lottoQuery;
        this.api = api;
        this.logService = logService;
    }
    /** Fetches the lottos and puts them in the store. */
    fetchLottos() {
        this.lottoStore.setLoading(true);
        const request$ = this.api.get('lottos').pipe(tap((lottos) => this.lottoStore.set(lottos)), mapTo(null));
        return this.lottoQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetches a specific lotto (ignoring cache) and puts it in the store. */
    fetchLottoById(id) {
        this.lottoStore.setLoading(true);
        const request$ = this.api.getById('lottos', id.toString()).pipe(tap((lotto) => this.lottoStore.upsert(id, lotto)), mapTo(null));
        return request$;
    }
    /** Enter a lotto. */
    async enterLotto(id, entries, memberId = '') {
        this.logService.debug(`Entering lotto ${entries} time(s)`, id);
        const request$ = this.api
            .postForParent('lottos', id, 'enter?memberId=' + memberId, entries)
            .pipe(tap({
            error: (error) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 400) {
                        // If the error is status 400, we need to fetch the lotto again to get the updated data.
                        // but if we know the exact error code we can just update the store so we dont need to call another api call, 
                        // instead we will just fetch the lotto again just to be safe.
                        firstValueFrom(this.fetchLottoById(id));
                    }
                }
            }
        }), switchMap(() => this.fetchLottoById(id)));
        return await firstValueFrom(request$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoService, deps: [{ token: LottoStore }, { token: LottoQuery }, { token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoStore }, { type: LottoQuery }, { type: ApiService }, { type: LoggingService }] });

class LottoResolver {
    constructor(lottoService, logService) {
        this.lottoService = lottoService;
        this.logService = logService;
    }
    resolve(route) {
        let id = route.paramMap.get('id');
        let currentUrl = route.pathFromRoot
            .filter((x) => x.routeConfig)
            .map((x) => x.routeConfig.path)
            .join('/');
        if (id) {
            this.logService.info(`Resolving lotto by id for route: ${currentUrl}`, +id);
            return this.lottoService.fetchLottoById(+id);
        }
        else {
            this.logService.info(`Resolving all lottos for route: ${currentUrl}`);
            return this.lottoService.fetchLottos();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoResolver, deps: [{ token: LottoService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoService }, { type: LoggingService }] });

let LottoWalletStore = class LottoWalletStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletStore, providedIn: 'root' }); }
};
LottoWalletStore = __decorate([
    StoreConfig({ name: 'lotto-wallet', idKey: 'LottoId', cache: { ttl: 20000 } })
], LottoWalletStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let LottoWalletQuery = class LottoWalletQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All lottos. */
    selectLottoWalletItems() {
        return this.selectAll();
    }
    /** A specific lotto by ID. */
    selectLottoWalletItem(id) {
        return this.selectEntity(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletQuery, deps: [{ token: LottoWalletStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletQuery, providedIn: 'root' }); }
};
LottoWalletQuery = __decorate([
    QueryConfig({ sortBy: 'EndDate', sortByOrder: Order.ASC })
], LottoWalletQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoWalletStore }] });

class LottoWalletService {
    constructor(lottoWalletStore, lottoWalletQuery, api, logService) {
        this.lottoWalletStore = lottoWalletStore;
        this.lottoWalletQuery = lottoWalletQuery;
        this.api = api;
        this.logService = logService;
    }
    /** Fetches the lotto wallet items and puts them in the store. */
    fetchLottoWalletItems() {
        this.lottoWalletStore.setLoading(true);
        this.logService.info('making call for lotto wallet items');
        const request$ = this.api.get('lottos/wallet').pipe(tap(lottos => this.lottoWalletStore.set(lottos)), mapTo(null));
        return this.lottoWalletQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletService, deps: [{ token: LottoWalletStore }, { token: LottoWalletQuery }, { token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoWalletStore }, { type: LottoWalletQuery }, { type: ApiService }, { type: LoggingService }] });

class LottoWalletResolver {
    constructor(lottoService, logService) {
        this.lottoService = lottoService;
        this.logService = logService;
    }
    resolve(route) {
        this.logService.info('Resolving lotto wallet items');
        return this.lottoService.fetchLottoWalletItems();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletResolver, deps: [{ token: LottoWalletService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LottoWalletResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LottoWalletService }, { type: LoggingService }] });

let MarketplaceStore = class MarketplaceStore extends EntityStore {
    constructor() {
        super();
    }
    akitaPreAddEntity(item) {
        const newItem = { ...item, ItemImageURL: item.ItemImageURL || item.ImageURL };
        return newItem;
    }
    akitaPreUpdateEntity(_, updatedItem) {
        const newItem = { ...updatedItem, ItemImageURL: updatedItem.ItemImageURL || updatedItem.ImageURL };
        return newItem;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceStore, providedIn: 'root' }); }
};
MarketplaceStore = __decorate([
    StoreConfig({ name: 'marketplace', idKey: 'Id', cache: { ttl: 20000 } })
], MarketplaceStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let MarketplaceQuery = class MarketplaceQuery extends QueryEntity {
    constructor(store, balanceQuery) {
        super(store);
        this.store = store;
        this.balanceQuery = balanceQuery;
    }
    /** All marketplace items. */
    selectMarketplaceItems() {
        return this.selectAll();
    }
    /** A specific marketplace item by ID. */
    selectMarketplaceItem(id) {
        return this.selectEntity(id);
    }
    /** All marketplace items that match any of the specified types. */
    selectMarketplaceItemsOfType(...types) {
        return this.selectAll({ filterBy: (item) => types.includes(item.ProcessProviderId) });
    }
    /** Favourite marketplace items. */
    selectFavourites() {
        return this.selectAll({ filterBy: (item) => item.Favourite });
    }
    /** get the maximum number of purchases a given member can make */
    selectPurchaseLimit(id, memberId, mappingId) {
        return this._purchaseLimit(id, memberId, mappingId).pipe(map((x) => x?.limit || 0));
    }
    /** get the message to display when the maximum number of purchases is exceeded */
    selectPurchaseLimitMessage(id, memberId, mappingId) {
        return this._purchaseLimit(id, memberId, mappingId).pipe(map((x) => x?.errorMessage || ''));
    }
    /** get the price of a marketplaceItem  */
    getPrice(id) {
        return this.getEntity(id)?.PointValue;
    }
    _purchaseLimit(id, memberId, mappingId) {
        return combineLatest([
            this.selectMarketplaceItem(id),
            this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty, memberId),
        ]).pipe(map(([item, balance]) => {
            if (item == undefined || balance == undefined) {
                return;
            }
            let limit;
            if (item.StockType === MarketplaceItemStockType.AttributeStockType && item.AttributeMappings) {
                let mapping = item.AttributeMappings.find((x) => x.AttributeMappingId === mappingId);
                limit = mapping ? mapping.AvailableStockCount : 0;
            }
            else {
                limit = item.AvailabilityCount;
            }
            let errorMessage = 'error.marketplace-notEnoughStock';
            const quantityLimitFromFunds = Math.floor(balance / item.PointValue);
            if (quantityLimitFromFunds < limit && item.PointValue) {
                limit = quantityLimitFromFunds;
                errorMessage = 'error.user-insufficientFunds';
            }
            if (item.MaxQuantity < limit) {
                limit = item.MaxQuantity;
                errorMessage = 'error.loyalty-memberLimitReached';
                if (item.LimitType !== MarketplaceItemLimitType.NoLimit) {
                    switch (item.LimitType) {
                        case MarketplaceItemLimitType.LimitByAccount:
                            errorMessage = 'error.marketplace-accountLimitReached';
                            break;
                        case MarketplaceItemLimitType.LimitByMember:
                            errorMessage = 'error.marketplace-memberLimitReached';
                            break;
                        default:
                            errorMessage = 'error.loyalty-memberLimitReached';
                            break;
                    }
                }
            }
            return { limit, errorMessage };
        }), shareReplay(1));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceQuery, deps: [{ token: MarketplaceStore }, { token: BalanceQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceQuery, providedIn: 'root' }); }
};
MarketplaceQuery = __decorate([
    QueryConfig({ sortBy: 'Id', sortByOrder: Order.DESC })
], MarketplaceQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MarketplaceStore }, { type: BalanceQuery }] });

let PurchaseStore = class PurchaseStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseStore, providedIn: 'root' }); }
};
PurchaseStore = __decorate([
    StoreConfig({ name: 'purchase', idKey: 'LogId', cache: { ttl: 30000 } })
], PurchaseStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BasketService {
    constructor(logService, api) {
        this.logService = logService;
        this.api = api;
        this._basket = new BehaviorSubject(new MarketplaceBasket());
        this.basket$ = this._basket.asObservable().pipe(shareReplay(1));
    }
    /** Gets the current basket. */
    getCurrentBasket() {
        return this._basket.value;
    }
    /** Adds an item to the basket. */
    addItemToBasket(item) {
        let basket = this.getCurrentBasket();
        let existingItem = basket.items.find((i) => {
            return i.id === item.id && i.attributeMappingId == item.attributeMappingId && isEqual(item.customFields, i.customFields);
        });
        if (existingItem) {
            existingItem.quantity += existingItem.quantity;
        }
        else {
            basket.items.push(item);
        }
        this._basket.next(basket);
    }
    /** Removes an item from the basket. */
    removeItemFromBasket(productId) {
        let basket = this.getCurrentBasket();
        let existingItem = basket.items.find((item) => item.id === productId);
        if (!existingItem) {
            this.logService.warning(`Failed to remove item ${productId} from basket as this item is not in the basket.`);
            return;
        }
        if (existingItem.quantity > 1) {
            existingItem.quantity -= 1;
        }
        else {
            basket.items = basket.items.filter((item) => item.id !== existingItem.id);
        }
        this._basket.next(basket);
    }
    /** Clears the basket of all items. */
    emptyBasket() {
        this._basket.next(new MarketplaceBasket());
    }
    async getPurchasesOrderBasket(orderId) {
        return await this.api.get(`purchases/order/basket/${orderId}`).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BasketService, deps: [{ token: LoggingService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BasketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BasketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: ApiService }] });

class MpThemeService {
    constructor() {
        this._themes = [
            'marketplace', // FortressGB
            'mp-unique-code', // Unique Code
            'mp-download', // Download
            'mp-event', // Event
            'mp-product', // Product
            'mp-virtual-event', // Virtual event
        ];
    }
    getTheme(id) {
        let theme = 'marketplace';
        if (id > -1 && id < this._themes.length) {
            theme = this._themes[id];
        }
        return theme;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MpThemeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MpThemeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MpThemeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class MarketplaceService {
    constructor(marketplaceStore, marketplaceQuery, purchaseStore, api, logService, basketService, themeService) {
        this.marketplaceStore = marketplaceStore;
        this.marketplaceQuery = marketplaceQuery;
        this.purchaseStore = purchaseStore;
        this.api = api;
        this.logService = logService;
        this.basketService = basketService;
        this.themeService = themeService;
    }
    /** Fetches the marketplace items and puts them in the store. */
    fetchMarketplaceItems() {
        this.marketplaceStore.setLoading(true);
        const request$ = this.api.get('marketplace/items').pipe(map((items) => items.map((item) => ({ ...item, theme: this.themeService.getTheme(item.ProcessProviderId) }))), tap((items) => this.marketplaceStore.set(items)), mapTo(null));
        return this.marketplaceQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetches a specific marketplace item (ignoring cache) and puts it in the store. */
    fetchMarketplaceItemById(id) {
        this.marketplaceStore.setLoading(true);
        const request$ = this.api.getById('marketplace/items', id.toString()).pipe(map((item) => ({ ...item, theme: this.themeService.getTheme(item.ProcessProviderId) })), tap((item) => this.marketplaceStore.upsert(id, item)), mapTo(null));
        return request$;
    }
    /**
     * update store values when item is added to basket.
     */
    updateMarketplaceStoreWithBasketItem(itemId, quantity) {
        let item = this.marketplaceQuery.getEntity(itemId);
        if (!item) {
            return;
        }
        this.marketplaceStore.update(itemId, {
            AvailabilityCount: item.AvailabilityCount - quantity,
            AccountPurchaseCount: item.AccountPurchaseCount + quantity,
            MemberPurchaseCount: item.MemberPurchaseCount + quantity,
        });
    }
    removeBasketItemFromStore(itemId, quantity) {
        let item = this.marketplaceQuery.getEntity(itemId);
        if (!item) {
            return;
        }
        this.marketplaceStore.update(itemId, {
            AvailabilityCount: item.AvailabilityCount + quantity,
            AccountPurchaseCount: item.AccountPurchaseCount - quantity,
            MemberPurchaseCount: item.MemberPurchaseCount - quantity,
        });
    }
    /**
     * Purchase a single item.
     * @returns the full provider response
     */
    async purchaseItemWithProviderResopnse(itemId, quantity, attributeMappingId, memberId, customFields, useCardToken = false) {
        const item = this.marketplaceQuery.getEntity(itemId);
        if (!item) {
            return;
        }
        this.logService.debug(`Purchasing ${quantity} quantity of marketplace item`, item);
        this.basketService.emptyBasket();
        this.basketService.addItemToBasket(MarketplaceBasketItem.fromMarketplaceItem(item, quantity, attributeMappingId, customFields));
        return this.purchaseBasketWithProviderResponse(this.basketService.getCurrentBasket().items, memberId, useCardToken);
    }
    /**
     * Purchase a single item.
     * @returns The order ID or the purchase.
     */
    async purchaseItem(itemId, quantity, attributeMappingId, memberId, customFields, useCardToken = false) {
        const item = this.marketplaceQuery.getEntity(itemId);
        if (!item) {
            return;
        }
        this.logService.debug(`Purchasing ${quantity} quantity of marketplace item`, item);
        this.basketService.emptyBasket();
        this.basketService.addItemToBasket(MarketplaceBasketItem.fromMarketplaceItem(item, quantity, attributeMappingId, customFields));
        return this.purchaseBasket(this.basketService.getCurrentBasket().items, memberId, useCardToken);
    }
    /**
     * Purchase the items in the current basket.
     * @returns The order ID or the purchase.
     */
    async purchaseBasket(basket, memberId, useCardToken = false) {
        return (await this.purchaseBasketWithProviderResponse(basket, memberId, useCardToken)).OrderId;
    }
    /**
     * Purchase the items in the current basket.
     * @returns The full provider response
     */
    async purchaseBasketWithProviderResponse(basket, memberId, useCardToken = false) {
        this.logService.debug(`Purchasing marketplace item basket`, basket);
        let response = await this.api
            .post('marketplace/Purchase' + (memberId ? '?memberId=' + memberId : '') + '?useCardToken=' + useCardToken, basket)
            .pipe(tap((response) => {
            if (response.Data.Success) {
                this.purchaseStore.setHasCache(false);
            }
        }))
            .toPromise();
        if (response.Data.Success) {
            this.basketService.emptyBasket();
        }
        return response.Data;
    }
    /**
     * This will download the marketplace purchased item
     * @param logId is the log id of the purchased item.
     */
    downloadMarketplaceItem(logId) {
        return this.api.getFile(`marketplace/download/${logId}`);
    }
    /**
     * This will disable cache of the marketpalce store, so
     * that a fetch can be made again.
     */
    disableMarketplaceStoreCache() {
        this.marketplaceStore.setHasCache(false);
    }
    /**
     * This endpoint is used to purchase marketplace items, it works with merchant and ecash.
     * This is to replace the api/purchase endpoint.
     */
    async purchaseBasketMarketplace(body) {
        this.logService.debug(`Purchasing marketplace item in the basket`, body);
        const response = await this.api
            .post('marketplace/purchasebasket', body).pipe(tap((res) => {
            if (res.Data.Success) {
                this.purchaseStore.setHasCache(false);
            }
        }))
            .toPromise();
        return response;
    }
    /**
     * This endpoint is used to purchase marketplace items, it works with merchant and ecash.
     * This is to replace the api/purchase endpoint.
     */
    async completePurchaseBasketOrder(orderId, failureUrl, successUrl, useCardToken = true, postBackUrl = '') {
        const body = {
            OrderId: orderId,
            FailureUrl: failureUrl,
            SuccessUrl: successUrl,
            PostBackUrl: postBackUrl,
            UseCardToken: useCardToken,
        };
        this.logService.debug(`Purchasing marketplace item in the basket`, body);
        const response = await this.api
            .post('marketplace/checkout/complete', body).toPromise();
        return response;
    }
    /**
     * This endpoint is used to purchase marketplace items, it works with merchant and ecash.
     * This is to replace the api/purchase endpoint.
     */
    async checkoutStart(body) {
        return await this.api.post('marketplace/checkout/start', body).toPromise();
    }
    /**
     * This endpoint is used to update the shipping option of the basket
     */
    async updateAdress(orderId, memberDetails) {
        return await this.api.post('marketplace/checkout/address' + (orderId ? '?orderId=' + orderId : ''), memberDetails).toPromise();
    }
    /**
     * This endpoint is used to update the shipping option of the basket
     */
    async updateShippingAdress(orderId, memberDetails) {
        return await this.api.post('marketplace/checkout/shipping' + (orderId ? '?orderId=' + orderId : ''), memberDetails).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceService, deps: [{ token: MarketplaceStore }, { token: MarketplaceQuery }, { token: PurchaseStore }, { token: ApiService }, { token: LoggingService }, { token: BasketService }, { token: MpThemeService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MarketplaceStore }, { type: MarketplaceQuery }, { type: PurchaseStore }, { type: ApiService }, { type: LoggingService }, { type: BasketService }, { type: MpThemeService }] });

class MarketplaceExtendedQuery {
    constructor(marketplaceQuery, balanceQuery) {
        this.marketplaceQuery = marketplaceQuery;
        this.balanceQuery = balanceQuery;
    }
    /** All marketplace items. */
    selectExtendedMarketplaceItems() {
        return this._mapArray(this.marketplaceQuery.selectMarketplaceItems());
    }
    /** A specific marketplace item by ID. */
    selectExtendedMarketplaceItem(id) {
        return this._mapSingle(this.marketplaceQuery.selectEntity(id));
    }
    /** All marketplace items that match any of the specified types. */
    selectExtendedMarketplaceItemsOfType(...types) {
        return this._mapArray(this.marketplaceQuery.selectMarketplaceItemsOfType(...types));
    }
    /** Favourite marketplace items. */
    selectExtendedMarketplaceFavourites() {
        return this._mapArray(this.marketplaceQuery.selectFavourites());
    }
    /**
     * Get the localised attributes for a marketplace item to inputed locale
     * @param marketplaceItemId Id of the marketplace item
     * @param lcid locale to be localised to
     */
    getLocalisedAttributes(marketplaceItemId, lcid) {
        let marketplaceItem = this.marketplaceQuery.getEntity(marketplaceItemId);
        if (!marketplaceItem) {
            return;
        }
        let attributesToLocalise = JSON.parse(JSON.stringify(marketplaceItem.Attributes));
        for (let index = 0; index < attributesToLocalise.length; index++) {
            let attribute = attributesToLocalise[index];
            attribute.DisplayName = this.getLocalaisedAttributeName(attribute, lcid);
            for (let avIndex = 0; avIndex < attribute.Values.length; avIndex++) {
                let indexAttributeValue = attribute.Values[avIndex];
                indexAttributeValue.DisplayName = this.getLocalisedValueName(indexAttributeValue, lcid);
            }
        }
        return attributesToLocalise;
    }
    /**
     * Get the selected attributes from an array of values which the user has selected
     * @param marketplaceItemId Id of the marketplace item
     * @param lcid locale to be localised to
     * @param values selected values which we need to filter the marketplace attributes for
     */
    getSelectedAttributes(marketplaceItemId, lcid, values) {
        let marketplaceItem = this.marketplaceQuery.getEntity(marketplaceItemId);
        if (marketplaceItem === undefined) {
            return;
        }
        // to fix error for marketplaceItem being undefined even though it's not possible..
        const foundMarketplaceItem = marketplaceItem;
        let selectedAttributes = [];
        values.forEach((value) => {
            for (let attr of foundMarketplaceItem.Attributes) {
                let foundValue = attr.Values.find((x) => x.RewardValueId === value);
                if (foundValue) {
                    let attribute = {
                        AttributeName: this.getLocalaisedAttributeName(attr, lcid),
                        ValueName: this.getLocalisedValueName(foundValue, lcid),
                    };
                    selectedAttributes.push(attribute);
                    break;
                }
            }
        });
        return selectedAttributes;
    }
    /**
     * Retrieve the localised attribute values from a list of attributes
     * @param attributes Array of attributes
     * @param lcid locale to be localised to
     */
    getLocalisedAttributeValuesFromArray(attributes, lcid) {
        let selectedAttributes = [];
        for (let attr of attributes) {
            if (attr.Values && attr.Values.length) {
                let attribute = {
                    AttributeName: this.getLocalaisedAttributeName(attr, lcid),
                    ValueName: this.getLocalisedValueName(attr.Values[0], lcid),
                };
                selectedAttributes.push(attribute);
            }
        }
        return selectedAttributes;
    }
    /**
     * Retrieve the localised attribute display name for supplied attribute
     * @param attribute Attribute we want to get the localised display name for
     * @param lcid Locale we want to localise the display name to
     */
    getLocalaisedAttributeName(attribute, lcid) {
        if (!attribute.Locales) {
            return attribute.DisplayName;
        }
        let matchedAttributeLocale = attribute.Locales.find((l) => l.LCID === lcid);
        if (matchedAttributeLocale) {
            return matchedAttributeLocale.DisplayName;
        }
        else if (!attribute.DisplayName || attribute.DisplayName === '') {
            return attribute.Locales[0].DisplayName;
        }
        else {
            return attribute.DisplayName;
        }
    }
    /**
     * Retrieve the localised attribute value display name for supplied attribute value
     * @param attributeValue Attribute value we want to get the localised display name for
     * @param lcid Locale we want to localise the display name to
     */
    getLocalisedValueName(attributeValue, lcid) {
        if (!attributeValue.Locales) {
            return attributeValue.DisplayName;
        }
        let matchedAttributeValueLocale = attributeValue.Locales.find((l) => l.LCID === lcid);
        if (matchedAttributeValueLocale) {
            return matchedAttributeValueLocale.DisplayName;
        }
        else if (!attributeValue.DisplayName || attributeValue.DisplayName === '') {
            return attributeValue.Locales[0].DisplayName;
        }
        else {
            return attributeValue.DisplayName;
        }
    }
    /**
     * Gets the item type and corresponding item group of the marketplace item
     * @param marketplaceItem Marketplace item that we want to identify
     */
    getMarketplaceItemType(marketplaceItem) {
        switch (marketplaceItem.ProcessProviderId) {
            case ProcessProviderId.Event:
            case ProcessProviderId.VirtualEvent:
                return {
                    backLink: '/rewards/events',
                    type: 'Event',
                    group: 'Events',
                };
            case ProcessProviderId.Product:
                return {
                    backLink: '/rewards/products',
                    type: 'Product',
                    group: 'Products',
                };
            default:
                return {
                    backLink: '/rewards/marketplace',
                    type: 'Marketplace',
                    group: 'Marketplace',
                };
        }
    }
    _mapArray(marketplaceItems) {
        return combineQueries([marketplaceItems, this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty)]).pipe(map(([items, balance]) => {
            if (!items || balance === undefined) {
                return;
            }
            return items.map((item) => this._transform(item, balance));
        }));
    }
    _mapSingle(marketplaceItems) {
        return combineQueries([marketplaceItems, this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty)]).pipe(map(([item, balance]) => {
            if (!item || balance === undefined) {
                return;
            }
            return this._transform(item, balance);
        }));
    }
    _transform(item, balance) {
        return {
            ...item,
            Status: this._calculateItemStatus(item, balance),
        };
    }
    /**
     * Calculates the status of a marketplace item. An item can fulfil all the criteria for multiple
     * statuses simultaneously, however only the highest priority status is returned.
     * @param marketplaceItem The marketplace item to calculate the status for.
     */
    _calculateItemStatus(marketplaceItem, loyaltyBalance) {
        let isLimited = !!marketplaceItem.ItemLimitType || !!marketplaceItem.LimitType;
        const requestTime = DateTime.fromISO(marketplaceItem.RequestTime, { zone: 'utc' });
        const startDate = DateTime.fromISO(marketplaceItem.ItemStartDate, { zone: 'utc' });
        if (marketplaceItem.ComingSoon && startDate > requestTime) {
            return MarketplaceItemStatus.ComingSoon;
        }
        else if (marketplaceItem.AvailabilityCount <= 0 && !marketplaceItem.UnlimitedStock) {
            return MarketplaceItemStatus.SoldOut;
        }
        else if (marketplaceItem.PointValue > loyaltyBalance) {
            return MarketplaceItemStatus.NotEnoughPoints;
        }
        else if (isLimited && marketplaceItem.MaxQuantity == 0) {
            return MarketplaceItemStatus.MemberLimitReached;
        }
        else {
            return MarketplaceItemStatus.Available;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceExtendedQuery, deps: [{ token: MarketplaceQuery }, { token: BalanceQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceExtendedQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MarketplaceExtendedQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MarketplaceQuery }, { type: BalanceQuery }] });

let PurchaseQuery = class PurchaseQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectPurchases() {
        return this.selectAll();
    }
    selectPurchaseById(logId) {
        return this.selectEntity(logId);
    }
    selectRedeemedPurchases() {
        return this.selectAll({ filterBy: (purchase) => purchase.RedeemStatus === 1 });
    }
    selectUnredeemedPurchases() {
        return this.selectAll({ filterBy: (purchase) => purchase.RedeemStatus === 0 });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseQuery, deps: [{ token: PurchaseStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseQuery, providedIn: 'root' }); }
};
PurchaseQuery = __decorate([
    QueryConfig({ sortBy: 'ExpirationDate' })
], PurchaseQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PurchaseStore }] });

var AuctionBidStatus;
(function (AuctionBidStatus) {
    AuctionBidStatus[AuctionBidStatus["All"] = 0] = "All";
    AuctionBidStatus[AuctionBidStatus["Active"] = 1] = "Active";
    AuctionBidStatus[AuctionBidStatus["Completed"] = 2] = "Completed";
    AuctionBidStatus[AuctionBidStatus["Failed"] = 3] = "Failed";
    AuctionBidStatus[AuctionBidStatus["Inactive"] = 4] = "Inactive";
})(AuctionBidStatus || (AuctionBidStatus = {}));

let AuctionBidStore = class AuctionBidStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidStore, providedIn: 'root' }); }
};
AuctionBidStore = __decorate([
    StoreConfig({ name: 'auction-bid', idKey: 'Id' })
], AuctionBidStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AuctionBidQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectBids() {
        return this.selectAll();
    }
    selectBid(id) {
        return this.selectEntity(id);
    }
    selectActiveBids() {
        return this.selectAll({ filterBy: bid => bid.Status === AuctionBidStatus.Active });
    }
    selectWonBids() {
        return this.selectAll({
            filterBy: bid => {
                return bid.Status === AuctionBidStatus.Completed && bid.ItemWon;
            }
        });
    }
    selectCurrentLosingBids() {
        return this.selectAll({
            filterBy: bid => {
                return bid.Status === AuctionBidStatus.Active && !bid.ItemWon;
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidQuery, deps: [{ token: AuctionBidStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionBidStore }] });

class AuctionBidService {
    constructor(auctionBidStore, auctionBidQuery, api) {
        this.auctionBidStore = auctionBidStore;
        this.auctionBidQuery = auctionBidQuery;
        this.api = api;
    }
    fetchBids() {
        this.auctionBidStore.setLoading(true);
        const request$ = this.api
            .get('purchases/auctionhistory')
            .pipe(tap(bids => this.auctionBidStore.set(bids)), mapTo(null));
        return this.auctionBidQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidService, deps: [{ token: AuctionBidStore }, { token: AuctionBidQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionBidStore }, { type: AuctionBidQuery }, { type: ApiService }] });

var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus[PurchaseStatus["Created"] = 1] = "Created";
    PurchaseStatus[PurchaseStatus["Cancelled"] = 2] = "Cancelled";
    PurchaseStatus[PurchaseStatus["Failed"] = 3] = "Failed";
    PurchaseStatus[PurchaseStatus["Partial"] = 4] = "Partial";
    PurchaseStatus[PurchaseStatus["Completed"] = 5] = "Completed";
    PurchaseStatus[PurchaseStatus["Refunded"] = 6] = "Refunded";
    PurchaseStatus[PurchaseStatus["CalledBack"] = 7] = "CalledBack";
    PurchaseStatus[PurchaseStatus["CalledBackFailed"] = 8] = "CalledBackFailed";
    PurchaseStatus[PurchaseStatus["RequireMoreInformation"] = 9] = "RequireMoreInformation";
    PurchaseStatus[PurchaseStatus["RefundedByCustomer"] = 10] = "RefundedByCustomer";
})(PurchaseStatus || (PurchaseStatus = {}));

class PurchaseService {
    constructor(purchaseStore, purchaseQuery, api, themeService, logger, router) {
        this.purchaseStore = purchaseStore;
        this.purchaseQuery = purchaseQuery;
        this.api = api;
        this.themeService = themeService;
        this.logger = logger;
        this.router = router;
    }
    /** Fetch all member purchases and put them in the store. */
    fetchMemberPurchases() {
        const request$ = this.api.get('purchases').pipe(map(purchases => purchases.map(purchase => ({
            ...purchase,
            theme: this.themeService.getTheme(purchase.ProcessProviderId),
        }))), tap(purchases => this.purchaseStore.set(purchases)), mapTo(null));
        return this.purchaseQuery.getHasCache() ? of(null) : request$;
    }
    /** @deprecated, use checkOrderSuccessStatus: Fetch a purchase basket by order ID. */
    fetchPurchaseBasketByOrderId(orderId) {
        return this.api.getById('purchases/order/basket', orderId);
    }
    /** update the address of a given purchase using its orderId and provided address model */
    updatePurchaseAddress(orderId, addressToUpdate) {
        return this.api.post(`purchases/updateaddress/${orderId}`, addressToUpdate);
    }
    /** update the address of a given purchase using its orderId and provided address model */
    continueOrder(orderId) {
        return this.api.post(`purchases/continue/${orderId}`, orderId);
    }
    /** Fetch a member purchases from by ID and put it in the store. */
    fetchMemberPurchaseById(logId, portalId = '') {
        return this.api.getAnySingle(`purchases/${logId}?portalId=${portalId}`).pipe(map(purchase => ({
            ...purchase,
            theme: this.themeService.getTheme(purchase.ProcessProviderId),
        })), tap(purchase => {
            this.purchaseStore.upsert(logId, purchase);
        }), mapTo(null));
    }
    async getDetailPurchase(logId) {
        return this.api.get(`purchases/${logId}`).toPromise();
    }
    getVirtualEventPurchaseDetails(logId) {
        return this.api.getAnySingle(`marketplace/purchase/virtualEvent/${logId}`);
    }
    checkOrderSuccessStatus(orderId, successUrl, failureUrl, isRegistration = false) {
        this.timerSubscription = timer(0, 3000)
            .pipe(switchMap(time => {
            if (time > 100) {
                this.timerSubscription.unsubscribe();
            }
            return this.fetchOrderById(orderId, isRegistration).pipe(map(x => {
                if (x.Status === PurchaseStatus.Completed) {
                    this.logger.info('Order succesful');
                    this.timerSubscription.unsubscribe();
                    this.router.navigateByUrl(successUrl + `?orderId=${orderId}`);
                }
                else if (x.Status === PurchaseStatus.Created) {
                    this.logger.info('Order not completed wait more');
                }
                else {
                    this.logger.info('Order failed');
                    this.timerSubscription.unsubscribe();
                    this.router.navigateByUrl(failureUrl + `?orderId=${orderId}`);
                }
            }));
        }))
            .subscribe();
    }
    completeTransaction(isRegistration = false) {
        let url = isRegistration ? 'register/processTransaction' : 'purchases/processTransaction';
        return this.api.post(url, JSON.stringify(config.portalUrl + this.router.url));
    }
    fetchOrderById(orderId, isRegistration = false) {
        let url = isRegistration ? 'register/order' : 'purchases/order';
        return this.api.getById(url, orderId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseService, deps: [{ token: PurchaseStore }, { token: PurchaseQuery }, { token: ApiService }, { token: MpThemeService }, { token: LoggingService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PurchaseStore }, { type: PurchaseQuery }, { type: ApiService }, { type: MpThemeService }, { type: LoggingService }, { type: i2.Router }] });

class LoyaltyStatusService {
    constructor(memberQuery, balanceQuery) {
        this.memberQuery = memberQuery;
        this.balanceQuery = balanceQuery;
        /**
         * These are statuses that are considered stock statuses
         * ex. limited stock, stock is low like 3 left.etc
         */
        this.stockStatus = [LOYALTY_STATUS.LIMITED_STOCK, LOYALTY_STATUS.STOCK_LOW];
        /**
         * These are statuses that are considered disabled
         */
        this.disabledStatus = [LOYALTY_STATUS.SOLD_OUT, LOYALTY_STATUS.COMING_SOON, LOYALTY_STATUS.LIMIT_REACHED, LOYALTY_STATUS.NOT_ENOUGH_POINTS];
    }
    /**
     * Gets the status of an item
     */
    getStatus(item) {
        // Check the instance of the item then get the status
        if (item instanceof AuctionItem) {
            return this._getAuctionStatus(item);
        }
        else if (item instanceof MarketplaceItemExtended) {
            return this._getMarketplaceStatus(item);
        }
        else if (item instanceof LottoItem) {
            return this._getLottoStatus(item);
        }
        return new LoyaltyStatus();
    }
    /**
     * Check if the item has a disabled state
     */
    hasDisabledStatus(item) {
        const status = this.getStatus(item);
        return this.disabledStatus.some(s => s === status.status);
    }
    /**
     * Check if the item has a stock status ex. limited stock, stock low
     */
    hasStockStatus(item) {
        const status = this.getStatus(item);
        return this.stockStatus.some(s => s === status.status);
    }
    /**
     * Check if the item is new where item creation date is less than 3 days
     */
    isNew(item) {
        const status = this.getStatus(item);
        return status.status === LOYALTY_STATUS.NEW;
    }
    /**
     * Get the status of an auction item
     * @returns LoyaltyStatus
     */
    _getAuctionStatus(item) {
        const memberId = this.memberQuery.getValue().user?.memberId;
        const balance = this.balanceQuery.getEntity([memberId, 6].join('-'))?.balance || 0;
        const requestTime = DateTime.fromISO(item.RequestTime, { zone: 'utc' });
        const startDate = DateTime.fromISO(item.StartDate, { zone: 'utc' });
        const pointsValue = item.PointsValue ?? 0;
        const bidIncrement = item.BidIncrement ?? 0;
        const currentValue = item.CurrentValue ?? 0;
        let comingSoon = item.ComingSoon;
        if (startDate <= requestTime) {
            comingSoon = false;
        }
        if (comingSoon && startDate > requestTime) {
            return new AuctionState({ theme: 'coming-soon', status: LOYALTY_STATUS.COMING_SOON });
        }
        else if (pointsValue > balance || bidIncrement > balance || (currentValue + bidIncrement) > balance) {
            return new AuctionState({ theme: 'not-enough-points', status: LOYALTY_STATUS.NOT_ENOUGH_POINTS });
        }
        else {
            const days = requestTime.diff(startDate, 'days').days;
            const status = days <= 3 ? LOYALTY_STATUS.NEW : item.Favourite ? LOYALTY_STATUS.FEATURED : LOYALTY_STATUS.NONE;
            return new AuctionState({ status });
        }
    }
    /**
     * Get the status of a marketplace item
     * @param item
     * @returns LoyaltyStatus
     */
    _getMarketplaceStatus(item) {
        const availableStock = item.AvailableCount || 0;
        const isUnlimited = !!item.UnlimitedStock;
        let comingSoon = item.ComingSoon;
        const requestTime = DateTime.fromISO(item.RequestTime, { zone: 'utc' });
        const startDate = DateTime.fromISO(item.ItemStartDate, { zone: 'utc' });
        if (startDate <= requestTime) {
            comingSoon = false;
        }
        if (comingSoon && startDate > requestTime) {
            return new MarketplaceState({ theme: 'coming-soon', status: LOYALTY_STATUS.COMING_SOON });
        }
        else if (!isUnlimited && availableStock <= 0) {
            return new MarketplaceState({ theme: 'sold-out', status: LOYALTY_STATUS.SOLD_OUT });
        }
        else if (item.Status === MarketplaceItemStatus.NotEnoughPoints) {
            return new MarketplaceState({ theme: 'not-enough-points', status: LOYALTY_STATUS.NOT_ENOUGH_POINTS });
        }
        else if (item.Status === MarketplaceItemStatus.MemberLimitReached) {
            return new MarketplaceState({ theme: 'limit-reached', status: LOYALTY_STATUS.LIMIT_REACHED });
        }
        else {
            const stockCount = item.AvailabilityCount;
            // Limited stock
            if (stockCount > 5 && stockCount <= 10) {
                return new MarketplaceState({ theme: 'limited-item', status: LOYALTY_STATUS.LIMITED_STOCK });
            }
            else if (stockCount > 0 && stockCount <= 5) {
                return new MarketplaceState({ theme: 'stock-low', status: LOYALTY_STATUS.STOCK_LOW });
            }
            else {
                const days = requestTime.diff(startDate, 'days').days;
                const status = days <= 3 ? LOYALTY_STATUS.NEW : item.Favourite ? LOYALTY_STATUS.FEATURED : LOYALTY_STATUS.NONE;
                return new MarketplaceState({ status });
            }
        }
    }
    /**
     * Get the status of a lotto item
     * @param item
     * @returns LoyaltyStatus
     */
    _getLottoStatus(item) {
        const memberId = this.memberQuery.getValue().user?.memberId;
        const balance = this.balanceQuery.getEntity([memberId, 6].join('-'))?.balance || 0;
        const requestTime = DateTime.fromISO(item.RequestTime, { zone: 'utc' });
        const startDate = DateTime.fromISO(item?.StartDate, { zone: 'utc' });
        const purchasePrice = item.PurchasePrice ?? 0;
        let comingSoon = item.AllowComingSoon === ItemLoyaltyState.ComingSoon;
        if (startDate <= requestTime) {
            comingSoon = false;
        }
        if (comingSoon && startDate > requestTime) {
            return new LottoState({ theme: 'coming-soon', status: LOYALTY_STATUS.COMING_SOON });
        }
        else if (item.ItemState === ItemLoyaltyState.OutOfStock) {
            return new LottoState({ theme: 'sold-out', status: LOYALTY_STATUS.SOLD_OUT });
        }
        else if (item.ItemState === ItemLoyaltyState.ItemLimitReached) {
            return new LottoState({ theme: 'limit-reached', status: LOYALTY_STATUS.LIMIT_REACHED });
        }
        else {
            if (balance < purchasePrice) {
                return new LottoState({ theme: 'not-enough-points', status: LOYALTY_STATUS.NOT_ENOUGH_POINTS });
            }
            else {
                const days = requestTime.diff(startDate, 'days').days;
                const status = days <= 3 ? LOYALTY_STATUS.NEW : item.Favourite ? LOYALTY_STATUS.FEATURED : LOYALTY_STATUS.NONE;
                return new LottoState({ status });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyStatusService, deps: [{ token: MemberQuery }, { token: BalanceQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyStatusService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyStatusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: MemberQuery }, { type: BalanceQuery }] });

class MixedLoyaltyQuery {
    constructor(auctionQuery, marketplaceExtendedQuery, lottoQuery, purchaseQuery, auctionBidQuery, auctionBidService, lottoWalletQuery, auctionService, lottoService, marketplaceService, purchaseService, statusService) {
        this.auctionQuery = auctionQuery;
        this.marketplaceExtendedQuery = marketplaceExtendedQuery;
        this.lottoQuery = lottoQuery;
        this.purchaseQuery = purchaseQuery;
        this.auctionBidQuery = auctionBidQuery;
        this.auctionBidService = auctionBidService;
        this.lottoWalletQuery = lottoWalletQuery;
        this.auctionService = auctionService;
        this.lottoService = lottoService;
        this.marketplaceService = marketplaceService;
        this.purchaseService = purchaseService;
        this.statusService = statusService;
    }
    /**
     * selects a combination of loyalty items, optionally filtered
     * @param itemType - the type of loyalty item to show
     * @param marketplaceFilterTypes - which marketplace item types to show
     */
    selectMixedLoyaltyItems(itemTypes = [MixedLoyaltyItemType.All], marketplaceFilterTypes = [0, 1, 2, 3, 4, 5]) {
        zip(this.auctionService.fetchAuctions(), this.lottoService.fetchLottos(), this.marketplaceService.fetchMarketplaceItems()).toPromise();
        const auctions$ = this.auctionQuery.selectAuctions().pipe(map((auctions) => {
            return itemTypes.includes(MixedLoyaltyItemType.Auction) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? auctions.map((x) => new MixedLoyaltyItem({ type: 'auction', data: x, status: this.statusService.getStatus(x) }))
                : [];
        }));
        const marketplaceItems$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceItemsOfType(...marketplaceFilterTypes).pipe(map((marketplaceItems) => {
            if (marketplaceItems &&
                (itemTypes.includes(MixedLoyaltyItemType.Marketplace) || itemTypes.includes(MixedLoyaltyItemType.All))) {
                return marketplaceItems.map((x) => new MixedLoyaltyItem({ type: 'marketplace', data: x, status: this.statusService.getStatus(x) }));
            }
            return [];
        }));
        const lottos$ = this.lottoQuery.selectLottos().pipe(map((lottos) => {
            return itemTypes.includes(MixedLoyaltyItemType.Lotto) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? lottos.map((x) => new MixedLoyaltyItem({ type: 'lotto', data: x, status: this.statusService.getStatus(x) }))
                : [];
        }));
        // Combines the lists by alternating i.e. - [[1,2,3],[4,5,6]] becomes [1,4,2,5,3,6]
        let combined$ = zip(auctions$, marketplaceItems$, lottos$).pipe(map((arrays) => arrays.reduce((t, u, v, w) => u.reduce((x, y, z) => ((x[z * w.length + v] = y), x), t), []).filter((e) => e != null)));
        return combined$;
    }
    /**
     * selected a combination of loyalty items that the user has purchase, optionally filtered
     * @param onlyRedeemed - show only redeemed items
     * @param marketplaceFilterTypes - which marketplace item types to show
     * @param itemType - which loyalty item type to show
     */
    selectMixedLoyaltyWalletItems(onlyRedeemed, marketplaceFilterTypes = [0, 1, 2, 3, 4, 5], itemTypes = [MixedLoyaltyItemType.All]) {
        zip(this.auctionService.fetchAuctions(), this.lottoService.fetchLottos(), this.marketplaceService.fetchMarketplaceItems(), this.auctionBidService.fetchBids(), this.purchaseService.fetchMemberPurchases()).toPromise();
        return this.selectWalletItems(onlyRedeemed, marketplaceFilterTypes, itemTypes);
    }
    /**
     * selected a combination of loyalty items that the user has purchase, optionally filtered
     * @param onlyRedeemed - show only redeemed items
     * @param marketplaceFilterTypes - which marketplace item types to show
     * @param itemType - which loyalty item type to show
     */
    selectMixedLoyaltyWalletItemsNoFetch(onlyRedeemed, marketplaceFilterTypes = [0, 1, 2, 3, 4, 5], itemTypes = [MixedLoyaltyItemType.All]) {
        return this.selectWalletItems(onlyRedeemed, marketplaceFilterTypes, itemTypes);
    }
    /**
     * Selects a combination of favorite loyalty items, optionally filtered
     * @param showSoldOut - show sold out items or not
     * @param itemTypes - item types to show
     */
    selectFavouriteMixedLoyaltyItems(showSoldOut = true, itemTypes = [MixedLoyaltyItemType.All]) {
        zip(this.auctionService.fetchAuctions(), this.lottoService.fetchLottos(), this.marketplaceService.fetchMarketplaceItems()).toPromise();
        const auctions$ = this.auctionQuery.selectFavourites().pipe(map((auctions) => {
            return itemTypes.includes(MixedLoyaltyItemType.Auction) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? auctions.map((x) => new MixedLoyaltyItem({ type: 'auction', data: x, status: this.statusService.getStatus(x) })) // ({ type: 'auction', data: x, status: this.statusService.getStatus(x) }
                : [];
        }), map((auctions) => auctions.sort(this._sortByOrdinal)));
        const marketplaceItems$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceFavourites().pipe(map((marketplaceItem) => {
            if (marketplaceItem &&
                (itemTypes.includes(MixedLoyaltyItemType.Marketplace) || itemTypes.includes(MixedLoyaltyItemType.All))) {
                return marketplaceItem
                    .filter((x) => showSoldOut || x.AvailabilityCount > 0)
                    .map((x) => new MixedLoyaltyItem({ type: 'marketplace', data: x, status: this.statusService.getStatus(x) }));
            }
            return [];
        }), map((marketplaceItems) => marketplaceItems.sort(this._sortByOrdinal)));
        const lottos$ = this.lottoQuery.selectFavourites().pipe(map((lottoItem) => {
            return itemTypes.includes(MixedLoyaltyItemType.Lotto) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? lottoItem.map((x) => new MixedLoyaltyItem({ type: 'lotto', data: x, status: this.statusService.getStatus(x) }))
                : [];
        }), map((lottos) => lottos.sort(this._sortByOrdinal)));
        // Combines the lists by alternating i.e. - [[1,2,3],[4,5,6]] becomes [1,4,2,5,3,6]
        let combined$ = zip(auctions$, marketplaceItems$, lottos$).pipe(map((arrays) => arrays.reduce((t, u, v, w) => u.reduce((x, y, z) => ((x[z * w.length + v] = y), x), t), []).filter((e) => e != null)));
        return combined$;
    }
    async walletFetch() {
        await forkJoin([
            this.auctionService.fetchAuctions(),
            this.lottoService.fetchLottos(),
            this.marketplaceService.fetchMarketplaceItems(),
            this.auctionBidService.fetchBids(),
            this.purchaseService.fetchMemberPurchases(),
        ]).toPromise();
    }
    // Sort function for sorting items by ordinal
    _sortByOrdinal(a, b) {
        if (a.data.Ordinal < b.data.Ordinal) {
            return -1;
        }
        else if (a.data.Ordinal > b.data.Ordinal) {
            return 1;
        }
        return 0;
    }
    selectWalletItems(onlyRedeemed, marketplaceFilterTypes = [0, 1, 2, 3, 4, 5], itemTypes = [MixedLoyaltyItemType.All]) {
        const auctions$ = this.auctionBidQuery.selectWonBids().pipe(map((auctions) => {
            return itemTypes.includes(MixedLoyaltyItemType.Auction) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? auctions
                    .filter((auction) => auction.RedeemStatus == +onlyRedeemed)
                    .map((x) => ({ type: 'auction', data: x }))
                : [];
        }));
        const marketplaceItems$ = this.purchaseQuery.selectPurchases().pipe(map((marketplacePurchases) => {
            return itemTypes.includes(MixedLoyaltyItemType.Marketplace) || itemTypes.includes(MixedLoyaltyItemType.All)
                ? marketplacePurchases
                    .filter((item) => marketplaceFilterTypes.includes(item.ProcessProviderId) && item.RedeemStatus == +onlyRedeemed)
                    .map((x) => ({ type: 'marketplace', data: x }))
                : [];
        }));
        const lottos$ = this.lottoWalletQuery.selectLottoWalletItems().pipe(map((lottos) => {
            if ((itemTypes.includes(MixedLoyaltyItemType.Lotto) || itemTypes.includes(MixedLoyaltyItemType.All)) && onlyRedeemed) {
                return lottos.map((x) => ({ type: 'lotto', data: x }));
            }
            return [];
        }));
        // Combines the lists by alternating i.e. - [[1,2,3],[4,5,6]] becomes [1,4,2,5,3,6]
        let combined$ = zip(auctions$, marketplaceItems$, lottos$).pipe(map((arrays) => arrays.reduce((t, u, v, w) => u.reduce((x, y, z) => ((x[z * w.length + v] = y), x), t), []).filter((e) => e != null)));
        return combined$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MixedLoyaltyQuery, deps: [{ token: AuctionQuery }, { token: MarketplaceExtendedQuery }, { token: LottoQuery }, { token: PurchaseQuery }, { token: AuctionBidQuery }, { token: AuctionBidService }, { token: LottoWalletQuery }, { token: AuctionService }, { token: LottoService }, { token: MarketplaceService }, { token: PurchaseService }, { token: LoyaltyStatusService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MixedLoyaltyQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MixedLoyaltyQuery, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AuctionQuery }, { type: MarketplaceExtendedQuery }, { type: LottoQuery }, { type: PurchaseQuery }, { type: AuctionBidQuery }, { type: AuctionBidService }, { type: LottoWalletQuery }, { type: AuctionService }, { type: LottoService }, { type: MarketplaceService }, { type: PurchaseService }, { type: LoyaltyStatusService }] });

var BenefitClaimStatus;
(function (BenefitClaimStatus) {
    BenefitClaimStatus[BenefitClaimStatus["Unclaimed"] = 0] = "Unclaimed";
    BenefitClaimStatus[BenefitClaimStatus["Unprocessed"] = 1] = "Unprocessed";
    BenefitClaimStatus[BenefitClaimStatus["Processed"] = 2] = "Processed";
    BenefitClaimStatus[BenefitClaimStatus["Refunded"] = 3] = "Refunded";
    BenefitClaimStatus[BenefitClaimStatus["Deleted"] = 4] = "Deleted";
    BenefitClaimStatus[BenefitClaimStatus["OutOfStock"] = 5] = "OutOfStock";
})(BenefitClaimStatus || (BenefitClaimStatus = {}));

let BenefitStore = class BenefitStore extends EntityStore {
    constructor() {
        super();
    }
    /** Set the claim limit */
    setLimit(claimLimit) {
        this.update({ claimLimit });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitStore, providedIn: 'root' }); }
};
BenefitStore = __decorate([
    StoreConfig({ name: 'benefit', idKey: 'BenefitId', cache: { ttl: 30000 } })
], BenefitStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BenefitQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All benefits. */
    selectBenefits() {
        return this.selectAll();
    }
    /** All benefits that have been claimed */
    selectClaimedBenefits() {
        return this.selectBenefits().pipe(map((b) => this._getBenefitsClaimed(b)));
    }
    /** The maximum number of benefits the member can claim */
    getClaimLimit() {
        return this.getValue().claimLimit;
    }
    /** Whether or not a benefit should be shown */
    shouldShowBenefit(benefit, withShownWhenInactive = true, showClaimed = true) {
        if ((this.isActiveBenefit(benefit, showClaimed) || (withShownWhenInactive && benefit.ShowWhenNotActive)) &&
            this.isShowableStatus(benefit, showClaimed)) {
            return true;
        }
        return false;
    }
    /** Check if the benefit is active or not using start and end dates */
    isActiveBenefit(benefit, showClaimed = false) {
        if (moment$1.utc().isAfter(benefit.StartDate) && moment$1.utc().isBefore(benefit.EndDate)) {
            return true;
        }
        if (showClaimed) {
            return benefit.Status == BenefitClaimStatus.Unprocessed || benefit.Status == BenefitClaimStatus.Processed;
        }
        return false;
    }
    isShowableStatus(benefit, showClaimed = true) {
        switch (benefit.Status) {
            case BenefitClaimStatus.Unclaimed:
                return true;
            case BenefitClaimStatus.Unprocessed:
            case BenefitClaimStatus.Processed:
                return showClaimed;
            case BenefitClaimStatus.Refunded:
                return true;
            case BenefitClaimStatus.Deleted:
                return false;
            case BenefitClaimStatus.OutOfStock:
                return benefit.ShowWhenOutOfStock;
            default:
                return true;
        }
    }
    /** Takes an array of benefits and returns only the ones that have been claimed */
    _getBenefitsClaimed(benefits) {
        const claimedStatuses = [BenefitClaimStatus.Processed, BenefitClaimStatus.Unprocessed];
        return benefits.filter((b) => claimedStatuses.includes(b.Status));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitQuery, deps: [{ token: BenefitStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BenefitStore }] });

class BenefitService {
    constructor(benefitStore, api, benefitQuery, errorService) {
        this.benefitStore = benefitStore;
        this.api = api;
        this.benefitQuery = benefitQuery;
        this.errorService = errorService;
    }
    /** Fetch all the benefits */
    fetchBenefits() {
        const request$ = this.api.get('benefits').pipe(tap((items) => this.benefitStore.set(items)), mapTo(null));
        return this.benefitQuery.getHasCache() ? of(null) : request$;
    }
    /** Claim a benefit, returns the benefit claimed */
    claimBenefit(benefit) {
        return this.api.postForParent('benefits', benefit.BenefitId, 'claim', benefit).pipe(tap((b) => this.benefitStore.upsert(b.BenefitId, b)), catchError((err) => {
            this.errorService.clearErrors();
            this.errorService.addError(err.error.toString());
            throw err;
        }), mapTo(null));
    }
    /** Fetches the maximum number of benefits the member can claim */
    fetchLimit() {
        const request$ = this.api.getChildData('benefits', 'limit').pipe(tap((limit) => {
            if (limit) {
                this.benefitStore.setLimit(limit.Limit);
            }
        }), mapTo(null));
        return request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitService, deps: [{ token: BenefitStore }, { token: ApiService }, { token: BenefitQuery }, { token: ErrorStateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BenefitStore }, { type: ApiService }, { type: BenefitQuery }, { type: ErrorStateService }] });

class BenefitResolver {
    constructor(logService, benefitService) {
        this.logService = logService;
        this.benefitService = benefitService;
    }
    resolve() {
        this.logService.info('Resolving benefits and claim limit');
        return combineLatest([this.benefitService.fetchBenefits(), this.benefitService.fetchLimit()]).pipe(mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitResolver, deps: [{ token: LoggingService }, { token: BenefitService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BenefitResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggingService }, { type: BenefitService }] });

class PurchaseResolver {
    constructor(purchaseService, logService) {
        this.purchaseService = purchaseService;
        this.logService = logService;
    }
    resolve(route) {
        let currentUrl = route.pathFromRoot
            .filter((x) => x.routeConfig)
            .map((x) => x.routeConfig.path)
            .join('/');
        this.logService.info(`Resolving all member purchases for route: ${currentUrl}`);
        return this.purchaseService.fetchMemberPurchases();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseResolver, deps: [{ token: PurchaseService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PurchaseResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PurchaseService }, { type: LoggingService }] });

class AccountPopulation {
}

class Login {
    constructor(username, password) {
        this.username = username;
        this.password = password;
    }
}

var ClientType;
(function (ClientType) {
    ClientType[ClientType["Web"] = 1] = "Web";
    ClientType[ClientType["App"] = 2] = "App";
    ClientType[ClientType["StandAlone"] = 3] = "StandAlone";
})(ClientType || (ClientType = {}));

class OutputField {
}

class LocaleService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    getAllLocales() {
        return this.apiService.get('locale');
    }
    getLocaleByLcid(lcid) {
        return this.apiService.getAnySingle(`locale/getlocale/${!!lcid ? lcid : 2057}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocaleService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocaleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocaleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }] });

class LocaleModel {
}

class AuthGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(route, state) {
        if (!this.authService.isAuthenticated()) {
            return this.router.createUrlTree(['login'], { queryParams: { returnUrl: state.url } });
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthGuard, deps: [{ token: AuthService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthGuard }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }, { type: i2.Router }] });

class TokenRefreshIntereptor {
    constructor(authService) {
        this.authService = authService;
        this.refreshSubject = new Subject();
    }
    refreshToken() {
        this.refreshSubject.subscribe({
            complete: () => {
                this.refreshSubject = new Subject();
            },
        });
        if (this.refreshSubject.observers.length === 1) {
            this.authService.refreshAccessToken().subscribe(this.refreshSubject);
        }
        return this.refreshSubject;
    }
    updateHeader(req) {
        const authToken = localStorage.getItem('token');
        req = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${authToken}`),
        });
        return req;
    }
    intercept(req, next) {
        if (req.url.endsWith('logout')) {
            return next.handle(req);
        }
        else if (req.url.endsWith('token/refresh')) {
            // if refresh token is expired
            return next.handle(req).pipe(catchError((error) => {
                if (this.unauthorizedResponse(error)) {
                    if (this.authService.hasCurrentRefreshToken()) {
                        this.authService.logout().toPromise();
                        location.reload();
                    }
                }
                return throwError(error);
            }));
        }
        else {
            // refresh access token if resource is requested with an expired token
            return next.handle(req).pipe(catchError((error, caught) => {
                if (error instanceof HttpErrorResponse) {
                    if (this.unauthorizedResponse(error)) {
                        return this.refreshToken().pipe(switchMap(() => {
                            return next.handle(this.updateHeader(req));
                        }));
                    }
                    else {
                        return throwError(error);
                    }
                }
                return caught;
            }));
        }
    }
    unauthorizedResponse(error) {
        return !!error.status && error.status === 401;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TokenRefreshIntereptor, deps: [{ token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TokenRefreshIntereptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TokenRefreshIntereptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }] });

function createInitialState$1() {
    return {};
}
let BarcodeStore = class BarcodeStore extends Store {
    constructor() {
        super(createInitialState$1());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeStore, providedIn: 'root' }); }
};
BarcodeStore = __decorate([
    StoreConfig({ name: 'barcode' })
], BarcodeStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class BarcodeQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeQuery, deps: [{ token: BarcodeStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BarcodeStore }] });

class BarcodeService {
    constructor(barcodeStore, barcodeQuery, memberQuery, api) {
        this.barcodeStore = barcodeStore;
        this.barcodeQuery = barcodeQuery;
        this.memberQuery = memberQuery;
        this.api = api;
    }
    fetchBarcode() {
        let userContext = this.memberQuery.getValue().user;
        if (this.barcodeQuery.getHasCache() && this.barcodeQuery.getValue().memberId === userContext.memberId) {
            return of('from cache');
        }
        return this.api.getById('barcodes', userContext.memberId).pipe(tap(barcode => this.barcodeStore.update(barcode)), mapTo('from server'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeService, deps: [{ token: BarcodeStore }, { token: BarcodeQuery }, { token: MemberQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BarcodeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BarcodeStore }, { type: BarcodeQuery }, { type: MemberQuery }, { type: ApiService }] });

class VoucherRedeemModel {
}

var REDEMPTION_RESULT;
(function (REDEMPTION_RESULT) {
    REDEMPTION_RESULT["EMPTY"] = "cl.voucher.code.empty.text";
    REDEMPTION_RESULT["SUCCESS"] = "cl.voucher.process.code";
    REDEMPTION_RESULT["FAILED"] = "cl.voucher.redeem.error";
})(REDEMPTION_RESULT || (REDEMPTION_RESULT = {}));
const intitialState = { voucher: null, loading: false, resultMessage: null };
let VoucherStore = class VoucherStore extends Store {
    constructor() {
        super(intitialState);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherStore, providedIn: 'root' }); }
};
VoucherStore = __decorate([
    StoreConfig({ name: 'voucher' })
], VoucherStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class VoucherService {
    constructor(api, logService, voucherStore, balanceService) {
        this.api = api;
        this.logService = logService;
        this.voucherStore = voucherStore;
        this.balanceService = balanceService;
    }
    /**
     * Redeem voucher code (normal)
     * @param voucherCode the voucher code model
     */
    redeemVoucher(voucherCode) {
        this.logService.debug('Redeeming voucher', voucherCode);
        return this.api.post('vouchers/redeem', voucherCode);
    }
    /**
     * Redeem voucher code (normal)
     * @param voucher the voucher code model
     */
    redeemVoucherUsingStore(voucher) {
        this._setMessage(null);
        if (!voucher.VoucherCode) {
            this._setMessage(REDEMPTION_RESULT.EMPTY);
            return of(null);
        }
        this.logService.debug('Redeeming voucher', voucher);
        this.voucherStore.setLoading(true);
        return this.api.post('vouchers/redeem', voucher).pipe(switchMap((voucher) => this.balanceService
            .fetchBalance(config.purseConfig.virtualLoyalty)
            .pipe(tap(() => this.voucherStore.update({ voucher, resultMessage: REDEMPTION_RESULT.SUCCESS, error: null })))), catchError((err) => {
            this.voucherStore.update({ resultMessage: err.error.Code, error: err.error });
            return EMPTY;
        }), finalize(() => this.voucherStore.setLoading(false)));
    }
    /**
     * Redeem voucher code location (when same code for different locations)
     * @param voucherCode the voucher code model
     */
    redeemVoucherLocation(voucherCode) {
        this.logService.debug('Redeeming location voucher', voucherCode);
        return this.api.post('vouchers/redeemLocation', voucherCode);
    }
    _setMessage(resultMessage) {
        this.voucherStore.update({ resultMessage });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherService, deps: [{ token: ApiService }, { token: LoggingService }, { token: VoucherStore }, { token: BalanceService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: LoggingService }, { type: VoucherStore }, { type: BalanceService }] });

class VoucherQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
        this.loading$ = this.selectLoading();
        this.resultMessage$ = this.select(state => state.resultMessage);
        this.error$ = this.selectError();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherQuery, deps: [{ token: VoucherStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: VoucherQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: VoucherStore }] });

class UserGeoLocation {
}

class Image {
}

class ImageUploadService {
    constructor(api) {
        this.api = api;
    }
    getCustomerImage() {
        return this.api.getFile("content/getcustomerimage");
    }
    uploadCustomerImage(formData) {
        return this.api.uploadForm("content/uploadcustomerimage", formData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ImageUploadService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ImageUploadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ImageUploadService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }] });

class StandardResult {
}

var SqlDbType;
(function (SqlDbType) {
    //
    // Summary:
    //     System.Int64. A 64-bit signed integer.
    SqlDbType[SqlDbType["BigInt"] = 0] = "BigInt";
    //
    // Summary:
    //     System.Array of type System.Byte. A fixed-length stream of binary data ranging
    //     between 1 and 8,000 bytes.
    SqlDbType[SqlDbType["Binary"] = 1] = "Binary";
    //
    // Summary:
    //     System.Boolean. An unsigned numeric value that can be 0, 1, or null.
    SqlDbType[SqlDbType["Bit"] = 2] = "Bit";
    //
    // Summary:
    //     System.String. A fixed-length stream of non-Unicode characters ranging between
    //     1 and 8,000 characters.
    SqlDbType[SqlDbType["Char"] = 3] = "Char";
    //
    // Summary:
    //     System.DateTime. Date and time data ranging in value from January 1, 1753 to
    //     December 31, 9999 to an accuracy of 3.33 milliseconds.
    SqlDbType[SqlDbType["DateTime"] = 4] = "DateTime";
    //
    // Summary:
    //     System.Decimal. A fixed precision and scale numeric value between -10 38 -1 and
    //     10 38 -1.
    SqlDbType[SqlDbType["Decimal"] = 5] = "Decimal";
    //
    // Summary:
    //     System.Double. A floating point number within the range of -1.79E +308 through
    //     1.79E +308.
    SqlDbType[SqlDbType["Float"] = 6] = "Float";
    //
    // Summary:
    //     System.Array of type System.Byte. A variable-length stream of binary data ranging
    //     from 0 to 2 31 -1 (or 2,147,483,647) bytes.
    SqlDbType[SqlDbType["Image"] = 7] = "Image";
    //
    // Summary:
    //     System.Int32. A 32-bit signed integer.
    SqlDbType[SqlDbType["Int"] = 8] = "Int";
    //
    // Summary:
    //     System.Decimal. A currency value ranging from -2 63 (or -9,223,372,036,854,775,808)
    //     to 2 63 -1 (or +9,223,372,036,854,775,807) with an accuracy to a ten-thousandth
    //     of a currency unit.
    SqlDbType[SqlDbType["Money"] = 9] = "Money";
    //
    // Summary:
    //     System.String. A fixed-length stream of Unicode characters ranging between 1
    //     and 4,000 characters.
    SqlDbType[SqlDbType["NChar"] = 10] = "NChar";
    //
    // Summary:
    //     System.String. A variable-length stream of Unicode data with a maximum length
    //     of 2 30 - 1 (or 1,073,741,823) characters.
    SqlDbType[SqlDbType["NText"] = 11] = "NText";
    //
    // Summary:
    //     System.String. A variable-length stream of Unicode characters ranging between
    //     1 and 4,000 characters. Implicit conversion fails if the string is greater than
    //     4,000 characters. Explicitly set the object when working with strings longer
    //     than 4,000 characters. Use System.Data.SqlDbType.NVarChar when the database column
    //     is nvarchar(max).
    SqlDbType[SqlDbType["NVarChar"] = 12] = "NVarChar";
    //
    // Summary:
    //     System.Single. A floating point number within the range of -3.40E +38 through
    //     3.40E +38.
    SqlDbType[SqlDbType["Real"] = 13] = "Real";
    //
    // Summary:
    //     System.Guid. A globally unique identifier (or GUID).
    SqlDbType[SqlDbType["UniqueIdentifier"] = 14] = "UniqueIdentifier";
    //
    // Summary:
    //     System.DateTime. Date and time data ranging in value from January 1, 1900 to
    //     June 6, 2079 to an accuracy of one minute.
    SqlDbType[SqlDbType["SmallDateTime"] = 15] = "SmallDateTime";
    //
    // Summary:
    //     System.Int16. A 16-bit signed integer.
    SqlDbType[SqlDbType["SmallInt"] = 16] = "SmallInt";
    //
    // Summary:
    //     System.Decimal. A currency value ranging from -214,748.3648 to +214,748.3647
    //     with an accuracy to a ten-thousandth of a currency unit.
    SqlDbType[SqlDbType["SmallMoney"] = 17] = "SmallMoney";
    //
    // Summary:
    //     System.String. A variable-length stream of non-Unicode data with a maximum length
    //     of 2 31 -1 (or 2,147,483,647) characters.
    SqlDbType[SqlDbType["Text"] = 18] = "Text";
    //
    // Summary:
    //     System.Array of type System.Byte. Automatically generated binary numbers, which
    //     are guaranteed to be unique within a database. timestamp is used typically as
    //     a mechanism for version-stamping table rows. The storage size is 8 bytes.
    SqlDbType[SqlDbType["Timestamp"] = 19] = "Timestamp";
    //
    // Summary:
    //     System.Byte. An 8-bit unsigned integer.
    SqlDbType[SqlDbType["TinyInt"] = 20] = "TinyInt";
    //
    // Summary:
    //     System.Array of type System.Byte. A variable-length stream of binary data ranging
    //     between 1 and 8,000 bytes. Implicit conversion fails if the byte array is greater
    //     than 8,000 bytes. Explicitly set the object when working with byte arrays larger
    //     than 8,000 bytes.
    SqlDbType[SqlDbType["VarBinary"] = 21] = "VarBinary";
    //
    // Summary:
    //     System.String. A variable-length stream of non-Unicode characters ranging between
    //     1 and 8,000 characters. Use System.Data.SqlDbType.VarChar when the database column
    //     is varchar(max).
    SqlDbType[SqlDbType["VarChar"] = 22] = "VarChar";
    //
    // Summary:
    //     System.Object. A special data type that can contain numeric, string, binary,
    //     or date data as well as the SQL Server values Empty and Null, which is assumed
    //     if no other type is declared.
    SqlDbType[SqlDbType["Variant"] = 23] = "Variant";
    //
    // Summary:
    //     An XML value. Obtain the XML as a string using the System.Data.SqlClient.SqlDataReader.GetValue(System.Int32)
    //     method or System.Data.SqlTypes.SqlXml.Value property, or as an System.Xml.XmlReader
    //     by calling the System.Data.SqlTypes.SqlXml.CreateReader method.
    SqlDbType[SqlDbType["Xml"] = 25] = "Xml";
    //
    // Summary:
    //     A SQL Server user-defined type (UDT).
    SqlDbType[SqlDbType["Udt"] = 29] = "Udt";
    //
    // Summary:
    //     A special data type for specifying structured data contained in table-valued
    //     parameters.
    SqlDbType[SqlDbType["Structured"] = 30] = "Structured";
    //
    // Summary:
    //     Date data ranging in value from January 1,1 AD through December 31, 9999 AD.
    SqlDbType[SqlDbType["Date"] = 31] = "Date";
    //
    // Summary:
    //     Time data based on a 24-hour clock. Time value range is 00:00:00 through 23:59:59.9999999
    //     with an accuracy of 100 nanoseconds. Corresponds to a SQL Server time value.
    SqlDbType[SqlDbType["Time"] = 32] = "Time";
    //
    // Summary:
    //     Date and time data. Date value range is from January 1,1 AD through December
    //     31, 9999 AD. Time value range is 00:00:00 through 23:59:59.9999999 with an accuracy
    //     of 100 nanoseconds.
    SqlDbType[SqlDbType["DateTime2"] = 33] = "DateTime2";
    //
    // Summary:
    //     Date and time data with time zone awareness. Date value range is from January
    //     1,1 AD through December 31, 9999 AD. Time value range is 00:00:00 through 23:59:59.9999999
    //     with an accuracy of 100 nanoseconds. Time zone value range is -14:00 through
    //     +14:00.
    SqlDbType[SqlDbType["DateTimeOffset"] = 34] = "DateTimeOffset";
})(SqlDbType || (SqlDbType = {}));

class TermsAndCondtion {
    constructor(termsAndCondtions, showTermsAndCondtions, termsAndCondtionsType) {
        this.termsAndCondtions = termsAndCondtions;
        this.showTermsAndCondtions = showTermsAndCondtions;
        this.termsAndCondtionsType = termsAndCondtionsType;
    }
}

class JokesModel {
    constructor(questionBanner, answerBanner, question, answer, answerEmoji) {
        this.questionBanner = questionBanner;
        this.answerBanner = answerBanner;
        this.question = question;
        this.answer = answer;
        this.answerEmoji = answerEmoji;
    }
}

var TermsAndCondtionsType;
(function (TermsAndCondtionsType) {
    TermsAndCondtionsType[TermsAndCondtionsType["Text"] = 1] = "Text";
    TermsAndCondtionsType[TermsAndCondtionsType["URL"] = 2] = "URL";
})(TermsAndCondtionsType || (TermsAndCondtionsType = {}));

;
const LANGUAGE = new InjectionToken('language');

function jwtTokenGetter() {
    return localStorage.getItem('token');
}

function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

class LocalStorageService {
    constructor() { }
    get(key) {
        return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) || '') : null;
    }
    set(key, value) {
        const data = JSON.stringify(value);
        if (data) {
            localStorage.setItem(key, data);
        }
    }
    clearAll() {
        localStorage.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocalStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocalStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class LocationService {
    constructor(logService) {
        this.logService = logService;
        this.locationSubject = new Subject();
    }
    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position) {
                    let location = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        timestamp: position.timestamp,
                    };
                    this.locationSubject.next(location);
                    this.logService.debug('Latitude: ' + position.coords.latitude + 'Longitude: ' + position.coords.longitude, position);
                }
            }, (error) => this.locationSubject.error(error));
        }
        else {
            this.locationSubject.error('Geolocation is not supported by this browser.');
        }
        return this.locationSubject.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocationService, deps: [{ token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: LoggingService }] });

class ScreenSizeService {
    constructor() {
        this.appScreenWidth$ = fromEvent(window, 'resize').pipe(map(() => window.innerWidth), distinctUntilChanged(), startWith(window.innerWidth), shareReplay(1));
    }
    selectScreenWidth() {
        return this.appScreenWidth$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScreenSizeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScreenSizeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ScreenSizeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

/**
 * Record for the link between LCID and culture code
 */
const locales = {
    1033: 'en-US',
    1036: 'fr-FR',
    1037: 'he-IL',
    2057: 'en-GB',
    3084: 'fr-CA',
    4105: 'en-CA',
    1032: 'el-GR'
};
/**
 * Get the lcid that is assigned to a culture code,
 * Or undefined if not found
 */
function getLcidByCultureCode(cultureCode) {
    return recordKeys(locales).find((locale) => locales[locale] === cultureCode);
}

class FGBTranslationLoader {
    constructor() {
        this.handler = inject(HttpBackend);
        this.http = new HttpClient(this.handler);
        this.authService = inject(AuthService);
        this.memberQuery = inject(MemberQuery);
    }
    /**
     * Used to get the data for the current language
     *
     * @param lang current language using the language code
     */
    getTranslation(lang) {
        let clubId = config.defaultClubId;
        if (this.authService.isAuthenticated()) {
            clubId = this.memberQuery.getClubId() || config.defaultClubId;
        }
        let lcid = getLcidByCultureCode(lang);
        if (lcid === undefined) {
            lcid = parseInt(config.defaultLcid);
        }
        return this.http.get(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`);
    }
}

/**
 * Guards against pages being accessible when maintence mode is on
 * Admin users are not affected by this guard and are always allowed to activate
 */
class MaintenanceGuard {
    constructor(authService, memberQuery, router, logService) {
        this.authService = authService;
        this.memberQuery = memberQuery;
        this.router = router;
        this.logService = logService;
        this.maintenanceUrl = '/maintenance';
    }
    canActivate(route, state) {
        return this.checkMaintenceMode();
    }
    canActivateChild(childRoute, state) {
        return this.checkMaintenceMode();
    }
    checkMaintenceMode() {
        // Admin users should be able to browse with maintence mode on
        if (this.authService.isAuthenticated() && this.memberQuery.getLoginType() == LoginType.Admin) {
            return of(true);
        }
        return this.authService.checkMaintenceMode().pipe(map(() => true), catchError((err) => {
            if (err.status == 503) {
                this.logService.warning('503 [Service Unavailable] received; Maintenance mode is probably on', err);
            }
            else {
                this.logService.error('500 [Internal API Error] received', err);
            }
            return of(this.router.parseUrl(this.maintenanceUrl));
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MaintenanceGuard, deps: [{ token: AuthService }, { token: MemberQuery }, { token: i2.Router }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MaintenanceGuard }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MaintenanceGuard, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }, { type: MemberQuery }, { type: i2.Router }, { type: LoggingService }] });

/**
 * FGB Missing translation handler will handle the translation if there is no translation found. To ensure that a translation
 * is always there you will need to added the extra parameter fgbdefault. This is used to replace if there is no translation found.
 * This is a kind of back up
 *
 * @example
 *
 * <p [translate]="'maintenance.text'" [translateParams]="{ fgbdefault : 'The page is currently unavailable'}"></p>
 */
class FGBMissingTranslationHandler {
    constructor() { }
    /**
     * Handles requests when a translation can not be found
     *
     * @param params missing translation parameter
     */
    handle(params) {
        if (params.interpolateParams && params.interpolateParams.hasOwnProperty('fgbdefault')) {
            return params.interpolateParams.fgbdefault;
        }
        return '*' + params.key;
    }
}

class HttpErrorInterceptor {
    constructor(errorStateService, logService, translate, router, authService) {
        this.errorStateService = errorStateService;
        this.logService = logService;
        this.translate = translate;
        this.router = router;
        this.authService = authService;
    }
    ngOnDestroy() {
        if (this.translationSub) {
            this.translationSub.unsubscribe();
        }
    }
    intercept(request, next) {
        return next.handle(request).pipe(tap(() => {
            this.errorStateService.clearErrors();
        }), catchError((response) => {
            if (response.error instanceof ErrorEvent) {
                // This is a client side error so we don't need to add this to the errors list.
                this.logService.error('[Http Error Interceptor] Client side error', response);
                return NEVER;
            }
            else if (response.status === 400) {
                const errorMessage = this.getTranslation(response);
                this.errorStateService.addError(errorMessage);
                this.logService.info('[Http Error Interceptor] 400 Bad Request', response.error);
            }
            else if (response.status === 401) {
                // handled by the token-refresh interceptor
            }
            else if (response.status === 403) {
                // handled by the first-time-registration interceptor
            }
            else if (response.status === 500) {
                this.errorStateService.addError('error.unexpectedError');
                this.logService.error('[Http Error Interceptor] 500 Internal Server Error', response.error);
            }
            else if (response.status === 503) {
                this.errorStateService.addError('error.unexpectedError');
                this.logService.error('[Http Error Interceptor] 503 Service Unavailable');
                if (this.authService.hasCurrentRefreshToken()) {
                    this.authService.logout().toPromise();
                }
                this.router.navigate(['/maintenance']);
            }
            else {
                // The error codes returned should be added to the error service to be displayed to the user.
                let error = `error.${response.error}`;
                this.translationSub = this.translate.get(error).subscribe((data) => {
                    /** if translation is found, return translation. If none found, return original error */
                    if (data == error) {
                        this.errorStateService.addError(response.error);
                    }
                    else {
                        this.errorStateService.addError(data);
                    }
                });
                this.logService.error(`[Http Error Interceptor] ${response.status} Uncaught server side error`, response.error);
            }
            return throwError(() => response);
        }));
    }
    getTranslation(error) {
        const errorCode = error.error.Code ? error.error.Code : error.error;
        const translatedText = this.translate.instant(`error.${errorCode}`);
        return translatedText ? translatedText : error.error.Message ? error.error.Message : this.translate.instant(`error.${error.status}.unexpected.occured`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: HttpErrorInterceptor, deps: [{ token: ErrorStateService }, { token: LoggingService }, { token: i3.TranslateService }, { token: i2.Router }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: HttpErrorInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: HttpErrorInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: ErrorStateService }, { type: LoggingService }, { type: i3.TranslateService }, { type: i2.Router }, { type: AuthService }] });

const DEFAULT_DATE_OPTIONS = {
    // Date pipe format
    LongDateFormat: 'M/d/yy h:mma',
    ShortDateFormat: 'MMM D, YYYY',
    // Date Format for NgbDatepicker which uses moment date format
    NgbDateFormat: 'MMM DD, YYYY',
};
/**
 * This is a token for the date options used in the date pipe and the date picker
 * The default value is US date format where month comes before day
 * Changing the values can be done in the app.module.ts
 * @example
 * change the date format to UK date format where day comes before month
 * in app.module.ts add the following code in the providers array
 *
 * providers: [
 *  {
 *    provide: DATE_OPTIONS,
 *    useValue: {
 *      LongDateFormat: 'd/M/yy h:mma',
 *      ShortDateFormat: 'dd MMM, YYYY',
 *      NgbDateFormat: 'DD MM, YYYY'
 *    }
 *  }
 * ]
 */
const DATE_OPTIONS = new InjectionToken('dateOption', {
    providedIn: 'root',
    factory: () => {
        // Defaults to US date format where month comes before day
        return DEFAULT_DATE_OPTIONS;
    },
});

class TranslationLoader {
    constructor(memberQuery, http, translateService) {
        this.memberQuery = memberQuery;
        this.http = http;
        this.translateService = translateService;
    }
    /**
     * Loads the translation file and updates the service to keep in line with the users clubId and LCID
     * if no user is found then it reverts back to the defaults in the config
     * (ClubId = defaultClubId, LCID = defaultLcid)
     */
    loadTranslations() {
        return this.memberQuery.userContext$.pipe(concatMap((userContext) => {
            let clubId;
            let lcid;
            if (userContext) {
                clubId = +userContext.clubId;
                lcid = +userContext.lcid;
            }
            else {
                clubId = config.defaultClubId;
                lcid = +config.defaultLcid;
            }
            let cultureCode = locales[lcid] ?? config.languages[0];
            return this.http.get(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`).pipe(concatMap((translation) => {
                this.translateService.setTranslation(cultureCode, translation);
                this.translateService.use(cultureCode);
                return of(null);
            }));
        }));
    }
    init() {
        let cultureCode = config.languages[0];
        let clubId = config.defaultClubId;
        let lcid = +config.defaultLcid;
        this.memberQuery.userContext$.pipe(switchMap((userContext) => {
            this.translateService.resetLang(cultureCode);
            if (userContext) {
                clubId = +userContext.clubId;
                lcid = +userContext.lcid;
                cultureCode = locales[lcid];
            }
            return this.http.get(`${config.baseApiUrl}/api/content/?clubId=${clubId}&lcid=${lcid}`)
                .pipe(map(translations => ({ lang: cultureCode, translations })));
        }), takeUntilDestroyed()).subscribe(({ lang, translations }) => {
            this.translateService.setTranslation(lang, translations);
            this.translateService.use(lang);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TranslationLoader, deps: [{ token: MemberQuery }, { token: i1.HttpClient }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TranslationLoader, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TranslationLoader, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: MemberQuery }, { type: i1.HttpClient }, { type: i3.TranslateService }] });

/**
 * Helper service for lazy load module, a custom preloading strategy used to pre-load modules
 * usage:
 * {
        path: 'register',
        loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule),
        data: { preload: true }
    }

    ...
    imports: [
     RouterModule.forRoot(routes, { preloadingStrategy: FGBPreLoadingStrategy })
    ]
    ...
 */
class FGBPreLoadingStrategy {
    constructor(logService) {
        this.logService = logService;
    }
    /** Checks if route contains data preload, if preload is set to true then load the module */
    preload(route, load) {
        if (route.data && route.data['preload']) {
            this.logService.info('Preload Path: ' + route.path);
            return load();
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FGBPreLoadingStrategy, deps: [{ token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FGBPreLoadingStrategy, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FGBPreLoadingStrategy, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: LoggingService }] });

/**
 * Error will be thrown to the error handler and the error handler will handle the error and translate the error message.
 * @see {@link FgbErrorHandler}
 * @param message - The error message to be displayed
 * @param translateKey - The key to be used to translate the error message
 * @param showInConsole - If true, the error will be displayed in the console
 * @param clearAfter - The time in milliseconds to clear the error message
 */
class FgbError {
    constructor(o, showInConsole = false, clearAfter = 3000) {
        this.showInConsole = showInConsole;
        this.clearAfter = clearAfter;
        o = o || {};
        this.message = o.message || '';
        this.translateKey = o.translateKey || '';
        if (o instanceof HttpErrorResponse) {
            this.message = o.message;
            this.translateKey = `error.code.${o.status}`;
            if (o.error && o.error.Message) {
                this.message = o.error.Message;
            }
            if (o.error && o.error.Code) {
                this.translateKey = `error.${o.error.Code}`;
            }
        }
    }
}

// import { TranslateService } from "@ngx-translate/core";
/**
 * Global error handler for the application
 *
 * component level error handling example
 *
 * Usage:
 *
 * import ErrorComponent
 *
 * Add the following to the html
 *
 * <fgbcl-error></fgbcl-error>
 *
 * Error handling in the component and service example
 *
 * @example
 *  someMethod(): void{
 *    const test = 'string';
 *
 *    if( typeof test === 'string' ){
 *     throw new FgbError({ message: 'this is a string!', translateKey: 'error.code.string' });
 *    }
 *  }
 *
 * service level error handling example
 * @example
 *  someMethod(): Observable<any>{
 *   return this.http.get('url').pipe(
 *      catchError((err: any) => throwError(() => new FgbError(err)))
 *   );
 * }
 */
class FgbErrorHandler {
    constructor() {
        this.translate = inject(TranslateService);
        this.errorService = inject(ErrorStateService);
        this.router = inject(Router);
        this.logService = inject(LoggingService);
    }
    handleError(error) {
        if (error instanceof FgbError) {
            // If translateKey is provided, the message will be translated, otherwise the message will be displayed
            // If from HttpErrorResponse, the translateKey will be translated first, while the message serves as a fallback or a reason for the error 
            const message = error.translateKey ? this.translate.instant(error.translateKey) : error.message;
            this.errorService.setError(message).clearAfter(error.clearAfter);
            // By default we will not show the error in the console
            if (!error.showInConsole) {
                return;
            }
        }
        /**
         * If the error is an HttpErrorResponse and the status is 403, redirect the user to first time.
         * No need to call member status as 403 is reserved for first time users.
         * Expected behaviour should be that the guard runs first then if user is already logged in and gets
         * a 403, the error handler will redirect the user to first time registration.
         */
        if (error instanceof HttpErrorResponse && error.status === 403) {
            this.logService.info('403 Forbidden response received, user is first time user.');
            this.setRedirectUrlAfterRegistration(this.router.url);
            this.logService.info('Redirecting to first time user registration...');
            this.router.navigate(['/register/firsttime']);
        }
        console.error('ERROR', error);
    }
    setRedirectUrlAfterRegistration(url) {
        const queryStringParameter = 'returnUrl=';
        let startIndex = url.toUpperCase().indexOf(queryStringParameter.toUpperCase());
        if (!isNaN(startIndex)) {
            startIndex += queryStringParameter.length;
            let endIndex = url.indexOf('&');
            let substrLength = endIndex ? endIndex - startIndex : undefined;
            url = url.substr(startIndex, substrLength);
            url = decodeURIComponent(url);
        }
        this.logService.debug('Setting redirectToUrlAfterRegistration session key to:', url);
        sessionStorage.setItem('redirectToUrlAfterRegistration', url);
    }
}

/**
 * stop navigation to pages if website content feature flag is not set to true.
 * if no redirectTo is set it defaults to 404 page not found
 * ex: {
 *    path: 'home'
 *    component: HomePageComponent,
 *    canActivate: [ WebsiteContentFeatureFlagGuard ]
 *    data: {
 *            featureKey: 'feature.flag.home.payment',
 *            redirectTo: 'home'
 *          }
 *  }
 */
class WebsiteContentFeatureFlagGuard {
    constructor(router, translate) {
        this.router = router;
        this.translate = translate;
    }
    fetchDataFromRoute(route) {
        this.featureKey = route.data.featureKey;
        this.redirectPath = route.data.redirectTo;
        if (this.featureKey === undefined || this.featureKey === null || this.featureKey === '') {
            throw new Error('feature key is missing.');
        }
        if (typeof this.featureKey != 'string') {
            throw new Error('feature key must be of type string.');
        }
    }
    getRedirect() {
        if (typeof this.redirectPath === 'string') {
            return this.router.parseUrl(this.redirectPath);
        }
        return;
        // return this.router.parseUrl('404page');
    }
    canActivate(route) {
        this.fetchDataFromRoute(route);
        return this.translate
            .stream(this.featureKey)
            .pipe(map(data => {
            let redirect = this.getRedirect();
            if (typeof data === 'string' && data === 'true') {
                return true;
            }
            if (!redirect) {
                return false;
            }
            return redirect;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebsiteContentFeatureFlagGuard, deps: [{ token: i2.Router }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebsiteContentFeatureFlagGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebsiteContentFeatureFlagGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.Router }, { type: i3.TranslateService }] });

var AccountStatus;
(function (AccountStatus) {
    AccountStatus[AccountStatus["FirstTimeUser"] = 1] = "FirstTimeUser";
    AccountStatus[AccountStatus["Active"] = 2] = "Active";
})(AccountStatus || (AccountStatus = {}));

function firstTimeUserGuard(redirectPath = 'register/firsttime') {
    return (route, state) => {
        const authService = inject(AuthService);
        const memberQuery = inject(MemberQuery);
        const router = inject(Router);
        const logService = inject(LoggingService);
        if (authService.isAuthenticated() && memberQuery.getUserContext().status === AccountStatus.FirstTimeUser) {
            logService.info('Redirecting to first time user registration...', { path: redirectPath });
            return router.createUrlTree(['/' + redirectPath]);
        }
        return true;
    };
}

// import { MemberQuery } from '../../../account/member/member.query';
// import { LoggingService } from '../core/logging.service';
// import { AccountStatus } from '../../../account/member/models/account-status.model';
/**
 * Commenting this as this is causing a lot of issues, interceptor runs first before the guard gets triggered,
 * and the guard is the one that should be handling the redirect. Having this with the guard would result to an infinite loop of
 * redirects. Passing the logic to the error handler instead
 */
class FirstTimeRegistrationInterceptor {
    // constructor(
    //   private memberQuery: MemberQuery,
    //   private logService: LoggingService,
    //   private router: Router) {}
    intercept(request, next) {
        return next.handle(request)
            .pipe(catchError((response) => {
            // if (response.status === 403) {
            // let userContext = this.memberQuery.getUserContext();
            // if (userContext && userContext.status === AccountStatus.FirstTimeUser) {
            // this.logService.info('403 Forbidden response received, user is first time user.');
            // this.setRedirectUrlAfterRegistration(this.router.url);
            // this.logService.info('Redirecting to first time user registration...');
            // this.router.navigate(['/register/firsttime']);
            // }
            // }
            return throwError(() => response);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FirstTimeRegistrationInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FirstTimeRegistrationInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FirstTimeRegistrationInterceptor, decorators: [{
            type: Injectable
        }] });

const REGISTRATION_STEP_MOCK = {
    Step: 1,
    Order: 1,
    Complete: true,
    Error: '',
    Data: CHILD_REGISTRATION_MOCK,
    ShouldSkip: false,
    Settings: [{ key: '', value: '' }],
};

let RegistrationStepStore = class RegistrationStepStore extends EntityStore {
    constructor(logService) {
        super();
        this.logService = logService;
    }
    /** Update the current wizard type in the state. */
    updateWizardType(value) {
        this.logService.debug('Updating current wizard type', value);
        this.update({ wizardType: value });
    }
    /** Update whether all steps have been complete in the state. */
    updateIsComplete(value) {
        this.logService.debug('Updating registration completion status', value);
        this.update({ isComplete: value });
    }
    /** Update the query data in the state. */
    updateQueryData(value) {
        this.logService.debug('Updating registration query data', value);
        this.update({ queryData: value });
    }
    selectWizardType() {
        return this._select(state => state.wizardType);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepStore, deps: [{ token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepStore, providedIn: 'root' }); }
};
RegistrationStepStore = __decorate([
    StoreConfig({ name: 'registration-step', idKey: 'Step' })
], RegistrationStepStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggingService }] });

let RegistrationStepQuery = class RegistrationStepQuery extends QueryEntity {
    constructor(store, logService) {
        super(store);
        this.store = store;
        this.logService = logService;
    }
    /** Gets the current registration type that the user is in. */
    getWizardType() {
        return this.getValue().wizardType;
    }
    selectWizardType() {
        return this.store.selectWizardType();
    }
    /** Gets the current value of the step that matches the given step type. */
    getStep(stepType) {
        return this.getEntity(stepType);
    }
    /** Gets the first incomplete or errored step for the user to complete next. */
    getNextStep() {
        // Get all the steps that aren't completed yet (and shouldn't be skipped) or that have an error.
        const incompleteSteps = this.getAll({ filterBy: (x) => (!x.Complete && !x.ShouldSkip) || !!x.Error });
        return incompleteSteps.length > 0 ? incompleteSteps[0] : null;
    }
    /** Gets the first incomplete or errored step for the user to complete next. */
    getPreviousStep(stepType) {
        const previousSteps = this.getPreviousSteps(stepType);
        if (!previousSteps) {
            return null;
        }
        return previousSteps[previousSteps.length - 1];
    }
    /** Gets all the steps prior to the given step, defaulting to steps prior to the current one if not provided. */
    getPreviousSteps(stepType) {
        // Use the current step if we don't provide a step type
        if (!stepType) {
            const currentStep = this.getPreviousStep();
            if (!currentStep) {
                this.logService.warning('Failed to calculate previous steps as the current step could not be determined.', stepType);
                return [];
            }
            stepType = currentStep.Step;
        }
        const allSteps = this.getAll();
        // Build a list of steps prior to the given one
        let previousSteps = [];
        for (let step of allSteps) {
            if (step.Step === stepType) {
                break;
            }
            previousSteps.push(step);
        }
        if (allSteps.length === previousSteps.length) {
            // If the entire list of steps was added then that step isn't part of the current process.
            this.logService.warning('Failed to calculate previous steps as the given step type could not be found in the current list of steps.', stepType, allSteps);
        }
        return previousSteps.filter((x) => !x.ShouldSkip);
    }
    /** Gets the final step in the registration process. */
    getFinalStep() {
        const lastStepAsArray = this.getAll({ sortByOrder: Order.DESC, limitTo: 1 });
        return lastStepAsArray.length ? lastStepAsArray[0] : null;
    }
    /** Checks if the current step is available to access for the current registration process. */
    isStepAvailable(stepType) {
        return this.getCount((x) => x.Step === stepType) > 0;
    }
    /** Determines if the given step, or the current step, has a previous step or not. */
    hasPreviousStep(stepType) {
        return !!this.getPreviousStep(stepType);
    }
    /** Determines if there are any steps that still require completing in the registration process. */
    anyIncompleteSteps() {
        return !!this.getCount((x) => !x.Complete || !!x.Error);
    }
    /**
     * Retrieves any data from the store matching the given key that was part of the query string when
     * the current registration was started, or undefined if data with that key was not provided.
     */
    getQueryData(key) {
        let result;
        const queryData = this.getValue().queryData;
        if (queryData) {
            const matchingKey = Object.keys(queryData).find((x) => x.toLowerCase() === key.toLowerCase());
            if (matchingKey) {
                result = queryData[matchingKey].toString();
            }
        }
        this.logService.debug(`Retrieving registration query data matching key '${key}':`, result);
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepQuery, deps: [{ token: RegistrationStepStore }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepQuery, providedIn: 'root' }); }
};
RegistrationStepQuery = __decorate([
    QueryConfig({ sortBy: 'Order' })
], RegistrationStepQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RegistrationStepStore }, { type: LoggingService }] });

// tslint:disable: variable-name
var StepType;
(function (StepType) {
    StepType[StepType["PersonalDetails"] = 1] = "PersonalDetails";
    StepType[StepType["TermsAndConditions"] = 2] = "TermsAndConditions";
    StepType[StepType["PartnerInvite"] = 3] = "PartnerInvite";
    StepType[StepType["ResetPassword"] = 5] = "ResetPassword";
    StepType[StepType["LoginDetails"] = 7] = "LoginDetails";
    StepType[StepType["PartnerCardPrint"] = 11] = "PartnerCardPrint";
    StepType[StepType["SocialLink"] = 16] = "SocialLink";
    StepType[StepType["SocialMediaCustomerIdentification"] = 17] = "SocialMediaCustomerIdentification";
    StepType[StepType["CheckGuardianMembership"] = 18] = "CheckGuardianMembership";
    StepType[StepType["GuardianQuestions"] = 19] = "GuardianQuestions";
    StepType[StepType["AddChild"] = 20] = "AddChild";
    StepType[StepType["GuardianDetails"] = 22] = "GuardianDetails";
    StepType[StepType["ProcessPartnerRequest"] = 23] = "ProcessPartnerRequest";
    StepType[StepType["LoginDetailsEdit"] = 24] = "LoginDetailsEdit";
    StepType[StepType["ValidateMemberIdAndCardNumber"] = 25] = "ValidateMemberIdAndCardNumber";
    StepType[StepType["ReferAFriend"] = 26] = "ReferAFriend";
    StepType[StepType["AgeVerificationAndTerms"] = 27] = "AgeVerificationAndTerms";
    StepType[StepType["OptOutEmails"] = 33] = "OptOutEmails";
    StepType[StepType["PartnerManagementRemoveOrKeep"] = 36] = "PartnerManagementRemoveOrKeep";
    StepType[StepType["OptOutAlerts"] = 37] = "OptOutAlerts";
    StepType[StepType["ProviderTranslation"] = 39] = "ProviderTranslation";
    StepType[StepType["ProviderAuthentication2"] = 41] = "ProviderAuthentication2";
    StepType[StepType["Questions"] = 44] = "Questions";
    StepType[StepType["ChildQuestions"] = 45] = "ChildQuestions";
    StepType[StepType["Payment"] = 46] = "Payment";
    StepType[StepType["Basket"] = 48] = "Basket";
    StepType[StepType["MembershipOption"] = 50] = "MembershipOption";
    StepType[StepType["GetProviderDetails"] = 51] = "GetProviderDetails";
    StepType[StepType["ShippingAddress"] = 52] = "ShippingAddress";
    StepType[StepType["OperatorName"] = 54] = "OperatorName";
    StepType[StepType["ChooseMembershipOption"] = 55] = "ChooseMembershipOption";
    StepType[StepType["ProviderOAuth"] = 56] = "ProviderOAuth";
    StepType[StepType["Marketing"] = 57] = "Marketing";
})(StepType || (StepType = {}));

const REGISTRATION_ROUTES = new InjectionToken('registrationRoutes', {
    providedIn: 'root',
    factory: () => []
});

class RegistrationStepService {
    constructor(registrationStepStore, registrationStepQuery, api, logService, errorService, router, authService) {
        this.registrationStepStore = registrationStepStore;
        this.registrationStepQuery = registrationStepQuery;
        this.api = api;
        this.logService = logService;
        this.errorService = errorService;
        this.router = router;
        this.authService = authService;
        this.isLoading = false;
        this.registrationRoutes = inject(REGISTRATION_ROUTES);
        this._calculateShouldSkipStatusesOnEntityChange();
    }
    getStepDataAndHandle(stepType) {
        let step = this.registrationStepQuery.getStep(stepType);
        if (!step) {
            this.logService.warning('No step data found in the store for step', stepType);
            return;
        }
        if (step !== null && step.ShouldSkip === true) {
            this.logService.info('mark step as completed', step);
            this.registrationStepStore.update(step, { Complete: true, ShouldSkip: true });
            this.logService.info('Skipping step', step);
            this.navigateToNextStep();
        }
    }
    /**
     * Fetch the required registration steps for the given wizard type from the API and the existing
     * data and put it in the store.
     */
    startRegistrationProcess(wizardType, queryData) {
        this.logService.debug('Starting registration process for wizard type', wizardType, queryData);
        return this.api.post('register/start/' + wizardType, null, this._getQueryParamsAsHttpParams(queryData)).pipe(withTransaction((response) => {
            this.registrationStepStore.updateIsComplete(false);
            this.registrationStepStore.updateWizardType(wizardType);
            if (response.Steps) {
                this.logService.info('Started wizard process', wizardType);
                this.logService.debug('Set registration steps in the store', response.Steps);
                this.registrationStepStore.set(response.Steps || []);
                this.registrationStepStore.updateQueryData(queryData || response.QueryData);
                this.navigateToNextStep();
            }
            else {
                this.logService.warning('No registration steps were returned, redirecting to the home page...');
                // @ts-ignore
                this.registrationStepStore.updateWizardType(-1);
                this.router.navigate(['/']);
            }
        }), map(() => null), catchError((err) => {
            this.registrationStepStore.set([]);
            this.registrationStepStore.updateIsComplete(false);
            // @ts-ignore
            this.registrationStepStore.updateWizardType(-1);
            if (err.status == 401) {
                this.logService.warning('Start check not passed the customer is logged in status is :' + this.authService.isAuthenticated());
                this.router.navigate(['/']);
            }
            else if (err.status == 400) {
                this.logService.warning('No in-progress registration could be found for this session...');
            }
            else if (err.status == 404) {
                this.logService.warning('Wizard is disabled, redirecting...');
                this.router.navigateByUrl('/register/wizardDisabled', { state: { wizardType } });
            }
            else if (err.status == 503) {
                this.logService.warning('Currently undergoing maintenance, redirecting to maintenance page...');
                this.router.navigate(['/maintenance']);
            }
            return EMPTY;
        }));
    }
    /** Fetch the required registration steps for the current process from the API and put the existing data in the store. */
    fetchRegistrationStepsForCurrentWizard(startStep) {
        return this.api.getAnySingle('register/current').pipe(withTransaction((response) => {
            this.registrationStepStore.updateIsComplete(false);
            if (response && response.WizardType !== undefined && response.WizardType !== null) {
                this.registrationStepStore.updateWizardType(response.WizardType);
                this.registrationStepStore.updateQueryData(response.QueryData);
            }
            // Add the list of step data to the store
            let registrationSteps = response.Steps
                ? response.Steps.map((step) => ({
                    Step: step.Step,
                    Order: step.Order,
                    Complete: false,
                    Error: step.Error,
                    Data: step.Data,
                    Settings: step.Settings,
                }))
                : null;
            if (registrationSteps) {
                this.registrationStepStore.set(registrationSteps);
                if (startStep) {
                    this._markPreviousStepsAsComplete(startStep);
                }
            }
            else {
                this.logService.warning('No registration steps were returned, redirecting to the home page...');
                this.router.navigate(['/']);
            }
        }), map(() => null), catchError((err) => {
            if (err.status == 400) {
                this.logService.warning('No in-progress registration could be found for this session so redirect');
                this.registrationStepStore.set([]);
                this.registrationStepStore.updateIsComplete(false);
                // @ts-ignore
                this.registrationStepStore.updateWizardType(-1);
                this.router.navigate(['/']);
            }
            else {
                this.logService.warning('No in-progress registration could be found for this session...');
                this.registrationStepStore.set([]);
                this.registrationStepStore.updateIsComplete(false);
                // @ts-ignore
                this.registrationStepStore.updateWizardType(-1);
            }
            return EMPTY;
        }));
    }
    /**
     * Retrieve the step data for the given step type
     * ===============================================
     * - shouldRunSetUpview will ensure that the stepProcessor set up view is run to retrive data required to display
     * - shouldSaveToStore is not run by default but if the set up returns data that you want to store you will need to enable this
     */
    fetchRegistrationStepForCurrentWizard(step, shouldRunSetUpView = true, shouldSaveToStore = false) {
        return this.api
            .getById('register/step', step.toString(), new HttpParams().set('setUpView', shouldRunSetUpView.toString()))
            .pipe(tap((x) => {
            this.logService.debug(`Retrieved registration step for step ${step}`, x);
            if (shouldSaveToStore) {
                this.registrationStepStore.update(step, { Data: x.Data });
            }
            if (x.ShouldSkip === true) {
                this.logService.info('mark step as completed', step);
                this.registrationStepStore.update(step, { Complete: true, ShouldSkip: true });
                this.logService.info('Skipping step', step);
                this.navigateToNextStep();
            }
        }));
    }
    /** Retrieve the current registration's basket to be purchased. */
    fetchRegistrationBasketForCurrentWizard() {
        return this.api.getAnySingle('register/basket');
    }
    /** Post a step's data to the API for validation and to complete the given step. */
    submitRegistrationStepData(stepType, data, shouldNavigateToNextStep = true) {
        this.isLoading = true;
        return this.api.post(`register/step/${stepType}`, data).pipe(tap((t) => {
            /**
             * Update all the steps to should skip to false so we have to rerun this
             */
            let response = t;
            if (response.ChangedData != null && response.ChangedData.length > 0) {
                response.ChangedData.forEach((element) => {
                    this.registrationStepStore.update(element, { ShouldSkip: false, Complete: false });
                });
            }
            this.registrationStepStore.update(stepType, { Complete: true, Data: data, Error: undefined });
            this.logService.info('Completed registration step type', stepType);
            this.logService.debug('Current registration data state', this.registrationStepQuery.getAll());
            if (shouldNavigateToNextStep) {
                this.navigateToNextStep();
            }
            else {
                this.isLoading = false;
            }
        }), map(() => null), catchError((err) => {
            this.logService.error('Error on submission of step data for step type', stepType, err);
            this.errorService.clearErrors();
            if (err.status == 404) {
                // registration no longer exists so remove the user
                this.logService.info('registration no longer exists so remove the user', stepType);
                this.registrationStepStore.updateIsComplete(true);
            }
            if (err.error.Data) {
                try {
                    const result = err.error.Data;
                    if (result && result.ErrorMessages && Object.keys(result.ErrorMessages).length > 0) {
                        for (const key in result.ErrorMessages) {
                            if (result.ErrorMessages.hasOwnProperty(key)) {
                                this.errorService.addError(result.ErrorMessages[key]);
                            }
                        }
                    }
                    else if (result.ErrorDescription) {
                        this.errorService.addError(result.ErrorDescription);
                    }
                }
                catch {
                    this.errorService.addError(err.error.toString());
                }
            }
            else {
                this.errorService.addError(err.error.Message);
            }
            this.isLoading = false;
            return EMPTY;
        }));
    }
    /** Request to complete the current registration process. */
    completeCurrentRegistration() {
        return this.api.post('register/complete', null).pipe(tap((data) => {
            this.logService.info('Registration process successfully completed.');
            this.registrationStepStore.updateIsComplete(true);
            if (this.authService.isAuthenticated()) {
                // Remove the auth token if the user is logged in, forcing a new one to be retrieved
                // with the refresh token so that the account_status property is updated.
                this.logService.info('Refreshing auth token...');
                firstValueFrom(this.authService.refreshAccessToken()).then((data) => {
                    this.isLoading = false;
                    this.authService.loginUsingToken(data.AccessToken, data.RefreshToken, '/');
                });
            }
            else {
                this.logService.info('Logging in using token');
                this.authService.loginUsingToken(data.ResultModel.AccessToken, data.ResultModel.RefreshToken, '/');
                this.isLoading = false;
            }
        }), map(() => null), catchError((err) => {
            if (err.status === 400) {
                try {
                    this.logService.error('An error occured when completing the registration process.');
                    this.errorService.clearErrors();
                    const result = err.error.Data;
                    if (result && result.ErrorNumber) {
                        // Add the errors to the error service list
                        if (result.ErrorMessages && Object.keys(result.ErrorMessages).length > 0) {
                            for (const key in result.ErrorMessages) {
                                if (result.ErrorMessages.hasOwnProperty(key)) {
                                    this.errorService.addError(result.ErrorMessages[key]);
                                }
                            }
                        }
                        else {
                            this.errorService.addError(result.ErrorDescription);
                        }
                        // Navigate to the offending step
                        const step = this.registrationStepQuery.getStep(result.StepType);
                        if (step) {
                            this.registrationStepStore.update(result.StepType, {
                                Complete: false,
                                Error: result.ErrorMessages,
                            });
                            this.navigateToStep(result.StepType);
                        }
                        else {
                            this.logService.info('No matching step could be found for the step that had an error.', result.StepType);
                            const finalStep = this.registrationStepQuery.getFinalStep();
                            if (!finalStep) {
                                this.logService.error('Failed to retrieve the final step in the registration process.', this.registrationStepQuery.getAll());
                            }
                            else {
                                this.logService.info('Navigating to the last step in the registration process.');
                                this.navigateToStep(finalStep.Step);
                            }
                        }
                    }
                    else {
                        this.logService.error('Failed to determine the format of the error response message.', err.error);
                    }
                }
                catch {
                    this.logService.error('Failed to parse the registration completion error response message.', err.error);
                }
            }
            else {
                this.logService.info('Response not a Bad Request so will be handled by the HttpErrorInterceptor.');
            }
            this.isLoading = false;
            return EMPTY;
        }));
    }
    /** Request to make payment for items selected in the registration process. */
    makeRegistrationPayment(billingAddress, shippingAddress, callbackUrl, giftCodes = [], useCardToken = false) {
        if (!billingAddress) {
            this.logService.error('Failed to make registration payment as no billing address was provided.');
            return EMPTY;
        }
        if (!callbackUrl) {
            this.logService.error('Failed to make registration payment as no callback URL was provided.');
            return EMPTY;
        }
        return this.api.post('register/payment', {
            BillingAddress: billingAddress,
            ShippingAddress: shippingAddress,
            PortalUrl: callbackUrl,
            GiftCodes: giftCodes,
            UseCardToken: useCardToken,
        });
    }
    /** Marks a step as complete or incomplete. */
    setStepCompleteStatus(stepType, complete) {
        this.logService.info('Updating step complete status', stepType, complete);
        this.registrationStepStore.update(stepType, { Complete: complete });
    }
    /** Marks a step to be skipped or not. */
    setStepSkipStatus(stepType, shouldSkip) {
        this.logService.info('Updating step skip status', stepType, shouldSkip);
        this.registrationStepStore.update(stepType, { ShouldSkip: shouldSkip });
    }
    /** Navigate to the route that represents the given step. */
    navigateToStep(stepType) {
        this.logService.info(`Navigating to step ${stepType ? StepType[stepType] : null}`, stepType);
        let routeNode = this._getRouteByStep(stepType);
        if (routeNode) {
            this.logService.debug('Matching route node found for next step', routeNode);
            const path = routeNode.path;
            this.logService.debug('Navigating to path:', path);
            this.router.navigate([this.modulePath + path || '/']);
        }
        else {
            this.logService.error('No route found for registration step', stepType);
            this.router.navigate(['/']);
        }
    }
    /** Navigate to the route that represents the next available step in the registration process. */
    navigateToNextStep() {
        let nextStep = this.registrationStepQuery.getNextStep();
        if (nextStep) {
            this.navigateToStep(nextStep.Step);
            this.isLoading = false;
            return;
        }
        this.logService.info('No more steps, completing the current registration process.');
        this.completeCurrentRegistration().toPromise();
    }
    /** Navigate to the route that represents the previous step in the registration process. */
    navigateToPreviousStep(stepType) {
        let previousStep = this.registrationStepQuery.getPreviousStep(stepType);
        if (!previousStep) {
            this.logService.info('There is no previous step in the registration process - redirecting to the home page...');
            this.router.navigate(['/']);
            return;
        }
        this.registrationStepStore.update(stepType, { Complete: false });
        this.logService.info('Navigating to previous step', previousStep.Step);
        this.errorService.clearErrors();
        this.navigateToStep(previousStep.Step);
    }
    /** Navigate to the route that represents the entry point of the given wizard type. */
    navigateToEntryPoint(wizardType) {
        this.logService.info('Navigating to the entry point for registration type', wizardType);
        let routeNode = this._getRouteByWizardType(wizardType);
        if (routeNode) {
            this.logService.debug('Matching route node found for registration entry point', routeNode);
            const path = routeNode.path;
            this.logService.debug('Navigating to path:', path);
            this.router.navigate([this.modulePath + path || '/']);
        }
        else {
            this.logService.error('No route found for entry point of registration type', wizardType);
            this.router.navigate(['/']);
        }
    }
    _getMappedRoutes() {
        let stack = [...this.registrationRoutes];
        let result = [];
        while (stack.length !== 0) {
            const node = stack.pop();
            if (node) {
                if (node.children && node.children.length > 0) {
                    for (let i = node.children.length; i > 0; i--) {
                        // Deep copy the child node (so that we don't modify the actual path)
                        let childNode = JSON.parse(JSON.stringify(node.children[i - 1]));
                        // Replace the relative path with its absolute one
                        childNode.path = node.path + '/' + childNode.path;
                        stack.push(childNode);
                    }
                }
                else {
                    result.push(node);
                }
            }
        }
        return result;
    }
    _getRouteByStep(stepType) {
        return this._getMappedRoutes().find((x) => !!x.data && x.data.registrationStep === stepType);
    }
    _getRouteByWizardType(wizardType) {
        return this._getMappedRoutes().find((x) => !!x.data && x.data.wizardType === wizardType);
    }
    /**
     * When refreshing the page we need to mark the previous steps as 'complete' on the client side
     * so that the user doesn't have to start from the beginning and resubmit all previous steps.
     */
    _markPreviousStepsAsComplete(stepType) {
        const previousSteps = this.registrationStepQuery.getPreviousSteps(stepType);
        this.logService.debug('Marking previous steps as complete', previousSteps);
        if (previousSteps) {
            for (let step of previousSteps) {
                this.registrationStepStore.update(step.Step, { Complete: true });
            }
        }
    }
    /**
     * Subscribes to the Akita Query to recalculate the skip status of relevant steps when an entity is
     * updated, added or removed from the store.
     *
     * @summary This logic cannot be added in the akitaPreUpdateEntity/akitaPreAddEntity methods of the
     * store as some logic depends on data from other steps. This would require the query class to be
     * injected into the store which causes a circular dependency, so instead we subscribe to any entity
     * actions made when constructing this service and calculate any updates when these events fire.
     */
    _calculateShouldSkipStatusesOnEntityChange() {
        this.registrationStepQuery.selectEntityAction().subscribe((action) => {
            action.ids.forEach((step) => {
                switch (step) {
                    case StepType.PersonalDetails:
                        const personalDetailsStep = this.registrationStepQuery.getStep(step);
                        const personalDetailsStepData = personalDetailsStep ? personalDetailsStep.Data : null;
                        if (action.type === EntityActions.Remove) {
                            this.logService.info('Personal details step removed - setting skip status of shipping address step', false);
                            this.registrationStepStore.update(StepType.ShippingAddress, { ShouldSkip: false });
                        }
                        else if (personalDetailsStepData) {
                            this.logService.info('Personal details step updated - setting skip status of shipping address step', !personalDetailsStepData.ShouldUseShippingAddress);
                            this.registrationStepStore.update(StepType.ShippingAddress, {
                                ShouldSkip: !personalDetailsStepData.ShouldUseShippingAddress,
                            });
                        }
                        else {
                            this.logService.info('Personal details step updated - no personal details step data...');
                        }
                        break;
                    // Any other skip logic for steps should be added as a case block here
                }
            });
        });
    }
    /** Get the given ParamMap as a HttpParams object. */
    _getQueryParamsAsHttpParams(queryParams) {
        if (!queryParams) {
            return undefined;
        }
        let httpParams = new HttpParams();
        const queryParamMap = convertToParamMap(queryParams);
        queryParamMap.keys.forEach((key) => {
            const value = queryParamMap.get(key);
            httpParams = value ? httpParams.set(key, value) : httpParams;
        });
        return httpParams;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepService, deps: [{ token: RegistrationStepStore }, { token: RegistrationStepQuery }, { token: ApiService }, { token: LoggingService }, { token: ErrorStateService }, { token: i2.Router }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepService, providedIn: 'root' }); }
}
__decorate([
    transaction()
], RegistrationStepService.prototype, "_markPreviousStepsAsComplete", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: RegistrationStepStore }, { type: RegistrationStepQuery }, { type: ApiService }, { type: LoggingService }, { type: ErrorStateService }, { type: i2.Router }, { type: AuthService }], propDecorators: { _markPreviousStepsAsComplete: [] } });

class RegistrationStepResolver {
    constructor(registrationStepQuery, registrationStepService, logService) {
        this.registrationStepQuery = registrationStepQuery;
        this.registrationStepService = registrationStepService;
        this.logService = logService;
    }
    resolve(route) {
        if (this.registrationStepQuery.getValue().wizardType === undefined) {
            // Haven't gone through a registration entry point yet in this session
            const currentStepType = this.getCurrentStepType(route);
            this.logService.info('Fetching current registration data from the API...', currentStepType);
            return this.registrationStepService.fetchRegistrationStepsForCurrentWizard(currentStepType);
        }
        else {
            // Continuing an already started registration process so do nothing
            this.logService.debug('Registration process already in progress, skipping syncing of registration data with the API.');
            return of(null).pipe(mapTo(null));
        }
    }
    /** Gets the current step type from the current route. */
    getCurrentStepType(route) {
        return route.firstChild ? route.firstChild.data.registrationStep : undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepResolver, deps: [{ token: RegistrationStepQuery }, { token: RegistrationStepService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationStepResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RegistrationStepQuery }, { type: RegistrationStepService }, { type: LoggingService }] });

// tslint:disable: variable-name
var WizardType;
(function (WizardType) {
    WizardType[WizardType["FirstTimeRegistration"] = 0] = "FirstTimeRegistration";
    WizardType[WizardType["QuickRegistration"] = 1] = "QuickRegistration";
    WizardType[WizardType["PartnerRegistration"] = 2] = "PartnerRegistration";
    WizardType[WizardType["NewMemberRegistration"] = 3] = "NewMemberRegistration";
    WizardType[WizardType["SocialRegistration"] = 4] = "SocialRegistration";
    WizardType[WizardType["GuardianRegistration"] = 5] = "GuardianRegistration";
    WizardType[WizardType["AccountActivation"] = 6] = "AccountActivation";
    WizardType[WizardType["ReferAFriend"] = 7] = "ReferAFriend";
    WizardType[WizardType["NoIpid"] = 8] = "NoIpid";
    WizardType[WizardType["ChildRegistration"] = 9] = "ChildRegistration";
    WizardType[WizardType["External"] = 10] = "External";
    WizardType[WizardType["InPark"] = 11] = "InPark";
})(WizardType || (WizardType = {}));

var RegistrationQuestionType;
(function (RegistrationQuestionType) {
    RegistrationQuestionType[RegistrationQuestionType["TextBox"] = 1] = "TextBox";
    RegistrationQuestionType[RegistrationQuestionType["DropDown"] = 2] = "DropDown";
    RegistrationQuestionType[RegistrationQuestionType["MultiSelect"] = 3] = "MultiSelect";
    RegistrationQuestionType[RegistrationQuestionType["Radio"] = 4] = "Radio";
    RegistrationQuestionType[RegistrationQuestionType["Checkbox"] = 5] = "Checkbox";
})(RegistrationQuestionType || (RegistrationQuestionType = {}));

const ALERT_MODEL_MOCK = [
    {
        AlertID: 1,
        Value: false,
        IsHidden: true,
    },
    {
        AlertID: 2,
        Value: true,
        IsHidden: false,
    },
];
const ALERT_MODEL_RESPONSE_MOCK = {
    Data: ALERT_MODEL_MOCK,
};

let CountryStore = class CountryStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryStore, providedIn: 'root' }); }
};
CountryStore = __decorate([
    StoreConfig({ name: 'country', idKey: 'ID' })
], CountryStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CountryQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    SelectCountryAndRegions(ID) {
        return this.getEntity(ID);
    }
    selectAllCountries() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryQuery, deps: [{ token: CountryStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CountryStore }] });

class CountryService {
    constructor(countryStore, api, countryQuery) {
        this.countryStore = countryStore;
        this.api = api;
        this.countryQuery = countryQuery;
    }
    fetchCountries() {
        const request$ = this.api.get('country/countries-with-regions').pipe(tap(a => {
            this.countryStore.set(a);
        }), mapTo(null));
        return this.countryQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryService, deps: [{ token: CountryStore }, { token: ApiService }, { token: CountryQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CountryStore }, { type: ApiService }, { type: CountryQuery }] });

class CountryResolver {
    constructor(countryService) {
        this.countryService = countryService;
    }
    resolve() {
        return this.countryService.fetchCountries();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryResolver, deps: [{ token: CountryService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountryResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CountryService }] });

/**
 * Resolver to set the module path for the registration step service.
 */
const registrationResolver = (route, state) => {
    inject(RegistrationStepService).modulePath = route.parent?.routeConfig?.path ?? '';
    return true;
};

let RegistrationBasketStore = class RegistrationBasketStore extends Store {
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketStore, providedIn: 'root' }); }
};
RegistrationBasketStore = __decorate([
    StoreConfig({ name: 'registration-basket' })
], RegistrationBasketStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class RegistrationBasketQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketQuery, deps: [{ token: RegistrationBasketStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RegistrationBasketStore }] });

class RegistrationBasketService {
    constructor(registrationBasketStore, registrationBasketQuery, apiService) {
        this.registrationBasketStore = registrationBasketStore;
        this.registrationBasketQuery = registrationBasketQuery;
        this.apiService = apiService;
    }
    /** Retrieve the current registration's basket to be purchased. */
    fetchRegistrationBasketForCurrentWizard(appliedGiftCodes = []) {
        let queryString = "?";
        appliedGiftCodes.forEach((giftCode) => {
            queryString += `appliedgiftcodeids=${giftCode.Id}`;
            if (appliedGiftCodes.indexOf(giftCode) < appliedGiftCodes.length - 1) {
                queryString += "&";
            }
        });
        const request$ = this.apiService.getAnySingle(`register/basket${appliedGiftCodes.length > 0 ? queryString : ''}`).pipe(tap(basket => this.registrationBasketStore.update(basket)), mapTo(null));
        return this.registrationBasketQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketService, deps: [{ token: RegistrationBasketStore }, { token: RegistrationBasketQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RegistrationBasketService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RegistrationBasketStore }, { type: RegistrationBasketQuery }, { type: ApiService }] });

const TICKET_INVITE_MOCK = {
    ACN: 1,
    Area: '',
    ClubId: 1,
    Comments: '',
    CreationDate: '',
    ErrorCode: '',
    ErrorDescription: '',
    ErrorNumber: 1,
    ExpiryDate: '',
    ExternalPendingRef: '',
    ExternalRefNumber: '',
    GameName: '',
    GameNumber: 1,
    LinkId: 1,
    MemberId: '',
    MemberName: '',
    PortalId: '',
    ProductCode: '',
    Row: '',
    Seat: '',
    TicketActionType: 1,
    TicketKey: '',
    TransferACN: 1,
    TransferEmail: '',
    TransferMemberId: '',
    TransferPortalId: '',
    UniqKey: '',
};

class SubmitTicketRequestModel {
}
var TicketTransactionType;
(function (TicketTransactionType) {
    TicketTransactionType[TicketTransactionType["TicketPrint"] = 1] = "TicketPrint";
    TicketTransactionType[TicketTransactionType["RePrint"] = 2] = "RePrint";
    TicketTransactionType[TicketTransactionType["SellBarcodeTicket"] = 3] = "SellBarcodeTicket";
    TicketTransactionType[TicketTransactionType["CancelBarcodeTicket"] = 4] = "CancelBarcodeTicket";
    TicketTransactionType[TicketTransactionType["ActiveCardTicket"] = 5] = "ActiveCardTicket";
    TicketTransactionType[TicketTransactionType["CritcalCardCancel"] = 6] = "CritcalCardCancel";
    TicketTransactionType[TicketTransactionType["CritcalBarcodeCancel"] = 7] = "CritcalBarcodeCancel";
    TicketTransactionType[TicketTransactionType["BarcodeTransferIn"] = 8] = "BarcodeTransferIn";
    TicketTransactionType[TicketTransactionType["BarcodeTransferOut"] = 9] = "BarcodeTransferOut";
    TicketTransactionType[TicketTransactionType["CardTransferIn"] = 10] = "CardTransferIn";
    TicketTransactionType[TicketTransactionType["CardTransferOut"] = 11] = "CardTransferOut";
    TicketTransactionType[TicketTransactionType["BarcodeLoadedToCard"] = 12] = "BarcodeLoadedToCard";
    TicketTransactionType[TicketTransactionType["Transferred"] = 13] = "Transferred";
    TicketTransactionType[TicketTransactionType["CallBack"] = 14] = "CallBack";
    TicketTransactionType[TicketTransactionType["CallBackByOrignalMember"] = 15] = "CallBackByOrignalMember";
    TicketTransactionType[TicketTransactionType["ResaleActiveCardTicket"] = 16] = "ResaleActiveCardTicket";
    TicketTransactionType[TicketTransactionType["ResaleCancelCardTicket"] = 17] = "ResaleCancelCardTicket";
    TicketTransactionType[TicketTransactionType["ResaleSellBarcodeTicket"] = 18] = "ResaleSellBarcodeTicket";
    TicketTransactionType[TicketTransactionType["ResaleCancelBarcodeTicket"] = 19] = "ResaleCancelBarcodeTicket";
    TicketTransactionType[TicketTransactionType["DonationCancelCardTicket"] = 20] = "DonationCancelCardTicket";
    TicketTransactionType[TicketTransactionType["DonationCancelBarcodeTicket"] = 21] = "DonationCancelBarcodeTicket";
    TicketTransactionType[TicketTransactionType["DonationSellBarcodeTicket"] = 22] = "DonationSellBarcodeTicket";
})(TicketTransactionType || (TicketTransactionType = {}));

class TicketService {
    constructor(ticketStore, ticketQuery, apiService) {
        this.ticketStore = ticketStore;
        this.ticketQuery = ticketQuery;
        this.apiService = apiService;
    }
    fetchTickets() {
        this.ticketStore.setLoading(true);
        const request$ = this.apiService.get('tickets').pipe(tap((tickets) => {
            tickets = tickets.map((ticket) => {
                ticket.Id = `${ticket.ACN}_${ticket.GameNumber}`;
                return ticket;
            });
            this.ticketStore.set(tickets);
        }), mapTo(null));
        return this.ticketQuery.getHasCache() ? of(null) : request$;
    }
    fetchTransferHistory(memberId, acn, gameNumber) {
        return this.apiService.get('tickets/log/' + memberId + '/' + acn + '/' + gameNumber);
    }
    toggleSelectTicket(id) {
        this.ticketStore.update(id, (ticket) => ({
            selected: !ticket.selected,
        }));
    }
    toggleSelectAllTickets(gameNumber, anyUnselected) {
        this.ticketStore.update((ticket) => ticket.GameNumber === gameNumber && ticket.Flag === TicketFlag.ACTIVE && ticket.MediaType === TicketMediaType.CARD, {
            selected: anyUnselected,
        });
    }
    removeSelectedTicket(id) {
        this.ticketStore.update(id, {
            selected: false,
        });
    }
    // Onload of page no tickets should be selected
    resetSelectedTickets() {
        this.ticketStore.update(null, {
            selected: false,
        });
    }
    resetTransferredTickets() {
        this.ticketStore.update(null, {
            Transferred: false,
        });
    }
    checkFlag(status, flag) {
        // tslint:disable-next-line: no-bitwise
        return status & flag;
    }
    setTransferredTicket(id, emailAddress) {
        this.ticketStore.update((ticket) => ticket.Id === id, {
            Transferred: true,
            RecipientEmailAddress: emailAddress,
        });
    }
    callbackTicket(ticket, deliveryParameters) {
        this.ticketStore.update((ticket) => ticket.Id === ticket.Id, {
            TicketAction: TicketActionType.Callback,
            ShouldUseUniqueDeliveryParameters: true,
            DeliveryParameters: deliveryParameters,
        });
        let objDeliveryParameters = {
            Callback: deliveryParameters,
        };
        let ticketToSubmit = this.ticketQuery.getEntity(ticket.Id);
        if (!ticketToSubmit) {
            return of(undefined);
        }
        let submitTicketRequest = new SubmitTicketRequestModel();
        submitTicketRequest.Tickets = [ticketToSubmit];
        submitTicketRequest.DeliveryParameters = objDeliveryParameters;
        submitTicketRequest.UsePurchaseService = false;
        return this.apiService.post('tickets/submit', submitTicketRequest).pipe(tap((result) => {
            if (!result) {
                return;
            }
            result.forEach((response) => {
                if (response.Result.ErrorNumber === 0) {
                    this.ticketStore.update((ticket) => ticket.ACN === response.Ticket.ACN && ticket.GameNumber === response.Ticket.GameNumber, {
                        Flag: TicketFlag.ACTIVE,
                    });
                }
            });
        }));
    }
    transferTicket(deliveryParameters) {
        let objDeliveryParameters = {
            TransferToEmail: deliveryParameters,
        };
        this.ticketStore.update((ticket) => ticket.selected, {
            TicketAction: TicketActionType.TransferToEmail,
            ShouldUseUniqueDeliveryParameters: true,
            DeliveryParameters: deliveryParameters,
        });
        let selectedTickets = this.ticketQuery.getAll({ filterBy: (ticket) => ticket.selected });
        let submitTicketRequest = new SubmitTicketRequestModel();
        submitTicketRequest.Tickets = selectedTickets;
        submitTicketRequest.DeliveryParameters = objDeliveryParameters;
        submitTicketRequest.UsePurchaseService = true;
        return this.apiService.post('tickets/submit', submitTicketRequest).pipe(tap((result) => result.forEach((response) => {
            this.ticketStore.update((ticket) => ticket.ACN === response.Ticket.ACN && ticket.GameNumber === response.Ticket.GameNumber, {
                Transferred: true,
                Flag: response.Ticket.Flag,
                TransfereeEmailAddress: response.Ticket.TransfereeEmailAddress,
            });
        })));
    }
    /*this method will verify the ticket key*/
    validateTicketInviteKey(ticketKey) {
        return this.apiService.get('tickets/pending/' + ticketKey);
    }
    /*this method will verify the email, unique code and ticket key*/
    validateTicketInviteCredentials(ticketRequest) {
        return this.apiService.post('tickets/pending/validate', ticketRequest);
    }
    /*this method will process the all ticket against the email unique code*/
    ticketTransferprocess(ticketRequest) {
        return this.apiService.post('tickets/pending/process', ticketRequest);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketService, deps: [{ token: TicketStore }, { token: TicketQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TicketStore }, { type: TicketQuery }, { type: ApiService }] });

class TicketResolver {
    constructor(ticketService) {
        this.ticketService = ticketService;
    }
    resolve() {
        return this.ticketService.fetchTickets();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketResolver, deps: [{ token: TicketService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TicketService }] });

class TicketTransferGuard {
    constructor(router, ticketQuery, logService) {
        this.router = router;
        this.ticketQuery = ticketQuery;
        this.logService = logService;
    }
    canActivate() {
        if (!(this.ticketQuery.getCount(ticket => ticket.selected) > 0)) {
            this.logService.info('No tickets selected, redirecting to the home page.');
            this.router.navigate(['/']);
            return false;
        }
        else {
            return true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketTransferGuard, deps: [{ token: i2.Router }, { token: TicketQuery }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketTransferGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TicketTransferGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.Router }, { type: TicketQuery }, { type: LoggingService }] });

class DeliveryParameters {
}

var TicketDetails;
(function (TicketDetails) {
    TicketDetails[TicketDetails["AreaLine1"] = 0] = "AreaLine1";
    TicketDetails[TicketDetails["Stand"] = 1] = "Stand";
    TicketDetails[TicketDetails["StandName"] = 2] = "StandName";
    TicketDetails[TicketDetails["Area"] = 3] = "Area";
    TicketDetails[TicketDetails["Hide"] = 4] = "Hide";
})(TicketDetails || (TicketDetails = {}));

// tslint:disable: variable-name
class ManageTicketStatusModel {
    constructor(gameNumber, barcodeAcn, barcodeText, area, row, seat, status, balance, date) {
        this.GameNumber = gameNumber;
        this.BarcodeACN = barcodeAcn;
        this.BarcodeText = barcodeText;
        this.Area = area;
        this.Row = row;
        this.Seat = seat;
        this.Status = status;
        this.Balance = balance;
        this.Date = date;
    }
}

class TopUpTicketPostModel {
    constructor(barcodeText, barcodeACN, gameNumber, area, row, seat, balance, stand, gameDate) {
        this.barcodeText = barcodeText;
        this.barcodeACN = barcodeACN;
        this.gameNumber = gameNumber;
        this.area = area;
        this.row = row;
        this.seat = seat;
        this.balance = balance;
        this.stand = stand;
        this.gameDate = gameDate;
    }
}

var TopUpTicketsStatus;
(function (TopUpTicketsStatus) {
    /// Can be loaded when topped up
    TopUpTicketsStatus[TopUpTicketsStatus["UnloadedActive"] = 0] = "UnloadedActive";
    /// Can be topped up and balance restored to account
    TopUpTicketsStatus[TopUpTicketsStatus["LoadedHasMoney"] = 1] = "LoadedHasMoney";
    /// Cannot be topped up but is loaded and doesn't have any value assigned to it
    TopUpTicketsStatus[TopUpTicketsStatus["LoadedNoMoney"] = 2] = "LoadedNoMoney";
    /// Ticket has to be moved to UnloadedActive before it can be topped up
    /// Ticket Inactive
    TopUpTicketsStatus[TopUpTicketsStatus["UnloadedBlocked"] = 3] = "UnloadedBlocked";
})(TopUpTicketsStatus || (TopUpTicketsStatus = {}));

class TopupTicketService {
    constructor(api, topupTicketStore, logService) {
        this.api = api;
        this.topupTicketStore = topupTicketStore;
        this.logService = logService;
    }
    getTicketsWithBalance(gameNumber) {
        this.logService.debug('Getting tickets with balance for game', gameNumber);
        return this.api.get(`tickets/ticketswithbalance?gamenumber=${gameNumber}`).pipe(tap((tickets) => {
            this.topupTicketStore.setTickets(tickets);
        }));
    }
    topUpTickets(topups) {
        this.logService.debug('Topping up tickets', topups);
        // Amount needs to be in pence / cents
        topups.map((topup) => (topup.amount *= 100));
        return this.api.postWithArray('tickets/topuptickets', topups);
    }
    manageTicketStatus(manageTicket) {
        this.logService.debug('Managing ticket status', manageTicket);
        return this.api.post('tickets/manageticketstatus', manageTicket);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketService, deps: [{ token: ApiService }, { token: TopupTicketStore }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TopupTicketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: TopupTicketStore }, { type: LoggingService }] });

let MobilePassStore = class MobilePassStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassStore, providedIn: 'root' }); }
};
MobilePassStore = __decorate([
    StoreConfig({ name: 'mobile-pass' })
], MobilePassStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class MobilePassQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassQuery, deps: [{ token: MobilePassStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MobilePassStore }] });

class MobilePassService {
    constructor(mobilePassStore, api, mobilePassQuery, loggingService) {
        this.mobilePassStore = mobilePassStore;
        this.api = api;
        this.mobilePassQuery = mobilePassQuery;
        this.loggingService = loggingService;
    }
    /**
     * This will fetch the mobile pass URL.
     * @param memberId Member ID of current user
     * @returns Request to fetch mobile pass URL if this
     * does not exist within the mobile pass store.
     */
    fetchPass(memberId) {
        let url = memberId ? `passes?memberId=${memberId}` : 'passes';
        this.loggingService.info('Fetching pass URL for current user...');
        const request$ = this.api.getAnySingle(url).pipe(tap((passUrlResonse) => {
            this.loggingService.info('Pass URL found.', passUrlResonse);
            let passUrl = { url: passUrlResonse };
            this.mobilePassStore.set([passUrl]);
        }), mapTo(null));
        return this.mobilePassQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassService, deps: [{ token: MobilePassStore }, { token: ApiService }, { token: MobilePassQuery }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MobilePassService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MobilePassStore }, { type: ApiService }, { type: MobilePassQuery }, { type: LoggingService }] });

var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["payment"] = 0] = "payment";
    TransactionType[TransactionType["loyalty"] = 1] = "loyalty";
    TransactionType[TransactionType["ecash"] = 2] = "ecash";
    TransactionType[TransactionType["cardlink"] = 3] = "cardlink";
})(TransactionType || (TransactionType = {}));

const TRANSACTION_MOCK = [{
        DescriptionText: "",
        Amount: 1,
        TransactionRef: 1,
        TransactionDate: new Date,
        TransactionDateUTC: new Date,
        POS: "",
        CardBalance: 1,
        AccountBalance: 1,
        AccountNumber: 1,
        ACN: 1,
        ExternalVendorRef: "",
        AccountDescriptionId: 1,
        ActionId: 1,
        TransactionDescription: "",
        Location: "",
        Type: TransactionType.cardlink,
    },
    {
        DescriptionText: "",
        Amount: 22,
        TransactionRef: 2,
        TransactionDate: new Date,
        TransactionDateUTC: new Date,
        POS: "",
        CardBalance: 2,
        AccountBalance: 2,
        AccountNumber: 2,
        ACN: 2,
        ExternalVendorRef: "",
        AccountDescriptionId: 2,
        ActionId: 2,
        TransactionDescription: "",
        Location: "",
        Type: TransactionType.cardlink,
    },
    {
        DescriptionText: "",
        Amount: 222,
        TransactionRef: 22,
        TransactionDate: new Date,
        TransactionDateUTC: new Date,
        POS: "",
        CardBalance: 21,
        AccountBalance: 21,
        AccountNumber: 21,
        ACN: 21,
        ExternalVendorRef: "",
        AccountDescriptionId: 21,
        ActionId: 21,
        TransactionDescription: "",
        Location: "",
        Type: TransactionType.cardlink,
    }];

function createInitialState() {
    return {
        cachedDates: {
            [TransactionType.payment]: new Array(),
            [TransactionType.ecash]: new Array(),
            [TransactionType.loyalty]: new Array(),
            [TransactionType.cardlink]: new Array()
        }
    };
}
let TransactionStore = class TransactionStore extends EntityStore {
    constructor() {
        super(createInitialState());
    }
    addCachedDate(startDate, endDate, type) {
        let range = { startDate, endDate };
        this.update(x => {
            let state = {
                cachedDates: {
                    [TransactionType.payment]: x.cachedDates[TransactionType.payment],
                    [TransactionType.ecash]: x.cachedDates[TransactionType.ecash],
                    [TransactionType.loyalty]: x.cachedDates[TransactionType.loyalty],
                    [TransactionType.cardlink]: x.cachedDates[TransactionType.cardlink]
                }
            };
            state.cachedDates[type] = x.cachedDates[type].concat([range]);
            return x;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionStore, providedIn: 'root' }); }
};
TransactionStore = __decorate([
    StoreConfig({ name: 'transaction', idKey: 'TransactionRef' })
], TransactionStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TransactionQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    getLastSearch(type) {
        const dates = this.getValue().cachedDates[type];
        if (dates.length > 0) {
            return dates[dates.length - 1];
        }
        return undefined;
    }
    /** @deprecated use selectTransactions, this will be changed to return a current value next major release */
    getTransactions(startDate, endDate, type) {
        return this.selectAll().pipe(map(ts => ts.filter(t => t.TransactionDate > startDate &&
            t.TransactionDate < endDate &&
            t.Type === type)));
    }
    selectTransactions(startDate, endDate, type) {
        return this.selectAll().pipe(map(ts => ts.filter(t => (!startDate || t.TransactionDate >= startDate) &&
            (!endDate || t.TransactionDate <= endDate) &&
            (type === undefined || type === null || t.Type === type))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionQuery, deps: [{ token: TransactionStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TransactionStore }] });

class TransactionService {
    constructor(transactionStore, api, transactionQuery) {
        this.transactionStore = transactionStore;
        this.api = api;
        this.transactionQuery = transactionQuery;
    }
    // check if the submitted date range is contained within a previously submitted range
    isCached(startDate, endDate, type) {
        return (this.transactionQuery.getValue().cachedDates[type].filter((q) => q.startDate <= startDate && q.endDate >= endDate).length >
            0);
    }
    fetchTransactions(startDate, endDate, memberId, type) {
        if (this.isCached(startDate, endDate, type)) {
            return of(null);
        }
        let source = of([]);
        const fromDate = encodeURI(formatDate(startDate, 'yyyy-MM-dd', 'en-GB'));
        const toDate = formatDate(endDate, 'yyyy-MM-dd', 'en-GB');
        switch (type) {
            case TransactionType.ecash:
                source = this.api.get('purse/transactions/' + config.purseConfig.combined + '/' + fromDate + '/' + toDate + '/' + memberId);
                break;
            case TransactionType.loyalty:
                source = this.api.get('purse/transactions/' + config.purseConfig.virtualLoyalty + '/' + fromDate + '/' + toDate + '/' + memberId);
                break;
            case TransactionType.payment:
                source = this.api.get('purse/paymenttransactions/' + config.purseConfig.combined + '/' + fromDate + '/' + toDate);
                break;
            case TransactionType.cardlink:
                startDate.setHours(0, 0, 0);
                endDate.setHours(23, 59, 59);
                const cardLinkFromDate = encodeURI(formatDate(startDate, 'yyyy-MM-dd HH:mm', 'en-GB'));
                const cardLinkToDate = encodeURI(formatDate(endDate, 'yyyy-MM-dd HH:mm', 'en-GB'));
                source = this.api.get('affiliates/transactions/' + cardLinkFromDate + '/' + cardLinkToDate + '/' + memberId);
                break;
        }
        return source.pipe(map((x) => {
            x.forEach((t) => {
                (t.TransactionDate = moment$1.utc(t.TransactionDate).local().toDate()), (t.Type = type);
            });
            return x;
        }), tap((x) => {
            this.transactionStore.upsertMany(x);
        }), tap(() => this.transactionStore.addCachedDate(startDate, endDate, type)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionService, deps: [{ token: TransactionStore }, { token: ApiService }, { token: TransactionQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TransactionStore }, { type: ApiService }, { type: TransactionQuery }] });

let TransactionExtendedStore = class TransactionExtendedStore extends EntityStore {
    constructor() {
        super({
            active: [],
            itemDetails: {},
            loading: false
        });
        this.createUIStore();
    }
    setItemDetails(id, items) {
        this.update((state) => {
            return {
                itemDetails: {
                    ...state.itemDetails,
                    ...{ [id]: items }
                }
            };
        });
    }
    setUILoading(id, value) {
        this.ui.upsert(id, { isLoading: value });
    }
    restoreDefaults() {
        this.update(() => {
            return {
                active: [],
                entities: [],
                ids: [],
                loading: false
            };
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedStore, providedIn: 'root' }); }
};
TransactionExtendedStore = __decorate([
    StoreConfig({ name: 'transactions-extended', idKey: 'TransactionRef' })
], TransactionExtendedStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TransactionExtendedQuery extends QueryEntity {
    constructor(dateFormat, store) {
        super(store);
        this.dateFormat = dateFormat;
        this.store = store;
        this.transactions$ = this.selectAll();
        this.groupedByDate$ = this.selectAll().pipe(map(this._groupByDate()));
        this.loading$ = this.selectLoading();
        this.createUIQuery();
    }
    isLoading(id) {
        return this.ui.selectEntity(id, 'isLoading')
            .pipe(map(val => val));
    }
    isDisabled(id) {
        return !this.getEntity(id)?.ExternalVendorRef;
    }
    getItemDetailsByTref(id) {
        return this.select(state => state.itemDetails[id] || undefined);
    }
    hasItemDetails(id) {
        return !!this.getValue().itemDetails[id];
    }
    _groupByDate() {
        return (arr) => {
            const uniqueDates = arr.sort(this._sortByDate())
                .filter((val, idx, a) => a.findIndex(i => this._formatDate(i.TransactionDateUTC) === this._formatDate(val.TransactionDateUTC)) === idx)
                .map(i => this._formatDate(i.TransactionDateUTC));
            return uniqueDates.map(date => ({ date, transactions: arr.filter(i => this._formatDate(i.TransactionDateUTC) === date).sort(this._sortByDate()) }));
        };
    }
    _sortByDate() {
        return (a, b) => new Date(b.TransactionDateUTC).getTime() - new Date(a.TransactionDateUTC).getTime();
    }
    _formatDate(date) {
        return moment(date).format(this.dateFormat.NgbDateFormat);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedQuery, deps: [{ token: DATE_OPTIONS }, { token: TransactionExtendedStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DATE_OPTIONS]
                }] }, { type: TransactionExtendedStore }] });

class TransactionExtendedService {
    constructor(transactionExtendedStore, transactionExtendedQuery, api) {
        this.transactionExtendedStore = transactionExtendedStore;
        this.transactionExtendedQuery = transactionExtendedQuery;
        this.api = api;
    }
    getExtendedTransactions(purseNumber, dateFrom, dateTo, pageNumber, pageSize) {
        const fromDate = encodeURI(formatDate(dateFrom, 'yyyy-MM-dd', 'en-GB'));
        const toDate = formatDate(dateTo, 'yyyy-MM-dd', 'en-GB');
        return this.api.get(`purse/transactions/extended/${purseNumber}/${fromDate}/${toDate}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }
    getTransactionDetailsByTref(tref) {
        return this.api.get(`purse/transactions/extended/item/${tref}`);
    }
    search(purseNumber, dateFrom, dateTo, pageNumber, pageSize) {
        this.transactionExtendedStore.setLoading(true);
        return this.getExtendedTransactions(purseNumber, dateFrom, dateTo, pageNumber, pageSize)
            .pipe(tap(entities => this.transactionExtendedStore.add(entities)), finalize(() => this.transactionExtendedStore.setLoading(false)));
    }
    loadItemDetailsByTref(tref) {
        if (this.transactionExtendedQuery.hasActive(tref)) {
            if (!this.transactionExtendedQuery.hasItemDetails(tref)) {
                this.transactionExtendedStore.setUILoading(tref, true);
                return this.getTransactionDetailsByTref(tref)
                    .pipe(tap((response) => {
                    if (response.ErrorCode === 'S') {
                        this.transactionExtendedStore.setItemDetails(tref, response.Data);
                    }
                }), finalize(() => this.transactionExtendedStore.setUILoading(tref, false)));
            }
            // err { Code: "Purse.CODE.3412", Message: null
            return this.transactionExtendedQuery.getItemDetailsByTref(tref);
        }
        return EMPTY;
    }
    toggleActive(id) {
        this.transactionExtendedStore.toggleActive(id);
    }
    reset() {
        this.transactionExtendedStore.restoreDefaults();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedService, deps: [{ token: TransactionExtendedStore }, { token: TransactionExtendedQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TransactionExtendedService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TransactionExtendedStore }, { type: TransactionExtendedQuery }, { type: ApiService }] });

var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["Ready"] = 0] = "Ready";
    GameStatus[GameStatus["Processing"] = 1] = "Processing";
    GameStatus[GameStatus["Processed"] = 2] = "Processed";
})(GameStatus || (GameStatus = {}));

let FantasyGameStore = class FantasyGameStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameStore, providedIn: 'root' }); }
};
FantasyGameStore = __decorate([
    StoreConfig({ name: 'fantasy-game', idKey: 'GameId' })
], FantasyGameStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let FantasyGameQuery = class FantasyGameQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
        this.pendingPeriod = 48;
    }
    /**
     * Get all fantasy games
     */
    selectGames() {
        return this.selectAll();
    }
    /**
     * Get fantasy game by id
     */
    selectGameById(id) {
        return this.selectEntity(id);
    }
    /**
     * Gets players for a given game
     * @param gameId game id to filter on
     */
    selectPlayersByGameId(gameId) {
        return this.selectEntity(gameId, (game) => game?.GamePlayers);
    }
    /**
     * Get the selected player for the fantasy game
     * @param gameId game id to filter on
     */
    getSelectedPlayer(gameId) {
        return this.getEntity(gameId)?.SelectedPlayerId;
    }
    /**
     * Get current games
     */
    selectCurrentGames() {
        return this.selectAll({
            filterBy: (game) => {
                return moment$1().isBetween(moment$1.utc(game.StartDate), moment$1.utc(game.EndDate)) && game.Status != GameStatus.Processed;
            },
        });
    }
    /**
     * Gets all finished fantasy games
     */
    selectFinishedGames() {
        return this.selectAll({
            filterBy: (game) => moment$1.utc(game.EndDate).isBefore(moment$1.utc()),
        });
    }
    /**
     * Get all finished games after given date
     */
    selectFinshedFantasyGamesAfterDate(date) {
        return this.selectFinishedGames().pipe(map((items) => items.filter((item) => {
            return moment$1.utc(item.EndDate).isAfter(date);
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameQuery, deps: [{ token: FantasyGameStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameQuery, providedIn: 'root' }); }
};
FantasyGameQuery = __decorate([
    QueryConfig({ sortBy: 'EndDate', sortByOrder: Order.ASC })
], FantasyGameQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyGameStore }] });

class FantasyGameService {
    constructor(fantasyGameStore, fantasyGameQuery, api) {
        this.fantasyGameStore = fantasyGameStore;
        this.fantasyGameQuery = fantasyGameQuery;
        this.api = api;
    }
    fetchFantasyGames() {
        return this.api.get('fantasy').pipe(tap((games) => {
            games.forEach((game) => {
                game.EndDate = moment$1.utc(game.EndDate).toDate();
                game.StartDate = moment$1.utc(game.StartDate).toDate();
                game.GameDate = moment$1.utc(game.GameDate).toDate();
            });
            this.fantasyGameStore.set(games);
        }), mapTo(null));
    }
    markSelected(gameId, playerId) {
        this.fantasyGameStore.update(gameId, (entity) => ({
            GamePlayers: arrayUpdate(entity.GamePlayers, () => true, {
                IsSelected: false,
            }),
        }));
        this.fantasyGameStore.update(gameId, (entity) => ({
            GamePlayers: arrayUpdate(entity.GamePlayers, (player) => player.PlayerId === playerId, {
                PlayerId: playerId,
                IsSelected: true,
            }),
        }));
        this.fantasyGameStore.update(gameId, { SelectedPlayerId: playerId });
    }
    confirmSelection(gameId) {
        const playerId = this.fantasyGameQuery.getSelectedPlayer(gameId);
        if (!playerId) {
            return of(null);
        }
        return this.api.post(`fantasy/${gameId}/players/${playerId}`, {}).pipe(switchMap(() => this.fetchFantasyGames()));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameService, deps: [{ token: FantasyGameStore }, { token: FantasyGameQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameService, providedIn: 'root' }); }
}
__decorate([
    transaction()
], FantasyGameService.prototype, "markSelected", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyGameStore }, { type: FantasyGameQuery }, { type: ApiService }], propDecorators: { markSelected: [] } });

class FantasyGameResolver {
    constructor(fantasyService, loggingService) {
        this.fantasyService = fantasyService;
        this.loggingService = loggingService;
    }
    resolve() {
        this.loggingService.info('resolving fantasy games');
        return this.fantasyService.fetchFantasyGames();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameResolver, deps: [{ token: FantasyGameService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyGameResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyGameService }, { type: LoggingService }] });

let FantasyLeaderboardStore = class FantasyLeaderboardStore extends Store {
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardStore, providedIn: 'root' }); }
};
FantasyLeaderboardStore = __decorate([
    StoreConfig({ name: 'FantasyLeaderboard' })
], FantasyLeaderboardStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class FantasyLeaderboardQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    getMonthlyLeaderboard() {
        return this.getValue().monthlyLeaderboard;
    }
    getYearlyLeaderboard() {
        return this.getValue().yearlyLeaderboard;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardQuery, deps: [{ token: FantasyLeaderboardStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyLeaderboardStore }] });

class FantasyLeaderboardService {
    constructor(fantasyLeaderboardStore, api) {
        this.fantasyLeaderboardStore = fantasyLeaderboardStore;
        this.api = api;
    }
    fetchMonthlyLeaderboard(amountToDisplay) {
        return this.api.get('fantasy/leaderboard/monthly/' + amountToDisplay).pipe(tap(entries => {
            this.fantasyLeaderboardStore.update(state => ({ monthlyLeaderboard: entries }));
        }), mapTo(null));
    }
    fetchYearlyLeaderboard(amountToDisplay) {
        return this.api.get('fantasy/leaderboard/yearly/' + amountToDisplay).pipe(tap(entries => {
            this.fantasyLeaderboardStore.update(state => ({ yearlyLeaderboard: entries }));
        }), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardService, deps: [{ token: FantasyLeaderboardStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyLeaderboardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyLeaderboardStore }, { type: ApiService }] });

let FantasyHistoryStore = class FantasyHistoryStore extends EntityStore {
    constructor() {
        super();
    }
    akitaPreAddEntity(history) {
        if (!history.UniqueIdentifier) {
            return {
                ...history,
                UniqueIdentifier: guid()
            };
        }
        return history;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryStore, providedIn: 'root' }); }
};
FantasyHistoryStore = __decorate([
    StoreConfig({ name: 'fantasy-history', idKey: 'UniqueIdentifier', cache: { ttl: 20000 } })
], FantasyHistoryStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class FantasyHistoryQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Gets a list of selected players for fantasy
     */
    selectAllHistory() {
        return this.selectAll();
    }
    /**
     * Gets a list of selected players for games before a given date
     * @param date the end date
     * @param gameStatuses Only the game statuses supplied will show
     */
    selectHistoryBeforeDate(date, gameStatuses = []) {
        return this.selectAll().pipe(map((items) => {
            return items
                .filter((item) => moment$1.utc(item.EndDate).isBefore(date))
                .filter((item) => {
                if (!gameStatuses || gameStatuses.length === 0) {
                    return true;
                }
                if (gameStatuses.includes(item.Status)) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryQuery, deps: [{ token: FantasyHistoryStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyHistoryStore }] });

class FantasyHistoryService {
    constructor(fantasyHistoryStore, api) {
        this.fantasyHistoryStore = fantasyHistoryStore;
        this.api = api;
    }
    /**
     * Calls the API to fetch fantasy games history and sets the store
     * @param take number of items to select
     */
    fetchFantasyHistory(take = 8) {
        return this.api.get('fantasy/history?take=' + take).pipe(tap(history => this.fantasyHistoryStore.set(history)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryService, deps: [{ token: FantasyHistoryStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyHistoryStore }, { type: ApiService }] });

class FantasyHistoryResolver {
    constructor(fantasyHistoryService) {
        this.fantasyHistoryService = fantasyHistoryService;
    }
    resolve() {
        return this.fantasyHistoryService.fetchFantasyHistory();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryResolver, deps: [{ token: FantasyHistoryService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FantasyHistoryResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: FantasyHistoryService }] });

class MemberCardResolver {
    constructor(memberCardService) {
        this.memberCardService = memberCardService;
    }
    resolve() {
        return this.memberCardService.fetchCard();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardResolver, deps: [{ token: MemberCardService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MemberCardResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberCardService }] });

/** to use
 *  {
 *    path: 'home'
 *    component: HomePageComponent,
 *    canActivate: [ PopulationGuard ]
 *    data: {
 *            exclude: ['vip', 'season ticket'],
 *            popRedirect: ['viphome', 'seasontickethome']
 *          }
 *    OR
 *    data: {
 *            include: ['vip', 'season ticket'],
 *            popRedirect: 'some/page'
 *          }
 *  }
 */
class PopulationGuard {
    constructor(loggingService, memberQuery, populationQuery, populationService, router) {
        this.loggingService = loggingService;
        this.memberQuery = memberQuery;
        this.populationQuery = populationQuery;
        this.populationService = populationService;
        this.router = router;
    }
    fetchDataFromRoute(route) {
        this.exclude = route.data.exclude;
        this.include = route.data.include;
        this.popRedirect = route.data.popRedirect;
        if (!this.popRedirect === undefined || this.popRedirect === null) {
            throw new Error('you must include a redirect');
        }
        if (this.include && this.exclude) {
            throw new Error('either include or exclude populations, not both.');
        }
        if ((!this.include || !this.include.length) && (!this.exclude || !this.exclude.length)) {
            throw new Error(`the population guard for ${route.url} has no populations specified.`);
        }
        if (typeof this.popRedirect !== 'string' && this.include) {
            throw new Error('inclusive population guard can only have one redirect');
        }
        if (typeof this.popRedirect !== 'string' && this.popRedirect.length > 1 && this.popRedirect.length !== this.exclude.length) {
            throw new Error('exclusive population guard needs a redirect for each excluded population or a single redirect for all populations');
        }
    }
    getRedirect() {
        if (typeof this.popRedirect === 'string') {
            return this.router.parseUrl(this.popRedirect);
        }
        else if (this.popRedirect.length === 1) {
            return this.router.parseUrl(this.popRedirect[0]);
        }
        else {
            const userPop = this.memberQuery.getPopulationName();
            if (!userPop) {
                return;
            }
            const redirect = this.popRedirect[this.exclude.indexOf(userPop)];
            return this.router.parseUrl(redirect);
        }
    }
    canActivate(route) {
        this.fetchDataFromRoute(route);
        return this.populationService.fetchPopulations().pipe(switchMap(() => iif(() => !!this.include, of(this.populationQuery.userInPopulation(this.include)), of(this.populationQuery.userNotInPopulation(this.exclude)))), tap((x) => this.loggingService.debug('population guard pass: ', x.toString(), 'population guard type: ', !!this.include ? 'include' : 'exclude')), map((allowed) => {
            if (allowed) {
                return true;
            }
            let redirect = this.getRedirect();
            if (!redirect) {
                return false;
            }
            return redirect;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationGuard, deps: [{ token: LoggingService }, { token: MemberQuery }, { token: PopulationQuery }, { token: PopulationService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationGuard }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PopulationGuard, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LoggingService }, { type: MemberQuery }, { type: PopulationQuery }, { type: PopulationService }, { type: i2.Router }] });

let ProductCodeStore = class ProductCodeStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeStore, providedIn: 'root' }); }
};
ProductCodeStore = __decorate([
    StoreConfig({ name: 'product-code', idKey: 'ProductCode' })
], ProductCodeStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class ProductCodeQuery extends QueryEntity {
    constructor(store, memberCardQuery, memberQuery) {
        super(store);
        this.store = store;
        this.memberCardQuery = memberCardQuery;
        this.memberQuery = memberQuery;
    }
    selectCurrentUserIsProductCode(productCodes) {
        return this.memberCardQuery.selectObservedMemberCard().pipe(map((card) => {
            if (card) {
                return productCodes.map(code => code.toLowerCase().trim()).includes(card.ProductCode.toLowerCase().trim());
            }
            else {
                return false;
            }
        }));
    }
    selectCurrentUserIsNotProductCode(productCodes) {
        return this.memberCardQuery.selectObservedMemberCard().pipe(map((card) => {
            if (card) {
                return !productCodes.map(code => code.toLowerCase().trim()).includes(card.ProductCode.toLowerCase().trim());
            }
            else {
                return false;
            }
        }));
    }
    currentUserIsProductCode(productCodes) {
        const currentCode = this.memberCardQuery.getEntity(this.memberQuery.getUserContext().memberId)?.ProductCode;
        if (!currentCode) {
            return false;
        }
        return productCodes.map(code => code.toLowerCase().trim()).includes(currentCode.toLowerCase().trim());
    }
    currentUserIsNotProductCode(productCodes) {
        return !this.currentUserIsProductCode(productCodes);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeQuery, deps: [{ token: ProductCodeStore }, { token: MemberCardQuery }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ProductCodeStore }, { type: MemberCardQuery }, { type: MemberQuery }] });

class ProductCodeService {
    constructor(productCodeStore, api) {
        this.productCodeStore = productCodeStore;
        this.api = api;
    }
    fetchProductCodes() {
        return this.api.get('productcodes').pipe(tap(codes => this.productCodeStore.set(codes)), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeService, deps: [{ token: ProductCodeStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ProductCodeStore }, { type: ApiService }] });

/** to use
 *  {
 *    path: 'home'
 *    component: HomePageComponent,
 *    canActivate: [ ProductCodeGuard ]
 *    data: {
 *            exclude: ['VIP_1', 'SESN_2'],
 *            codesRedirect: ['viphome', 'seasontickethome']
 *          }
 *    OR
 *    data: {
 *            include: ['VIP_1', 'SESN_2'],
 *            codesRedirect: 'some/page'
 *          }
 *  }
 */
class ProductCodeGuard {
    constructor(loggingService, memberQuery, memberCardQuery, memberCardService, productCodeQuery, productCodeService, router) {
        this.loggingService = loggingService;
        this.memberQuery = memberQuery;
        this.memberCardQuery = memberCardQuery;
        this.memberCardService = memberCardService;
        this.productCodeQuery = productCodeQuery;
        this.productCodeService = productCodeService;
        this.router = router;
    }
    fetchDataFromRoute(route) {
        this.exclude = route.data.excludeCodes;
        this.include = route.data.includeCodes;
        this.codesRedirect = route.data.codesRedirect;
        if (!this.codesRedirect === undefined || this.codesRedirect === null) {
            throw new Error('you must include a redirect');
        }
        if (this.include && this.exclude) {
            throw new Error('either include or exclude product codes, not both.');
        }
        if ((!this.include || !this.include.length) && (!this.exclude || !this.exclude.length)) {
            throw new Error(`the product code guard for ${route.url} has no product codes specified.`);
        }
        if (typeof this.codesRedirect !== 'string' && this.include) {
            throw new Error('inclusive product code guard can only have one redirect');
        }
        if (typeof this.codesRedirect !== 'string' &&
            this.codesRedirect.length > 1 &&
            this.codesRedirect.length !== this.exclude.length) {
            throw new Error('exclusive product code guard needs a redirect for each excluded code or a single redirect for all product codes');
        }
    }
    getRedirect() {
        if (typeof this.codesRedirect === 'string') {
            return this.router.parseUrl(this.codesRedirect);
        }
        else if (this.codesRedirect.length === 1) {
            return this.router.parseUrl(this.codesRedirect[0]);
        }
        else {
            const userPop = this.memberCardQuery.getEntity(this.memberQuery.getUserContext().memberId)?.ProductCode;
            if (!userPop) {
                return undefined;
            }
            const redirect = this.codesRedirect[this.exclude.indexOf(userPop)];
            return this.router.parseUrl(redirect);
        }
    }
    canActivate(route) {
        this.fetchDataFromRoute(route);
        const productCodesFetch$ = this.productCodeService.fetchProductCodes();
        const memberCardFetch$ = this.memberCardService.fetchCard();
        return combineLatest([productCodesFetch$, memberCardFetch$]).pipe(switchMap(() => iif(() => !!this.include, this.productCodeQuery.selectCurrentUserIsProductCode(this.include), this.productCodeQuery.selectCurrentUserIsNotProductCode(this.exclude))), tap((x) => this.loggingService.debug('product code guard pass: ', x.toString(), 'product code guard type: ', !!this.include ? 'include' : 'exclude')), map((allowed) => {
            if (allowed) {
                return true;
            }
            let redirect = this.getRedirect();
            if (!redirect) {
                return false;
            }
            return redirect;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeGuard, deps: [{ token: LoggingService }, { token: MemberQuery }, { token: MemberCardQuery }, { token: MemberCardService }, { token: ProductCodeQuery }, { token: ProductCodeService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeGuard }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ProductCodeGuard, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LoggingService }, { type: MemberQuery }, { type: MemberCardQuery }, { type: MemberCardService }, { type: ProductCodeQuery }, { type: ProductCodeService }, { type: i2.Router }] });

class ClubTagQuery {
    constructor(memberQuery) {
        this.memberQuery = memberQuery;
    }
    selectUserHasTag(lookupTag, checkValue = true) {
        return this.memberQuery
            .select((state) => (state.user ? state.user.customerTags : undefined))
            .pipe(map((userTags) => this.hasTag(lookupTag, userTags, checkValue)));
    }
    selectUserNotHasTag(lookupTag, checkValue = true) {
        return this.selectUserHasTag(lookupTag, checkValue).pipe(map((hasTag) => !hasTag));
    }
    hasTag(lookupTag, userTags, checkValue) {
        if (!userTags || userTags.length === 0 || (!lookupTag.TagId && !lookupTag.TagName)) {
            return false;
        }
        let foundTag;
        if (lookupTag.TagId) {
            foundTag = userTags.find((x) => x.TagId === lookupTag.TagId);
        }
        else {
            foundTag = userTags.find((x) => x.TagName === lookupTag.TagName);
        }
        if (checkValue && foundTag) {
            if (foundTag && foundTag.TagValue === lookupTag.TagValue) {
                return true;
            }
        }
        else {
            if (foundTag) {
                return true;
            }
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ClubTagQuery, deps: [{ token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ClubTagQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ClubTagQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: MemberQuery }] });

let AddressBookStore = class AddressBookStore extends EntityStore {
    constructor() {
        super();
    }
    akitaPreAddEntity(address) {
        if (!address.Id) {
            return {
                ...address,
                Id: Math.floor(Math.random() * -1000000)
            };
        }
        return address;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookStore, providedIn: 'root' }); }
};
AddressBookStore = __decorate([
    StoreConfig({ name: 'address-book', idKey: 'Id', cache: { ttl: 20000 } })
], AddressBookStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class AddressBookQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    // Get all contacts
    selectAllContacts() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookQuery, deps: [{ token: AddressBookStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressBookStore }] });

class AddressBookService {
    constructor(addressBookStore, addressBookQuery, apiService) {
        this.addressBookStore = addressBookStore;
        this.addressBookQuery = addressBookQuery;
        this.apiService = apiService;
    }
    fetchAddressBook() {
        let request$ = this.apiService.get('addressBook').pipe(tap((entities) => this.addressBookStore.set(entities)), mapTo(null));
        return this.addressBookQuery.getHasCache() ? of(null) : request$;
    }
    remove(id) {
        return this.apiService.delete('addressBook', id).pipe(tap(() => this.addressBookStore.remove(id)));
    }
    add(fullName, emailAddress) {
        let contact = { Id: 0, FullName: fullName, EmailAddress: emailAddress };
        if (this.addressBookQuery.getCount((contact) => contact.EmailAddress.trim().toLowerCase() === emailAddress.trim().toLowerCase()) > 0) {
            return throwError('Error: A contact with this email already exists.');
        }
        else {
            return this.apiService.post('addressBook/create', contact).pipe(tap(() => this.addressBookStore.setHasCache(false)), switchMap(() => this.fetchAddressBook()));
        }
    }
    update(contactId, fullName, emailAddress) {
        let contact = { Id: contactId, FullName: fullName, EmailAddress: emailAddress };
        if (contact.FullName === '' || contact.EmailAddress === '') {
            return throwError('Fullname/Email cannot be empty!');
        }
        else {
            if (this.addressBookQuery.getCount((contact) => contact.EmailAddress.trim().toLowerCase() === emailAddress.trim().toLowerCase() && contact.Id !== contactId) > 0) {
                return throwError('Error: A contact with this email already exists.');
            }
            else {
                return this.apiService.put('addressBook', 'save', contact).pipe(tap(() => this.addressBookStore.update(contact.Id, {
                    FullName: contact.FullName,
                    EmailAddress: contact.EmailAddress,
                })));
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookService, deps: [{ token: AddressBookStore }, { token: AddressBookQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressBookStore }, { type: AddressBookQuery }, { type: ApiService }] });

class AddressBookResolver {
    constructor(addressBookService) {
        this.addressBookService = addressBookService;
    }
    resolve() {
        return this.addressBookService.fetchAddressBook();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookResolver, deps: [{ token: AddressBookService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AddressBookResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AddressBookService }] });

var PointProcessType;
(function (PointProcessType) {
    PointProcessType[PointProcessType["Manual"] = 0] = "Manual";
    PointProcessType[PointProcessType["OnEndDate"] = 1] = "OnEndDate";
    PointProcessType[PointProcessType["OnAnswer"] = 2] = "OnAnswer";
})(PointProcessType || (PointProcessType = {}));

var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus[ProcessStatus["Ready"] = 0] = "Ready";
    ProcessStatus[ProcessStatus["Processing"] = 1] = "Processing";
    ProcessStatus[ProcessStatus["Processed"] = 2] = "Processed";
    ProcessStatus[ProcessStatus["Failed"] = 3] = "Failed";
})(ProcessStatus || (ProcessStatus = {}));

var ScorePredictorStatus;
(function (ScorePredictorStatus) {
    ScorePredictorStatus[ScorePredictorStatus["ComingSoon"] = 0] = "ComingSoon";
    ScorePredictorStatus[ScorePredictorStatus["EntryOpen"] = 1] = "EntryOpen";
    ScorePredictorStatus[ScorePredictorStatus["Answered"] = 2] = "Answered";
    ScorePredictorStatus[ScorePredictorStatus["EntryClosedNoAnswer"] = 3] = "EntryClosedNoAnswer";
})(ScorePredictorStatus || (ScorePredictorStatus = {}));

var SurveyListOrderType;
(function (SurveyListOrderType) {
    SurveyListOrderType[SurveyListOrderType["SurveyId"] = 0] = "SurveyId";
    SurveyListOrderType[SurveyListOrderType["Question"] = 1] = "Question";
    SurveyListOrderType[SurveyListOrderType["StartDate"] = 2] = "StartDate";
    SurveyListOrderType[SurveyListOrderType["EndDate"] = 3] = "EndDate";
})(SurveyListOrderType || (SurveyListOrderType = {}));

var SurveyType;
(function (SurveyType) {
    SurveyType[SurveyType["All"] = 0] = "All";
    SurveyType[SurveyType["Survey"] = 1] = "Survey";
    SurveyType[SurveyType["Poll"] = 2] = "Poll";
    SurveyType[SurveyType["Feedback"] = 3] = "Feedback";
    SurveyType[SurveyType["Trivia"] = 4] = "Trivia";
    SurveyType[SurveyType["Predictor"] = 5] = "Predictor";
    SurveyType[SurveyType["ScorePredictor"] = 6] = "ScorePredictor";
})(SurveyType || (SurveyType = {}));
var AnswerType;
(function (AnswerType) {
    AnswerType[AnswerType["Single"] = 0] = "Single";
    AnswerType[AnswerType["Multiple"] = 1] = "Multiple";
})(AnswerType || (AnswerType = {}));
var AnswerDisplayType;
(function (AnswerDisplayType) {
    AnswerDisplayType[AnswerDisplayType["ImageAndText"] = 0] = "ImageAndText";
    AnswerDisplayType[AnswerDisplayType["Image"] = 1] = "Image";
    AnswerDisplayType[AnswerDisplayType["Text"] = 2] = "Text";
})(AnswerDisplayType || (AnswerDisplayType = {}));
var PredictorAnswerType;
(function (PredictorAnswerType) {
    PredictorAnswerType[PredictorAnswerType["None"] = 0] = "None";
    PredictorAnswerType[PredictorAnswerType["Home"] = 1] = "Home";
    PredictorAnswerType[PredictorAnswerType["Away"] = 2] = "Away";
})(PredictorAnswerType || (PredictorAnswerType = {}));

let SurveyStore = class SurveyStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyStore, providedIn: 'root' }); }
};
SurveyStore = __decorate([
    StoreConfig({ name: 'survey', idKey: 'SurveyId', cache: { ttl: 30000 } })
], SurveyStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

const sortByOrdinal = (a, b) => {
    if (a.Ordinal < b.Ordinal) {
        return -1;
    }
    if (a.Ordinal > b.Ordinal) {
        return 1;
    }
    return 0;
};
// @dynamic
let SurveyQuery = class SurveyQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /** All surveys with supplied type and take amount */
    selectSurveys(surveyType, take = Number.MAX_SAFE_INTEGER) {
        return this.selectAll({
            filterBy: (entity) => entity.SurveyType === surveyType,
            limitTo: take,
        });
    }
    /** Select all avalaible surveys of a given type, or empty array if none*/
    selectRelevantSurveys(surveyType) {
        return this.selectAll({
            filterBy: (entity) => entity.SurveyType === surveyType,
        }).pipe(map((surveys) => {
            let returnSurveys = !!surveys.filter((survey) => survey.EndDate > survey.RequestTime).length
                ? surveys.filter((survey) => survey.EndDate > survey.RequestTime)
                : [];
            /** If survey is predictor then only return processed predictors where user has previously answered */
            return surveyType == SurveyType.Predictor
                ? returnSurveys.filter((predictor) => predictor.ProcessStatus !== ProcessStatus.Processed ||
                    (predictor.ProcessStatus == ProcessStatus.Processed && predictor.HasBeenAnsweredByUser))
                : returnSurveys;
        }));
    }
    /** Select featured/favorited surveys */
    selectFavoriteSurvey(surveyType) {
        return this.selectAll({ filterBy: (entity) => entity.SurveyType === surveyType }).pipe(map((surveys) => {
            //** if any favorites are found, return them, else return empty array */
            let returnSurveys = !!surveys.filter((survey) => survey.Favourite == 1 && survey.EndDate > survey.RequestTime).length
                ? surveys.filter((survey) => survey.Favourite == 1 && survey.EndDate > survey.RequestTime)
                : [];
            /** If survey is predictor then only return processed predictors where user has previously answered */
            return surveyType == SurveyType.Predictor
                ? returnSurveys.filter((predictor) => predictor.ProcessStatus !== ProcessStatus.Processed ||
                    (predictor.ProcessStatus == ProcessStatus.Processed && predictor.HasBeenAnsweredByUser))
                : returnSurveys;
        }));
    }
    /** Select latest featured survey */
    selectHomepageSurvey(surveyType) {
        return this.selectFavoriteSurvey(surveyType).pipe(map((surveys) => {
            //** if any favorites are found, return latest, else return empty array */
            let returnSurveys = !!surveys.length
                ? [surveys.sort((a, b) => new Date(b.EndDate).getTime() - new Date(a.EndDate).getTime())[0]]
                : [];
            /** If survey is predictor then only return processed predictors where user has previously answered */
            return surveyType == SurveyType.Predictor
                ? returnSurveys.filter((predictor) => predictor.ProcessStatus !== ProcessStatus.Processed ||
                    (predictor.ProcessStatus == ProcessStatus.Processed && predictor.HasBeenAnsweredByUser))
                : returnSurveys;
        }));
    }
    /** Select score predictors */
    selectScorePredictors() {
        return this.selectRelevantSurveys(SurveyType.ScorePredictor).pipe(map((surveys) => {
            return surveys.filter((x) => {
                let endDate = x.SeparateEntryWindow ? x.EntryEndDate : x.EndDate;
                if (!x.HasBeenAnsweredByUser && x.RequestTime > endDate) {
                    return false;
                }
                return true;
            });
        }), map((surveys) => {
            return surveys.sort((a, b) => {
                if (a.HasBeenAnsweredByUser && b.HasBeenAnsweredByUser) {
                    let entryA = a.StartDate;
                    if (a.SeparateEntryWindow) {
                        entryA = a.EntryStartDate;
                    }
                    let entryB = b.StartDate;
                    if (b.SeparateEntryWindow) {
                        entryB = b.EntryStartDate;
                    }
                    return new Date(entryA).getTime() - new Date(entryB).getTime();
                }
                return a.HasBeenAnsweredByUser ? 1 : -1;
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyQuery, deps: [{ token: SurveyStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyQuery, providedIn: 'root' }); }
};
SurveyQuery = __decorate([
    QueryConfig({ sortBy: sortByOrdinal })
], SurveyQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SurveyStore }] });

class SurveyService {
    constructor(surveyStore, surveyQuery, api) {
        this.surveyStore = surveyStore;
        this.surveyQuery = surveyQuery;
        this.api = api;
    }
    /** Fetches all the surveys and puts them in the store
     * @showAnswered {boolean} show items that have been answered
     * @showComingSoon {boolean} show items that have not started
     * @showEndedItems {boolean} show items passed end date
     * @showOutOfStock {boolean} show out of stock items
     *
     * @returns Survey[]
     */
    fetchAllSurveys(showComingSoon = true, showOutOfStock = true, showEndedItems = true, showAnswered = true) {
        const request$ = this.api
            .get('surveys/withanswers?showComingSoon=' +
            showComingSoon +
            '&showOutOfStock=' +
            showOutOfStock +
            '&showEndedItems=' +
            showEndedItems +
            '&showAnswered=' +
            showAnswered)
            .pipe(tap((surveys) => {
            surveys.forEach((survey) => {
                survey.ShowToUser = !survey.HasBeenAnsweredByUser;
                survey.ShowAtTop = false;
            });
            this.surveyStore.upsertMany(surveys);
        }), mapTo(null));
        return this.surveyQuery.getHasCache() ? of(null) : request$;
    }
    /** Fetches a specific survey (ignoring cache) and puts it in the store. */
    fetchSurveyById(id) {
        const request$ = this.api.getById('surveys', id.toString()).pipe(tap((survey) => {
            this.surveyStore.upsert(id, survey);
        }), mapTo(null));
        return request$;
    }
    /** hide the current question after a specified amount of time */
    hideToUserAfterTimeout(timeoutMs, surveyId) {
        setTimeout(async () => {
            this.surveyStore.update(surveyId, { ShowToUser: false, ShowAtTop: false });
        }, timeoutMs);
    }
    /** Submit an array of survey answers */
    async postSurveyAnswers(surveyId, surveyAnswers) {
        this.surveyStore.update(surveyId, { ShowAtTop: true });
        return await firstValueFrom(this.api
            .postWithArray('surveys/submitanswers', surveyAnswers)
            .pipe(switchMap(() => this.fetchSurveyById(surveyId))));
    }
    async postScorePredictorAnswers(surveyId, scorePredictorAnswers) {
        this.surveyStore.update(surveyId, { ShowAtTop: true });
        return await firstValueFrom(this.api
            .postWithArray('surveys/submitscorepredictor', scorePredictorAnswers)
            .pipe(switchMap(() => this.fetchAllSurveys(true, true, false, true))));
    }
    removeSurvey(surveyId) {
        this.surveyStore.remove(surveyId);
    }
    scorePredictorStatus(survey) {
        if (survey.SeparateEntryWindow) {
            if (survey.RequestTime > survey.EntryStartDate) {
                if (survey.HasBeenAnsweredByUser) {
                    return ScorePredictorStatus.Answered;
                }
                else if (survey.EntryEndDate < survey.RequestTime) {
                    this.removeSurvey(survey.SurveyId);
                }
                else {
                    return ScorePredictorStatus.EntryOpen;
                }
            }
            else {
                return ScorePredictorStatus.ComingSoon;
            }
        }
        else {
            if (survey.RequestTime > survey.StartDate && survey.RequestTime < survey.EndDate) {
                if (survey.HasBeenAnsweredByUser) {
                    return ScorePredictorStatus.Answered;
                }
                else {
                    return ScorePredictorStatus.EntryOpen;
                }
            }
            else {
                if (survey.RequestTime < survey.StartDate) {
                    return ScorePredictorStatus.ComingSoon;
                }
                else if (survey.RequestTime > survey.EndDate) {
                    this.removeSurvey(survey.SurveyId);
                }
            }
        }
        return ScorePredictorStatus.ComingSoon;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyService, deps: [{ token: SurveyStore }, { token: SurveyQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SurveyStore }, { type: SurveyQuery }, { type: ApiService }] });

class SurveyResolver {
    constructor(surveyService) {
        this.surveyService = surveyService;
    }
    resolve() {
        return this.surveyService.fetchAllSurveys(true, true, false, true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyResolver, deps: [{ token: SurveyService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SurveyResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SurveyService }] });

class AuctionBidsResolver {
    constructor(auctionBidService, logService) {
        this.auctionBidService = auctionBidService;
        this.logService = logService;
    }
    resolve() {
        this.logService.info(`Resolving all historical bids`);
        return this.auctionBidService.fetchBids();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidsResolver, deps: [{ token: AuctionBidService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidsResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: AuctionBidsResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AuctionBidService }, { type: LoggingService }] });

var EmailKind;
(function (EmailKind) {
    EmailKind[EmailKind["None"] = 0] = "None";
    EmailKind[EmailKind["RegistrationConfirmation"] = 1] = "RegistrationConfirmation";
    EmailKind[EmailKind["ForgotPassword"] = 2] = "ForgotPassword";
    EmailKind[EmailKind["FeedBackForm"] = 3] = "FeedBackForm";
    EmailKind[EmailKind["SingleTicketTransfer"] = 4] = "SingleTicketTransfer";
    EmailKind[EmailKind["SinglePendingTicket"] = 5] = "SinglePendingTicket";
    EmailKind[EmailKind["MultipleTicketTransfer"] = 6] = "MultipleTicketTransfer";
    EmailKind[EmailKind["MultiplePendingTicket"] = 7] = "MultiplePendingTicket";
    EmailKind[EmailKind["TicketSentConfirmation"] = 8] = "TicketSentConfirmation";
    EmailKind[EmailKind["TicketCallBack"] = 9] = "TicketCallBack";
    EmailKind[EmailKind["TicketConfirmationCallBack"] = 10] = "TicketConfirmationCallBack";
    EmailKind[EmailKind["TopUpConfirmation"] = 11] = "TopUpConfirmation";
    EmailKind[EmailKind["DownloadLinkTicket"] = 12] = "DownloadLinkTicket";
    EmailKind[EmailKind["FamilyTopUpConfirmation"] = 13] = "FamilyTopUpConfirmation";
    EmailKind[EmailKind["ActiveAccountRequest"] = 14] = "ActiveAccountRequest";
    EmailKind[EmailKind["RedmptionTicketCompletionConfirmation"] = 15] = "RedmptionTicketCompletionConfirmation";
    EmailKind[EmailKind["FirstTimeUserComplete"] = 16] = "FirstTimeUserComplete";
    EmailKind[EmailKind["FirstTimeUserCompletedByAnAccountMember"] = 17] = "FirstTimeUserCompletedByAnAccountMember";
    EmailKind[EmailKind["PartnerInviteEmail1"] = 18] = "PartnerInviteEmail1";
    EmailKind[EmailKind["PartnerInviteEmail2"] = 19] = "PartnerInviteEmail2";
    EmailKind[EmailKind["PointsTransferedOut"] = 20] = "PointsTransferedOut";
    EmailKind[EmailKind["PointsTransferdIn"] = 21] = "PointsTransferdIn";
    EmailKind[EmailKind["MultipleTicketConfirmationSent"] = 22] = "MultipleTicketConfirmationSent";
    EmailKind[EmailKind["AutomaticTopUpSuccess"] = 23] = "AutomaticTopUpSuccess";
    EmailKind[EmailKind["AutomaticTopUpFailure"] = 24] = "AutomaticTopUpFailure";
    EmailKind[EmailKind["ResaleSingleTicket"] = 25] = "ResaleSingleTicket";
    EmailKind[EmailKind["ResaleConfirmationSoldEmail"] = 26] = "ResaleConfirmationSoldEmail";
    EmailKind[EmailKind["RewardVoucherEmail"] = 27] = "RewardVoucherEmail";
    EmailKind[EmailKind["Distribution_PendingDistribution"] = 28] = "Distribution_PendingDistribution";
    EmailKind[EmailKind["Distribution_PendingConfirmation"] = 29] = "Distribution_PendingConfirmation";
    EmailKind[EmailKind["Distribution_PendingRejection"] = 30] = "Distribution_PendingRejection";
    EmailKind[EmailKind["Distribution_TicketTransfer"] = 31] = "Distribution_TicketTransfer";
    EmailKind[EmailKind["Distribution_TicketTimeout"] = 32] = "Distribution_TicketTimeout";
    EmailKind[EmailKind["Distribution_TicketCancellation"] = 33] = "Distribution_TicketCancellation";
    EmailKind[EmailKind["PendingPartner_SendPendingRequest"] = 34] = "PendingPartner_SendPendingRequest";
    EmailKind[EmailKind["AuctionWin_Admin"] = 35] = "AuctionWin_Admin";
    EmailKind[EmailKind["AuctionWin_Customer"] = 36] = "AuctionWin_Customer";
    EmailKind[EmailKind["Ticket_DontateTicket"] = 37] = "Ticket_DontateTicket";
    EmailKind[EmailKind["Ticket_DontateTicketSent"] = 38] = "Ticket_DontateTicketSent";
    EmailKind[EmailKind["Customer_RequestAccountTransfer"] = 39] = "Customer_RequestAccountTransfer";
    EmailKind[EmailKind["ResaleMultipleTicket"] = 40] = "ResaleMultipleTicket";
    EmailKind[EmailKind["ParkingTicketCallBack"] = 41] = "ParkingTicketCallBack";
    EmailKind[EmailKind["ParkingTicketTransfer"] = 42] = "ParkingTicketTransfer";
    EmailKind[EmailKind["Resale_OrderCreationConfirmation"] = 43] = "Resale_OrderCreationConfirmation";
    EmailKind[EmailKind["Resale_ChangeResaleTicketChangeConfirmation"] = 44] = "Resale_ChangeResaleTicketChangeConfirmation";
    EmailKind[EmailKind["Resale_ChangeResaleOrderChangeConfirmation"] = 45] = "Resale_ChangeResaleOrderChangeConfirmation";
    EmailKind[EmailKind["Resale_TicketWindowClosed"] = 46] = "Resale_TicketWindowClosed";
    EmailKind[EmailKind["Passbook"] = 47] = "Passbook";
    EmailKind[EmailKind["Resale_InvoiceEmail"] = 48] = "Resale_InvoiceEmail";
    EmailKind[EmailKind["Ticket_MultipleDontateTicket"] = 49] = "Ticket_MultipleDontateTicket";
    EmailKind[EmailKind["Ticket_MultipleDontateTicketSentConfirmation"] = 50] = "Ticket_MultipleDontateTicketSentConfirmation";
    EmailKind[EmailKind["Resale_DeleteOrderGroup"] = 51] = "Resale_DeleteOrderGroup";
    EmailKind[EmailKind["Resale_InvoiceAdminEmail"] = 52] = "Resale_InvoiceAdminEmail";
    EmailKind[EmailKind["Redemtpion_SuiteQuestionaire"] = 53] = "Redemtpion_SuiteQuestionaire";
    EmailKind[EmailKind["RewardUniqCodeEmail"] = 54] = "RewardUniqCodeEmail";
    EmailKind[EmailKind["Auction_SingleNotification"] = 55] = "Auction_SingleNotification";
    EmailKind[EmailKind["Auction_GeneralNotification"] = 56] = "Auction_GeneralNotification";
    EmailKind[EmailKind["Admin_AutomaticTopUpFailure"] = 57] = "Admin_AutomaticTopUpFailure";
    EmailKind[EmailKind["PendingFriend_SendPendingRequest"] = 58] = "PendingFriend_SendPendingRequest";
    EmailKind[EmailKind["PendingFriend_SendFriendCompleteConfirmation"] = 59] = "PendingFriend_SendFriendCompleteConfirmation";
    EmailKind[EmailKind["PendingPartner_SendPartnerCompleteConfirmation"] = 60] = "PendingPartner_SendPartnerCompleteConfirmation";
    EmailKind[EmailKind["LottoWin_Customer"] = 61] = "LottoWin_Customer";
    EmailKind[EmailKind["Reward_DownloadEmail"] = 62] = "Reward_DownloadEmail";
    EmailKind[EmailKind["Reward_EventEmail"] = 63] = "Reward_EventEmail";
    EmailKind[EmailKind["SocialConnection_RemovedAutomatically"] = 64] = "SocialConnection_RemovedAutomatically";
    EmailKind[EmailKind["PasswordChanged"] = 65] = "PasswordChanged";
    EmailKind[EmailKind["ReferAFriend"] = 66] = "ReferAFriend";
    EmailKind[EmailKind["Voucher_SendDepartmentCode"] = 67] = "Voucher_SendDepartmentCode";
    EmailKind[EmailKind["CardPendingPrintRequest"] = 68] = "CardPendingPrintRequest";
    EmailKind[EmailKind["LottoEntry"] = 69] = "LottoEntry";
    EmailKind[EmailKind["ReprintRequest_Confirm"] = 70] = "ReprintRequest_Confirm";
    EmailKind[EmailKind["AccountActivationEmail"] = 71] = "AccountActivationEmail";
    EmailKind[EmailKind["GuardianRegistrationCompleteEmail"] = 72] = "GuardianRegistrationCompleteEmail";
    EmailKind[EmailKind["ReferAFriendCompleteEmail"] = 73] = "ReferAFriendCompleteEmail";
    EmailKind[EmailKind["SocialRegistrationCompleteEmail"] = 74] = "SocialRegistrationCompleteEmail";
})(EmailKind || (EmailKind = {}));

var EmailRequestAttachmentType;
(function (EmailRequestAttachmentType) {
    EmailRequestAttachmentType[EmailRequestAttachmentType["PDF"] = 1] = "PDF";
    EmailRequestAttachmentType[EmailRequestAttachmentType["Image"] = 2] = "Image";
})(EmailRequestAttachmentType || (EmailRequestAttachmentType = {}));
var EmailRequestAttachmentDocumentType;
(function (EmailRequestAttachmentDocumentType) {
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["TicketTransfer"] = 1] = "TicketTransfer";
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["DonationTicket"] = 2] = "DonationTicket";
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["MarketPlace"] = 3] = "MarketPlace";
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["ResaleTicket"] = 4] = "ResaleTicket";
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["ParkingTicket"] = 5] = "ParkingTicket";
    EmailRequestAttachmentDocumentType[EmailRequestAttachmentDocumentType["MarketPlaceDownload"] = 6] = "MarketPlaceDownload";
})(EmailRequestAttachmentDocumentType || (EmailRequestAttachmentDocumentType = {}));
var EmailRequestAttachmentStatus;
(function (EmailRequestAttachmentStatus) {
    EmailRequestAttachmentStatus[EmailRequestAttachmentStatus["WaitingForProcessing"] = 0] = "WaitingForProcessing";
    EmailRequestAttachmentStatus[EmailRequestAttachmentStatus["BeingProcessed"] = 1] = "BeingProcessed";
    EmailRequestAttachmentStatus[EmailRequestAttachmentStatus["Ready"] = 10] = "Ready";
})(EmailRequestAttachmentStatus || (EmailRequestAttachmentStatus = {}));

const EMAIL_TYPE_STATUS_MOCK = [
    {
        EmailTypeId: 1,
        DisplayName: '',
        Description: '',
        Status: 1,
    },
    {
        EmailTypeId: 2,
        DisplayName: '',
        Description: '',
        Status: 2,
    }
];

class MailingService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    /**
     * Send a request to the API to send an Email
     */
    sendEmail(emailModel) {
        return this.apiService.post('emails', emailModel);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MailingService, deps: [{ token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MailingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: MailingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }] });

var CardStatus;
(function (CardStatus) {
    CardStatus[CardStatus["Active"] = 0] = "Active";
    CardStatus[CardStatus["Inactive"] = 1] = "Inactive";
})(CardStatus || (CardStatus = {}));

var PropertyTypeCode;
(function (PropertyTypeCode) {
    PropertyTypeCode[PropertyTypeCode["EMPTY"] = 0] = "EMPTY";
    PropertyTypeCode[PropertyTypeCode["Boolean"] = 1] = "Boolean";
    PropertyTypeCode[PropertyTypeCode["Char"] = 2] = "Char";
    PropertyTypeCode[PropertyTypeCode["Number"] = 3] = "Number";
    PropertyTypeCode[PropertyTypeCode["Decimal"] = 4] = "Decimal";
    PropertyTypeCode[PropertyTypeCode["DateTime"] = 5] = "DateTime";
    PropertyTypeCode[PropertyTypeCode["String"] = 6] = "String";
    PropertyTypeCode[PropertyTypeCode["Gender"] = 7] = "Gender";
    PropertyTypeCode[PropertyTypeCode["Title"] = 8] = "Title";
    PropertyTypeCode[PropertyTypeCode["Country"] = 9] = "Country";
    PropertyTypeCode[PropertyTypeCode["Region"] = 10] = "Region";
    PropertyTypeCode[PropertyTypeCode["PostCode"] = 11] = "PostCode";
    PropertyTypeCode[PropertyTypeCode["DateOfBirth"] = 12] = "DateOfBirth";
    PropertyTypeCode[PropertyTypeCode["DateOfBirthNoYear"] = 13] = "DateOfBirthNoYear";
})(PropertyTypeCode || (PropertyTypeCode = {}));

var ModelDisplay;
(function (ModelDisplay) {
    ModelDisplay[ModelDisplay["Hidden"] = 0] = "Hidden";
    ModelDisplay[ModelDisplay["Full"] = 1] = "Full";
    ModelDisplay[ModelDisplay["Half"] = 2] = "Half";
})(ModelDisplay || (ModelDisplay = {}));

let TenGameClubStore = class TenGameClubStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubStore, providedIn: 'root' }); }
};
TenGameClubStore = __decorate([
    StoreConfig({ name: 'tenGameClub', idKey: 'Id', cache: { ttl: 20000 } })
], TenGameClubStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TenGameClubQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Select all past and present tenGameClubs for the season.
     */
    selectAllTenGameClubs() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubQuery, deps: [{ token: TenGameClubStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TenGameClubStore }] });

class TenGameClubService {
    constructor(tenGameClubStore, api, tenGameClubQuery) {
        this.tenGameClubStore = tenGameClubStore;
        this.api = api;
        this.tenGameClubQuery = tenGameClubQuery;
    }
    fetchTenGameClubs() {
        this.tenGameClubStore.setLoading(true);
        const request$ = this.api.get('events/tengameclubs').pipe(tap(tenGameClubs => this.tenGameClubStore.set(tenGameClubs)), mapTo(null));
        return this.tenGameClubQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubService, deps: [{ token: TenGameClubStore }, { token: ApiService }, { token: TenGameClubQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TenGameClubService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TenGameClubStore }, { type: ApiService }, { type: TenGameClubQuery }] });

class ProductTag {
}

var ProductIntervalPeriodType;
(function (ProductIntervalPeriodType) {
    ProductIntervalPeriodType[ProductIntervalPeriodType["None"] = 0] = "None";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Minute"] = 1] = "Minute";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Hour"] = 2] = "Hour";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Day"] = 3] = "Day";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Week"] = 4] = "Week";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Month"] = 5] = "Month";
    ProductIntervalPeriodType[ProductIntervalPeriodType["Year"] = 6] = "Year";
})(ProductIntervalPeriodType || (ProductIntervalPeriodType = {}));

let PortalProductsStore = class PortalProductsStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsStore, providedIn: 'root' }); }
};
PortalProductsStore = __decorate([
    StoreConfig({ name: 'portal-products', idKey: 'ProductId' })
], PortalProductsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class PortalProductsQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * @deprecated Please use getAllProductsByProductType instead as this should not be an observable
     * Selects a list of portal porducts, filtered by a given product type */
    getProductsByProductType(productType) {
        return this.selectAll({
            filterBy: [entity => entity.ProductType === productType],
        });
    }
    /** Gets a list of portal porducts, filtered by a given product type */
    getAllProductsByProductType(productType, paidForOnly = false) {
        return this.getAll({
            filterBy: [entity => {
                    if (paidForOnly) {
                        return entity.ProductType === productType && entity.MerchantPrice > 0;
                    }
                    else {
                        return entity.ProductType === productType;
                    }
                }],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsQuery, deps: [{ token: PortalProductsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PortalProductsStore }] });

class PortalProductsService {
    constructor(portalProductsStore, portalProductsQuery, api, logService) {
        this.portalProductsStore = portalProductsStore;
        this.portalProductsQuery = portalProductsQuery;
        this.api = api;
        this.logService = logService;
    }
    fetchPortalProducts() {
        this.portalProductsStore.setLoading(true);
        this.logService.info('making call for portal products');
        const request$ = this.api.get('portalproducts').pipe(tap((products) => this.portalProductsStore.set(products)), mapTo(null));
        return this.portalProductsQuery.getHasCache() ? of(null) : request$;
    }
    calculateAdditionalCharges(memberProducts, useMemberDetailsAddress = false, appliedGiftCodes = []) {
        this.logService.info('calculating additional charges');
        let queryString = "";
        memberProducts.forEach((product) => {
            queryString += `productids=${product.ProductId}`;
            if ((memberProducts.indexOf(product) < memberProducts.length - 1) || appliedGiftCodes.length > 0) {
                queryString += "&";
            }
        });
        appliedGiftCodes.forEach((giftCode) => {
            queryString += `appliedgiftcodeids=${giftCode.Id}`;
            if (appliedGiftCodes.indexOf(giftCode) < appliedGiftCodes.length - 1) {
                queryString += "&";
            }
        });
        return this.api.getAnySingle(`portalproducts/additionalcharges?${queryString}&useMemberDetailsAddress=${useMemberDetailsAddress}`);
    }
    purchase(memberProducts, address, appliedGiftCodes, resultUrl = '/portalproducts/result', useMemberDetailsAddress = false, useSubmittedAddress = false) {
        let order = {
            ResultUrl: config.portalUrl + resultUrl,
            MemberProducts: memberProducts,
            Address: address,
            UseMemberDetailsAddress: useMemberDetailsAddress,
            UseSubmittedAddress: useSubmittedAddress,
            GiftCodes: appliedGiftCodes,
        };
        this.logService.debug('Making request for purchases', order);
        return this.api.post('portalproducts/createorder', order);
    }
    callBack(callback) {
        this.logService.debug('Portal Product callback received', callback);
        return this.api.post('portalproducts/result', callback);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsService, deps: [{ token: PortalProductsStore }, { token: PortalProductsQuery }, { token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PortalProductsStore }, { type: PortalProductsQuery }, { type: ApiService }, { type: LoggingService }] });

let PartnerStore = class PartnerStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerStore, providedIn: 'root' }); }
};
PartnerStore = __decorate([
    StoreConfig({ name: 'partner', idKey: 'RelationshipId' })
], PartnerStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class PartnerQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerQuery, deps: [{ token: PartnerStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerStore }] });

class PartnerService {
    constructor(partnerStore, api) {
        this.partnerStore = partnerStore;
        this.api = api;
    }
    fetchPartners() {
        return this.api.get('partners').pipe(tap(entities => {
            this.partnerStore.set(entities);
        }), mapTo(null));
    }
    confirmPartner(partnerCode, partnerSecretCode) {
        return this.api.post('partners/processInvite', { partnerCode, partnerSecretCode }).pipe(switchMapTo(this.fetchPartners()));
    }
    remove(id) {
        return this.api.delete(`partners/remove`, `${id}`).pipe(tap(() => this.partnerStore.remove(id)));
    }
    getPartnerLimit() {
        return this.api
            .getAnySingle('partners/partnerLimit');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerService, deps: [{ token: PartnerStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerStore }, { type: ApiService }] });

class PartnerResolver {
    constructor(partnerService) {
        this.partnerService = partnerService;
    }
    resolve() {
        return this.partnerService.fetchPartners();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerResolver, deps: [{ token: PartnerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerService }] });

let PartnerPendingStore = class PartnerPendingStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingStore, providedIn: 'root' }); }
};
PartnerPendingStore = __decorate([
    StoreConfig({ name: 'partner-pending', idKey: 'TicketKey' })
], PartnerPendingStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class PartnerPendingQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingQuery, deps: [{ token: PartnerPendingStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerPendingStore }] });

class PartnerPendingService {
    constructor(partnerPendingStore, api) {
        this.partnerPendingStore = partnerPendingStore;
        this.api = api;
    }
    fetchPartnersPending() {
        return this.api.get('partners/pending').pipe(tap(entities => {
            this.partnerPendingStore.set(entities);
        }), mapTo(null));
    }
    add(fullName, partnerEmail, comments) {
        return this.api.post('partners/invite', { fullName, partnerEmail, comments })
            .pipe(switchMapTo(this.fetchPartnersPending()));
    }
    remove(ticketKey) {
        return this.api.delete(`partners/delete`, `${ticketKey}`)
            .pipe(tap(this.partnerPendingStore.remove(ticketKey)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingService, deps: [{ token: PartnerPendingStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerPendingStore }, { type: ApiService }] });

class PartnerPendingResolver {
    constructor(partnerPendingService) {
        this.partnerPendingService = partnerPendingService;
    }
    resolve() {
        return this.partnerPendingService.fetchPartnersPending();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingResolver, deps: [{ token: PartnerPendingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PartnerPendingResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PartnerPendingService }] });

let SeatingDetailStore = class SeatingDetailStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailStore, providedIn: 'root' }); }
};
SeatingDetailStore = __decorate([
    StoreConfig({ name: 'seating-details', idKey: 'MemberId' })
], SeatingDetailStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class SeatingDetailQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectCurrentSeatingDetails() {
        return this.selectFirst();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailQuery, deps: [{ token: SeatingDetailStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SeatingDetailStore }] });

class SeatingDetailService {
    constructor(seatingDetailsStore, api, memberQuery) {
        this.seatingDetailsStore = seatingDetailsStore;
        this.api = api;
        this.memberQuery = memberQuery;
    }
    fetchSeatingDetails() {
        const user = this.memberQuery.getUserContext();
        return this.api.getAnySingle(`members/${user.memberId}/seating`).pipe(tap(seatingDetails => this.seatingDetailsStore.set([seatingDetails])), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailService, deps: [{ token: SeatingDetailStore }, { token: ApiService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SeatingDetailStore }, { type: ApiService }, { type: MemberQuery }] });

class SeatingDetailResolver {
    constructor(seatingDetailservice) {
        this.seatingDetailservice = seatingDetailservice;
    }
    resolve() {
        return this.seatingDetailservice.fetchSeatingDetails();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailResolver, deps: [{ token: SeatingDetailService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatingDetailResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: SeatingDetailService }] });

var GiftCodeType;
(function (GiftCodeType) {
    GiftCodeType[GiftCodeType["Order"] = 0] = "Order";
    GiftCodeType[GiftCodeType["Shipping"] = 1] = "Shipping";
    GiftCodeType[GiftCodeType["Product"] = 2] = "Product";
})(GiftCodeType || (GiftCodeType = {}));

var GiftCodeEntitlementValueType;
(function (GiftCodeEntitlementValueType) {
    GiftCodeEntitlementValueType[GiftCodeEntitlementValueType["Value"] = 0] = "Value";
    GiftCodeEntitlementValueType[GiftCodeEntitlementValueType["Percentage"] = 1] = "Percentage";
    GiftCodeEntitlementValueType[GiftCodeEntitlementValueType["NumberOfEntitlements"] = 2] = "NumberOfEntitlements";
})(GiftCodeEntitlementValueType || (GiftCodeEntitlementValueType = {}));

class GiftCodeService {
    constructor(apiService, errorService, authService, memberQuery) {
        this.apiService = apiService;
        this.errorService = errorService;
        this.authService = authService;
        this.memberQuery = memberQuery;
    }
    /**
     * Validate GiftCode for Portal user
     * @param code GiftCode code to validate
     */
    validateGiftCode(code) {
        let portalId = '';
        if (this.authService.isAuthenticated()) {
            portalId = this.memberQuery.getUserContext().portalId;
        }
        return this.apiService.post(`giftCodes/apply?giftCode=${code}&portalId=${portalId}`, {});
    }
    /**
     * Calculates the decuation to be applied to the basket when a GiftCode is used
     * @param giftCode - GiftCode being applied
     * @param productPrice - The price of the products being purchased
     * @param shippingPrice - The shipping price for the order
     * @param totalBasketPrice - The total basket price (inc. tax)
     */
    calculateGiftCodeDeduction(giftCode, productPrice, shippingPrice, totalBasketPrice) {
        this.errorService.clearErrors();
        let discount = 0;
        if (giftCode.GiftCodeAssignType === GiftCodeType.Order) {
            discount = this._getDiscountByEntitlementType(giftCode.EntitlementValueType, giftCode.EntitlementValue, totalBasketPrice);
        }
        else if (giftCode.GiftCodeAssignType === GiftCodeType.Shipping) {
            if (shippingPrice === 0) {
                this.errorService.addError('Gift Code cannot be applied if the shipping is already 0');
                return 0;
            }
            discount = this._getDiscountByEntitlementType(giftCode.EntitlementValueType, giftCode.EntitlementValue, totalBasketPrice, shippingPrice);
        }
        return Math.max(0, totalBasketPrice - discount);
    }
    /**
     * Calculates the basket discount using the entitlementType
     * @param entitlementType - How the GiftCode discounts are applied e.g. by percentage
     * @param entitlementValue - The value associated with the entitlementType - e.g entitlementValue = 70 with entitlementType = Percentage means 70% discount
     * @param totalBasketPrice - Total order price
     * @param amountToDiscountFrom - How much of the order is able to be discounted
     */
    _getDiscountByEntitlementType(entitlementType, entitlementValue, totalBasketPrice, amountToDiscountFrom = 0) {
        let discount = 0;
        switch (entitlementType) {
            // Value
            case GiftCodeEntitlementValueType.Value: {
                discount = amountToDiscountFrom > 0 ? amountToDiscountFrom - entitlementValue : entitlementValue;
                break;
            }
            case GiftCodeEntitlementValueType.Percentage: {
                // Percentage
                let percentageAmount = (entitlementValue / 100) * this._getAmountToDiscount(amountToDiscountFrom, totalBasketPrice);
                discount = amountToDiscountFrom > 0 ? amountToDiscountFrom - percentageAmount : percentageAmount;
                break;
            }
            case GiftCodeEntitlementValueType.NumberOfEntitlements: {
                // Number of Items - Only used for Free
                discount = this._getAmountToDiscount(amountToDiscountFrom, totalBasketPrice);
                break;
            }
            default: {
                this.errorService.addError('Invalid Gift Code');
                break;
            }
        }
        return discount;
    }
    _getAmountToDiscount(amount, totalBasketPrice) {
        return amount > 0 ? amount : totalBasketPrice;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GiftCodeService, deps: [{ token: ApiService }, { token: ErrorStateService }, { token: AuthService }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GiftCodeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GiftCodeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: ErrorStateService }, { type: AuthService }, { type: MemberQuery }] });

var GiftCodeEntitlementPaymentType;
(function (GiftCodeEntitlementPaymentType) {
    GiftCodeEntitlementPaymentType[GiftCodeEntitlementPaymentType["Points"] = 0] = "Points";
    GiftCodeEntitlementPaymentType[GiftCodeEntitlementPaymentType["Ecash"] = 1] = "Ecash";
    GiftCodeEntitlementPaymentType[GiftCodeEntitlementPaymentType["Merchant"] = 2] = "Merchant";
})(GiftCodeEntitlementPaymentType || (GiftCodeEntitlementPaymentType = {}));

var GiftCodeEntitlementType;
(function (GiftCodeEntitlementType) {
    GiftCodeEntitlementType[GiftCodeEntitlementType["Free"] = 0] = "Free";
    GiftCodeEntitlementType[GiftCodeEntitlementType["Discount"] = 1] = "Discount";
})(GiftCodeEntitlementType || (GiftCodeEntitlementType = {}));

var GiftCodeStatus;
(function (GiftCodeStatus) {
    GiftCodeStatus[GiftCodeStatus["Available"] = 0] = "Available";
    GiftCodeStatus[GiftCodeStatus["Pending"] = 1] = "Pending";
    GiftCodeStatus[GiftCodeStatus["Used"] = 2] = "Used";
})(GiftCodeStatus || (GiftCodeStatus = {}));

var GiftCodeUseType;
(function (GiftCodeUseType) {
    GiftCodeUseType[GiftCodeUseType["OnceOnly"] = 0] = "OnceOnly";
    GiftCodeUseType[GiftCodeUseType["PerUser"] = 1] = "PerUser";
    GiftCodeUseType[GiftCodeUseType["NumberOfTimes"] = 2] = "NumberOfTimes";
})(GiftCodeUseType || (GiftCodeUseType = {}));

class ExternalConnect {
    constructor(jwt, provider = ProviderName.TicketMaster, redirectUrl = '') {
        this.jwt = jwt;
        this.providerId = provider;
        this.redirectUrl = redirectUrl;
    }
}

class tmOAuthConfig {
    constructor() {
        this.clientId = '';
        this.club = '';
        this.clientSecret = '';
        this.callBackUri = config.portalUrl + '/ticketmaster/callback';
        this.tokenUri = 'https://app.ticketmaster.com/acctmgr-oauth/token';
        this.loginUri = 'https://am.ticketmaster.com/padres/sso';
        this.authoriseUri = 'https://app.ticketmaster.com/acctmgr-oauth/authorize';
        this.amCookieName = 'am-token';
        this.useCookie = false;
    }
}

class tmAuthConfig {
    constructor() {
        this.clientId = 'd535bb7d3584.fortress.integ3-sandbox.us';
        this.authUri = 'https://auth.ticketmaster.com/archtics/sign-in';
        this.authRedirectUri = config.portalUrl + '/tm-auth-callback';
        this.loginUri = 'https://am.ticketmaster.com/padres/sso';
        this.signOutUri = 'https://auth.ticketmaster.com/archtics/sign-out';
        this.visualPresents = 'LAFC.android.sdk';
        this.integratorId = 'fortress';
        this.placementId = 'homepage';
        this.scope = 'openid profile archtics';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: tmAuthConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: tmAuthConfig, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: tmAuthConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ExternalProviderService {
    constructor(api, errorService, loggingService) {
        this.api = api;
        this.errorService = errorService;
        this.loggingService = loggingService;
    }
    async externalRedirectToProvider(request) {
        this.loggingService.debug('Beginning external redirect', request);
        let response = await this.api.post('provider/ExternalConnect', request)
            .pipe(catchError((err) => {
            this.errorService.clearErrors();
            this.loggingService.error(err.error.toString());
            this.errorService.addError(err.error.toString());
            throw err;
        }), mapTo(null))
            .toPromise();
        return response;
    }
    async generateVideoToken(providerId, meetingNumber) {
        this.loggingService.debug('Generating token', meetingNumber);
        let response = await this.api.post('provider/videoconference/token/' + providerId + '/' + meetingNumber, null).pipe(catchError((err) => {
            this.errorService.clearErrors();
            this.loggingService.error(err.error.toString());
            this.errorService.addError(err.error.toString());
            throw err;
        }))
            .toPromise();
        return response;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalProviderService, deps: [{ token: ApiService }, { token: ErrorStateService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalProviderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ExternalProviderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: ErrorStateService }, { type: LoggingService }] });

class TMOauthService {
    constructor(api, http, cookieService, oauthConfig, memberQuery) {
        this.api = api;
        this.http = http;
        this.cookieService = cookieService;
        this.oauthConfig = oauthConfig;
        this.memberQuery = memberQuery;
        this.oauthConfig = Object.assign({}, new tmOAuthConfig(), oauthConfig);
    }
    /**
     * Use this once the customer has gone from TM back to Fortress to complete the OAuth
     * @param code this is the code that is returned in the url
     */
    callBackToken(code) {
        let params = new URLSearchParams();
        params.append('grant_type', 'authorization_code');
        params.append('client_id', this.oauthConfig.clientId);
        params.append('client_secret', this.oauthConfig.clientSecret);
        params.append('code', code);
        let headers = new HttpHeaders({
            'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        });
        this.http.post(this.oauthConfig.tokenUri, params.toString(), { headers: headers }).subscribe((data) => this._saveToken(data), (err) => {
            alert('Unable to login to Ticket Master');
        });
    }
    /**
     * will return a tm connections from the api
     */
    _getToken() {
        return this.api.getAnySingle('social/' + ProviderName.TicketMaster);
    }
    /**
     * sets the token, if the useCookie is turned on the will set it to the api
     *
     * @param token full token from the response of tm
     */
    _setToken(token) {
        let access_token = token.access_token;
        let refresh_token = token.refresh_token;
        if (this.oauthConfig.useCookie) {
            let expires = token.expires_in;
            let expiresDate = new Date().getTime() + 1000 * expires;
            this.cookieService.set(this.oauthConfig.amCookieName, refresh_token, expiresDate, '/');
        }
        else {
            let memberContext = this.memberQuery.getUserContext();
            let connection = {
                AccessToken: access_token,
                LoginSocialId: 0,
                ProviderId: ProviderName.TicketMaster,
                SocialMembershipId: '',
                Key1: refresh_token,
                Key2: '',
                Username: memberContext.portalId,
                PortalId: memberContext.portalId,
                ClubId: memberContext.clubId,
            };
            this.api.post('social', connection).toPromise();
        }
    }
    _saveToken(token) {
        let access_token = token.access_token;
        this._setToken(token);
        window.location.href = this.oauthConfig.loginUri + '?accessToken=' + access_token + '&redir=myevents';
    }
    loginUsingCurrentToken(refreshToken) {
        let params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('client_id', this.oauthConfig.clientId);
        params.append('client_secret', this.oauthConfig.clientSecret);
        params.append('refresh_token', refreshToken);
        let headers = new HttpHeaders({
            'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        });
        this.http.post(this.oauthConfig.tokenUri, params.toString(), { headers: headers }).subscribe((data) => {
            window.location.href = this.oauthConfig.loginUri + '?accessToken=' + data.access_token + '&redir=myevents';
        }, (err) => {
            this.cookieService.delete(this.oauthConfig.amCookieName, '/');
            alert('Unable to login to Ticket Master');
        });
    }
    /**
     * This is the main starting point of the oauth integration with TM
     */
    authenticate() {
        let redirectUrl = this.oauthConfig.authoriseUri +
            '?client_id=' +
            this.oauthConfig.clientId +
            '&redirect_uri=' +
            this.oauthConfig.callBackUri +
            '&response_type=code';
        if (this.oauthConfig.useCookie) {
            var loginToken = this.cookieService.get(this.oauthConfig.amCookieName);
            if (loginToken != null && loginToken != '') {
                this.loginUsingCurrentToken(loginToken);
            }
            else {
                window.location.href = redirectUrl;
            }
        }
        else {
            this._getToken()
                .pipe(map((x) => {
                if (x != null) {
                    this.loginUsingCurrentToken(x.Key1);
                }
                else {
                    window.location.href = redirectUrl;
                }
            }), catchError((err) => {
                window.location.href = redirectUrl;
                return of([]);
            }))
                .toPromise();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMOauthService, deps: [{ token: ApiService }, { token: i1.HttpClient }, { token: i4$1.CookieService }, { token: tmOAuthConfig }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMOauthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMOauthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: i1.HttpClient }, { type: i4$1.CookieService }, { type: tmOAuthConfig }, { type: MemberQuery }] });

class TMAuthService {
    constructor(http, cookie, errorService, jwtHelper, logService, api, authService, router, tmConfig) {
        this.http = http;
        this.cookie = cookie;
        this.errorService = errorService;
        this.jwtHelper = jwtHelper;
        this.logService = logService;
        this.api = api;
        this.authService = authService;
        this.router = router;
        this.tmConfig = tmConfig;
        this.tmConfig = Object.assign({}, new tmAuthConfig(), tmConfig);
    }
    /**
     * Attempt to login using tm auth
     *
     * @param additionalState any additional information you want returned
     */
    login(additionalState = '') {
        let state = this._createNonce(16) + additionalState;
        let isHttps = false;
        if (this.tmConfig.authRedirectUri && this.tmConfig.authRedirectUri.toUpperCase().indexOf('HTTPS') != -1) {
            isHttps = true;
        }
        this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
        let url = this.tmConfig.authUri +
            '?client_id=' +
            this.tmConfig.clientId +
            '&response_type=&scope=' +
            this.tmConfig.scope +
            '&redirect_uri=' +
            this.tmConfig.authRedirectUri +
            '&visualPresets=' +
            this.tmConfig.visualPresents +
            '&lang=en-us&placementId=' +
            this.tmConfig.placementId +
            '&integratorId=' +
            this.tmConfig.integratorId +
            '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
            state;
        this.windowObjectReference = window.open(url, 'oauth-tm-popup', 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100');
        this.windowObjectReference.focus();
        let authPromise = new Promise((resolve, reject) => {
            const eventMessageFunction = (e) => {
                if (config.portalUrl.toUpperCase().indexOf(e.origin.toUpperCase()) == -1) {
                    this.logService.info('mismatch in urls', config.portalUrl, e.origin);
                    return;
                }
                if (e.data) {
                    resolve(e.data);
                    this.windowObjectReference.close();
                }
                else {
                    this.windowObjectReference.close();
                    reject('Unauthorised');
                }
            };
            window.addEventListener('message', eventMessageFunction, true);
        });
        return authPromise;
    }
    /**
     * Attempt to login using tm auth using redirect process
     *
     * @param additionalState any additional information you want returned
     */
    loginRedirect(additionalState = '') {
        let state = this._createNonce(16) + additionalState;
        let isHttps = false;
        if (this.tmConfig.authRedirectUri && this.tmConfig.authRedirectUri.toUpperCase().indexOf('HTTPS') != -1) {
            isHttps = true;
        }
        this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
        let url = this.tmConfig.authUri +
            '?client_id=' +
            this.tmConfig.clientId +
            '&response_type=&scope=' +
            this.tmConfig.scope +
            '&redirect_uri=' +
            this.tmConfig.authRedirectUri +
            '&visualPresets=' +
            this.tmConfig.visualPresents +
            '&lang=en-us&placementId=' +
            this.tmConfig.placementId +
            '&integratorId=' +
            this.tmConfig.integratorId +
            '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
            state;
        window.location.href = url;
    }
    /**
     * SSO to modern account
     *
     * @param clubId ClubId defaulted to 1
     */
    ssoToModernAccount(clubId = 1) {
        let state = this._createNonce(16);
        let isHttps = false;
        if (this.tmConfig.authRedirectUri && this.tmConfig.authRedirectUri.toUpperCase().indexOf('HTTPS') != -1) {
            isHttps = true;
        }
        this._getToken()
            .pipe(map((x) => {
            if (x != null) {
                let headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                });
                this.http
                    .post(config.baseApiUrl + '/api/sso/oauth/refresh/2/' + x.Key1 + '/' + clubId, null, { headers: headers })
                    .subscribe((data) => {
                    window.location.href = this.tmConfig.loginUri + '?accessToken=' + data.AccessToken + '&redir=myevents';
                }, (errorException) => {
                    this.logService.debug(errorException);
                    let errorMessage = 'unable to complete login';
                    if (errorException.message) {
                        errorMessage = errorException.message;
                    }
                    this.errorService.addError(errorMessage);
                });
            }
            else {
                // show login
                this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
                let url = this.tmConfig.authUri +
                    '?client_id=' +
                    this.tmConfig.clientId +
                    '&response_type=&scope=' +
                    this.tmConfig.scope +
                    '&redirect_uri=' +
                    this.tmConfig.authRedirectUri +
                    '&visualPresets=' +
                    this.tmConfig.visualPresents +
                    '&lang=en-us&placementId=' +
                    this.tmConfig.placementId +
                    '&integratorId=' +
                    this.tmConfig.integratorId +
                    '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
                    state;
                this.windowObjectReference = window.open(url, 'oauth-tm-popup', 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100');
                this.windowObjectReference.focus();
                const eventer = window.addEventListener;
                new Promise((resolve, reject) => {
                    eventer('message', (e) => {
                        if (config.portalUrl.toUpperCase().indexOf(e.origin.toUpperCase()) == -1) {
                            this.logService.info('mismatch in urls', config.portalUrl, e.origin);
                            return;
                        }
                        if (e.data) {
                            resolve(e.data);
                            this.windowObjectReference.close();
                            window.location.href = this.tmConfig.loginUri + '?accessToken=' + e.data.auth.AccessToken + '&redir=myevents';
                        }
                        else {
                            this.windowObjectReference.close();
                            reject('Unauthorised');
                        }
                    }, false);
                });
            }
        }), catchError((err) => {
            this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
            let url = this.tmConfig.authUri +
                '?client_id=' +
                this.tmConfig.clientId +
                '&response_type=&scope=' +
                this.tmConfig.scope +
                '&redirect_uri=' +
                this.tmConfig.authRedirectUri +
                '&visualPresets=' +
                this.tmConfig.visualPresents +
                '&lang=en-us&placementId=' +
                this.tmConfig.placementId +
                '&integratorId=' +
                this.tmConfig.integratorId +
                '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
                state;
            this.windowObjectReference = window.open(url, 'oauth-tm-popup', 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100');
            this.windowObjectReference.focus();
            const eventer = window.addEventListener;
            new Promise((resolve, reject) => {
                eventer('message', (e) => {
                    if (config.portalUrl.toUpperCase().indexOf(e.origin.toUpperCase()) == -1) {
                        this.logService.info('mismatch in urls', config.portalUrl, e.origin);
                        return;
                    }
                    if (e.data) {
                        resolve(e.data);
                        this.windowObjectReference.close();
                        window.location.href = this.tmConfig.loginUri + '?accessToken=' + e.data.auth.AccessToken + '&redir=myevents';
                    }
                    else {
                        this.windowObjectReference.close();
                        reject('Unauthorised');
                    }
                }, false);
            });
            return of([]);
        }))
            .toPromise();
    }
    /**
     * SSO to modern account redirect
     *
     * @param clubId ClubId defaulted to 1
     */
    ssoToModernAccountRedirect(clubId = 1) {
        let state = this._createNonce(16) + 'O';
        let isHttps = false;
        if (this.tmConfig.authRedirectUri && this.tmConfig.authRedirectUri.toUpperCase().indexOf('HTTPS') != -1) {
            isHttps = true;
        }
        this._getToken()
            .pipe(map((x) => {
            if (x != null) {
                let headers = new HttpHeaders({
                    'Content-Type': 'application/json',
                });
                this.http
                    .post(config.baseApiUrl + '/api/sso/oauth/refresh/2/' + x.Key1 + '/' + clubId, null, { headers: headers })
                    .subscribe((data) => {
                    window.location.href = this.tmConfig.loginUri + '?accessToken=' + data.AccessToken + '&redir=myevents';
                }, (errorException) => {
                    this.logService.debug(errorException);
                    let errorMessage = 'unable to complete login';
                    if (errorException.message) {
                        errorMessage = errorException.message;
                    }
                    this.errorService.addError(errorMessage);
                });
            }
            else {
                // show login
                this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
                let url = this.tmConfig.authUri +
                    '?client_id=' +
                    this.tmConfig.clientId +
                    '&response_type=&scope=' +
                    this.tmConfig.scope +
                    '&redirect_uri=' +
                    this.tmConfig.authRedirectUri +
                    '&visualPresets=' +
                    this.tmConfig.visualPresents +
                    '&lang=en-us&placementId=' +
                    this.tmConfig.placementId +
                    '&integratorId=' +
                    this.tmConfig.integratorId +
                    '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
                    state;
                window.location.href = url;
            }
        }), catchError((err) => {
            this.cookie.set('tm-state', state, undefined, '/', undefined, isHttps, undefined);
            let url = this.tmConfig.authUri +
                '?client_id=' +
                this.tmConfig.clientId +
                '&response_type=&scope=' +
                this.tmConfig.scope +
                '&redirect_uri=' +
                this.tmConfig.authRedirectUri +
                '&visualPresets=' +
                this.tmConfig.visualPresents +
                '&lang=en-us&placementId=' +
                this.tmConfig.placementId +
                '&integratorId=' +
                this.tmConfig.integratorId +
                '&intSiteToken=tm1-us&hideLeftPanel=false&state=' +
                state;
            window.location.href = url;
            return of([]);
        }))
            .toPromise();
    }
    /**
     * Log out of the portal and provider (TM).
     * Passes provider tokens and provider ID
     * to logout for the logout endpoint
     * with portal provider details.
     */
    logout() {
        let providerTokens = {};
        providerTokens.accessToken = localStorage.getItem('TMAccessToken');
        localStorage.removeItem('TMRefreshToken');
        localStorage.removeItem('TMAccessToken');
        return this.authService.logout(ProviderName.TicketMaster, providerTokens);
    }
    /**
     * Will process the auth response
     *
     * @param code the code from the authentication process
     * @param state the state that is sent in the inital request
     */
    authCallback(code, state, clubId = 1) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        let openerLocation = window.opener?.location.href ?? '';
        let callbackSubscription = this.http
            .post(config.baseApiUrl + '/api/sso/oauth/2/' + code + '/' + clubId, null, { headers: headers })
            .subscribe((data) => {
            let cookieState = this.cookie.get('tm-state');
            if (state !== cookieState) {
                window.opener?.postMessage({ error: 'invalid state' }, openerLocation);
            }
            else {
                window.opener?.postMessage(data, openerLocation);
            }
            // set provider access and refresh token in local storage
            localStorage.setItem('TMRefreshToken', data.auth.RefreshToken.toString());
            localStorage.setItem('TMAccessToken', data.auth.AccessToken.toString());
            callbackSubscription.unsubscribe();
        }, (errorException) => {
            let errorMessage = 'unable to complete callback';
            if (errorException.message) {
                errorMessage = errorException.message;
            }
            this.logService.debug(errorException);
            this.errorService.addError(errorMessage);
            window.opener?.postMessage({ error: errorMessage }, openerLocation);
            callbackSubscription.unsubscribe();
        });
    }
    /**
     * Will process the auth response
     *
     * Direction 0 and 1 for Login, 2 for Registration
     *
     * @param code the code from the authentication process
     * @param state the state that is sent in the inital request
     */
    authCallbackRedirect(code, state, clubId = 1, redirectUrl = '/', registrationUrl = '/register/provideroauth', chooseRegUrl = '/login') {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        let cookieState = this.cookie.get('tm-state');
        let stateSplit = state.split('_');
        let direction = 0;
        if (stateSplit.length > 1) {
            if (stateSplit[1] === 'O') {
                direction = 1;
            }
            else if (stateSplit[1] === 'R') {
                direction = 2;
            }
        }
        let callbackSubscription = this.http
            .post(config.baseApiUrl + '/api/sso/oauth/2/' + code + '/' + clubId, null, { headers: headers })
            .subscribe((data) => {
            if (state !== cookieState) {
                this.router.navigate(['/login']);
                this.logService.debug('invalid state');
            }
            else {
                if (direction == 0) {
                    // login page
                    if (data.tokens && data.tokens.AccessToken) {
                        // set provider access and refresh token in local storage
                        localStorage.setItem('TMRefreshToken', data.auth.RefreshToken.toString());
                        localStorage.setItem('TMAccessToken', data.auth.AccessToken.toString());
                        callbackSubscription.unsubscribe();
                        this.authService.loginUsingToken(data.tokens.AccessToken, data.tokens.RefreshToken, redirectUrl);
                    }
                    else {
                        // User doesn't exist within fortress, redirect to chooseRegUrl
                        callbackSubscription.unsubscribe();
                        this.router.navigate([chooseRegUrl]);
                    }
                }
                else if (direction == 2) {
                    // registration page
                    callbackSubscription.unsubscribe();
                    this.router.navigateByUrl(registrationUrl, { state: { AccountNumber: data.auth.AccountNumber } });
                }
                else {
                    // to mordern account
                    if (data.tokens && data.tokens.AccessToken) {
                        callbackSubscription.unsubscribe();
                        window.location.href = this.tmConfig.loginUri + '?accessToken=' + data.auth.AccessToken + '&redir=myevents';
                    }
                    else {
                        callbackSubscription.unsubscribe();
                        this.router.navigate(['/']);
                        this.logService.debug('not valid token');
                    }
                }
            }
        }, (errorException) => {
            let errorMessage = 'unable to complete callback';
            if (errorException.message) {
                errorMessage = errorException.message;
            }
            this.logService.debug(errorException);
            this.errorService.addError(errorMessage);
            callbackSubscription.unsubscribe();
            if (direction == 0) {
                this.router.navigate(['/login']);
            }
            else {
                this.router.navigate(['/']);
            }
        });
    }
    /**
     * will return a tm connections from the api
     */
    _getToken() {
        return this.api.getAnySingle('social/' + ProviderName.TicketMaster);
    }
    /**
     * Create a nonce for the state
     *
     * @param length length of the nonce
     */
    _createNonce(length) {
        let charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-.';
        let result = '';
        while (length > 0) {
            var bytes = new Uint8Array(16);
            var random = window.crypto.getRandomValues(bytes);
            random.forEach(function (c) {
                if (length == 0) {
                    return;
                }
                if (c < charset.length) {
                    result += charset[c];
                    length--;
                }
            });
        }
        return result + '_';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMAuthService, deps: [{ token: i1.HttpClient }, { token: i4$1.CookieService }, { token: ErrorStateService }, { token: i4.JwtHelperService }, { token: LoggingService }, { token: ApiService }, { token: AuthService }, { token: i2.Router }, { token: tmAuthConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TMAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i4$1.CookieService }, { type: ErrorStateService }, { type: i4.JwtHelperService }, { type: LoggingService }, { type: ApiService }, { type: AuthService }, { type: i2.Router }, { type: tmAuthConfig }] });

class UrbanZooAuthService {
    /**
     * Create a instance of the urban zoo integration
     * @param http http client used to make api calls
     * @param cookie cookie client used to read cookie data
     * @param authService auth services used to help with logging the customer into the portal
     * @param logService log service used to output information to the console
     */
    constructor(http, cookie, authService, logService) {
        this.http = http;
        this.cookie = cookie;
        this.authService = authService;
        this.logService = logService;
        if (this.settings === undefined) {
            let urbanZooConfig = config.providerSettings.find((x) => x.providerId === ProviderName.UrbanZoo);
            if (urbanZooConfig != undefined && urbanZooConfig.settings != undefined) {
                this.settings = urbanZooConfig.settings;
            }
        }
        if (this.settings.ApplicationId == undefined) {
            this.logService.warning('application Id is currently not in the config file');
        }
    }
    /**
     * This method will check to ensure that the customer has the required tokens on the machine. First it will check that the customer will have the LastAuthUser then the Id token.
     *
     * This method will not check the that the token is valid
     *
     * @example
     * if (!this.urbanZooAuthService.isUserLoggedIn() && !this.authService.isAuthenticated()) {
     *  if (!this.urbanZooAuthService.isTokenInHeader()) {
     *      this.urbanZooAuthService.login("http://localhost:4200");
     *  }
     *  this.urbanZooAuthService.validateJWT();
     *  }
     * }
     */
    isUserLoggedIn() {
        let applicationId = this.settings.ApplicationId;
        let lastAuthUser = this.cookie.get('CognitoIdentityServiceProvider.' + applicationId + '.LastAuthUser');
        if (lastAuthUser == undefined || lastAuthUser == '') {
            this.logService.info('unable to find the lastUser token');
            return false;
        }
        let idToken = this.cookie.get('CognitoIdentityServiceProvider.' + applicationId + '.' + lastAuthUser + '.idToken');
        if (idToken == undefined || idToken == '') {
            this.logService.info('unable to find the id token');
            return false;
        }
        return true;
    }
    /**
     * This is used to determine if the required header is in the query to auto login
     *
     * @returns Whether the token is in the query string
     */
    isTokenInHeader() {
        let jwtToken = this.getQueryString('token', '');
        if (jwtToken != '' && jwtToken != undefined) {
            return true;
        }
        return false;
    }
    /**
     * This method will look at the header for a token or read the cookies set by urban zoo then push the information to the apis for validation.
     *
     * If API call retuens status 200, tokens are set and observable value of true is returned. else, observable value of false returned.
     * @example
     * validateJWT()
     */
    validateJWT() {
        if (this.authService.hasAccessToken()) {
            return of(true);
        }
        let token = '';
        let jwtToken = this.getQueryString('token', '');
        if (jwtToken != '' && jwtToken != undefined) {
            token = jwtToken;
        }
        else {
            let applicationId = this.settings.ApplicationId;
            let lastAuthUser = this.cookie.get('CognitoIdentityServiceProvider.' + applicationId + '.LastAuthUser');
            if (lastAuthUser == undefined || lastAuthUser == '') {
                this.logService.info('unable to find the lastUser token');
                return of(false);
            }
            let idToken = this.cookie.get('CognitoIdentityServiceProvider.' + applicationId + '.' + lastAuthUser + '.idToken');
            if (idToken == undefined || idToken == '') {
                this.logService.info('unable to find the id token');
                return of(false);
            }
            token = idToken;
        }
        let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(`${config.baseApiUrl}/api/sso/JWT/validate/57/1`, `"${token}"`, { headers: headersList }).pipe(tap((authResponse) => {
            if (authResponse) {
                const accessToken = authResponse.tokens.AccessToken;
                this.authService.loginUsingToken(accessToken, authResponse.tokens.RefreshToken, '/');
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Will direct the customer to the urban zoo main website for the customer to change their password
     *
     * @example
     * urbanZooAuthService.changePassword(redirectUrl);
     *
     * @param returnUrl The url where once the process is completed the customer should return
     */
    changePassword(returnUrl) {
        window.location.href = this.settings.WebsiteUrl + '/?returnUrl=' + returnUrl;
    }
    /**
     * Will direct the customer to the urban zoo main website for the customer to login
     *
     * @param returnUrl The url where once the process is completed the customer should return
     */
    login(returnUrl) {
        window.location.href = this.settings.WebsiteUrl + '/?returnUrl=' + returnUrl;
    }
    /**
     * Get a query string parameter without case sensitivity.
     * @param parameter the parameter that you require the information for
     * @param defaultValue the value to return if no parameter is found
     */
    getQueryString(parameter, defaultValue) {
        const url = window.location.href;
        let paramValue;
        if (url.includes('?')) {
            const httpParams = new HttpParams({ fromString: url.split('?')[1] });
            paramValue = httpParams.get(parameter);
        }
        if (paramValue) {
            return paramValue;
        }
        return '';
    }
    /**
     * Deletes all urban zoo specific cookies for a given domain to log user out
     * @param domain domain to delete cookies from
     */
    deleteUrbanZooCookies(domain) {
        const applicationId = this.settings.ApplicationId;
        const lastAuthUser = this.cookie.get('CognitoIdentityServiceProvider.' + applicationId + '.LastAuthUser');
        if (lastAuthUser) {
            this.cookie.delete('CognitoIdentityServiceProvider.' + applicationId + '.' + lastAuthUser + '.idToken', '/', domain);
            this.cookie.delete('CognitoIdentityServiceProvider.' + applicationId + '.' + lastAuthUser + '.accessToken', '/', domain);
            this.cookie.delete('CognitoIdentityServiceProvider.' + applicationId + '.' + lastAuthUser + '.clockDrift', '/', domain);
            this.cookie.delete('CognitoIdentityServiceProvider.' + applicationId + '.LastAuthUser', '/', domain);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UrbanZooAuthService, deps: [{ token: i1.HttpClient }, { token: i4$1.CookieService }, { token: AuthService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UrbanZooAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UrbanZooAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i4$1.CookieService }, { type: AuthService }, { type: LoggingService }] });

class SAPAuthService {
    /**
     * Create a instance of the sap integration
     */
    constructor(http, authService, logService, zone, router) {
        this.http = http;
        this.authService = authService;
        this.logService = logService;
        this.zone = zone;
        this.router = router;
        if (this.settings === undefined) {
            let SAPConfig = config.providerSettings.find((x) => x.providerId === ProviderName.SAP);
            if (SAPConfig != undefined && SAPConfig.settings != undefined) {
                this.settings = SAPConfig.settings;
            }
        }
        if (this.settings.LoginScreenSet == undefined) {
            this.logService.warning('Login screen set is currently not in the config file');
        }
    }
    /**
     * This process will either log the customer in or show the login screen
     */
    login() {
        if (this.authService.hasAccessToken()) {
            return;
        }
        gigya.accounts.getAccountInfo({
            callback: (result) => {
                if (result.errorCode === 0) {
                    let token = result.UID;
                    let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });
                    this.zone.run(() => {
                        this.http
                            .post(`${config.baseApiUrl}/api/sso/JWT/validate/58/1`, `"${token}"`, { headers: headersList })
                            .pipe(tap((authResponse) => {
                            if (authResponse) {
                                const accessToken = authResponse.tokens.AccessToken;
                                this.authService.loginUsingToken(accessToken, authResponse.tokens.RefreshToken, '/');
                            }
                        }))
                            .toPromise();
                    });
                }
                else {
                    this.showLoginDialog();
                }
            },
        });
    }
    /**
     * Will show a login dialog screen and when the customer enters a valid username and password will attempt to log the customer in
     */
    showLoginDialog() {
        gigya.accounts.showScreenSet({
            screenSet: 'inviqa-v1-RegistrationLogin',
            authFlow: 'redirect',
            onHide: (result) => {
                if (result.reason == 'finished') {
                    if (result.user == null) {
                        this.logService.warning('no profile');
                        return;
                    }
                    let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });
                    this.zone.run(() => {
                        this.http
                            .post(`${config.baseApiUrl}/api/sso/JWT/validate/58/1`, `'${result.user.UID.toString()}'`, {
                            headers: headersList,
                        })
                            .pipe(tap((authResponse) => {
                            if (authResponse) {
                                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken);
                            }
                        }))
                            .toPromise()
                            .then(() => {
                            this.router.navigate(['/']);
                        });
                    });
                }
            },
        });
    }
    /**
     * Will check the the user is logged into sap if they customer is logged in then we will try and log them into the portal
     */
    logUserInIfLoggedInSAP() {
        gigya.accounts.getAccountInfo({
            callback: (result) => {
                if (result.errorCode === 0) {
                    let token = result.UID;
                    let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });
                    this.zone.run(() => {
                        this.http
                            .post(`${config.baseApiUrl}/api/sso/JWT/validate/58/1`, `"${token}"`, { headers: headersList })
                            .pipe(tap((authResponse) => {
                            if (authResponse) {
                                const accessToken = authResponse.tokens.AccessToken;
                                this.authService.loginUsingToken(accessToken, authResponse.tokens.RefreshToken, '/');
                            }
                        }))
                            .toPromise();
                    });
                }
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SAPAuthService, deps: [{ token: i1.HttpClient }, { token: AuthService }, { token: LoggingService }, { token: i0.NgZone }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SAPAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SAPAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AuthService }, { type: LoggingService }, { type: i0.NgZone }, { type: i2.Router }] });

Injectable({
    providedIn: 'root'
});
class IncrowdAuthService {
    /**
     * Create a instance of the Incrowd integration
     */
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
        if (this.settings === undefined) {
            let IncrowdConfig = config.providerSettings.find(x => x.providerId === ProviderName.Incrowd);
            if (IncrowdConfig != undefined && IncrowdConfig.settings != undefined) {
                this.settings = IncrowdConfig.settings;
            }
        }
    }
    /**
     * Will check the the user is logged into Incrowd if they customer is logged in then we will try and log them into the portal
     */
    logUserInIfLoggedInIncrowd() {
        let token = ''; // need to get this data 
        let headersList = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.http.post(`${config.baseApiUrl}/api/sso/JWT/validate/56/1`, `"${token}"`, { headers: headersList })
            .pipe(tap((authResponse) => {
            if (authResponse) {
                const accessToken = authResponse.tokens.AccessToken;
                this.authService.loginUsingToken(accessToken, authResponse.tokens.RefreshToken, "/");
            }
        })).toPromise();
    }
    /**
    * Will log the customer out of Incrowd as well as the portal
    */
    logout() {
        let providerTokens = {};
        providerTokens.accessToken = ''; // need to get this data
        return this.authService.logout(ProviderName.Incrowd, providerTokens);
    }
}

class SportsAllianceAuthService {
    constructor(authService, logService, api, cookieService) {
        this.authService = authService;
        this.logService = logService;
        this.api = api;
        this.cookieService = cookieService;
        if (this.settings === undefined) {
            let sportsAllianceConfig = config.providerSettings.find((x) => x.providerId === ProviderName.SportsAlliance);
            if (sportsAllianceConfig != undefined && sportsAllianceConfig.settings != undefined) {
                this.settings = sportsAllianceConfig.settings;
            }
        }
        if (this.settings.tenantId == undefined) {
            this.logService.warning('tenant Id is currently not in the config file');
        }
    }
    /**
     * Attempt to login using sports alliance using redirect process.
     * This will call an endpoint to generate the login URL,
     * depending on the parameters passed.
     * This can also be used for registration, handled by the parameters passed.
     * @param returnVisitPath path for previous page button within SA login page,
     * e.g. /login (which is the default value)
     * @param successredirectPath redirect path after successfully authenticated
     * e.g. /sa-callback (which is the default value)
     * @param mandatoryReg Enforces mandatory registration mode in which
     * users must register a full account rather than a lite or social account.
     * @param ssoMode ssoMode for URL, 0 = login, 1 = registration,
     * 2 = external login
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     */
    login(returnVisitPath = '/login', successredirectPath = '/sa-callback', mandatoryReg = false, ssoMode = '0', clubId = 1) {
        this.settings.returnVisitUrl = config.portalUrl + returnVisitPath;
        this.settings.successDirectUrl = config.portalUrl + successredirectPath;
        this.settings.mandatoryReg = mandatoryReg;
        this.settings.ssoMode = ssoMode;
        const loginUrlParameters = this.generateLoginParameters();
        return this.api.post(`sso/JWT/GenerateUrl/${ProviderName.SportsAlliance}/${clubId}`, loginUrlParameters).pipe(tap((generatedUrl) => {
            window.location.href = generatedUrl;
        }));
    }
    /**
     * This method will generate the login
     * URL for sports alliance from the defined
     * settings, when login has been attempted.
     *
     * @returns array of parameters required
     * to generate the Sports Alliance
     * login URL of type InputField.
     */
    generateLoginParameters() {
        let generateLoginParams = [];
        if (this.settings.returnVisitUrl) {
            let returnVisitParam = {
                FieldName: 'ReturnVisitorUrl',
                InputType: InputType.Text,
                Active: true,
                Value: this.settings.returnVisitUrl,
                ErrorMessage: '',
            };
            generateLoginParams.push(returnVisitParam);
        }
        if (this.settings.successDirectUrl) {
            let successDirectParam = {
                FieldName: 'SuccessUrl',
                InputType: InputType.Text,
                Active: true,
                Value: this.settings.successDirectUrl,
                ErrorMessage: '',
            };
            generateLoginParams.push(successDirectParam);
        }
        if (this.settings.tenantId) {
            let tenantIdParam = {
                FieldName: 'Externaltenantid',
                InputType: InputType.Text,
                Active: true,
                Value: this.settings.tenantId,
                ErrorMessage: '',
            };
            generateLoginParams.push(tenantIdParam);
        }
        let mandatoryRegValue = 'false';
        if (this.settings.mandatoryReg) {
            mandatoryRegValue = 'true';
        }
        let manadatoryRegParam = {
            FieldName: 'Mandatory',
            InputType: InputType.Text,
            Active: true,
            Value: mandatoryRegValue,
            ErrorMessage: '',
        };
        generateLoginParams.push(manadatoryRegParam);
        if (this.settings.ssoMode) {
            let ssoModeParam = {
                FieldName: 'SSOMode',
                InputType: InputType.Text,
                Active: true,
                Value: this.settings.ssoMode,
                ErrorMessage: '',
            };
            generateLoginParams.push(ssoModeParam);
        }
        return generateLoginParams;
    }
    /**
     * This method is used to authenticate a token
     * that comes back from the Sports Alliance login page
     * and log the user in via the tokens returned
     * from the response.
     * @param jwtToken JWT Token returned from
     * Sports Alliance, to be authenticated and
     * passed to given endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    validateJwt(jwtToken, clubId = 1) {
        if (this.authService.hasAccessToken()) {
            return of(true);
        }
        let token = '';
        if (jwtToken != '' && jwtToken != undefined) {
            token = jwtToken;
        }
        return this.api.post(`sso/JWT/Validate/${ProviderName.SportsAlliance}/${clubId}`, `"${token}"`).pipe(tap((authResponse) => {
            if (authResponse) {
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
                localStorage.setItem('SARefreshToken', authResponse.auth.ProviderRefreshToken.toString());
                localStorage.setItem('SAAccessToken', authResponse.auth.ProviderAccessToken.toString());
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Log out of the portal and provider (Sports Alliance).
     * Passes provider tokens and provider ID
     * to logout for the logout endpoint
     * with portal provider details.
     */
    logout() {
        let providerTokens = {};
        providerTokens.providerRefreshToken = localStorage.getItem('SARefreshToken');
        providerTokens.providerAccessToken = localStorage.getItem('SAAccessToken');
        localStorage.removeItem('SARefreshToken');
        localStorage.removeItem('SAAccessToken');
        return this.authService.logout(ProviderName.SportsAlliance, providerTokens);
    }
    /**
     * This method is used to authenticate a domain
     * token used from the _sa_sso_upid cookie given
     * from Sports Alliance domain and log the user
     * using tokens returned.
     * @param domainCookie domain cookie to be
     * authenticated and passed to endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    loginUsingToken(domainCookie, clubId = 1) {
        let saDomainCookie = '';
        if (domainCookie != '' && domainCookie != undefined) {
            saDomainCookie = domainCookie;
        }
        return this.api.get(`sso/OAuth/${ProviderName.SportsAlliance}/${saDomainCookie}/${clubId}`).pipe(tap((authResponse) => {
            if (authResponse) {
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
                localStorage.setItem('SARefreshToken', authResponse.auth.RefreshToken.toString());
                localStorage.setItem('SAAccessToken', authResponse.auth.AccessToken.toString());
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Check if a named cookie exists.
     * @param cookieName cookie name to be checked.
     * @returns boolean value depending if cookie name
     * exists.
     */
    hasNamedCookie(cookieName) {
        if (this.cookieService.check(cookieName)) {
            return true;
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SportsAllianceAuthService, deps: [{ token: AuthService }, { token: LoggingService }, { token: ApiService }, { token: i4$1.CookieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SportsAllianceAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SportsAllianceAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AuthService }, { type: LoggingService }, { type: ApiService }, { type: i4$1.CookieService }] });

/**
 * @example
 * providerSettings : [{
 *    providerId : 60,
 *    settings : {
 *        tenantId : "UKRTGHgYr0CNWMEXbYy_3Q",
 *    }
 * }]
 *
 * @description
 * This is all the settings tha comes from the config.js file
 * and also set within the login or registration process
 */
class SportsAllianceSettings {
}

class FidelService {
    /**
     * Create a instance of the fidel integration
     */
    constructor(api, logService) {
        this.api = api;
        this.logService = logService;
        if (this.settings === undefined) {
            let FidelConfig = config.providerSettings.find((x) => x.providerId === ProviderName.Fidel);
            if (FidelConfig != undefined && FidelConfig.settings != undefined) {
                this.settings = FidelConfig.settings;
            }
        }
        if (this.settings.ProgramId == undefined) {
            this.logService.warning('program set is currently not in the config file');
        }
    }
    /**
     * Invoke the link card process on fidel so the customer can attach their card
     *
     * @param memberId the member of the customer, used to mark the card in fidel to be used to retrive the information
     * @param custom this allows the developer to overwrite the styling. https://fidel.uk/docs/web-sdk/v3
     * @param callbacks holds the success and failed callback when linking a card
     */
    linkcard(memberId, custom = {}, countries, callbacks = undefined) {
        if (memberId.length <= 5) {
            let fillNumber = 5 - memberId.length;
            for (var i = 0; i < fillNumber; i++) {
                memberId = '0' + memberId;
            }
        }
        Fidel.openForm({
            companyName: 'Fortress',
            sdkKey: this.settings.SdkKey,
            programId: this.settings.ProgramId,
            metadata: {
                id: memberId,
                applicationId: this.settings.ApplicationId,
            },
            custom,
            countries: countries,
            callback() {
                if (arguments.length == 1) {
                    // failed response
                    if (callbacks != undefined) {
                        callbacks.callbackFailed(arguments[0]);
                    }
                }
                else {
                    // card linked
                    if (callbacks != undefined) {
                        callbacks.callbackSuccess(arguments[1]);
                    }
                }
            },
        });
    }
    /**
     * Deletes the card from fidel
     *
     * @param cardId the fidel card unique identifier
     *
     * @returns success if completed with no errors
     * */
    deletecard(cardId) {
        return this.api.delete(`provider/63/deletelinkedcards`, cardId);
    }
    /**
     * Get the cards from fidel
     *
     * @returns A list of cards for the current customer
     */
    getcards() {
        return this.api.get(`provider/63/getlinkedcards`);
    }
    /**
     * Will get all the offers for the current customer
     *
     * @param cardId the fidel card unique identifier (if no card pass in 'card')
     *
     * @returns all the offers
     */
    getOffers(cardId) {
        return this.api.get(`provider/63/getlinkedoffers/${cardId}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelService, deps: [{ token: ApiService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: LoggingService }] });

function LoadScripts(dynamicScripts) {
    const promises = [];
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < dynamicScripts.length; i++) {
        const promise = new Promise((res) => {
            let isFound = false;
            for (let j = 0; j < scripts.length; ++j) {
                let src = scripts[j].getAttribute('src');
                if (src != null && src.startsWith(dynamicScripts[i].src)) {
                    isFound = true;
                    break;
                }
            }
            if (isFound) {
                res();
            }
            else {
                const node = document.createElement('script');
                node.src = dynamicScripts[i].src;
                node.type = 'text/javascript';
                node.async = false;
                node.onload = () => res();
                node.onerror = () => res();
                (dynamicScripts[i].attrs || []).forEach((attr) => node.setAttribute(attr.name, attr.value));
                document.getElementsByTagName('head')[0].appendChild(node);
            }
        });
        promises.push(promise);
    }
    return Promise.all(promises);
}
function UnloadScript(name) {
    const scripts = document.getElementsByTagName('script');
    for (let j = 0; j < scripts.length; ++j) {
        let src = scripts[j].getAttribute('src');
        if (src != null && src.startsWith(name)) {
            document.getElementsByTagName('head')[0].removeChild(scripts[j]);
            return;
        }
    }
}

// @dynamic
class FidelJsLoaderService {
    constructor() { }
    /**
     * Loads the required js for fidel to work
     *
     * @example
     * this.fidelJsLoaderService.loadJs().pipe(delay(100))
     * .subscribe((status) => {
     *   if (status == 'loaded') {
     *   this.fidelService.linkcard("test");
     *   }
     * });
     */
    loadJs() {
        if (FidelJsLoaderService.behaviourSubject == null) {
            FidelJsLoaderService.behaviourSubject = new BehaviorSubject('initializing');
            LoadScripts([{ src: 'https://resources.fidel.uk/sdk/js/v3/fidel.js' }]).then(() => {
                FidelJsLoaderService.behaviourSubject.next('loaded');
            });
        }
        return FidelJsLoaderService.behaviourSubject.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelJsLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelJsLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FidelJsLoaderService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class FidelLinkedCardError {
}

class LinkedCard {
}

var PaymentCardType;
(function (PaymentCardType) {
    /**
     * No payment card found
     */
    PaymentCardType[PaymentCardType["None"] = 0] = "None";
    /**
     * Master card
     */
    PaymentCardType[PaymentCardType["MasterCard"] = 1] = "MasterCard";
    /**
     * Amex / AmericanExpress
     */
    PaymentCardType[PaymentCardType["AmericanExpress"] = 2] = "AmericanExpress";
    /**
     * Visa
     */
    PaymentCardType[PaymentCardType["Visa"] = 3] = "Visa";
    /**
     * Discover
     */
    PaymentCardType[PaymentCardType["Discover"] = 4] = "Discover";
    /**
     * JCB
     */
    PaymentCardType[PaymentCardType["JCB"] = 5] = "JCB";
    /**
     * Default debit card
     */
    PaymentCardType[PaymentCardType["DebitCard"] = 6] = "DebitCard";
    /**
     * Diners club
     */
    PaymentCardType[PaymentCardType["DinersClub"] = 7] = "DinersClub";
    /**
     * Union pay
     */
    PaymentCardType[PaymentCardType["UnionPay"] = 8] = "UnionPay";
    /**
     * Other not listed
     */
    PaymentCardType[PaymentCardType["Other"] = 99] = "Other";
})(PaymentCardType || (PaymentCardType = {}));

const LINK_CARD_MOCK = {
    ExternalCardId: '',
    PortalId: '',
    ClubId: 1,
    CardNumber: '',
    ExpiryDate: new Date(),
    CardType: PaymentCardType.MasterCard,
};

class LinkedOffer {
}

var LinkOfferStatus;
(function (LinkOfferStatus) {
    /**
     * The offer is active to the customer
     */
    LinkOfferStatus[LinkOfferStatus["Active"] = 0] = "Active";
    /**
     * The offer is inactive
     */
    LinkOfferStatus[LinkOfferStatus["Inactive"] = 1] = "Inactive";
    /**
     * The offer is not active and is waiting to be activated
     */
    LinkOfferStatus[LinkOfferStatus["Pending"] = 2] = "Pending";
    /**
     * The offer is active but not in date range yet
     */
    LinkOfferStatus[LinkOfferStatus["ComingSoon"] = 4] = "ComingSoon";
})(LinkOfferStatus || (LinkOfferStatus = {}));

class SQWADService {
    constructor(api, authService) {
        this.api = api;
        this.authService = authService;
    }
    /**
     * This is used to SSO to the provider
     * @param url url paramater which can be changed to pass through a hard coded url or it will default to the one set in the settings
     *
     * @example
     * launchWebsite() {
     *  this.sqwadService.sso(1, 'www.google.co.uk')
     * }
     */
    sso(clubId, url) {
        let options = [];
        if (url) {
            options = [{ key: 'Url', value: url }];
        }
        this.authService.loginThirdParty(ProviderName.SQWAD, clubId, '', false, options);
    }
    /**
     * Used when the user is returned from the provider to the UI
     * @param token the users external ref number
     */
    callback(token, options) {
        return this.api.post(`provider/${ProviderName.SQWAD}/ssocallback/${token}`, options).toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SQWADService, deps: [{ token: ApiService }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SQWADService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SQWADService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: AuthService }] });

class KeyCloakAuthService {
    constructor(authService, logService, api, cookieService) {
        this.authService = authService;
        this.logService = logService;
        this.api = api;
        this.cookieService = cookieService;
        if (this.settings === undefined) {
            let KeyCloakConfig = config.providerSettings.find((x) => x.providerId === ProviderName.KeyCloak);
            if (KeyCloakConfig != undefined && KeyCloakConfig.settings != undefined) {
                this.settings = KeyCloakConfig.settings;
            }
        }
        if (this.settings == undefined) {
            this.logService.warning('tenant Id is currently not in the config file');
        }
    }
    /**
     * Attempt to login using key cloake using redirect process.
     * This will call an endpoint to generate the login URL,
     * depending on the parameters passed.
     * This can also be used for registration, handled by the parameters passed.
     * @param successredirectPath redirect path after successfully authenticated
     * e.g. /sa-callback (which is the default value)
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     */
    login(successredirectPath = '/kc-callback', clubId = 1) {
        const loginUrlParameters = this.generateLoginParameters(successredirectPath);
        return this.api.post(`sso/OAuth/GenerateUrl/${ProviderName.KeyCloak}/${clubId}`, loginUrlParameters).pipe(tap((generatedUrl) => {
            window.location.href = generatedUrl;
        }));
    }
    /**
     * This method will generate the login
     * URL for key cloak from the defined
     * settings, when login has been attempted.
     *
     * @returns array of parameters required
     * to generate the Key Cloak
     * login URL of type InputField.
     */
    generateLoginParameters(successredirectPath) {
        let generateLoginParams = [];
        if (!this.settings.redirectUrl) {
            this.settings.redirectUrl = config.portalUrl + successredirectPath;
        }
        let returnVisitParam = {
            FieldName: 'RedirectUrl',
            InputType: InputType.Text,
            Active: true,
            Value: this.settings.redirectUrl,
            ErrorMessage: '',
        };
        generateLoginParams.push(returnVisitParam);
        return generateLoginParams;
    }
    /**
     * This method is used to authenticate a token
     * that comes back from the Key Cloak login page
     * and log the user in via the tokens returned
     * from the response.
     * @param code code returned from
     * Key Cloak, to be authenticated and
     * passed to given endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    validateCode(code, clubId = 1) {
        if (this.authService.hasAccessToken()) {
            return of(true);
        }
        return this.api.post(`sso/OAuth/${ProviderName.KeyCloak}/${code}/${clubId}`, `"${code}"`).pipe(tap((authResponse) => {
            if (authResponse) {
                localStorage.setItem('KCRefreshToken', authResponse.auth.RefreshToken.toString());
                localStorage.setItem('KCAccessToken', authResponse.auth.AccessToken.toString());
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
            }
        }), map((authResponse) => {
            if (authResponse) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Log out of the portal and provider (key cloak).
     * Passes provider tokens and provider ID
     * to logout for the logout endpoint
     * with portal provider details.
     */
    logout() {
        let providerTokens = {};
        providerTokens.providerRefreshToken = localStorage.getItem('KCRefreshToken');
        providerTokens.providerAccessToken = localStorage.getItem('KCAccessToken');
        localStorage.removeItem('KCRefreshToken');
        localStorage.removeItem('KCAccessToken');
        return this.authService.logout(ProviderName.KeyCloak, providerTokens);
    }
    /**
     * This method is used to authenticate a domain
     * token used from the _sa_sso_upid cookie given
     * from Key Cloak domain and log the user
     * using tokens returned.
     * @param domainCookie domain cookie to be
     * authenticated and passed to endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    loginUsingToken(domainCookie, clubId = 1) {
        let saDomainCookie = '';
        if (domainCookie != '' && domainCookie != undefined) {
            saDomainCookie = domainCookie;
        }
        return this.api.get(`sso/OAuth/${ProviderName.KeyCloak}/${saDomainCookie}/${clubId}`).pipe(tap((authResponse) => {
            if (authResponse) {
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
                localStorage.setItem('SARefreshToken', authResponse.auth.RefreshToken.toString());
                localStorage.setItem('SAAccessToken', authResponse.auth.AccessToken.toString());
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Check if a named cookie exists.
     * @param cookieName cookie name to be checked.
     * @returns boolean value depending if cookie name
     * exists.
     */
    hasNamedCookie(cookieName) {
        if (this.cookieService.check(cookieName)) {
            return true;
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: KeyCloakAuthService, deps: [{ token: AuthService }, { token: LoggingService }, { token: ApiService }, { token: i4$1.CookieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: KeyCloakAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: KeyCloakAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AuthService }, { type: LoggingService }, { type: ApiService }, { type: i4$1.CookieService }] });

/**
 * @example
 * providerSettings : [{
 *    providerId : 72,
 *    settings : {
 *        tenantId : "UKRTGHgYr0CNWMEXbYy_3Q",
 *    }
 * }]
 *
 * @description
 * This is all the settings tha comes from the config.js file
 * and also set within the login or registration process
 */
class KeyCloakSettings {
}

class SeatGeekAuthService {
    /**
     * This holds all the SeatGeek settings required for sso,
     * this information will be read from the config js file
     * and also passed or defaulted from the login process.
     */
    constructor(authService, api) {
        this.authService = authService;
        this.api = api;
    }
    /**
     * Attempt to login using SeatGeek using redirect process.
     * This will call an endpoint to generate the login URL,
     * depending on the parameters passed.
     * @param clubId clubId to be passed to endpoint, default to 1.
     */
    login(clubId = 1) {
        return this.api.post(`sso/OAuth/GenerateUrl/${ProviderName.SeatGeek}/${clubId}`, []).pipe(tap((generatedUrl) => {
            window.location.href = generatedUrl;
        }));
    }
    /**
     * This method is used to authenticate a token
     * that comes back from the SeatGeek login page
     * and log the user in via the tokens returned
     * from the response.
     * @param code code returned from SeatGeek, to be authenticated and passed to given endpoint.
     * @param clubId clubId to be passed to endpoint, default to 1.
     * @returns boolean from status of response.
     */
    validateCode(code, clubId = 1) {
        if (this.authService.hasAccessToken()) {
            return of(true);
        }
        return this.api.post(`sso/OAuth/${ProviderName.SeatGeek}/${code}/${clubId}`, `"${code}"`).pipe(tap((authResponse) => {
            if (authResponse) {
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatGeekAuthService, deps: [{ token: AuthService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatGeekAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: SeatGeekAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AuthService }, { type: ApiService }] });

class OtherMediaAuthService {
    /**
     * This holds all the other media settings required for sso,
     * this information will be read from the config js file
     * and also passed or defaulted from the login process.
     */
    constructor(authService, api, cookieService) {
        this.authService = authService;
        this.api = api;
        this.cookieService = cookieService;
    }
    /**
     * Attempt to login using key cloake using redirect process.
     * This will call an endpoint to generate the login URL,
     * depending on the parameters passed.
     * This can also be used for registration, handled by the parameters passed.
     * @param successredirectPath redirect path after successfully authenticated
     * e.g. /sa-callback (which is the default value)
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     */
    login(successredirectPath = '/om-callback', clubId = 1) {
        const loginUrlParameters = this.generateLoginParameters(successredirectPath);
        return this.api.post(`sso/OAuth/GenerateUrl/${ProviderName.OtherMedia}/${clubId}`, loginUrlParameters).pipe(tap((generatedUrl) => {
            window.location.href = generatedUrl;
        }));
    }
    /**
     * This method will generate the login
     * URL for other media from the defined
     * settings, when login has been attempted.
     *
     * @returns array of parameters required
     * to generate the Other Media
     * login URL of type InputField.
     */
    generateLoginParameters(successredirectPath) {
        let generateLoginParams = [];
        let returnVisitParam = {
            FieldName: 'RedirectUrl',
            InputType: InputType.Text,
            Active: true,
            Value: config.portalUrl + successredirectPath,
            ErrorMessage: '',
        };
        generateLoginParams.push(returnVisitParam);
        return generateLoginParams;
    }
    /**
     * This method is used to authenticate a token
     * that comes back from the Other Media login page
     * and log the user in via the tokens returned
     * from the response.
     * @param code code returned from
     * Other Media, to be authenticated and
     * passed to given endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    validateCode(code, clubId = 1) {
        if (this.authService.hasAccessToken()) {
            return of(true);
        }
        return this.api.post(`sso/OAuth/${ProviderName.OtherMedia}/${code}/${clubId}`, `"${code}"`).pipe(tap((authResponse) => {
            if (authResponse) {
                localStorage.setItem('OMRefreshToken', authResponse.auth.RefreshToken.toString());
                localStorage.setItem('OMAccessToken', authResponse.auth.AccessToken.toString());
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
            }
        }), map((authResponse) => {
            if (authResponse) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Log out of the portal and provider (Other Media).
     * Passes provider tokens and provider ID
     * to logout for the logout endpoint
     * with portal provider details.
     */
    logout() {
        let providerTokens = {};
        providerTokens.providerRefreshToken = localStorage.getItem('OMRefreshToken');
        providerTokens.providerAccessToken = localStorage.getItem('OMccessToken');
        localStorage.removeItem('OMRefreshToken');
        localStorage.removeItem('OMAccessToken');
        return this.authService.logout(ProviderName.Fortress, providerTokens);
    }
    /**
     * This method is used to authenticate a domain
     * token used from the _sa_sso_upid cookie given
     * from Other Media domain and log the user
     * using tokens returned.
     * @param domainCookie domain cookie to be
     * authenticated and passed to endpoint.
     * @param clubId clubId to be passed to endpoint,
     * default to 1.
     * @returns boolean from status of response.
     */
    loginUsingToken(domainCookie, clubId = 1) {
        let saDomainCookie = '';
        if (domainCookie != '' && domainCookie != undefined) {
            saDomainCookie = domainCookie;
        }
        return this.api.get(`sso/OAuth/${ProviderName.OtherMedia}/${saDomainCookie}/${clubId}`).pipe(tap((authResponse) => {
            if (authResponse) {
                this.authService.loginUsingToken(authResponse.tokens.AccessToken, authResponse.tokens.RefreshToken, '/');
                localStorage.setItem('SARefreshToken', authResponse.auth.RefreshToken.toString());
                localStorage.setItem('SAAccessToken', authResponse.auth.AccessToken.toString());
            }
        }), map((authResponse) => {
            if ((authResponse.status = 200)) {
                return true;
            }
            else {
                return false;
            }
        }));
    }
    /**
     * Check if a named cookie exists.
     * @param cookieName cookie name to be checked.
     * @returns boolean value depending if cookie name
     * exists.
     */
    hasNamedCookie(cookieName) {
        if (this.cookieService.check(cookieName)) {
            return true;
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: OtherMediaAuthService, deps: [{ token: AuthService }, { token: ApiService }, { token: i4$1.CookieService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: OtherMediaAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: OtherMediaAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AuthService }, { type: ApiService }, { type: i4$1.CookieService }] });

let LeaderboardStore = class LeaderboardStore extends Store {
    // todo: when multiple leaderboards are implemented, make this an entity store that stores objects in this shape:
    // { date: Date, leaderboard: LeaderboardEntry[] }
    // keyed on date.
    constructor() {
        super({});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardStore, providedIn: 'root' }); }
};
LeaderboardStore = __decorate([
    StoreConfig({ name: 'leaderboard' })
], LeaderboardStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class LeaderboardService {
    constructor(leaderboardStore, api) {
        this.leaderboardStore = leaderboardStore;
        this.api = api;
    }
    fetchLeaderboard(amountToDisplay = 5) {
        return this.api.get('leaderboard?recordCount=' + amountToDisplay).pipe(tap((entries) => {
            this.leaderboardStore.update((state) => ({ leaderboard: entries }));
        }), mapTo(null));
    }
    fetchMonthlyLeaderboard(amountToDisplay = 5) {
        return this.api.get('/leaderboard/month/top?recordCount=' + amountToDisplay).pipe(tap((entries) => {
            this.leaderboardStore.update((state) => ({ monthlyLeaderboard: entries }));
        }), mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardService, deps: [{ token: LeaderboardStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LeaderboardStore }, { type: ApiService }] });

class LeaderboardQuery extends Query {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectLeaderboard() {
        return this.select((state) => state.leaderboard);
    }
    getMonthlyLeaderboard() {
        return this.getValue().monthlyLeaderboard;
    }
    /**
     * Format the array to show amount to display and then add user if not in the array
     */
    formatArrayWithUser(amountToDisplay, entries) {
        let currentUserIndex = entries.findIndex((l) => l.IsCurrentUser === true);
        let currentUser = entries[currentUserIndex];
        let slicedArray = entries.slice(0, amountToDisplay - 1);
        if (slicedArray.some((l) => l.IsCurrentUser === true)) {
            if (entries[amountToDisplay - 1]) {
                slicedArray.push(entries[amountToDisplay - 1]);
            }
        }
        else {
            slicedArray.push(currentUser);
        }
        return slicedArray;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardQuery, deps: [{ token: LeaderboardStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LeaderboardStore }] });

class LeaderboardResolver {
    constructor(leaderboardService) {
        this.leaderboardService = leaderboardService;
    }
    resolve(route, state) {
        return this.leaderboardService.fetchLeaderboard();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardResolver, deps: [{ token: LeaderboardService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LeaderboardResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LeaderboardService }] });

/**
 * This points transfer service will handle transferring points from
 * the current member to a target member. Each method will handle transfers
 * for different purses.
 */
class PointsTransferService {
    constructor(api, balanceService) {
        this.api = api;
        this.balanceService = balanceService;
    }
    /**
     * Calls the points transfer endpoint to transfer by external ref
     * @param amount  The amount to be transferred to the target member
     * @param toExternalRef External ref number of the target user
     */
    pointsTransfer(amount, toExternalRef) {
        return this.api.post('points/' + toExternalRef + '/transfer/' + amount, null).pipe(tap((x) => {
            this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, amount);
        }));
    }
    /**
     * Calls the points transfer endpoint to transfer by MemberId
     * @param amount  The amount to be transferred to the target member
     * @param toMemberId MemberId of the target user
     */
    pointsTransferToMemberID(amount, toMemberId) {
        return this.api.post('points/' + toMemberId + '/transferByMemberId/' + amount, null).pipe(tap((x) => {
            this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, amount);
        }));
    }
    /**
     * @param fromMemberId  The current member
     * @param toMemberId  The target member
     * @param amount  The amount to be transferred to the target member
     * @returns This method handles a post request to the required endpoint responsible
     * for transferring the renewal bonus purse balance from one member to another. It must be passed the source MemberId
     * (member to transfer balance from), target MemberId (member to transfer balance to),
     * and amountToTransfer (how much to be transferred in pence).
     */
    renewalBonusTransfer(fromMemberId, toMemberId, amount) {
        return this.api.post(`bonuscredit/transferrenewalbonus?sourceMemberId=${fromMemberId}&targetMemberId=${toMemberId}&amountToTransfer=${amount}`, null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PointsTransferService, deps: [{ token: ApiService }, { token: BalanceService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PointsTransferService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PointsTransferService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: BalanceService }] });

var PointsTransferType;
(function (PointsTransferType) {
    PointsTransferType[PointsTransferType["Partner"] = 0] = "Partner";
    PointsTransferType[PointsTransferType["NonPartner"] = 1] = "NonPartner";
})(PointsTransferType || (PointsTransferType = {}));

var WorksheetType;
(function (WorksheetType) {
    WorksheetType[WorksheetType["Download"] = 0] = "Download";
    WorksheetType[WorksheetType["Gallery"] = 1] = "Gallery";
    WorksheetType[WorksheetType["ProviderVideo"] = 2] = "ProviderVideo";
    WorksheetType[WorksheetType["Link"] = 3] = "Link";
})(WorksheetType || (WorksheetType = {}));

let WorksheetStore = class WorksheetStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetStore, providedIn: 'root' }); }
};
WorksheetStore = __decorate([
    StoreConfig({ name: 'worksheet', idKey: 'WorksheetId' })
], WorksheetStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class WorksheetQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * Get all the worksheets for the route
     * @param route rotue of the current page
     */
    getWorksheetByRoute(route) {
        return this.selectAll({ filterBy: [(entity) => entity.RouteUrl == route] }).pipe(map((worksheets) => {
            return worksheets.map((w) => {
                if (!w || !w.Items) {
                    return w;
                }
                const itemsCopy = [...w.Items];
                return {
                    ...w,
                    Items: itemsCopy.sort(this._sortItemsByOrdinal)
                };
            });
        }));
    }
    /**
     * Has Route will return whether there is any route loaded for the page
     * @param route route of the current page
     *
     */
    hasRoute(route) {
        return this.getAll({ filterBy: [(entity) => entity.RouteUrl == route] }).length > 0;
    }
    /**
     * Has worksheet will return whether the worksheet id exists
     * @param worksheetId worksheet Id
     */
    hasWorksheet(worksheetId) {
        return this.hasEntity(worksheetId);
    }
    _sortItemsByOrdinal(a, b) {
        if (a.Ordinal > b.Ordinal) {
            return 1;
        }
        if (b.Ordinal > a.Ordinal) {
            return -1;
        }
        return 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetQuery, deps: [{ token: WorksheetStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: WorksheetStore }] });

class WorksheetService {
    constructor(api, worksheetStore, worksheetQuery, logService, http) {
        this.api = api;
        this.worksheetStore = worksheetStore;
        this.worksheetQuery = worksheetQuery;
        this.logService = logService;
        this.http = http;
    }
    /**
     * Gets a worksheet by Id
     *
     * @param worksheetId worksheet Id
     */
    fetchWorksheetIdId(worksheetId) {
        if (this.worksheetQuery.hasEntity(worksheetId)) {
            return this.worksheetQuery.selectEntity(worksheetId);
        }
        else {
            return this.api.getById('worksheet', worksheetId.toString()).pipe(tap((worksheet) => {
                this.worksheetStore.add(worksheet);
            }));
        }
    }
    /**
     * Gets all worksheets by url
     *
     * @param route route of the current page
     */
    fetchWorksheetByRoute(route) {
        this.worksheetStore.setLoading(true);
        this.logService.info('making call for worksheets');
        const request$ = this.api.get('worksheet/route?route=' + route).pipe(tap((worksheet) => {
            if (worksheet.length == 0) {
                worksheet = [{ WorksheetId: 0, RouteUrl: route }];
            }
            this.worksheetStore.add(worksheet);
        }), mapTo(null));
        return this.worksheetQuery.hasRoute(route) ? of(null) : request$;
    }
    /**
     * Will download a worksheet and log this download
     *
     * @param worksheetId the id of the worksheet
     * @param worksheetItemId the item id of the worksheet
     */
    downloadWorksheet(worksheetId, worksheetItemId) {
        return this.http.get(`${config.baseApiUrl}/api/worksheet/download/` + worksheetId + '/' + worksheetItemId, {
            headers: this.api.getHeaders(),
            responseType: 'blob',
        });
    }
    /**
     * Logs that the customer has started watching the stream
     *
     * @param streamKey stream key
     */
    logViewStreamStart(streamKey) {
        let headers = this.api.getHeaders();
        let streamToken = localStorage.getItem('streamToken');
        if (streamToken) {
            localStorage.removeItem('streamToken');
        }
        return this.http
            .post(`${config.baseApiUrl}/api/worksheet/view/` + streamKey, null, { headers: headers })
            .pipe(tap((token) => {
            localStorage.setItem('streamToken', token);
        }))
            .toPromise();
    }
    /**
     * Logs that the customer is still watching the stream
     *
     * @param streamKey stream key
     */
    logStreamWatching(streamKey) {
        let headers = this.api.getHeaders();
        let streamToken = localStorage.getItem('streamToken');
        if (streamToken) {
            headers = headers.append('streamToken', streamToken);
        }
        return this.http
            .post(`${config.baseApiUrl}/api/worksheet/view/` + streamKey, null, { headers: headers })
            .pipe(tap((token) => {
            localStorage.setItem('streamToken', token);
        }))
            .toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetService, deps: [{ token: ApiService }, { token: WorksheetStore }, { token: WorksheetQuery }, { token: LoggingService }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WorksheetService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }, { type: WorksheetStore }, { type: WorksheetQuery }, { type: LoggingService }, { type: i1.HttpClient }] });

function createMarketplaceCartItem(marketplaceItem, purchaseQuantity, memberId, attributes, customFields) {
    return {
        id: guid(),
        purchaseQuantity: purchaseQuantity,
        totalPrice: marketplaceItem.MerchantValue * purchaseQuantity,
        productData: Object.assign({}, marketplaceItem),
        memberId: memberId,
        attributes: attributes,
        customFields: customFields,
    };
}
function createPortalProductCartItem(portalProduct, purchaseQuantity, memberId) {
    return {
        id: guid(),
        purchaseQuantity: purchaseQuantity,
        totalPrice: portalProduct.MerchantPrice * purchaseQuantity,
        productData: Object.assign({}, portalProduct),
        memberId: memberId,
    };
}

const CART_ITEM_MOCK = {
    /** ID of entity */
    id: 0,
    /** The quantity of the item added to the cart */
    purchaseQuantity: 10,
    /** The total price of the item added calculated by the items value and quantity selected */
    totalPrice: 20,
    /** The type of the item added to cart (MarketplaceItemExtended or PortalProduct) */
    productData: MARKETPLACE_ITEM_MOCK,
    /** The selected attributes, if any */
    attributes: MARKETPLACE_ATTRIBUTE_CART_ITEM,
    /** The selected custom fields, if any */
    customFields: [MARKETPLACE_CUSTOMFIELD_CART_ITEM],
    /** Member ID of the current user */
    memberId: '123',
};

const MARKETPLACE_CART_ITEM_MOCK = {
    /** ID of entity */
    id: 0,
    /** The quantity of the item added to the cart */
    purchaseQuantity: 10,
    /** The total price of the item added calculated by the items value and quantity selected */
    totalPrice: 20,
    /** The type of the item added to cart (MarketplaceItemExtended or PortalProduct) */
    productData: MARKETPLACE_ITEM_MOCK,
    /** The selected attributes, if any */
    attributes: MARKETPLACE_ATTRIBUTE_CART_ITEM,
    /** The selected custom fields, if any */
    customFields: [MARKETPLACE_CUSTOMFIELD_CART_ITEM],
    /** Member ID of the current user */
    memberId: '123',
};

/**
 * This cart store will consist of the
 * collection of cart item entities.
 * Items being of type marketplace items or
 * portal products, as there is 2 add to cart processes.
 * Within the cart query and service there is logic to
 * split the item types when updating or making a query to
 * this cart store.
 */
let CartStore = class CartStore extends EntityStore {
    constructor() {
        super();
        persistState({ include: ['cart'] });
    }
    /**
     * @param cartItem The item to be updated.
     * @param quantitySelected The quantity to be added.
     * @param updateFromCart Update quantity from cart which the quantity is already in cart,
     *  if get more from cartItem purchaseQuantity it will duplicate.
     * @returns Update the quantity of a marketplace item,
     * which already exists within the cart store.
     * This will also update the total price of the item.
     */
    updateQuantityOfItem(cartItem, quantitySelected, updateFromCart) {
        let newQuantity = updateFromCart ? quantitySelected : cartItem.purchaseQuantity + quantitySelected;
        this.update(cartItem.id, {
            purchaseQuantity: newQuantity,
            totalPrice: cartItem.productData.MerchantValue * newQuantity,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartStore, providedIn: 'root' }); }
};
CartStore = __decorate([
    StoreConfig({
        name: 'cart',
    })
], CartStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

/**
 * This cart query will handle the queries made
 * to the cart store for both marketplace items
 * and portal products.
 */
class CartQuery extends QueryEntity {
    constructor(store, marketPlaceQuery, memberQuery) {
        super(store);
        this.store = store;
        this.marketPlaceQuery = marketPlaceQuery;
        this.memberQuery = memberQuery;
    }
    /**
     * @returns Combined queries from
     * both the cart store and the marketplace store.
     * This combine query is required to get all information
     * on the marketplace item added to cart store.
     */
    selectAllMarketplaceCartData() {
        return combineQueries([
            this.selectAll({
                filterBy: [
                    (entity) => this.instanceOfMarketplaceItem(entity.productData) && entity.memberId == this.memberQuery.getUserContext().memberId,
                ],
            }),
            this.marketPlaceQuery.selectExtendedMarketplaceItems(),
        ]).pipe(map(([cartItems, productItems]) => {
            if (!cartItems || !productItems) {
                return undefined;
            }
            return cartItems.map((cartItem) => {
                return {
                    ...cartItem,
                    productData: productItems.find((marketplaceProduct) => marketplaceProduct.Id === cartItem.productData.Id),
                };
            });
        }), tap((cart) => {
            if (cart) {
                this.verifyCartItems(cart);
            }
        }));
    }
    /**
     * Calculate items within the cart for the current
     * member ID and only for marktetplace items.
     */
    updateTotalItems() {
        return this.selectAll({
            filterBy: [
                (entity) => this.instanceOfMarketplaceItem(entity.productData) && entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        }).pipe(map((items) => items.reduce((accumVal, item) => accumVal + item.purchaseQuantity, 0)));
    }
    /**
     * @returns Calculate total points value of all items added and the quantities
     * (only for marketplace items within the cart), total points value is returned.
     */
    updateBasketPointsTotal() {
        const totalPoints = this.selectAllMarketplaceCartData().pipe(map((items) => {
            if (items) {
                return items.reduce((accumVal, item) => accumVal + item.purchaseQuantity * item.productData.PointValue, 0);
            }
            return;
        }));
        return totalPoints;
    }
    /**
     * Select all portal products added to
     * the cart store.
     */
    selectAllSubscriptionCartData() {
        return this.selectAll({
            filterBy: [
                (entity) => this.instanceOfPortalProduct(entity.productData) && entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        });
    }
    /**
     * Calculates the total cost of all
     * portal products within the cart.
     */
    calculateTotalCost() {
        const totalCost = this.selectAllSubscriptionCartData().pipe(map((items) => items.reduce((accumVal, item) => accumVal + item.productData.MerchantPrice, 0)));
        return totalCost;
    }
    /**
     * @param object Object passed to be checked.
     * @returns Returns the portal product Id.
     * This is a check to see whether a object in the cart store is
     * an instance of PortalProduct
     */
    instanceOfPortalProduct(object) {
        return 'ProductId' in object;
    }
    /**
     * @param object Object passed to be checked.
     * @returns Returns the martketplace item Id.
     * This is a check to see whether a object in the cart store is
     * an instance of MarketplaceItemExtended
     */
    instanceOfMarketplaceItem(object) {
        return 'Id' in object;
    }
    /**
     * @param items array of items within the store
     * to be cleared.
     * @returns To clear all items from the cart store,
     * which would be called on the payment processs.
     */
    removeItems(items) {
        this.store.remove(items.map((cartItem) => cartItem.id));
    }
    /**
     * @returns To get all marketplace items
     * within the cart store, for the current
     * member ID.
     */
    getMemberMarketplaceCart() {
        return this.getAll({
            filterBy: [
                (entity) => this.instanceOfMarketplaceItem(entity.productData) && entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        });
    }
    /**
     * @returns To get all portal product items
     * within the cart store, for the current
     * member ID.
     */
    getMemberPortalProductCart() {
        return this.getAll({
            filterBy: [
                (entity) => this.instanceOfPortalProduct(entity.productData) && entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        });
    }
    /**
     * @param attributeMappingId Attribute Mapping ID of the desired item, if any
     * @param customFields Custom Fields Values of the desired item, if any
     * @returns To get specifc martketplace item
     * within the cart store, for the current
     * member ID.
     */
    getMemberMarketplaceCartItem(itemId, attributeMappingId, customFields) {
        return this.getAll({
            filterBy: [
                (entity) => this.instanceOfMarketplaceItem(entity.productData) &&
                    entity.productData.Id == itemId &&
                    entity.attributes.AttributeMappingId == attributeMappingId &&
                    (customFields ? isEqual(entity.customFields, customFields) : !entity.customFields) &&
                    entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        })[0];
    }
    /**
     * @param attributeMappingId Attribute Mapping ID of the desired item, if any
     * @returns To get purchase quantity of martketplace item
     * within the cart store, for the current member ID.
     * Cart items are differenciated by attributes and custom fields, but custom fields are not relevant to stock.
     */
    getCartItemPurchaseQuantity(itemId, attributeMappingId) {
        return this.getAll({
            filterBy: [
                (entity) => this.instanceOfMarketplaceItem(entity.productData) &&
                    entity.productData.Id == itemId &&
                    entity.attributes.AttributeMappingId == attributeMappingId &&
                    entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        }).reduce((a, b) => a + (b['purchaseQuantity'] || 0), 0);
    }
    /**
     * @returns To get specifc portal product item
     * within the cart store, for the current
     * member ID.
     */
    getMemberPortalProductCartItem(portalProductId) {
        return this.getAll({
            filterBy: [
                (entity) => this.instanceOfPortalProduct(entity.productData) &&
                    entity.productData.ProductId == portalProductId &&
                    entity.memberId == this.memberQuery.getUserContext().memberId,
            ],
        })[0];
    }
    /**
     * @param itemId The marketplace item ID.
     * @param attributeMappingId The selected attribute ID from the marketplace item.
     * @returns Select marketplace item in the cart, which
     * is used to disable the add to cart button preventing
     * more items being added than possible.
     */
    selectMemberMarketplaceCartItem(itemId, attributeMappingId) {
        return this.selectAllMarketplaceCartData().pipe(map((cartItems) => {
            if (cartItems) {
                return cartItems.filter((cartItem) => {
                    const matchingIDs = cartItem.productData.Id == itemId;
                    let matchingAttributes = true;
                    if (attributeMappingId && cartItem.attributes) {
                        matchingAttributes = cartItem.attributes.AttributeMappingId == attributeMappingId;
                    }
                    return matchingIDs && matchingAttributes;
                })[0];
            }
            return;
        }));
    }
    /**
     * @param productId The portal product ID.
     * @returns Select portal product item in the cart,
     * use to prevent more portal product items being added than possible.
     */
    selectMemberPortalProductCartItem(productId) {
        return this.selectAllSubscriptionCartData().pipe(map((cartItems) => cartItems.filter((cartItem) => cartItem.productData.ProductId == productId)[0]));
    }
    /**
     * Verify and Remove any items within the users cart
     * which are no longer available (removed).
     * @param cart array items within cart store
     * @returns updated points total of items in
     * cart.
     */
    verifyCartItems(cart) {
        cart.forEach((item) => {
            if (item && !item.productData) {
                this.store.remove(item.id);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartQuery, deps: [{ token: CartStore }, { token: MarketplaceExtendedQuery }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CartStore }, { type: MarketplaceExtendedQuery }, { type: MemberQuery }] });

/**
 * This cart service will handle the updates of
 * adding and removing items to the cart store (for both
 * marketplaceitems and portal products).
 */
class CartService {
    constructor(cartStore, cartQuery, basketService, marketplaceService, marketplaceQuery, balanceService, transactionSuccessService, memberQuery, router) {
        this.cartStore = cartStore;
        this.cartQuery = cartQuery;
        this.basketService = basketService;
        this.marketplaceService = marketplaceService;
        this.marketplaceQuery = marketplaceQuery;
        this.balanceService = balanceService;
        this.transactionSuccessService = transactionSuccessService;
        this.memberQuery = memberQuery;
        this.router = router;
    }
    /**
     * @param marketplaceItem  The marketplace item added to the cart
     * @param quantitySelected  The quantity of the item selected by the user
     * @param selectedAttribute  The attribute of the marketplace item added to the cart, if any
     * @param customFields  The custom fields of the marketplace item added to the cart, if any
     * @param updateFormCart  Update quantity from cart
     * @returns This method adds to the cart store with marketplace items and the quantity added
     * by the user. The conditions within this method handles the action
     * of adding new marktetplace items to the cart store as well as updating the
     * quantity of existing items within the cart store.
     */
    addMarketplaceItemToCart(marketplaceItem, quantitySelected, attribute, customFields, updateFormCart) {
        const attributeID = attribute ? attribute.AttributeMappingId : undefined;
        const cartItem = this.cartQuery.getMemberMarketplaceCartItem(marketplaceItem.Id, attributeID, customFields);
        if (!!cartItem) {
            this.cartStore.updateQuantityOfItem(cartItem, quantitySelected, updateFormCart);
        }
        else {
            this.cartStore.add(createMarketplaceCartItem(marketplaceItem, quantitySelected, this.memberQuery.getUserContext().memberId, attribute, customFields));
        }
    }
    removeAllCartItems() {
        return this.cartStore.remove();
    }
    /**
     * @param id  The unique id of the item being removed from the cart store.
     * @returns This method removes individual items from the cart store.
     */
    remove(id) {
        this.cartStore.remove(id);
    }
    /**
     * @param totalPoints the total points to be deducted after purchasing marketplace items within the cart store
     * @returns This method is called to purchase the marketplace items within the cart.
     */
    async purchaseMarketplaceItemsInCart(totalPoints) {
        this.basketService.emptyBasket();
        this.cartQuery
            .selectAllMarketplaceCartData()
            .pipe(tap((cart) => {
            if (!cart) {
                return;
            }
            cart.forEach((cartItem) => {
                let item = this.marketplaceQuery.getEntity(cartItem.productData.Id);
                if (item !== undefined) {
                    this.basketService.addItemToBasket(MarketplaceBasketItem.fromMarketplaceItem(item, cartItem.purchaseQuantity, cartItem.attributes ? cartItem.attributes.AttributeMappingId : undefined, cartItem.customFields));
                }
            });
        }), take(1))
            .toPromise()
            .then(() => {
            this.marketplaceService.purchaseBasket(this.basketService.getCurrentBasket().items).then((orderIdResponse) => {
                this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, totalPoints);
                this.basketService.getCurrentBasket().items.forEach((item) => {
                    let marketplaceItem = this.marketplaceQuery.getEntity(item.id);
                    if (marketplaceItem !== undefined) {
                        this.transactionSuccessService.setTransaction(marketplaceItem, item.quantity, item.merchantValue);
                    }
                });
                this.router.navigate(['checkout/results'], {
                    queryParams: { orderId: orderIdResponse },
                });
            }, (error) => {
                // if has an error,data will fetch agian to check real stock quantity for cart-item
                this.marketplaceService.disableMarketplaceStoreCache();
                this.marketplaceService.fetchMarketplaceItems().toPromise();
            });
        });
    }
    /**
     * @param portalProduct The portal product added to cart
     * @returns This method adds to the cart store with portal product items
     * added by the user.
     */
    addPortalProductToCart(portalProduct) {
        this.cartStore.add(createPortalProductCartItem(portalProduct, 1, this.memberQuery.getUserContext().memberId));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartService, deps: [{ token: CartStore }, { token: CartQuery }, { token: BasketService }, { token: MarketplaceService }, { token: MarketplaceQuery }, { token: BalanceService }, { token: TransactionSuccessService }, { token: MemberQuery }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CartStore }, { type: CartQuery }, { type: BasketService }, { type: MarketplaceService }, { type: MarketplaceQuery }, { type: BalanceService }, { type: TransactionSuccessService }, { type: MemberQuery }, { type: i2.Router }] });

var CustomerProductSusbcriptionPaymentStatusType;
(function (CustomerProductSusbcriptionPaymentStatusType) {
    /// <summary>
    /// Inactive
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Inactive"] = 0] = "Inactive";
    /// <summary>
    /// Payment is currently in a processing state
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Pending"] = 1] = "Pending";
    /// <summary>
    /// Payment is Active waiting to be in a pending state
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Active"] = 2] = "Active";
    /// <summary>
    /// Payment has failed
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Failed"] = 3] = "Failed";
    /// <summary>
    /// Process was cancelled
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Cancelled"] = 4] = "Cancelled";
    /// <summary>
    /// The process was cancelled as the product has ended
    /// </summary>
    CustomerProductSusbcriptionPaymentStatusType[CustomerProductSusbcriptionPaymentStatusType["Ended"] = 5] = "Ended";
})(CustomerProductSusbcriptionPaymentStatusType || (CustomerProductSusbcriptionPaymentStatusType = {}));

/**
 * This subscribed portal products
 * store will consist of entities which are
 * portal products that have been purchased
 * by a member.
 */
let PortalProductsSubscriptionsStore = class PortalProductsSubscriptionsStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsStore, providedIn: 'root' }); }
};
PortalProductsSubscriptionsStore = __decorate([
    StoreConfig({ name: 'portal-products-subscriptions', idKey: 'SubscriptionId' })
], PortalProductsSubscriptionsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

/**
 * This query will handle the queries made
 * to the subscribed portal products store.
 */
class PortalProductsSubscriptionsQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    /**
     * @param productTypes An array of portal product types to be returned
     * @returns Returns all subscribed portal products of the given
     * portal product types from the array passed.
     */
    selectSubscriptionsByProductTypes(productTypes) {
        return this.selectAll({
            filterBy: [(sub) => productTypes.includes(sub.ProductType)],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsQuery, deps: [{ token: PortalProductsSubscriptionsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PortalProductsSubscriptionsStore }] });

/**
 * This service will handle fetching the
 * portal products which have been purchased by
 * a member and setting the store.
 * This service also includes the call to reset
 * the subscribed portal products store.
 */
class PortalProductsSubscriptionsService {
    constructor(portalProductsSubscriptionsStore, portalProductsSubscriptionsQuery, logService, api) {
        this.portalProductsSubscriptionsStore = portalProductsSubscriptionsStore;
        this.portalProductsSubscriptionsQuery = portalProductsSubscriptionsQuery;
        this.logService = logService;
        this.api = api;
    }
    /**
     * @returns This method gets the subscribed portal
     * products data and sets the store. This will be
     * called within the resolver.
     */
    fetchSubscriptions() {
        this.portalProductsSubscriptionsStore.setLoading(true);
        this.logService.info('making call for user portal subscriptions');
        const request$ = this.api.get('subscriptions').pipe(tap((subscriptions) => this.portalProductsSubscriptionsStore.set(subscriptions)), mapTo(null));
        return this.portalProductsSubscriptionsQuery.getHasCache() ? of(null) : request$;
    }
    /**
     * @returns This method is called to reset
     * the subscribed portal products store.
     */
    clear() {
        this.portalProductsSubscriptionsStore.reset();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsService, deps: [{ token: PortalProductsSubscriptionsStore }, { token: PortalProductsSubscriptionsQuery }, { token: LoggingService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PortalProductsSubscriptionsStore }, { type: PortalProductsSubscriptionsQuery }, { type: LoggingService }, { type: ApiService }] });

/**
 * This resolver will handle the call
 * to fetch the subscribed portal products
 * of the current member.
 */
class PortalProductsSubscriptionsResolver {
    constructor(portalProductsSubscriptionsService, logService) {
        this.portalProductsSubscriptionsService = portalProductsSubscriptionsService;
        this.logService = logService;
    }
    /**
     * Call to subscribed products service
     * to fetch all purchased portal products.
     */
    resolve() {
        this.logService.info('resolving portal subscriptions');
        return this.portalProductsSubscriptionsService.fetchSubscriptions();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsResolver, deps: [{ token: PortalProductsSubscriptionsService }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: PortalProductsSubscriptionsResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: PortalProductsSubscriptionsService }, { type: LoggingService }] });

/**
 * MLBAM Tracking service, to track events
 * taken place on the register payment page.
 * Custom variables are required to be passed
 * back during the event tracking.
 */
class FloodlightTrackingService {
    constructor() {
        if (this.settings === undefined) {
            let floodlightConfig = config.providerSettings.find((x) => x.providerId === ProviderName.MLBAM);
            if (floodlightConfig != undefined && floodlightConfig.settings != undefined) {
                this.settings = floodlightConfig.settings;
            }
        }
    }
    /**
     * This function is called to track the events
     * and pass the required data back to the analytics.
     *
     * @param value This is the revenue and would include taxes and fees with the total cost
     * @param transaction_id Order confirmation number (Order ID)
     * @param quantity Quantity of items
     * @param eventName The name of the items being purchased
     * @param facevalue Cost of the items purchased without additional costs
     * @param eventdatetime The date and time of the event
     * @param dateofpur The date and time of the purchase
     * @param billingstate The state from the users billing address
     * @param billingzip The zip/postal code of users the billing address
     * @param delvmethod Method of purchase, e.g. Mailed item.
     */
    eventEmitter(value, transaction_id, quantity, eventName, facevalue, eventdatetime, dateofpur, billingstate, billingzip, delvmethod) {
        /**
         * Random number for unqique case where the order ID
         * is set to 1, avoiding analytics warning.
         */
        let num;
        if (transaction_id == '1') {
            num = Math.floor(1000000000 + Math.random() * 9000000000);
        }
        /**
         * Removing any special characters from
         * the Order ID of the purchase.
         */
        let transid = transaction_id.replace(/\D/g, '');
        /**
         * Seperating multiple items purchased
         * by a plus symbol if more than 1 item
         */
        let eventNameSeperated = eventName.join(' + ');
        gtag('event', 'purchase', {
            allow_custom_scripts: true,
            value: value,
            transaction_id: transid,
            quantity: quantity,
            u1: eventNameSeperated,
            u2: eventdatetime,
            u3: facevalue,
            u4: dateofpur,
            u5: billingstate,
            u6: billingzip,
            u7: delvmethod,
            send_to: this.settings.SendToPath,
            dc_custom_params: {
                num: num,
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FloodlightTrackingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FloodlightTrackingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: FloodlightTrackingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

const SCORECARD_ACTION_CONTENT_MOCK = [
    {
        LCID: 2057,
        Name: 'Action name',
        Description: 'Action description',
    },
];

const SCORECARD_ACTION_MOCK = [
    {
        ScorecardActionId: 1,
        ScorecardId: 1,
        LoyaltyActionId: 1,
        ActionCompleted: true,
        CompletionDate: new Date(),
        Content: SCORECARD_ACTION_CONTENT_MOCK,
        Image: '',
    },
    {
        ScorecardActionId: 2,
        ScorecardId: 1,
        LoyaltyActionId: 2,
        ActionCompleted: false,
        CompletionDate: new Date(),
        Content: SCORECARD_ACTION_CONTENT_MOCK,
        Image: '',
    },
];

const SCORECARD_CONTENT_MOCK = [
    {
        LCID: 2057,
        Name: 'Scorecard test',
        Description: 'Scorecard test description',
        CompletedText: 'Completed scorecard',
        PrizeTitle: 'Prize test title',
        PrizeDescription: 'Prize test description',
        ShortDescription: 'Short test description',
        TermsAndConditions: 'test tnc',
    },
];

const SCORECARD_MILESTONE_DETAILS_CONTENT_MOCK = [
    {
        LCID: 2057,
        Name: 'Test milestone 1',
        Description: 'Test milestone 1',
    },
];

const SCORECARD_MILESTONE_DETAILS_MOCK = [
    {
        MilestoneActionId: 1,
        ScorecardId: 1,
        Content: SCORECARD_MILESTONE_DETAILS_CONTENT_MOCK,
        Value: 10,
        Ordinal: 0,
    },
    {
        MilestoneActionId: 1,
        ScorecardId: 1,
        Content: SCORECARD_MILESTONE_DETAILS_CONTENT_MOCK,
        Value: 12,
        Ordinal: 1,
    },
];

const SCORECARD_MILESTONE_MOCK = {
    CustomerValue: 6,
    DisplayMilestones: true,
    MilestoneActionType: 0,
    MilestoneActionDisplayType: 1,
    Milestones: SCORECARD_MILESTONE_DETAILS_MOCK,
};

const SCORECARD_MOCK = {
    ScorecardId: 1,
    Content: SCORECARD_CONTENT_MOCK,
    Image: '',
    CompletedImage: 'completed',
    StartDate: new Date(),
    EndDate: new Date(),
    ScoreCardDisplayType: 1,
    Favourite: 0,
    Sponsor: undefined,
    Actions: SCORECARD_ACTION_MOCK,
    Milestone: SCORECARD_MILESTONE_MOCK,
    Completed: false,
    CompletionDate: new Date(),
    ScorecardCategory: 1,
    ActionsCompleted: 1,
    TotalToComplete: 1,
    DisplayCounterLimit: true,
    Locked: false,
    ParentId: 0,
    ChildId: 0,
    PrizeOptions: { CustomerHasSelected: false, Prizes: [] },
    HasCustomerSelectedPrize: false,
    CompleteAction: 0,
};

/**
 * A factory function that creates Scorecard
 */
function createScorecard(params) {
    return {};
}

/**
 * This model holds all the
 * scorecard translations in the system
 */
class ScorecardContent {
}

/**
 * This is the scorecard action model, which
 * represents properties used for individual
 * actions within a scorecard.
 */
class ScorecardAction {
}

/**
 * This model holds all the
 * actions translations
 * within a scorecard.
 */
class ScorecardActionContent {
}

class ScorecardActionMessage {
}

class ScorecardCompleteMessage {
}

var ScorecardDisplayType;
(function (ScorecardDisplayType) {
    ScorecardDisplayType[ScorecardDisplayType["punchcardView"] = 0] = "punchcardView";
    ScorecardDisplayType[ScorecardDisplayType["numberView"] = 1] = "numberView";
    ScorecardDisplayType[ScorecardDisplayType["progressBarView"] = 2] = "progressBarView";
    ScorecardDisplayType[ScorecardDisplayType["milestoneProgressBarView"] = 3] = "milestoneProgressBarView";
    ScorecardDisplayType[ScorecardDisplayType["soloAction"] = 4] = "soloAction";
    ScorecardDisplayType[ScorecardDisplayType["singleAction"] = 5] = "singleAction";
})(ScorecardDisplayType || (ScorecardDisplayType = {}));

class ScorecardMilestone {
}

class ScorecardMilestoneDetails {
}

class ScorecardMilestonesDetailsContent {
}

var ScorecardMilestoneActionDisplayType;
(function (ScorecardMilestoneActionDisplayType) {
    ScorecardMilestoneActionDisplayType[ScorecardMilestoneActionDisplayType["segment"] = 0] = "segment";
    ScorecardMilestoneActionDisplayType[ScorecardMilestoneActionDisplayType["value"] = 1] = "value";
})(ScorecardMilestoneActionDisplayType || (ScorecardMilestoneActionDisplayType = {}));

class ScorecardMilestoneMessage {
}

var PrizeType;
(function (PrizeType) {
    PrizeType[PrizeType["None"] = 0] = "None";
    PrizeType[PrizeType["Reward"] = 1] = "Reward";
    PrizeType[PrizeType["GivePoints"] = 2] = "GivePoints";
    PrizeType[PrizeType["GiveEcash"] = 3] = "GiveEcash";
    PrizeType[PrizeType["SkuItem"] = 4] = "SkuItem";
    PrizeType[PrizeType["LottoEntry"] = 5] = "LottoEntry";
})(PrizeType || (PrizeType = {}));

var BadgeStatus;
(function (BadgeStatus) {
    BadgeStatus[BadgeStatus["NotCompleted"] = 0] = "NotCompleted";
    BadgeStatus[BadgeStatus["Completed"] = 1] = "Completed";
})(BadgeStatus || (BadgeStatus = {}));

class BadgesQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectAllCompletedBadges(limit = 6) {
        return this.selectAll().pipe(map((badges) => {
            return badges.sort(this.sortBadges).slice(0, limit);
        }));
    }
    selectAllBadgeCategories() {
        return this.selectAll().pipe(map((badges) => {
            let categories = [];
            let sortedBadges = badges.sort(this.sortBadges);
            sortedBadges.forEach((badge) => {
                badge.Categories.forEach((cat) => {
                    let foundCategory = categories.find((c) => c.Category == cat);
                    if (foundCategory) {
                        foundCategory.Badges.push(badge);
                    }
                    else {
                        categories.push({
                            Category: cat,
                            Badges: [badge],
                        });
                    }
                });
            });
            return categories.map((category) => ({
                ...category,
                Badges: [
                    ...category.Badges.filter(this._filterByStatus(BadgeStatus.Completed)).sort(this._sortByCompletionDate),
                    ...category.Badges.filter(this._filterByStatus(BadgeStatus.NotCompleted)).sort(this._sortByCompletionDate),
                ],
            }));
        }));
    }
    sortBadges(a, b) {
        if (a.Status === BadgeStatus.Completed && b.Status !== BadgeStatus.Completed) {
            return -1;
        }
        else if (b.Status === BadgeStatus.Completed && a.Status !== BadgeStatus.Completed) {
            return 1;
        }
        return 0;
    }
    _filterByStatus(status) {
        return (badge) => badge.Status === status;
    }
    _sortByCompletionDate(a, b) {
        return moment$1.utc(b.CompletionDate).diff(a.CompletionDate);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesQuery, deps: [{ token: BadgesStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: BadgesQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BadgesStore }] });

let GbgIdentityVerificationStore = class GbgIdentityVerificationStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationStore, providedIn: 'root' }); }
};
GbgIdentityVerificationStore = __decorate([
    StoreConfig({ name: 'gbg-identity-verification' })
], GbgIdentityVerificationStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class GbgIdentityVerificationQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationQuery, deps: [{ token: GbgIdentityVerificationStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: GbgIdentityVerificationStore }] });

/**
 * This GBG identity service will handle
 * fetching the user verified status and set the
 * store if needed.
 *
 * This service will also handle a generated
 * SSO to GBG by passing the users member ID.
 */
class GbgIdentityVerificationService {
    constructor(gbgIdentityVerificationStore, gbgVerificationQuery, api) {
        this.gbgIdentityVerificationStore = gbgIdentityVerificationStore;
        this.gbgVerificationQuery = gbgVerificationQuery;
        this.api = api;
    }
    /**
     * @param memberID member ID of the
     * current user.
     * @returns Fetch the gbg identity verification
     * status from the api and set the
     * store if needed.
     */
    fetchVerificationStatus(memberID) {
        const request$ = this.api.post(`access/identitycheckstatus/${memberID}`, null).pipe(tap((result) => {
            let identityStatus = { identityVerificationStatus: result };
            this.gbgIdentityVerificationStore.set([identityStatus]);
        }), mapTo(null));
        return this.gbgVerificationQuery.getHasCache() ? of(null) : request$;
    }
    /**
     * @param memberID member ID of the
     * current user.
     * @returns returns a SSO to GBG by passing the
     * users member ID.
     */
    generateGbgSso(memberID) {
        return this.api.post(`access/documentsso/${memberID}`, null).pipe(tap((generatedUrl) => {
            window.open(generatedUrl.url, '_blank');
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationService, deps: [{ token: GbgIdentityVerificationStore }, { token: GbgIdentityVerificationQuery }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: GbgIdentityVerificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: GbgIdentityVerificationStore }, { type: GbgIdentityVerificationQuery }, { type: ApiService }] });

class GbgIdentityVerificationSso {
}

let RedsoxChildrenTicketCodesStore = class RedsoxChildrenTicketCodesStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesStore, providedIn: 'root' }); }
};
RedsoxChildrenTicketCodesStore = __decorate([
    StoreConfig({ name: 'redsox-children-ticket-codes', idKey: 'Id' })
], RedsoxChildrenTicketCodesStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class RedsoxChildrenTicketCodesService {
    constructor(redsoxChildrenTicketCodesStore) {
        this.redsoxChildrenTicketCodesStore = redsoxChildrenTicketCodesStore;
    }
    /**
     * This will set the store and called in the component
     * if there is no cache on the store. So no change
     * is made to the custom data service.
     * @param data data of custom data set returned.
     */
    setChildrenTicketCodes(data) {
        this.redsoxChildrenTicketCodesStore.set(data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesService, deps: [{ token: RedsoxChildrenTicketCodesStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RedsoxChildrenTicketCodesStore }] });

class RedsoxChildrenTicketCodesQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesQuery, deps: [{ token: RedsoxChildrenTicketCodesStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: RedsoxChildrenTicketCodesQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RedsoxChildrenTicketCodesStore }] });

let CardLinkingStore = class CardLinkingStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingStore, providedIn: 'root' }); }
};
CardLinkingStore = __decorate([
    StoreConfig({ name: 'card-linking', idKey: 'ExternalCardId' }) // Meta Data of store
], CardLinkingStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CardLinkingQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingQuery, deps: [{ token: CardLinkingStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkingStore }] });

let CardLinkOffersStore = class CardLinkOffersStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersStore, providedIn: 'root' }); }
};
CardLinkOffersStore = __decorate([
    StoreConfig({ name: 'card-link-offers', idKey: 'OfferId' })
], CardLinkOffersStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

let CardLinkOffersQuery = class CardLinkOffersQuery extends QueryEntity {
    constructor(store, router, memberQuery) {
        super(store);
        this.store = store;
        this.router = router;
        this.memberQuery = memberQuery;
    }
    /**
     * @retuns all the offers
     * @param limitOffersTo is limit you want to return
     */
    selectAllOffer(limitOffersTo) {
        return this.selectAll({
            limitTo: limitOffersTo,
        });
    }
    /**
     * @returns Activated  offers
     * @param limitOffersTo is limit you want to return
     */
    selectActivatedOffer(limitOffersTo = 4) {
        return this.selectAll({
            filterBy: (offer) => offer.OfferType == 6 && offer.CustomerOfferStatus == 1,
            limitTo: limitOffersTo,
        });
    }
    /** filter all the other offers of the company
     * @param companyId is the id of company
     * @param offerId is the offer which detail already display
     */
    selectOtherOffer(companyId, excludingOfferId, limitOffersTo) {
        return this.selectAll({
            filterBy: [(offer) => offer.CompanyId == companyId, (offer) => offer.OfferId != excludingOfferId],
            limitTo: limitOffersTo,
        });
    }
    /**
     * This query will return the number of Other offers of same company
     * for the current user.
     * @returns Observable count of active offers
     */
    selectOtherOfferCount(companyId, excludingOfferId) {
        return this.selectCount((offer) => offer.CompanyId == companyId && offer.OfferId != excludingOfferId);
    }
    /**
     * Will filter the offers depending
     * on the given searchText and lcid.
     * will check name and Description Contain the searchText and retrun the offer
     * @param searchText is the text user want to search
     * @param lcid is the current language ID
     * @returns request to get data and add to store
     */
    searchOffer(searchText = '', tagId, limit = 0) {
        return this.selectAll({
            filterBy: [
                (offer) => offer.Content?.some((x) => x.LCID == +this.memberQuery.getUserContext().lcid &&
                    (x.Name.toLowerCase().includes(searchText.toLowerCase()) ||
                        x.Description.toLowerCase().includes(searchText.toLowerCase()))),
                (offer) => (tagId == 0 ? true : offer.CategoryTags?.some((x) => x.TagId == tagId)),
            ],
            limitTo: limit,
        });
    }
    /**
     * This method will navigate to the first offer
     * of a given company by the company ID.
     * @param companyId The ID of the company.
     * @param baseOfferDetailsUrl This is the base path of the offers detail
     * set up in the app routing, by default this is offerdetail. If this path is different
     * pass in the path you have set in the app routing.
     * @returns Router navigation to the first offer of the given
     * company ID.
     */
    navigateToCompaniesFirstOffer(companyId, baseOfferDetailsUrl = 'offerdetail') {
        return this.selectAll({
            filterBy: [(offer) => offer.CompanyId == companyId],
        }).pipe(tap((offer) => {
            if (offer[0]) {
                this.router.navigateByUrl(`${baseOfferDetailsUrl}/${offer[0].OfferId}`);
            }
        }));
    }
    /**
     * This query will return recommended offers, defaulted to 4 offers.
     * A offer ID can be passed to exclude the give offer within the list.
     * @param excludingOfferId Optional offer ID to exclude from
     * recommended list. Passed when on offers details page.
     * @param limitOffersTo This will limit the amount of offers shown and
     * defaulted to 4.
     * @returns List of recommended offers.
     */
    selectRecommendedOffers(excludingOfferId, limitOffersTo) {
        return this.selectAll({
            limitTo: limitOffersTo,
            filterBy: [
                (offer) => (excludingOfferId ? offer.OfferId != excludingOfferId : true),
                (offer) => (offer.OfferType == 6 ? offer.CustomerOfferStatus == 0 && offer.OfferType == 6 : offer.OfferType != 6),
            ],
        });
    }
    /**
     * This query will return the number of recommend offers
     * for the current user.
     * @returns Observable count of active offers
     */
    recommendOffersCount(excludingOfferId) {
        return this.selectCount((offer) => (excludingOfferId ? offer.OfferId != excludingOfferId : true) &&
            (offer.OfferType == 6 ? offer.CustomerOfferStatus == 0 && offer.OfferType == 6 : offer.OfferType != 6));
    }
    /**
     * This query will return the number of activated offers
     * for the current user.
     * @returns Observable count of active offers
     */
    selectActivatedOffersCount() {
        return this.selectCount((offer) => offer.OfferType == 6 && offer.CustomerOfferStatus == 1);
    }
    /**
     * @returns fatch featured offers.
     * @param numberOfOffers is the number of the offers you want to fatch
     * if limit is equal to 0 it will return all featured offers
     */
    featuredOffers(limit) {
        return this.selectAll({
            filterBy: (offer) => offer.Favorite == 1,
            limitTo: limit,
        });
    }
    /**
     * This query will return the number of featured offers
     * for the current user.
     * @returns Observable count of active offers
     */
    featuredOffersCount() {
        return this.selectCount((offer) => offer.Favorite == 1);
    }
    /**
     * This method will deactivate offers of type 6
     * and customer offer status 1.
     * This will be used when deleting a card to update the
     * store to match the api.
     */
    deactivateFidelOffersState() {
        let activatedFidelOffers = this.selectAll({
            filterBy: [({ OfferType }) => OfferType == 6, ({ CustomerOfferStatus }) => CustomerOfferStatus == 1],
        });
        activatedFidelOffers
            .subscribe((activatedOffers) => {
            activatedOffers.forEach((offer) => {
                this.store.update(offer.OfferId, { CustomerOfferStatus: 0 });
            });
        })
            .unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersQuery, deps: [{ token: CardLinkOffersStore }, { token: i2.Router }, { token: MemberQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersQuery, providedIn: 'root' }); }
};
CardLinkOffersQuery = __decorate([
    QueryConfig({ sortBy: 'Favorite', sortByOrder: Order.DESC })
], CardLinkOffersQuery);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkOffersStore }, { type: i2.Router }, { type: MemberQuery }] });

class CardLinkingService {
    constructor(cardLinkingStore, fidelService, cardLinkOffersQuery) {
        this.cardLinkingStore = cardLinkingStore;
        this.fidelService = fidelService;
        this.cardLinkOffersQuery = cardLinkOffersQuery;
    }
    /*
     Fetch the list of linked cards from the api and then set the result into the store
    */
    fetchFidelLinkedCard() {
        return this.fidelService.getcards().pipe(tap((cardsLinked) => this.cardLinkingStore.set(cardsLinked)));
    }
    /**
     * Delete the linked Card.
     * also remove the card from store
     * @param cardId select card id.
     */
    deleteCard(cardID) {
        return this.fidelService.deletecard(cardID).pipe(tap(() => {
            this.cardLinkingStore.remove(cardID);
            this.cardLinkOffersQuery.deactivateFidelOffersState();
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingService, deps: [{ token: CardLinkingStore }, { token: FidelService }, { token: CardLinkOffersQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkingStore }, { type: FidelService }, { type: CardLinkOffersQuery }] });

var CardLinkingFidelCountries;
(function (CardLinkingFidelCountries) {
    CardLinkingFidelCountries["GBR"] = "GBR";
    CardLinkingFidelCountries["IRL"] = "IRL";
    CardLinkingFidelCountries["USA"] = "USA";
    CardLinkingFidelCountries["SWE"] = "SWE";
})(CardLinkingFidelCountries || (CardLinkingFidelCountries = {}));

/**
 * use in offer model to take the list of content in different language
 */
const CONTENT_MOCK = [
    {
        LCID: 1,
        Name: 'offer',
        Description: 'offerdes',
    },
    {
        LCID: 2057,
        Name: 'offer',
        Description: 'offerdes',
    },
];

const CARD_LINK_OFFER_ACTIVATE_MOCK = {
    RedirectUrl: '',
    ErrorCode: '',
    ErrorNumber: 1,
    ErrorDesc: '',
};

const CARD_LINK_OFFER_CATEGORY_MOCK = [
    {
        TagId: 1,
        Name: 'Category',
    },
    {
        TagId: 2,
        Name: 'Category',
    },
];

const CARD_LINK_OFFER_MOCK = [
    {
        OfferId: 1,
        CompanyId: 1,
        DepartmentId: 1,
        Content: CONTENT_MOCK,
        ImageUrl: 'OfferImage.jpg',
        CompanyImageUrl: 'companyimage.jpg',
        DepartmentImageUrl: '',
        OfferType: 6,
        StartDate: new Date(),
        EndDate: new Date(),
        TermsAndConditionsType: 1,
        TermsAndConditions: '',
        Favorite: 1,
        Ordinal: 1,
        CategoryTags: CARD_LINK_OFFER_CATEGORY_MOCK,
        Latitude: 1,
        Longitude: 1,
        CustomerOfferStatus: 1,
        OfferLocations: 1,
    },
    {
        OfferId: 2,
        CompanyId: 1,
        DepartmentId: 1,
        Content: CONTENT_MOCK,
        ImageUrl: '',
        CompanyImageUrl: '',
        DepartmentImageUrl: '',
        OfferType: 6,
        StartDate: new Date(),
        EndDate: new Date(),
        TermsAndConditionsType: 1,
        TermsAndConditions: '',
        Favorite: 0,
        Ordinal: 1,
        CategoryTags: CARD_LINK_OFFER_CATEGORY_MOCK,
        Latitude: 1,
        Longitude: 1,
        CustomerOfferStatus: 1,
        OfferLocations: 2,
    },
    {
        OfferId: 2,
        CompanyId: 1,
        DepartmentId: 1,
        Content: CONTENT_MOCK,
        ImageUrl: '',
        CompanyImageUrl: '',
        DepartmentImageUrl: '',
        OfferType: 3,
        StartDate: new Date(),
        EndDate: new Date(),
        TermsAndConditionsType: 1,
        TermsAndConditions: '',
        Favorite: 0,
        Ordinal: 1,
        CategoryTags: CARD_LINK_OFFER_CATEGORY_MOCK,
        Latitude: 1,
        Longitude: 1,
        CustomerOfferStatus: 1,
        OfferLocations: 2,
    },
];

const CARD_LINK_OPTION_MOCK = {
    offerType: 1,
    limit: 4,
    showMoreButton: false,
    showMoreIncrement: 1,
    excludingOfferId: 1,
    companyID: 1,
};

var CardLinkOfferType;
(function (CardLinkOfferType) {
    CardLinkOfferType[CardLinkOfferType["AllOffers"] = 1] = "AllOffers";
    CardLinkOfferType[CardLinkOfferType["FeatureOffers"] = 2] = "FeatureOffers";
    CardLinkOfferType[CardLinkOfferType["OffersYouMayLike"] = 3] = "OffersYouMayLike";
    CardLinkOfferType[CardLinkOfferType["OtherOffers"] = 4] = "OtherOffers";
    CardLinkOfferType[CardLinkOfferType["ActivatedOffers"] = 5] = "ActivatedOffers";
    CardLinkOfferType[CardLinkOfferType["CustomOffersData"] = 6] = "CustomOffersData";
})(CardLinkOfferType || (CardLinkOfferType = {}));

let CardLinkOfferCategoriesStore = class CardLinkOfferCategoriesStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesStore, providedIn: 'root' }); }
};
CardLinkOfferCategoriesStore = __decorate([
    StoreConfig({ name: 'card-link-offer-categories', idKey: 'TagId' })
], CardLinkOfferCategoriesStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CardLinkOffersService {
    /** to set the offer id which user want to activate */
    constructor(cardLinkOffersStore, cardLinkOfferCategoriesStore, api) {
        this.cardLinkOffersStore = cardLinkOffersStore;
        this.cardLinkOfferCategoriesStore = cardLinkOfferCategoriesStore;
        this.api = api;
    }
    /** Fetch all the Offers and puts them in the store.*/
    fatchAffiliateOffer() {
        const request$ = this.api.get(`affiliates/offers`).pipe(tap((offers) => {
            this.cardLinkOfferCategoriesStore.set(this.extractCategories(offers));
            this.cardLinkOffersStore.set(offers);
        }));
        return cacheable(this.cardLinkOffersStore, request$);
    }
    /**
     * activate offer by offer ID
     * @param offerId is the id of the offer which user want to activate.
     */
    activateOffer(offerId) {
        const request$ = this.api.post(`affiliates/offers/activate/${offerId}`, {}).pipe(tap((res) => {
            if (res.ErrorDesc == 'Success') {
                this.cardLinkOffersStore.update(offerId, { CustomerOfferStatus: 1 });
            }
        }));
        return request$;
    }
    /**
     * deactivate offer by offer ID
     * @param offerId is the id of the offer which user want to activate.
     */
    companiesClaim(offerId) {
        const request$ = this.api.post(`companies/claim/${offerId}`, {});
        return request$;
    }
    /**
     * Extract the categories from the offer and return the categories
     * @param offers the list of offers.
     */
    extractCategories(offers) {
        let allCategoryTags = [];
        offers.forEach((offer) => {
            offer.CategoryTags?.forEach((categoryTag) => {
                if (allCategoryTags && !allCategoryTags.find((x) => x.TagId == categoryTag.TagId)) {
                    allCategoryTags.push(categoryTag);
                }
            });
        });
        allCategoryTags.unshift({ TagId: 0, Name: 'All' });
        return allCategoryTags;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersService, deps: [{ token: CardLinkOffersStore }, { token: CardLinkOfferCategoriesStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOffersService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkOffersStore }, { type: CardLinkOfferCategoriesStore }, { type: ApiService }] });

class CardLinkOfferCategoriesQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesQuery, deps: [{ token: CardLinkOfferCategoriesStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkOfferCategoriesStore }] });

class CardLinkOfferCategoriesService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferCategoriesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

/**
*  use in affiliate model to take the list of category
*/

const CARD_LINK_AFFILIATE_CATEGORY_TAGS_MOCK = [
    {
        CategoryTagId: 1,
        LoyaltyCategoryId: 1,
        CategoryName: '',
        ClubId: 1,
    }
];

const CARD_LINK_AFFILIATE_MOCK = [
    {
        CompanyId: 1,
        ImageUrl: 'testImage.jpg',
        TermsAndConditions: '',
        Ordinal: 1,
        CategoryTags: CARD_LINK_AFFILIATE_CATEGORY_TAGS_MOCK,
        CompanyType: 1,
        DisplayName: '',
        Description: '',
        PageText: '',
        WebsiteUrl: '',
        Active: 1,
        ImageUrl2: '',
        Favourite: true,
    },
    {
        CompanyId: 1,
        ImageUrl: 'testImage.jpg',
        TermsAndConditions: '',
        Ordinal: 2,
        CategoryTags: CARD_LINK_AFFILIATE_CATEGORY_TAGS_MOCK,
        CompanyType: 1,
        DisplayName: '',
        Description: '',
        PageText: '',
        WebsiteUrl: '',
        Active: 0,
        ImageUrl2: '',
        Favourite: false,
    },
];

let CardLinkAffiliatesStore = class CardLinkAffiliatesStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesStore, providedIn: 'root' }); }
};
CardLinkAffiliatesStore = __decorate([
    StoreConfig({ name: 'card-link-affiliates', idKey: 'CompanyId' })
], CardLinkAffiliatesStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CardLinkAffiliatesQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesQuery, deps: [{ token: CardLinkAffiliatesStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkAffiliatesStore }] });

class CardLinkAffiliatesService {
    constructor(cardLinkAffiliatesStore, api) {
        this.cardLinkAffiliatesStore = cardLinkAffiliatesStore;
        this.api = api;
    }
    /**
     * fatch the all affiliate Brands and put them into the store
     * depending on the clubId and lcid.
     * @param clubId take as param and fatch affiliate related to club.
     * @param lcid is the current language ID
     * @returns request to get data and add to store
     */
    fetchAffiliates(clubId, lcid) {
        const request$ = this.api.get(`affiliates/${clubId}/${lcid}`).pipe(tap((entities) => {
            this.cardLinkAffiliatesStore.set(entities);
        }));
        return cacheable(this.cardLinkAffiliatesStore, request$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesService, deps: [{ token: CardLinkAffiliatesStore }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkAffiliatesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkAffiliatesStore }, { type: ApiService }] });

let CardLinkOfferLocationsStore = class CardLinkOfferLocationsStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsStore, providedIn: 'root' }); }
};
CardLinkOfferLocationsStore = __decorate([
    StoreConfig({ name: 'card-link-offer-locations', idKey: 'OfferId' })
], CardLinkOfferLocationsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CardLinkOfferLocationsQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsQuery, deps: [{ token: CardLinkOfferLocationsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CardLinkOfferLocationsStore }] });

class CardLinkOfferLocationsService {
    constructor(api, cardLinkOfferLocationsStore) {
        this.api = api;
        this.cardLinkOfferLocationsStore = cardLinkOfferLocationsStore;
    }
    /**
     * fatch Offer Location from api and set to the store
     * @param offerId is the id of the offer which user want to activate.
     */
    fetchOfferLocations(offerId) {
        const request$ = this.api
            .getAnySingle('affiliates/offers/' + offerId)
            .pipe(tap((offerLocations) => {
            this.cardLinkOfferLocationsStore.add(offerLocations);
        }));
        return cacheable(this.cardLinkOfferLocationsStore, request$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsService, deps: [{ token: ApiService }, { token: CardLinkOfferLocationsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CardLinkOfferLocationsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }, { type: CardLinkOfferLocationsStore }] });

function createCardLinkOfferLocation(params) {
    return {};
}

const CARCLINK_OFFER_LOCATIONS_MOCK = {
    ErrorCode: '',
    ErrorDescription: '',
    ErrorNumber: 1,
    OfferId: 1,
    Locations: [
        {
            Latitude: 1,
            Longitude: 1,
            PostCode: '',
            Address: '',
            City: '',
            MasterCardEnabled: true,
            VisaEnabled: true,
            AmexEnabled: true,
        },
        {
            Latitude: 1,
            Longitude: 1,
            PostCode: '',
            Address: '',
            City: '',
            MasterCardEnabled: true,
            VisaEnabled: true,
            AmexEnabled: true,
        },
        {
            Latitude: 1,
            Longitude: 1,
            PostCode: '',
            Address: '',
            City: '',
            MasterCardEnabled: true,
            VisaEnabled: true,
            AmexEnabled: true,
        },
    ],
};

const CARDLINK_OFFER_LOCATION_DETAIL = [{
        Latitude: 1,
        Longitude: 1,
        PostCode: '',
        Address: '',
        City: '',
        MasterCardEnabled: false,
        VisaEnabled: false,
        AmexEnabled: false,
    },
    {
        Latitude: 1,
        Longitude: 1,
        PostCode: '',
        Address: '',
        City: '',
        MasterCardEnabled: false,
        VisaEnabled: false,
        AmexEnabled: false,
    },
    {
        Latitude: 1,
        Longitude: 1,
        PostCode: '',
        Address: '',
        City: '',
        MasterCardEnabled: false,
        VisaEnabled: false,
        AmexEnabled: false,
    }];

let UserQuestionsStore = class UserQuestionsStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsStore, providedIn: 'root' }); }
};
UserQuestionsStore = __decorate([
    StoreConfig({ name: 'user-questions', idKey: 'Id', cache: { ttl: 30000 } })
], UserQuestionsStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class UserQuestionsQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectUserQuestion() {
        return this.selectAll();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsQuery, deps: [{ token: UserQuestionsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: UserQuestionsStore }] });

class UserQuestionsService {
    constructor(api, userQuestionQuery, userQuestionStore) {
        this.api = api;
        this.userQuestionQuery = userQuestionQuery;
        this.userQuestionStore = userQuestionStore;
    }
    /* Get question from API and put data into the store. */
    fetchQuestions() {
        const request$ = this.api.get('question').pipe(tap((response) => {
            //create id for RegistrationQuestionAnswerModel to use idKey in akita store
            response = response.map((res, idx) => {
                return { ...res, Id: idx };
            });
            this.userQuestionStore.set(response);
        }), mapTo(null));
        return this.userQuestionQuery.getHasCache() ? of(null) : request$;
    }
    /* Update the answers with the id of question, array answers and then update answers to store */
    updateAnswers(answer) {
        return this.api
            .put('question', '', answer)
            .pipe(tap(() => this.userQuestionStore.setHasCache(false), switchMap(() => this.fetchQuestions())))
            .toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsService, deps: [{ token: ApiService }, { token: UserQuestionsQuery }, { token: UserQuestionsStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: UserQuestionsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }, { type: UserQuestionsQuery }, { type: UserQuestionsStore }] });

/** Answer model of question of user */
class UserQuestionAnswerModel {
    constructor(body, clubId, portalId) {
        this.QuestionId = body.QuestionId;
        this.AnswerId = body?.Id;
        this.AnswerValue = body.Answer;
        this.Selected = body.Selected;
        this.AnswerDate = new Date().toISOString();
        this.ClubId = clubId;
        this.PortalId = portalId;
    }
}

const REGISTRATION_QUESTION_ANSWER_MOCK = [
    {
        Answer: [
            {
                Id: 24,
                QuestionId: 24,
                Answer: '<div style="display: none;">&nbsp;</div>\r\nAnswer 1',
                AnswerType: 2,
                Selected: false,
                Active: true,
            },
            {
                Id: 25,
                QuestionId: 24,
                Answer: '<div style="display: none;">&nbsp;</div>\r\nAnswer 2',
                AnswerType: 2,
                Selected: false,
                Active: true,
            },
        ],
        Question: {
            Id: 24,
            Question: '<div style="display: none;">&nbsp;</div>\r\nRadio',
            QuestionType: 4,
            QuestionCategory: 0,
            Active: true,
            IsRequired: true,
        },
    },
    {
        Answer: [
            { Id: 27, QuestionId: 26, Answer: 'Html??', AnswerType: 1, Selected: false, Active: true },
            { Id: 28, QuestionId: 26, Answer: 'ISit', AnswerType: 2, Selected: false, Active: true },
        ],
        Question: {
            Id: 26,
            Question: 'This is required you cannot bypass',
            QuestionType: 2,
            QuestionCategory: 0,
            Active: true,
            IsRequired: true,
        },
    },
    { Answer: [], Question: { Id: 27, Question: 'muli', QuestionType: 3, QuestionCategory: 0, Active: true, IsRequired: false } },
    { Answer: [], Question: { Id: 28, Question: 'Radio', QuestionType: 4, QuestionCategory: 0, Active: true, IsRequired: false } },
    {
        Answer: [{ Id: 29, QuestionId: 29, Answer: 'null', AnswerType: 1, Selected: false, Active: true }],
        Question: { Id: 29, Question: 'test', QuestionType: 1, QuestionCategory: 0, Active: true, IsRequired: false },
    },
    {
        Answer: [
            { Id: 30, QuestionId: 30, Answer: 'answer 1', AnswerType: 2, Selected: false, Active: true },
            { Id: 31, QuestionId: 30, Answer: 'bjkbjk', AnswerType: 2, Selected: false, Active: true },
        ],
        Question: { Id: 30, Question: 'test', QuestionType: 3, QuestionCategory: 0, Active: true, IsRequired: false },
    },
    {
        Answer: [
            { Id: 33, QuestionId: 31, Answer: 'tet1', AnswerType: 1, Selected: false, Active: true },
            { Id: 34, QuestionId: 31, Answer: 'test2', AnswerType: 1, Selected: false, Active: true },
        ],
        Question: { Id: 31, Question: 'test 2', QuestionType: 3, QuestionCategory: 0, Active: true, IsRequired: false },
    },
];

let CampaignOffersStore = class CampaignOffersStore extends EntityStore {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersStore, providedIn: 'root' }); }
};
CampaignOffersStore = __decorate([
    StoreConfig({ name: 'campaign-offers', idKey: 'MemberID', cache: { ttl: 30000 } })
], CampaignOffersStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CampaignOffersQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
    }
    selectAllCampaignOffers() {
        return this.selectAll().pipe(map((campaignOffers) => {
            return campaignOffers;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersQuery, deps: [{ token: CampaignOffersStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CampaignOffersStore }] });

class CampaignOffersService {
    constructor(api, campaignOffersStore, campaignOffersQuery) {
        this.api = api;
        this.campaignOffersStore = campaignOffersStore;
        this.campaignOffersQuery = campaignOffersQuery;
    }
    fetchOffers() {
        const request$ = this.api.getAnySingle('purchases/entitlements').pipe(tap((response) => {
            this.campaignOffersStore.set([response]);
        }), mapTo(null));
        return this.campaignOffersQuery.getHasCache() ? of(null) : request$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersService, deps: [{ token: ApiService }, { token: CampaignOffersStore }, { token: CampaignOffersQuery }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CampaignOffersService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }, { type: CampaignOffersStore }, { type: CampaignOffersQuery }] });

/**
 * Service to handle web push notifications
 */
class WebPushNotificationService {
    constructor(api, http, logger, injector, deviceService) {
        this.api = api;
        this.http = http;
        this.logger = logger;
        this.injector = injector;
        this.deviceService = deviceService;
        this.isAppBadgeSupported = false;
        this.swPush = this.injector.get(SwPush, undefined);
        this.notification = this.injector.get(NotificationCenterQuery);
        this.isEnabled = this.swPush.isEnabled;
        this.isSubscribed$ = this.swPush.subscription.pipe(map((sub) => !!sub), distinctUntilChanged());
        this.isAppBadgeSupported = 'setAppBadge' in navigator;
    }
    /**
     * Save the subscription details to the database
     */
    _subscribeToWebPushNotifications(wb) {
        return this.api.post('webpush', wb);
    }
    /**
     * Remove the subscription details from the database then unsubscribe from the browser
     *
     */
    _unsubscribeToWebPushNotifications(key) {
        return this.http.delete(`${config.baseApiUrl}/api/webpush`, { headers: this.api.getHeaders(), params: { Key: key } });
    }
    /**
     * Log that the user has received a notification
     */
    logMessageReceived(id) {
        return this.api.post(`webpush/messageRecieved/${id}`, {});
    }
    /**
     * Subscribe to webpush notifications and log the message to the database if Id is found
     */
    subscribe(next, error, complete) {
        this.swPush.messages.pipe(mergeMap((message) => iif(() => !!message.Id, this.logMessageReceived(message.Id).pipe(mapTo(message)), of(message)))).subscribe({ next, error, complete });
    }
    /**
     * Log the reason why the user denied permission to send notifications
     */
    logDenyPermission(reason) {
        return this.api.post('webpush/reject', null, { reason });
    }
    /**
     * Ask the user for permission to send notifications and subscribe to the notifications then save the subscription details to the database
     */
    requestSubscription(publicKey) {
        return new Promise((resolve, reject) => {
            if (!this.swPush.isEnabled) {
                throw new Error("Notification is not enabled.");
            }
            this.swPush.requestSubscription({
                serverPublicKey: publicKey
            }).then((sub) => {
                this.logger.info('Notification Subscription: ', sub.toJSON());
                let json = sub.toJSON();
                const key = json.keys?.p256dh || '';
                const auth = json.keys?.auth || '';
                const webPush = {
                    Auth: auth,
                    P256DH: key,
                    Endpoint: sub.endpoint,
                    ExpirationTime: sub.expirationTime,
                    PublicKey: publicKey,
                    DeviceInfo: JSON.stringify(this.deviceService.getDeviceInfo())
                };
                // Save the subscription details to the database
                this._subscribeToWebPushNotifications(webPush).toPromise().then((res) => {
                    // Once subscribed to webpush notifications, we can set the app icon badge count
                    // Note: This badge count only works when app is installed and does not apply in normal browser
                    // Tested on iPhone and Macbook, Windows if installed
                    const count = this.notification.getValue().unseenCount || 0;
                    this.setAppBadge(count);
                    resolve(res);
                }, (reason) => {
                    this.logger.error('Could not save subscription details to the database', reason);
                    // Unsubscribe to the browser locally if database save fails
                    this.swPush.unsubscribe();
                    reject(reason);
                });
            }).catch((err) => {
                this.logger.error('Could not subscribe to notifications', err);
                // Log to the database that the user denied permission
                this.logDenyPermission('denied').toPromise().then(resolve, reject);
            });
        });
    }
    /**
     * Unsubscribe user from the notifications and remove the subscription details from the database
     */
    unsubscribe() {
        return new Promise(async (resolve, reject) => {
            const pushSubscription = await this.swPush.subscription.pipe(take(1)).toPromise();
            if (!pushSubscription) {
                throw new Error('The user was never subscribed');
            }
            else {
                // Retrieve the key from the subscription
                const key = pushSubscription.toJSON().keys?.p256dh || '';
                // Unsubscribe from the database using the key
                this._unsubscribeToWebPushNotifications(key).toPromise()
                    .then(() => {
                    // Once we are unsubscribed from webpush notifications, we can clear the app badge count
                    this.clearAppBadge();
                    this.logger.info('Successfully unsubscribed to notifications');
                    // Unsubscribe from the browser locally
                    this.swPush.unsubscribe().then(resolve, reject);
                }).catch((err) => {
                    this.logger.error('Could not unsubscribe to notifications', err);
                    reject(err);
                });
            }
        });
    }
    /**
     * Set the app icon badge count
     */
    setAppBadge(count) {
        // Check if app badge is supported
        if (this.isAppBadgeSupported) {
            // Set the app icon badge count
            navigator.setAppBadge(count);
        }
    }
    /**
     * Clear the app icon badge count
     */
    clearAppBadge() {
        if (this.isAppBadgeSupported) {
            navigator.setAppBadge(0);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebPushNotificationService, deps: [{ token: ApiService }, { token: i1.HttpClient }, { token: LoggingService }, { token: i0.Injector }, { token: i4$2.DeviceDetectorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebPushNotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: WebPushNotificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ApiService }, { type: i1.HttpClient }, { type: LoggingService }, { type: i0.Injector }, { type: i4$2.DeviceDetectorService }] });

let TierStore = class TierStore extends EntityStore {
    constructor() {
        super({});
    }
    setTier(tier) {
        this.update({ tier });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierStore, providedIn: 'root' }); }
};
TierStore = __decorate([
    StoreConfig({ name: 'tiers', idKey: 'TierId', cache: { ttl: 30000 } })
], TierStore);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class TierService {
    constructor(api, tierStore, logService) {
        this.api = api;
        this.tierStore = tierStore;
        this.logService = logService;
    }
    fetchTiers(clubId) {
        const request$ = this.api.get(`loyalty/tiers/${clubId}`).pipe(tap((tiers) => {
            this.logService.debug(`Fetching Tiers`);
            this.tierStore.set(tiers);
        }));
        return cacheable(this.tierStore, request$).pipe(mapTo(null));
    }
    fetchTier(clubId, portalId, purseNumber) {
        const request$ = this.api.getAnySingle(`loyalty/tiers/${clubId}/${portalId}/${purseNumber}`)
            .pipe(tap((tier) => {
            this.logService.debug(`Fetching customer loyalty tier`);
            this.tierStore.setTier(tier);
        }));
        return cacheable(this.tierStore, request$).pipe(mapTo(null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierService, deps: [{ token: ApiService }, { token: TierStore }, { token: LoggingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ApiService }, { type: TierStore }, { type: LoggingService }] });

class TierQuery extends QueryEntity {
    constructor(store) {
        super(store);
        this.store = store;
        this.customerTier$ = this.select((state) => state.tier);
        this.tiers$ = this.selectAll();
    }
    /**
     * Gets the current tier id of the customer
     * @returns the current tier id
     */
    getCurrentTierId() {
        return this.getValue().tier?.CurrentTierId;
    }
    /**
     * Gets the current tier of the customer tiers list
     */
    getCurrentTier() {
        return this.select(state => state.tier?.Tiers.find(tier => tier.TierId === state.tier?.CurrentTierId));
    }
    /**
     * Gets the tier by id
     * @param id
     */
    getTierById(id) {
        return this.getEntity(id);
    }
    /**
     * Selects the tier by id
     * @param id
     */
    selectTierById(id) {
        return this.selectEntity(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierQuery, deps: [{ token: TierStore }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierQuery, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: TierQuery, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: TierStore }] });

/**
 * Configurations for the application to work.
 * should be provided in the root module
 * @example
 *  providers: [
 *       provideAppConfig({
 *           dateOptions: {
 *               LongDateFormat: 'MMM D, yyyy h:mma'
 *           }
 *       }),
 *   ...
 *   ]
 */
function provideAppConfig(appConfig) {
    // intialize defaults
    const dateOptions = { ...DEFAULT_DATE_OPTIONS, ...appConfig.dateOptions };
    return makeEnvironmentProviders([
        DatePipe,
        CurrencyPipe,
        MaintenanceGuard,
        CookieService,
        AuthGuard,
        AuthService,
        {
            provide: DATE_OPTIONS,
            useValue: dateOptions,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenRefreshIntereptor,
            multi: true,
            deps: [AuthService],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FirstTimeRegistrationInterceptor,
            multi: true,
            deps: [MemberQuery, RegistrationStepService, LoggingService, Router],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
            deps: [ErrorStateService, LoggingService, TranslateService, Router, AuthService],
        },
        {
            provide: ErrorHandler,
            useClass: FgbErrorHandler
        },
        // Languages for the language selector, if language does not exist in the default languages
        // just provide the LANGUAGE in the app module
        // ex: 
        // {
        //   provide: LANGUAGE,
        //   useValue: { label: 'TEST', lang: 'en-US', lcid: '1234' },
        //   multi: true
        // }
        // 
        {
            provide: LANGUAGE,
            useValue: { label: 'EN', lang: 'en-GB', lcid: '2057', flag: 'GB' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'FR', lang: 'fr-FR', lcid: '1036', flag: 'FR' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'FR-CA', lang: 'fr-CA', lcid: '3084', flag: 'FR' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'HE', lang: 'he-IL', lcid: '1037', flag: 'IL' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'GR', lang: 'el-GR', lcid: '1032', flag: 'GR' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'US', lang: 'en-US', lcid: '1033', flag: 'US' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'EN-CA', lang: 'en-CA', lcid: '4105', flag: 'US' },
            multi: true
        },
        {
            provide: LANGUAGE,
            useValue: { label: 'IRE', lang: 'en-IE', lcid: '6153', flag: 'IE' },
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                // Initialize translation
                inject(TranslationLoader).init();
                return () => { };
            },
            multi: true
        }
    ]);
}

/**
 * Provides the TM Auth services
 * should be provided in the root module
 * @example
 *  providers: [
 *      provideTMAuth({
 *           ssoAuth: tmSSOAuthConfig,
 *           loginAuth: tmLoginAuthConfig
 *       }),
 *    ...
 *   ]
 *
 */
function provideTMAuth(config) {
    return makeEnvironmentProviders([
        TMOauthService,
        TMAuthService,
        {
            provide: tmOAuthConfig,
            useValue: config.ssoAuth
        },
        {
            provide: tmAuthConfig,
            useValue: config.loginAuth
        },
    ]);
}

class CoreModule {
    static forRoot() {
        return {
            ngModule: CoreModule
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: CoreModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CoreModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

//utility functions

/**
 * Generated bundle index. Do not edit.
 */

export { ADDRESS_DEFAULT_MOCK, ADDRESS_SHIPPING_MOCK, ALERT_MODEL_MOCK, ALERT_MODEL_RESPONSE_MOCK, ANNOUNCMENET_MOCK, AUCTION_STATE, AUCTION_TEXT_COLOR, AccountModel, AccountPopulation, ActionLabels, AddressBookQuery, AddressBookResolver, AddressBookService, AddressQuery, AddressResolver, AddressService, AddressType, AnnouncementLinkType, AnnouncementQuery, AnnouncementService, AnswerDisplayType, AnswerType, ApiService, AuctionBid, AuctionBidQuery, AuctionBidService, AuctionBidStatus, AuctionBidsResolver, AuctionItem, AuctionItemDto, AuctionQuery, AuctionResolver, AuctionService, AuctionState, AuctionStatus, AuthGuard, AuthService, AutoAssignBarcodeType, AutoTopupQuery, AutoTopupService, BadgeStatus, BadgesQuery, BadgesService, BalanceQuery, BalanceResolver, BalanceService, BarcodeQuery, BarcodeService, BasketService, BenefitClaimStatus, BenefitQuery, BenefitResolver, BenefitService, BenefitStore, CARCLINK_OFFER_LOCATIONS_MOCK, CARDLINK_OFFER_LOCATION_DETAIL, CARD_LINK_AFFILIATE_CATEGORY_TAGS_MOCK, CARD_LINK_AFFILIATE_MOCK, CARD_LINK_OFFER_ACTIVATE_MOCK, CARD_LINK_OFFER_CATEGORY_MOCK, CARD_LINK_OFFER_MOCK, CARD_LINK_OPTION_MOCK, CARD_TOKEN_MOCK_DEFAULT, CARD_TOKEN_MOCK_OTHERS, CART_ITEM_MOCK, CHILD_REGISTRATION_MOCK, COMPANY_OFFERS_MOCK, CONTENT_MOCK, CUSTOM_FIELD_CHECKBOX_MOCK, CUSTOM_FIELD_MULTILINE_MOCK, CUSTOM_FIELD_TEXTBOX_MOCK, CallBackModel, CampaignOffersQuery, CampaignOffersService, CampaignOffersStore, CardLinkAffiliatesQuery, CardLinkAffiliatesService, CardLinkOfferCategoriesQuery, CardLinkOfferCategoriesService, CardLinkOfferLocationsQuery, CardLinkOfferLocationsService, CardLinkOfferType, CardLinkOffersQuery, CardLinkOffersService, CardLinkingFidelCountries, CardLinkingQuery, CardLinkingService, CardQuery, CardService, CardStatus, CardTokenQuery, CardTokenResolver, CardTokenService, CartQuery, CartService, CartStore, ChildQuery, ChildService, ClientType, ClubTagQuery, CompanyOfferQuery, CompanyOfferService, CompanyOfferType, CompanyQuery, CompanyService, CompanyType, ContactService, CoreModule, CountryQuery, CountryResolver, CountryService, CountryStore, CustomDataSetService, CustomerProductSusbcriptionPaymentStatusType, CustomerTag, DATE_OPTIONS, DEFAULT_DATE_OPTIONS, DEPARTMENT_MOCK, DeliveryParameters, DepartmentQuery, DepartmentResolver, DepartmentService, DepartmentType, EMAIL_TYPE_STATUS_MOCK, EarnPointsQuery, EarnPointsService, EcashService, EcashTransferViewModel, EmailKind, EmailRequestAttachmentDocumentType, EmailRequestAttachmentStatus, EmailRequestAttachmentType, EntityNotificationGroupDto, EntityNotificationGroupItem, ErrorStateService, EventsService, ExternalCashTransferQuery, ExternalCashTransferService, ExternalCashTransferStore, ExternalConnect, ExternalProviderService, FGBMissingTranslationHandler, FGBPreLoadingStrategy, FGBTranslationLoader, FantasyGameQuery, FantasyGameResolver, FantasyGameService, FantasyHistoryQuery, FantasyHistoryResolver, FantasyHistoryService, FantasyHistoryStore, FantasyLeaderboardQuery, FantasyLeaderboardService, FaqSectionQuery, FaqSectionService, FeaturesRewardsItem, FgbError, FgbErrorHandler, FidelJsLoaderService, FidelLinkedCardError, FidelService, FirstTimeRegistrationInterceptor, FloodlightTrackingService, GAME_MOCK, GameDataSource, GameQuery, GameService, GameStatus, GbgIdentityVerificationQuery, GbgIdentityVerificationService, GbgIdentityVerificationSso, GiftCodeEntitlementPaymentType, GiftCodeEntitlementType, GiftCodeEntitlementValueType, GiftCodeService, GiftCodeStatus, GiftCodeType, GiftCodeUseType, GroupHasLoyaltyTypeAndIsActive, GuardianFlags, Guid, HttpErrorInterceptor, HttpLoaderFactory, Image, ImageUploadService, IncrowdAuthService, InputType, ItemLoyaltyState, JokesModel, KeyCloakAuthService, KeyCloakSettings, LANGUAGE, LINK_CARD_MOCK, LOTTO_STATE, LOTTO_TEXT_COLOR, LOYALTY_STATUS, LeaderboardQuery, LeaderboardResolver, LeaderboardService, LinkOfferStatus, LinkedCard, LinkedOffer, LocalStorageService, LocaleModel, LocaleService, LocationService, LogLevel, LoggingService, Login, LoginType, LottoItem, LottoQuery, LottoResolver, LottoService, LottoState, LottoWalletQuery, LottoWalletResolver, LottoWalletService, LoyaltyActionType, LoyaltyCategoryType, LoyaltyLimitType, LoyaltyStatus, LoyaltyStatusService, LoyaltyType, MARKETPLACE_ATTRIBUTE_CART_ITEM, MARKETPLACE_CART_ITEM_MOCK, MARKETPLACE_CUSTOMFIELD_CART_ITEM, MARKETPLACE_ITEM_ATTRIBUTES_MOCK, MARKETPLACE_ITEM_ATTRIBUTE_MAPPING_MOCK, MARKETPLACE_ITEM_ATTRIBUTE_VALUE_MOCK, MARKETPLACE_ITEM_CUSTOM_FIELDS_MOCK, MARKETPLACE_ITEM_FR_ATTRIBUTES_MOCK, MARKETPLACE_ITEM_MOCK, MARKETPLACE_STATE, MEMBERSHIP_OPTION_MOCK, MEMBER_DETAILS_MOCK, MailingService, MaintenanceGuard, ManageTicketStatusModel, MarketplaceBasket, MarketplaceBasketItem, MarketplaceExtendedQuery, MarketplaceItem, MarketplaceItemAttributeDisplayType, MarketplaceItemExtended, MarketplaceItemLimitType, MarketplaceItemMapping, MarketplaceItemMappingAttribute, MarketplaceItemStatus, MarketplaceItemStockType, MarketplacePurchasedItem, MarketplaceQuery, MarketplaceService, MarketplaceState, MarketplaceVirtualEvent, MemberCardQuery, MemberCardResolver, MemberCardService, MemberLoyaltyStatusQuery, MemberLoyaltyStatusResolver, MemberLoyaltyStatusService, MemberQuery, MemberResolver, MemberService, MemberStore, MembershipOptionQuery, MembershipOptionService, MixedLoyaltyItem, MixedLoyaltyItemType, MixedLoyaltyQuery, MixedLoyaltyWalletItem, MobileAppRequest, MobilePassQuery, MobilePassService, ModelDisplay, NotificationCenterActionType, NotificationCenterMappingResolver, NotificationCenterMessage, NotificationCenterMessageDto, NotificationCenterMessageType, NotificationCenterMessageView, NotificationCenterQuery, NotificationCenterService, NotificationCenterStore, NotificationLoyaltyType, NotificationManagementQuery, NotificationManagementResolver, NotificationManagementService, NotificationManagementStore, NotificationMappingModel, NotificationsCenterMappingQuery, NotificationsCenterMappingService, NotificationsCenterMappingStore, OtherMediaAuthService, OutputField, POPUP_NOTIFICATION_ACTION_MOCK, POPUP_NOTIFICATION_TEXT_MOCK, PRIORITY, PROVIDER_RESPONSE_ERROR_MOCK, PROVIDER_RESPONSE_NEED_ADDRESS_MOCK, PROVIDER_RESPONSE_NEED_SHIPPING_MOCK, PROVIDER_RESPONSE_SUCCESS_MOCK, PartnerPendingQuery, PartnerPendingResolver, PartnerPendingService, PartnerQuery, PartnerResolver, PartnerService, PaymentCardType, PaymentOptionType, PaymentService, PointProcessType, PointsTransferService, PointsTransferType, PopUpCommandType, PopUpNotificationDto, PopUpNotificationModel, PopUpNotificationQuery, PopUpNotificationResolver, PopUpNotificationResponseType, PopUpNotificationService, PopUpNotificationType, PopUpNotificationViewModel, PopUpWindowType, PopulationGuard, PopulationQuery, PopulationService, PortalProductsQuery, PortalProductsService, PortalProductsStore, PortalProductsSubscriptionsQuery, PortalProductsSubscriptionsResolver, PortalProductsSubscriptionsService, PortalProductsSubscriptionsStore, PredictorAnswerType, PrizeType, ProcessProviderId, ProcessStatus, ProductCodeGuard, ProductCodeQuery, ProductCodeService, ProductIntervalPeriodType, ProductTag, PropertyTypeCode, ProviderActionKind, ProviderActionModel, ProviderName, ProviderNextActionKind, ProviderService, ProviderTranslationStatus, ProviderUiActionResponse, PurchaseQuery, PurchaseResolver, PurchaseService, REDEMPTION_RESULT, REGISTRATION_QUESTION_ANSWER_MOCK, REGISTRATION_ROUTES, REGISTRATION_STEP_MOCK, RedsoxChildrenTicketCodesQuery, RedsoxChildrenTicketCodesService, RegistrationBasketQuery, RegistrationBasketService, RegistrationBasketStore, RegistrationMembershipOptionResolver, RegistrationQuestionType, RegistrationStepQuery, RegistrationStepResolver, RegistrationStepService, RegistrationStepStore, RenewalBonusService, RewardsWalletQuery, RewardsWalletService, RewardsWalletStore, SAPAuthService, SCORECARD_MOCK, SQWADService, ScorePredictorStatus, ScorecardAction, ScorecardActionContent, ScorecardActionMessage, ScorecardCompleteMessage, ScorecardContent, ScorecardDisplayType, ScorecardMilestone, ScorecardMilestoneActionDisplayType, ScorecardMilestoneDetails, ScorecardMilestoneMessage, ScorecardMilestonesDetailsContent, ScorecardQuery, ScorecardService, ScreenSizeService, SeatGeekAuthService, SeatingDetailQuery, SeatingDetailResolver, SeatingDetailService, ShippingType, SignalRHub, SignalRUnauthrosiedHub, SportsAllianceAuthService, SportsAllianceSettings, SqlDbType, StandardResult, StepType, SubmitTicketRequestModel, SurveyListOrderType, SurveyQuery, SurveyResolver, SurveyService, SurveyType, TEXT_COLOR, TICKET_INVITE_MOCK, TMAuthService, TMOauthService, TRANSACTION_MOCK, TenGameClubQuery, TenGameClubService, TermsAndConditionQuery, TermsAndConditionsDisplayType, TermsAndConditionsService, TermsAndConditionsType, TermsAndCondtion, TermsAndCondtionsType, TicketActionType, TicketDetails, TicketFlag, TicketMediaType, TicketQuery, TicketResolver, TicketService, TicketTransactionType, TicketTransferGuard, TierQuery, TierService, TierStore, TokenRefreshIntereptor, TopUpAmountTypeId, TopUpTicketPostModel, TopUpTicketsStatus, TopUpViewModel, TopupTicketService, TopupTicketStore, TransactionExtendedQuery, TransactionExtendedService, TransactionExtendedStore, TransactionQuery, TransactionService, TransactionSuccessGuard, TransactionSuccessQuery, TransactionSuccessService, TransactionType, TransferFundsRequest, TranslationLoader, USERCONTEXT_MOCK_FR, UrbanZooAuthService, UserContext, UserGeoLocation, UserQuestionAnswerModel, UserQuestionsQuery, UserQuestionsService, VALID_ADDRESS_MOCK, VerifyEmailAddressRequest, VoucherQuery, VoucherRedeemModel, VoucherService, VoucherStore, WalletAttributes, WalletCustomFields, WalletItemType, WebPushNotificationService, WebsiteContentFeatureFlagGuard, WizardType, WorksheetQuery, WorksheetService, WorksheetType, config, configMock, createCardLinkOfferLocation, createDepartment, createMarketplaceCartItem, createMemberCard, createPortalProductCartItem, createRenewalBonus, createScorecard, firstTimeUserGuard, flattenToAuction, getLcidByCultureCode, getLoyaltyBalance, isEqual, jwtTokenGetter, locales, marketplaceIdArr, provideAppConfig, provideTMAuth, recordKeys, registrationResolver, tmAuthConfig, tmOAuthConfig, wipeBalance };
